var fs = Object.create;
var Pa = Object.defineProperty;
var ys = Object.getOwnPropertyDescriptor;
var Rn = (e, r) => (r = Symbol[e]) ? r : Symbol.for("Symbol." + e), mt = (e) => {
  throw TypeError(e);
};
var Un = (e, r, t) => r in e ? Pa(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t;
var On = (e, r) => Pa(e, "name", { value: r, configurable: !0 });
var Vn = (e) => [, , , fs((e == null ? void 0 : e[Rn("metadata")]) ?? null)], Hn = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"], gt = (e) => e !== void 0 && typeof e != "function" ? mt("Function expected") : e, bs = (e, r, t, a, n) => ({ kind: Hn[e], name: r, metadata: a, addInitializer: (o) => t._ ? mt("Already initialized") : n.push(gt(o || null)) }), Sa = (e, r) => Un(r, Rn("metadata"), e[3]), Wn = (e, r, t, a) => {
  for (var n = 0, o = e[r >> 1], i = o && o.length; n < i; n++) r & 1 ? o[n].call(t) : a = o[n].call(t, a);
  return a;
}, Yn = (e, r, t, a, n, o) => {
  var i, s, l, c, p, u = r & 7, _ = !!(r & 8), g = !!(r & 16), m = u > 3 ? e.length + 1 : u ? _ ? 1 : 2 : 0, f = Hn[u + 5], h = u > 3 && (e[m - 1] = []), v = e[m] || (e[m] = []), y = u && (!g && !_ && (n = n.prototype), u < 5 && (u > 3 || !g) && ys(u < 4 ? n : { get [t]() {
    return Ln(this, o);
  }, set [t](T) {
    return Bn(this, o, T);
  } }, t));
  u ? g && u < 4 && On(o, (u > 2 ? "set " : u > 1 ? "get " : "") + t) : On(n, t);
  for (var x = a.length - 1; x >= 0; x--)
    c = bs(u, t, l = {}, e[3], v), u && (c.static = _, c.private = g, p = c.access = { has: g ? (T) => hs(n, T) : (T) => t in T }, u ^ 3 && (p.get = g ? (T) => (u ^ 1 ? Ln : vs)(T, n, u ^ 4 ? o : y.get) : (T) => T[t]), u > 2 && (p.set = g ? (T, S) => Bn(T, n, S, u ^ 4 ? o : y.set) : (T, S) => T[t] = S)), s = (0, a[x])(u ? u < 4 ? g ? o : y[f] : u > 4 ? void 0 : { get: y.get, set: y.set } : n, c), l._ = 1, u ^ 4 || s === void 0 ? gt(s) && (u > 4 ? h.unshift(s) : u ? g ? o = s : y[f] = s : n = s) : typeof s != "object" || s === null ? mt("Object expected") : (gt(i = s.get) && (y.get = i), gt(i = s.set) && (y.set = i), gt(i = s.init) && h.unshift(i));
  return u || Sa(e, n), y && Pa(n, t, y), g ? u ^ 4 ? o : y : n;
}, M = (e, r, t) => Un(e, typeof r != "symbol" ? r + "" : r, t), Ea = (e, r, t) => r.has(e) || mt("Cannot " + t), hs = (e, r) => Object(r) !== r ? mt('Cannot use the "in" operator on this value') : e.has(r), Ln = (e, r, t) => (Ea(e, r, "read from private field"), t ? t.call(e) : r.get(e));
var Bn = (e, r, t, a) => (Ea(e, r, "write to private field"), a ? a.call(e, t) : r.set(e, t), t), vs = (e, r, t) => (Ea(e, r, "access private method"), t);
const ks = "5";
typeof window < "u" && (window.__svelte || (window.__svelte = { v: /* @__PURE__ */ new Set() })).v.add(ks);
const nn = 1, on = 2, zo = 4, ws = 8, xs = 16, Ps = 1, Ss = 2, Es = 4, Ts = 8, Is = 16, qs = 1, Fs = 2, zs = 4, Ds = 1, As = 2, Te = Symbol(), xt = "http://www.w3.org/2000/svg";
function Ms(e) {
  return e.endsWith("capture") && e !== "gotpointercapture" && e !== "lostpointercapture";
}
const js = [
  "beforeinput",
  "click",
  "change",
  "dblclick",
  "contextmenu",
  "focusin",
  "focusout",
  "input",
  "keydown",
  "keyup",
  "mousedown",
  "mousemove",
  "mouseout",
  "mouseover",
  "mouseup",
  "pointerdown",
  "pointermove",
  "pointerout",
  "pointerover",
  "pointerup",
  "touchend",
  "touchmove",
  "touchstart"
];
function Ns(e) {
  return js.includes(e);
}
const Cs = {
  // no `class: 'className'` because we handle that separately
  formnovalidate: "formNoValidate",
  ismap: "isMap",
  nomodule: "noModule",
  playsinline: "playsInline",
  readonly: "readOnly",
  defaultvalue: "defaultValue",
  defaultchecked: "defaultChecked",
  srcobject: "srcObject"
};
function Os(e) {
  return e = e.toLowerCase(), Cs[e] ?? e;
}
const Ls = ["touchstart", "touchmove"];
function Bs(e) {
  return Ls.includes(e);
}
const Gn = !1;
var pa = Array.isArray, Rs = Array.prototype.indexOf, sn = Array.from, Us = Object.defineProperty, Sr = Object.getOwnPropertyDescriptor, Do = Object.getOwnPropertyDescriptors, Vs = Object.prototype, Hs = Array.prototype, ln = Object.getPrototypeOf;
function Kr(e) {
  return typeof e == "function";
}
const ne = () => {
};
function Ws(e) {
  return e();
}
function Na(e) {
  for (var r = 0; r < e.length; r++)
    e[r]();
}
const Ze = 2, Ao = 4, Ft = 8, _a = 16, Ke = 32, zt = 64, Zt = 128, Vr = 256, Kt = 512, Ie = 1024, qr = 2048, Dt = 4096, cr = 8192, st = 16384, Mo = 32768, zr = 65536, Ys = 1 << 17, Gs = 1 << 19, jo = 1 << 20, Er = Symbol("$state"), No = Symbol("legacy props"), Xs = Symbol("");
function Co(e) {
  return e === this.v;
}
function Oo(e, r) {
  return e != e ? r == r : e !== r || e !== null && typeof e == "object" || typeof e == "function";
}
function cn(e) {
  return !Oo(e, this.v);
}
function Zs(e) {
  throw new Error("https://svelte.dev/e/effect_in_teardown");
}
function Ks() {
  throw new Error("https://svelte.dev/e/effect_in_unowned_derived");
}
function Js(e) {
  throw new Error("https://svelte.dev/e/effect_orphan");
}
function Qs() {
  throw new Error("https://svelte.dev/e/effect_update_depth_exceeded");
}
function $s(e) {
  throw new Error("https://svelte.dev/e/props_invalid_value");
}
function el() {
  throw new Error("https://svelte.dev/e/state_descriptors_fixed");
}
function rl() {
  throw new Error("https://svelte.dev/e/state_prototype_fixed");
}
function tl() {
  throw new Error("https://svelte.dev/e/state_unsafe_local_read");
}
function al() {
  throw new Error("https://svelte.dev/e/state_unsafe_mutation");
}
let lt = !1, nl = !1;
function ol() {
  lt = !0;
}
function je(e, r) {
  var t = {
    f: 0,
    // TODO ideally we could skip this altogether, but it causes type errors
    v: e,
    reactions: null,
    equals: Co,
    rv: 0,
    wv: 0
  };
  return t;
}
function X(e) {
  return /* @__PURE__ */ Lo(je(e));
}
// @__NO_SIDE_EFFECTS__
function ga(e, r = !1) {
  var a;
  const t = je(e);
  return r || (t.equals = cn), lt && $ !== null && $.l !== null && ((a = $.l).s ?? (a.s = [])).push(t), t;
}
function Ca(e, r = !1) {
  return /* @__PURE__ */ Lo(/* @__PURE__ */ ga(e, r));
}
// @__NO_SIDE_EFFECTS__
function Lo(e) {
  return le !== null && (le.f & Ze) !== 0 && (dr === null ? ml([e]) : dr.push(e)), e;
}
function D(e, r) {
  return le !== null && mn() && (le.f & (Ze | _a)) !== 0 && // If the source was created locally within the current derived, then
  // we allow the mutation.
  (dr === null || !dr.includes(e)) && al(), Oa(e, r);
}
function Oa(e, r) {
  return e.equals(r) || (e.v, e.v = r, e.wv = ri(), Bo(e, qr), mn() && Z !== null && (Z.f & Ie) !== 0 && (Z.f & Ke) === 0 && (Se !== null && Se.includes(e) ? (Je(Z, qr), ba(Z)) : Tr === null ? fl([e]) : Tr.push(e))), r;
}
function Bo(e, r) {
  var t = e.reactions;
  if (t !== null)
    for (var a = mn(), n = t.length, o = 0; o < n; o++) {
      var i = t[o], s = i.f;
      (s & qr) === 0 && (!a && i === Z || (Je(i, r), (s & (Ie | Vr)) !== 0 && ((s & Ze) !== 0 ? Bo(
        /** @type {Derived} */
        i,
        Dt
      ) : ba(
        /** @type {Effect} */
        i
      ))));
    }
}
let dn = !1;
function B(e, r = null, t) {
  if (typeof e != "object" || e === null || Er in e)
    return e;
  const a = ln(e);
  if (a !== Vs && a !== Hs)
    return e;
  var n = /* @__PURE__ */ new Map(), o = pa(e), i = je(0);
  o && n.set("length", je(
    /** @type {any[]} */
    e.length
  ));
  var s;
  return new Proxy(
    /** @type {any} */
    e,
    {
      defineProperty(l, c, p) {
        (!("value" in p) || p.configurable === !1 || p.enumerable === !1 || p.writable === !1) && el();
        var u = n.get(c);
        return u === void 0 ? (u = je(p.value), n.set(c, u)) : D(u, B(p.value, s)), !0;
      },
      deleteProperty(l, c) {
        var p = n.get(c);
        if (p === void 0)
          c in l && n.set(c, je(Te));
        else {
          if (o && typeof c == "string") {
            var u = (
              /** @type {Source<number>} */
              n.get("length")
            ), _ = Number(c);
            Number.isInteger(_) && _ < u.v && D(u, _);
          }
          D(p, Te), Xn(i);
        }
        return !0;
      },
      get(l, c, p) {
        var m;
        if (c === Er)
          return e;
        var u = n.get(c), _ = c in l;
        if (u === void 0 && (!_ || (m = Sr(l, c)) != null && m.writable) && (u = je(B(_ ? l[c] : Te, s)), n.set(c, u)), u !== void 0) {
          var g = d(u);
          return g === Te ? void 0 : g;
        }
        return Reflect.get(l, c, p);
      },
      getOwnPropertyDescriptor(l, c) {
        var p = Reflect.getOwnPropertyDescriptor(l, c);
        if (p && "value" in p) {
          var u = n.get(c);
          u && (p.value = d(u));
        } else if (p === void 0) {
          var _ = n.get(c), g = _ == null ? void 0 : _.v;
          if (_ !== void 0 && g !== Te)
            return {
              enumerable: !0,
              configurable: !0,
              value: g,
              writable: !0
            };
        }
        return p;
      },
      has(l, c) {
        var g;
        if (c === Er)
          return !0;
        var p = n.get(c), u = p !== void 0 && p.v !== Te || Reflect.has(l, c);
        if (p !== void 0 || Z !== null && (!u || (g = Sr(l, c)) != null && g.writable)) {
          p === void 0 && (p = je(u ? B(l[c], s) : Te), n.set(c, p));
          var _ = d(p);
          if (_ === Te)
            return !1;
        }
        return u;
      },
      set(l, c, p, u) {
        var x;
        var _ = n.get(c), g = c in l;
        if (o && c === "length")
          for (var m = p; m < /** @type {Source<number>} */
          _.v; m += 1) {
            var f = n.get(m + "");
            f !== void 0 ? D(f, Te) : m in l && (f = je(Te), n.set(m + "", f));
          }
        _ === void 0 ? (!g || (x = Sr(l, c)) != null && x.writable) && (_ = je(void 0), D(_, B(p, s)), n.set(c, _)) : (g = _.v !== Te, D(_, B(p, s)));
        var h = Reflect.getOwnPropertyDescriptor(l, c);
        if (h != null && h.set && h.set.call(u, p), !g) {
          if (o && typeof c == "string") {
            var v = (
              /** @type {Source<number>} */
              n.get("length")
            ), y = Number(c);
            Number.isInteger(y) && y >= v.v && D(v, y + 1);
          }
          Xn(i);
        }
        return !0;
      },
      ownKeys(l) {
        d(i);
        var c = Reflect.ownKeys(l).filter((_) => {
          var g = n.get(_);
          return g === void 0 || g.v !== Te;
        });
        for (var [p, u] of n)
          u.v !== Te && !(p in l) && c.push(p);
        return c;
      },
      setPrototypeOf() {
        rl();
      }
    }
  );
}
function Xn(e, r = 1) {
  D(e, e.v + r);
}
var Zn, Ro, Uo;
function il() {
  if (Zn === void 0) {
    Zn = window;
    var e = Element.prototype, r = Node.prototype;
    Ro = Sr(r, "firstChild").get, Uo = Sr(r, "nextSibling").get, e.__click = void 0, e.__className = "", e.__attributes = null, e.__styles = null, e.__e = void 0, Text.prototype.__t = void 0;
  }
}
function At(e = "") {
  return document.createTextNode(e);
}
// @__NO_SIDE_EFFECTS__
function Br(e) {
  return Ro.call(e);
}
// @__NO_SIDE_EFFECTS__
function ma(e) {
  return Uo.call(e);
}
function P(e, r) {
  return /* @__PURE__ */ Br(e);
}
function Y(e, r) {
  {
    var t = (
      /** @type {DocumentFragment} */
      /* @__PURE__ */ Br(
        /** @type {Node} */
        e
      )
    );
    return t instanceof Comment && t.data === "" ? /* @__PURE__ */ ma(t) : t;
  }
}
function O(e, r = 1, t = !1) {
  let a = e;
  for (; r--; )
    a = /** @type {TemplateNode} */
    /* @__PURE__ */ ma(a);
  return a;
}
function sl(e) {
  e.textContent = "";
}
// @__NO_SIDE_EFFECTS__
function E(e) {
  var r = Ze | qr;
  Z === null ? r |= Vr : Z.f |= jo;
  var t = le !== null && (le.f & Ze) !== 0 ? (
    /** @type {Derived} */
    le
  ) : null;
  const a = {
    children: null,
    ctx: $,
    deps: null,
    equals: Co,
    f: r,
    fn: e,
    reactions: null,
    rv: 0,
    v: (
      /** @type {V} */
      null
    ),
    wv: 0,
    parent: t ?? Z
  };
  return t !== null && (t.children ?? (t.children = [])).push(a), a;
}
// @__NO_SIDE_EFFECTS__
function et(e) {
  const r = /* @__PURE__ */ E(e);
  return r.equals = cn, r;
}
function Vo(e) {
  var r = e.children;
  if (r !== null) {
    e.children = null;
    for (var t = 0; t < r.length; t += 1) {
      var a = r[t];
      (a.f & Ze) !== 0 ? un(
        /** @type {Derived} */
        a
      ) : Ve(
        /** @type {Effect} */
        a
      );
    }
  }
}
function ll(e) {
  for (var r = e.parent; r !== null; ) {
    if ((r.f & Ze) === 0)
      return (
        /** @type {Effect} */
        r
      );
    r = r.parent;
  }
  return null;
}
function Ho(e) {
  var r, t = Z;
  qe(ll(e));
  try {
    Vo(e), r = ti(e);
  } finally {
    qe(t);
  }
  return r;
}
function Wo(e) {
  var r = Ho(e), t = (Or || (e.f & Vr) !== 0) && e.deps !== null ? Dt : Ie;
  Je(e, t), e.equals(r) || (e.v = r, e.wv = ri());
}
function un(e) {
  Vo(e), St(e, 0), Je(e, st), e.v = e.children = e.deps = e.ctx = e.reactions = null;
}
function Yo(e) {
  Z === null && le === null && Js(), le !== null && (le.f & Vr) !== 0 && Ks(), gn && Zs();
}
function cl(e, r) {
  var t = r.last;
  t === null ? r.last = r.first = e : (t.next = e, e.prev = t, r.last = e);
}
function ct(e, r, t, a = !0) {
  var n = (e & zt) !== 0, o = Z, i = {
    ctx: $,
    deps: null,
    deriveds: null,
    nodes_start: null,
    nodes_end: null,
    f: e | qr,
    first: null,
    fn: r,
    last: null,
    next: null,
    parent: n ? null : o,
    prev: null,
    teardown: null,
    transitions: null,
    wv: 0
  };
  if (t) {
    var s = rt;
    try {
      Jn(!0), jt(i), i.f |= Mo;
    } catch (p) {
      throw Ve(i), p;
    } finally {
      Jn(s);
    }
  } else r !== null && ba(i);
  var l = t && i.deps === null && i.first === null && i.nodes_start === null && i.teardown === null && (i.f & jo) === 0;
  if (!l && !n && a && (o !== null && cl(i, o), le !== null && (le.f & Ze) !== 0)) {
    var c = (
      /** @type {Derived} */
      le
    );
    (c.children ?? (c.children = [])).push(i);
  }
  return i;
}
function Go(e) {
  const r = ct(Ft, null, !1);
  return Je(r, Ie), r.teardown = e, r;
}
function at(e) {
  Yo();
  var r = Z !== null && (Z.f & Ke) !== 0 && $ !== null && !$.m;
  if (r) {
    var t = (
      /** @type {ComponentContext} */
      $
    );
    (t.e ?? (t.e = [])).push({
      fn: e,
      effect: Z,
      reaction: le
    });
  } else {
    var a = fa(e);
    return a;
  }
}
function dl(e) {
  return Yo(), ya(e);
}
function ul(e) {
  const r = ct(zt, e, !0);
  return (t = {}) => new Promise((a) => {
    t.outro ? Rr(r, () => {
      Ve(r), a(void 0);
    }) : (Ve(r), a(void 0));
  });
}
function fa(e) {
  return ct(Ao, e, !1);
}
function Kn(e, r) {
  var t = (
    /** @type {ComponentContextLegacy} */
    $
  ), a = { effect: null, ran: !1 };
  t.l.r1.push(a), a.effect = ya(() => {
    e(), !a.ran && (a.ran = !0, D(t.l.r2, !0), br(r));
  });
}
function pl() {
  var e = (
    /** @type {ComponentContextLegacy} */
    $
  );
  ya(() => {
    if (d(e.l.r2)) {
      for (var r of e.l.r1) {
        var t = r.effect;
        (t.f & Ie) !== 0 && Je(t, Dt), dt(t) && jt(t), r.ran = !1;
      }
      e.l.r2.v = !1;
    }
  });
}
function ya(e) {
  return ct(Ft, e, !0);
}
function A(e) {
  return Dr(e);
}
function Dr(e, r = 0) {
  return ct(Ft | _a | r, e, !0);
}
function Ue(e, r = !0) {
  return ct(Ft | Ke, e, !0, r);
}
function Xo(e) {
  var r = e.teardown;
  if (r !== null) {
    const t = gn, a = le;
    Qn(!0), He(null);
    try {
      r.call(null);
    } finally {
      Qn(t), He(a);
    }
  }
}
function Zo(e) {
  var r = e.deriveds;
  if (r !== null) {
    e.deriveds = null;
    for (var t = 0; t < r.length; t += 1)
      un(r[t]);
  }
}
function Ko(e, r = !1) {
  var t = e.first;
  for (e.first = e.last = null; t !== null; ) {
    var a = t.next;
    Ve(t, r), t = a;
  }
}
function _l(e) {
  for (var r = e.first; r !== null; ) {
    var t = r.next;
    (r.f & Ke) === 0 && Ve(r), r = t;
  }
}
function Ve(e, r = !0) {
  var t = !1;
  if ((r || (e.f & Gs) !== 0) && e.nodes_start !== null) {
    for (var a = e.nodes_start, n = e.nodes_end; a !== null; ) {
      var o = a === n ? null : (
        /** @type {TemplateNode} */
        /* @__PURE__ */ ma(a)
      );
      a.remove(), a = o;
    }
    t = !0;
  }
  Ko(e, r && !t), Zo(e), St(e, 0), Je(e, st);
  var i = e.transitions;
  if (i !== null)
    for (const l of i)
      l.stop();
  Xo(e);
  var s = e.parent;
  s !== null && s.first !== null && Jo(e), e.next = e.prev = e.teardown = e.ctx = e.deps = e.fn = e.nodes_start = e.nodes_end = null;
}
function Jo(e) {
  var r = e.parent, t = e.prev, a = e.next;
  t !== null && (t.next = a), a !== null && (a.prev = t), r !== null && (r.first === e && (r.first = a), r.last === e && (r.last = t));
}
function Rr(e, r) {
  var t = [];
  pn(e, t, !0), Qo(t, () => {
    Ve(e), r && r();
  });
}
function Qo(e, r) {
  var t = e.length;
  if (t > 0) {
    var a = () => --t || r();
    for (var n of e)
      n.out(a);
  } else
    r();
}
function pn(e, r, t) {
  if ((e.f & cr) === 0) {
    if (e.f ^= cr, e.transitions !== null)
      for (const i of e.transitions)
        (i.is_global || t) && r.push(i);
    for (var a = e.first; a !== null; ) {
      var n = a.next, o = (a.f & zr) !== 0 || (a.f & Ke) !== 0;
      pn(a, r, o ? t : !1), a = n;
    }
  }
}
function Pt(e) {
  $o(e, !0);
}
function $o(e, r) {
  if ((e.f & cr) !== 0) {
    dt(e) && jt(e), e.f ^= cr;
    for (var t = e.first; t !== null; ) {
      var a = t.next, n = (t.f & zr) !== 0 || (t.f & Ke) !== 0;
      $o(t, n ? r : !1), t = a;
    }
    if (e.transitions !== null)
      for (const o of e.transitions)
        (o.is_global || r) && o.in();
  }
}
let La = !1, Ba = [];
function gl() {
  La = !1;
  const e = Ba.slice();
  Ba = [], Na(e);
}
function Hr(e) {
  La || (La = !0, queueMicrotask(gl)), Ba.push(e);
}
function _n(e) {
  throw new Error("https://svelte.dev/e/lifecycle_outside_component");
}
let ht = !1, Jt = !1, Qt = null, rt = !1, gn = !1;
function Jn(e) {
  rt = e;
}
function Qn(e) {
  gn = e;
}
let Ra = [], vt = 0;
let le = null;
function He(e) {
  le = e;
}
let Z = null;
function qe(e) {
  Z = e;
}
let dr = null;
function ml(e) {
  dr = e;
}
let Se = null, Me = 0, Tr = null;
function fl(e) {
  Tr = e;
}
let ei = 1, Ua = 0, Or = !1, $ = null;
function $n(e) {
  $ = e;
}
function ri() {
  return ++ei;
}
function mn() {
  return !lt || $ !== null && $.l === null;
}
function dt(e) {
  var c;
  var r = e.f;
  if ((r & qr) !== 0)
    return !0;
  if ((r & Dt) !== 0) {
    var t = e.deps, a = (r & Vr) !== 0;
    if (t !== null) {
      var n, o, i = (r & Kt) !== 0, s = a && Z !== null && !Or, l = t.length;
      if (i || s) {
        for (n = 0; n < l; n++)
          o = t[n], (i || !((c = o == null ? void 0 : o.reactions) != null && c.includes(e))) && (o.reactions ?? (o.reactions = [])).push(e);
        i && (e.f ^= Kt);
      }
      for (n = 0; n < l; n++)
        if (o = t[n], dt(
          /** @type {Derived} */
          o
        ) && Wo(
          /** @type {Derived} */
          o
        ), o.wv > e.wv)
          return !0;
    }
    (!a || Z !== null && !Or) && Je(e, Ie);
  }
  return !1;
}
function yl(e, r) {
  for (var t = r; t !== null; ) {
    if ((t.f & Zt) !== 0)
      try {
        t.fn(e);
        return;
      } catch {
        t.f ^= Zt;
      }
    t = t.parent;
  }
  throw ht = !1, e;
}
function bl(e) {
  return (e.f & st) === 0 && (e.parent === null || (e.parent.f & Zt) === 0);
}
function Ta() {
  ht = !1;
}
function Mt(e, r, t, a) {
  if (ht) {
    if (t === null && (ht = !1), bl(r))
      throw e;
    return;
  }
  t !== null && (ht = !0);
  {
    yl(e, r);
    return;
  }
}
function ti(e) {
  var _;
  var r = Se, t = Me, a = Tr, n = le, o = Or, i = dr, s = $, l = e.f;
  Se = /** @type {null | Value[]} */
  null, Me = 0, Tr = null, le = (l & (Ke | zt)) === 0 ? e : null, Or = !rt && (l & Vr) !== 0, dr = null, $ = e.ctx, Ua++;
  try {
    var c = (
      /** @type {Function} */
      (0, e.fn)()
    ), p = e.deps;
    if (Se !== null) {
      var u;
      if (St(e, Me), p !== null && Me > 0)
        for (p.length = Me + Se.length, u = 0; u < Se.length; u++)
          p[Me + u] = Se[u];
      else
        e.deps = p = Se;
      if (!Or)
        for (u = Me; u < p.length; u++)
          ((_ = p[u]).reactions ?? (_.reactions = [])).push(e);
    } else p !== null && Me < p.length && (St(e, Me), p.length = Me);
    return c;
  } finally {
    Se = r, Me = t, Tr = a, le = n, Or = o, dr = i, $ = s;
  }
}
function hl(e, r) {
  let t = r.reactions;
  if (t !== null) {
    var a = Rs.call(t, e);
    if (a !== -1) {
      var n = t.length - 1;
      n === 0 ? t = r.reactions = null : (t[a] = t[n], t.pop());
    }
  }
  t === null && (r.f & Ze) !== 0 && // Destroying a child effect while updating a parent effect can cause a dependency to appear
  // to be unused, when in fact it is used by the currently-updating parent. Checking `new_deps`
  // allows us to skip the expensive work of disconnecting and immediately reconnecting it
  (Se === null || !Se.includes(r)) && (Je(r, Dt), (r.f & (Vr | Kt)) === 0 && (r.f ^= Kt), St(
    /** @type {Derived} **/
    r,
    0
  ));
}
function St(e, r) {
  var t = e.deps;
  if (t !== null)
    for (var a = r; a < t.length; a++)
      hl(e, t[a]);
}
function jt(e) {
  var r = e.f;
  if ((r & st) === 0) {
    Je(e, Ie);
    var t = Z, a = $;
    Z = e;
    try {
      (r & _a) !== 0 ? _l(e) : Ko(e), Zo(e), Xo(e);
      var n = ti(e);
      e.teardown = typeof n == "function" ? n : null, e.wv = ei;
      var o = e.deps, i;
      Gn && nl && e.f & qr;
    } catch (s) {
      Mt(s, e, t, a || e.ctx);
    } finally {
      Z = t;
    }
  }
}
function vl() {
  if (vt > 1e3) {
    vt = 0;
    try {
      Qs();
    } catch (e) {
      if (Qt !== null)
        Mt(e, Qt, null);
      else
        throw e;
    }
  }
  vt++;
}
function kl(e) {
  var r = e.length;
  if (r !== 0) {
    vl();
    var t = rt;
    rt = !0;
    try {
      for (var a = 0; a < r; a++) {
        var n = e[a];
        (n.f & Ie) === 0 && (n.f ^= Ie);
        var o = [];
        ai(n, o), wl(o);
      }
    } finally {
      rt = t;
    }
  }
}
function wl(e) {
  var r = e.length;
  if (r !== 0)
    for (var t = 0; t < r; t++) {
      var a = e[t];
      if ((a.f & (st | cr)) === 0)
        try {
          dt(a) && (jt(a), a.deps === null && a.first === null && a.nodes_start === null && (a.teardown === null ? Jo(a) : a.fn = null));
        } catch (n) {
          Mt(n, a, null, a.ctx);
        }
    }
}
function xl() {
  if (Jt = !1, vt > 1001)
    return;
  const e = Ra;
  Ra = [], kl(e), Jt || (vt = 0, Qt = null);
}
function ba(e) {
  Jt || (Jt = !0, queueMicrotask(xl)), Qt = e;
  for (var r = e; r.parent !== null; ) {
    r = r.parent;
    var t = r.f;
    if ((t & (zt | Ke)) !== 0) {
      if ((t & Ie) === 0) return;
      r.f ^= Ie;
    }
  }
  Ra.push(r);
}
function ai(e, r) {
  var t = e.first, a = [];
  e: for (; t !== null; ) {
    var n = t.f, o = (n & Ke) !== 0, i = o && (n & Ie) !== 0, s = t.next;
    if (!i && (n & cr) === 0)
      if ((n & Ft) !== 0) {
        if (o)
          t.f ^= Ie;
        else
          try {
            dt(t) && jt(t);
          } catch (u) {
            Mt(u, t, null, t.ctx);
          }
        var l = t.first;
        if (l !== null) {
          t = l;
          continue;
        }
      } else (n & Ao) !== 0 && a.push(t);
    if (s === null) {
      let u = t.parent;
      for (; u !== null; ) {
        if (e === u)
          break e;
        var c = u.next;
        if (c !== null) {
          t = c;
          continue e;
        }
        u = u.parent;
      }
    }
    t = s;
  }
  for (var p = 0; p < a.length; p++)
    l = a[p], r.push(l), ai(l, r);
}
function d(e) {
  var p;
  var r = e.f, t = (r & Ze) !== 0;
  if (t && (r & st) !== 0) {
    var a = Ho(
      /** @type {Derived} */
      e
    );
    return un(
      /** @type {Derived} */
      e
    ), a;
  }
  if (le !== null) {
    dr !== null && dr.includes(e) && tl();
    var n = le.deps;
    e.rv < Ua && (e.rv = Ua, Se === null && n !== null && n[Me] === e ? Me++ : Se === null ? Se = [e] : Se.push(e), Tr !== null && Z !== null && (Z.f & Ie) !== 0 && (Z.f & Ke) === 0 && Tr.includes(e) && (Je(Z, qr), ba(Z)));
  } else if (t && /** @type {Derived} */
  e.deps === null)
    for (var o = (
      /** @type {Derived} */
      e
    ), i = o.parent, s = o; i !== null; )
      if ((i.f & Ze) !== 0) {
        var l = (
          /** @type {Derived} */
          i
        );
        s = l, i = l.parent;
      } else {
        var c = (
          /** @type {Effect} */
          i
        );
        (p = c.deriveds) != null && p.includes(s) || (c.deriveds ?? (c.deriveds = [])).push(s);
        break;
      }
  return t && (o = /** @type {Derived} */
  e, dt(o) && Wo(o)), e.v;
}
function br(e) {
  const r = le;
  try {
    return le = null, e();
  } finally {
    le = r;
  }
}
const Pl = -7169;
function Je(e, r) {
  e.f = e.f & Pl | r;
}
function Ee(e) {
  return (
    /** @type {T} */
    ni().get(e)
  );
}
function Ia(e, r) {
  return ni().set(e, r), r;
}
function ni(e) {
  return $ === null && _n(), $.c ?? ($.c = new Map(Sl($) || void 0));
}
function Sl(e) {
  let r = e.p;
  for (; r !== null; ) {
    const t = r.c;
    if (t !== null)
      return t;
    r = r.p;
  }
  return null;
}
function V(e, r = !1, t) {
  $ = {
    p: $,
    c: null,
    e: null,
    m: !1,
    s: e,
    x: null,
    l: null
  }, lt && !r && ($.l = {
    s: null,
    u: null,
    r1: [],
    r2: je(!1)
  });
}
function H(e) {
  const r = $;
  if (r !== null) {
    e !== void 0 && (r.x = e);
    const i = r.e;
    if (i !== null) {
      var t = Z, a = le;
      r.e = null;
      try {
        for (var n = 0; n < i.length; n++) {
          var o = i[n];
          qe(o.effect), He(o.reaction), fa(o.fn);
        }
      } finally {
        qe(t), He(a);
      }
    }
    $ = r.p, r.m = !0;
  }
  return e || /** @type {T} */
  {};
}
function Va(e) {
  if (!(typeof e != "object" || !e || e instanceof EventTarget)) {
    if (Er in e)
      Ha(e);
    else if (!Array.isArray(e))
      for (let r in e) {
        const t = e[r];
        typeof t == "object" && t && Er in t && Ha(t);
      }
  }
}
function Ha(e, r = /* @__PURE__ */ new Set()) {
  if (typeof e == "object" && e !== null && // We don't want to traverse DOM elements
  !(e instanceof EventTarget) && !r.has(e)) {
    r.add(e), e instanceof Date && e.getTime();
    for (let a in e)
      try {
        Ha(e[a], r);
      } catch {
      }
    const t = ln(e);
    if (t !== Object.prototype && t !== Array.prototype && t !== Map.prototype && t !== Set.prototype && t !== Date.prototype) {
      const a = Do(t);
      for (let n in a) {
        const o = a[n].get;
        if (o)
          try {
            o.call(e);
          } catch {
          }
      }
    }
  }
}
function El(e, r) {
  if (r) {
    const t = document.body;
    e.autofocus = !0, Hr(() => {
      document.activeElement === t && e.focus();
    });
  }
}
function Tl(e) {
  var r = le, t = Z;
  He(null), qe(null);
  try {
    return e();
  } finally {
    He(r), qe(t);
  }
}
const oi = /* @__PURE__ */ new Set(), Wa = /* @__PURE__ */ new Set();
function ii(e, r, t, a) {
  function n(o) {
    if (a.capture || ft.call(r, o), !o.cancelBubble)
      return Tl(() => t.call(this, o));
  }
  return e.startsWith("pointer") || e.startsWith("touch") || e === "wheel" ? Hr(() => {
    r.addEventListener(e, n, a);
  }) : r.addEventListener(e, n, a), n;
}
function nt(e, r, t, a, n) {
  var o = { capture: a, passive: n }, i = ii(e, r, t, o);
  (r === document.body || r === window || r === document) && Go(() => {
    r.removeEventListener(e, i, o);
  });
}
function ha(e) {
  for (var r = 0; r < e.length; r++)
    oi.add(e[r]);
  for (var t of Wa)
    t(e);
}
function ft(e) {
  var y;
  var r = this, t = (
    /** @type {Node} */
    r.ownerDocument
  ), a = e.type, n = ((y = e.composedPath) == null ? void 0 : y.call(e)) || [], o = (
    /** @type {null | Element} */
    n[0] || e.target
  ), i = 0, s = e.__root;
  if (s) {
    var l = n.indexOf(s);
    if (l !== -1 && (r === document || r === /** @type {any} */
    window)) {
      e.__root = r;
      return;
    }
    var c = n.indexOf(r);
    if (c === -1)
      return;
    l <= c && (i = l);
  }
  if (o = /** @type {Element} */
  n[i] || e.target, o !== r) {
    Us(e, "currentTarget", {
      configurable: !0,
      get() {
        return o || t;
      }
    });
    var p = le, u = Z;
    He(null), qe(null);
    try {
      for (var _, g = []; o !== null; ) {
        var m = o.assignedSlot || o.parentNode || /** @type {any} */
        o.host || null;
        try {
          var f = o["__" + a];
          if (f !== void 0 && !/** @type {any} */
          o.disabled)
            if (pa(f)) {
              var [h, ...v] = f;
              h.apply(o, [e, ...v]);
            } else
              f.call(o, e);
        } catch (x) {
          _ ? g.push(x) : _ = x;
        }
        if (e.cancelBubble || m === r || m === null)
          break;
        o = m;
      }
      if (_) {
        for (let x of g)
          queueMicrotask(() => {
            throw x;
          });
        throw _;
      }
    } finally {
      e.__root = r, delete e.currentTarget, He(p), qe(u);
    }
  }
}
function fn(e) {
  var r = document.createElement("template");
  return r.innerHTML = e, r.content;
}
function Ur(e, r) {
  var t = (
    /** @type {Effect} */
    Z
  );
  t.nodes_start === null && (t.nodes_start = e, t.nodes_end = r);
}
// @__NO_SIDE_EFFECTS__
function I(e, r) {
  var t = (r & Ds) !== 0, a = (r & As) !== 0, n, o = !e.startsWith("<!>");
  return () => {
    n === void 0 && (n = fn(o ? e : "<!>" + e), t || (n = /** @type {Node} */
    /* @__PURE__ */ Br(n)));
    var i = (
      /** @type {TemplateNode} */
      a ? document.importNode(n, !0) : n.cloneNode(!0)
    );
    if (t) {
      var s = (
        /** @type {TemplateNode} */
        /* @__PURE__ */ Br(i)
      ), l = (
        /** @type {TemplateNode} */
        i.lastChild
      );
      Ur(s, l);
    } else
      Ur(i, i);
    return i;
  };
}
// @__NO_SIDE_EFFECTS__
function pr(e, r, t = "svg") {
  var a = !e.startsWith("<!>"), n = `<${t}>${a ? e : "<!>" + e}</${t}>`, o;
  return () => {
    if (!o) {
      var i = (
        /** @type {DocumentFragment} */
        fn(n)
      ), s = (
        /** @type {Element} */
        /* @__PURE__ */ Br(i)
      );
      o = /** @type {Element} */
      /* @__PURE__ */ Br(s);
    }
    var l = (
      /** @type {TemplateNode} */
      o.cloneNode(!0)
    );
    return Ur(l, l), l;
  };
}
function ie(e = "") {
  {
    var r = At(e + "");
    return Ur(r, r), r;
  }
}
function ee() {
  var e = document.createDocumentFragment(), r = document.createComment(""), t = At();
  return e.append(r, t), Ur(r, t), e;
}
function b(e, r) {
  e !== null && e.before(
    /** @type {Node} */
    r
  );
}
let $t = !0;
function eo(e) {
  $t = e;
}
function te(e, r) {
  var t = r == null ? "" : typeof r == "object" ? r + "" : r;
  t !== (e.__t ?? (e.__t = e.nodeValue)) && (e.__t = t, e.nodeValue = t == null ? "" : t + "");
}
function ro(e, r) {
  return Il(e, r);
}
const Xr = /* @__PURE__ */ new Map();
function Il(e, { target: r, anchor: t, props: a = {}, events: n, context: o, intro: i = !0 }) {
  il();
  var s = /* @__PURE__ */ new Set(), l = (u) => {
    for (var _ = 0; _ < u.length; _++) {
      var g = u[_];
      if (!s.has(g)) {
        s.add(g);
        var m = Bs(g);
        r.addEventListener(g, ft, { passive: m });
        var f = Xr.get(g);
        f === void 0 ? (document.addEventListener(g, ft, { passive: m }), Xr.set(g, 1)) : Xr.set(g, f + 1);
      }
    }
  };
  l(sn(oi)), Wa.add(l);
  var c = void 0, p = ul(() => {
    var u = t ?? r.appendChild(At());
    return Ue(() => {
      if (o) {
        V({});
        var _ = (
          /** @type {ComponentContext} */
          $
        );
        _.c = o;
      }
      n && (a.$$events = n), $t = i, c = e(u, a) || {}, $t = !0, o && H();
    }), () => {
      var m;
      for (var _ of s) {
        r.removeEventListener(_, ft);
        var g = (
          /** @type {number} */
          Xr.get(_)
        );
        --g === 0 ? (document.removeEventListener(_, ft), Xr.delete(_)) : Xr.set(_, g);
      }
      Wa.delete(l), u !== t && ((m = u.parentNode) == null || m.removeChild(u));
    };
  });
  return Ya.set(c, p), c;
}
let Ya = /* @__PURE__ */ new WeakMap();
function qa(e, r) {
  const t = Ya.get(e);
  return t ? (Ya.delete(e), t(r)) : Promise.resolve();
}
function N(e, r, t = !1) {
  var a = e, n = null, o = null, i = Te, s = t ? zr : 0, l = !1;
  const c = (u, _ = !0) => {
    l = !0, p(_, u);
  }, p = (u, _) => {
    i !== (i = u) && (i ? (n ? Pt(n) : _ && (n = Ue(() => _(a))), o && Rr(o, () => {
      o = null;
    })) : (o ? Pt(o) : _ && (o = Ue(() => _(a))), n && Rr(n, () => {
      n = null;
    })));
  };
  Dr(() => {
    l = !1, r(c), l || p(null, null);
  }, s);
}
function ot(e, r) {
  return r;
}
function ql(e, r, t, a) {
  for (var n = [], o = r.length, i = 0; i < o; i++)
    pn(r[i].e, n, !0);
  var s = o > 0 && n.length === 0 && t !== null;
  if (s) {
    var l = (
      /** @type {Element} */
      /** @type {Element} */
      t.parentNode
    );
    sl(l), l.append(
      /** @type {Element} */
      t
    ), a.clear(), Pr(e, r[0].prev, r[o - 1].next);
  }
  Qo(n, () => {
    for (var c = 0; c < o; c++) {
      var p = r[c];
      s || (a.delete(p.k), Pr(e, p.prev, p.next)), Ve(p.e, !s);
    }
  });
}
function it(e, r, t, a, n, o = null) {
  var i = e, s = { flags: r, items: /* @__PURE__ */ new Map(), first: null }, l = (r & zo) !== 0;
  if (l) {
    var c = (
      /** @type {Element} */
      e
    );
    i = c.appendChild(At());
  }
  var p = null, u = !1;
  Dr(() => {
    var _ = t(), g = pa(_) ? _ : _ == null ? [] : sn(_), m = g.length;
    if (!(u && m === 0)) {
      u = m === 0;
      {
        var f = (
          /** @type {Effect} */
          le
        );
        Fl(
          g,
          s,
          i,
          n,
          r,
          (f.f & cr) !== 0,
          a
        );
      }
      o !== null && (m === 0 ? p ? Pt(p) : p = Ue(() => o(i)) : p !== null && Rr(p, () => {
        p = null;
      })), t();
    }
  });
}
function Fl(e, r, t, a, n, o, i, s) {
  var re, pe, me, ce;
  var l = (n & ws) !== 0, c = (n & (nn | on)) !== 0, p = e.length, u = r.items, _ = r.first, g = _, m, f = null, h, v = [], y = [], x, T, S, z;
  if (l)
    for (z = 0; z < p; z += 1)
      x = e[z], T = i(x, z), S = u.get(T), S !== void 0 && ((re = S.a) == null || re.measure(), (h ?? (h = /* @__PURE__ */ new Set())).add(S));
  for (z = 0; z < p; z += 1) {
    if (x = e[z], T = i(x, z), S = u.get(T), S === void 0) {
      var C = g ? (
        /** @type {TemplateNode} */
        g.e.nodes_start
      ) : t;
      f = Dl(
        C,
        r,
        f,
        f === null ? r.first : f.next,
        x,
        T,
        z,
        a,
        n
      ), u.set(T, f), v = [], y = [], g = f.next;
      continue;
    }
    if (c && zl(S, x, z, n), (S.e.f & cr) !== 0 && (Pt(S.e), l && ((pe = S.a) == null || pe.unfix(), (h ?? (h = /* @__PURE__ */ new Set())).delete(S))), S !== g) {
      if (m !== void 0 && m.has(S)) {
        if (v.length < y.length) {
          var k = y[0], w;
          f = k.prev;
          var q = v[0], G = v[v.length - 1];
          for (w = 0; w < v.length; w += 1)
            to(v[w], k, t);
          for (w = 0; w < y.length; w += 1)
            m.delete(y[w]);
          Pr(r, q.prev, G.next), Pr(r, f, q), Pr(r, G, k), g = k, f = G, z -= 1, v = [], y = [];
        } else
          m.delete(S), to(S, g, t), Pr(r, S.prev, S.next), Pr(r, S, f === null ? r.first : f.next), Pr(r, f, S), f = S;
        continue;
      }
      for (v = [], y = []; g !== null && g.k !== T; )
        (o || (g.e.f & cr) === 0) && (m ?? (m = /* @__PURE__ */ new Set())).add(g), y.push(g), g = g.next;
      if (g === null)
        continue;
      S = g;
    }
    v.push(S), f = S, g = S.next;
  }
  if (g !== null || m !== void 0) {
    for (var W = m === void 0 ? [] : sn(m); g !== null; )
      (o || (g.e.f & cr) === 0) && W.push(g), g = g.next;
    var ae = W.length;
    if (ae > 0) {
      var J = (n & zo) !== 0 && p === 0 ? t : null;
      if (l) {
        for (z = 0; z < ae; z += 1)
          (me = W[z].a) == null || me.measure();
        for (z = 0; z < ae; z += 1)
          (ce = W[z].a) == null || ce.fix();
      }
      ql(r, W, J, u);
    }
  }
  l && Hr(() => {
    var ke;
    if (h !== void 0)
      for (S of h)
        (ke = S.a) == null || ke.apply();
  }), Z.first = r.first && r.first.e, Z.last = f && f.e;
}
function zl(e, r, t, a) {
  (a & nn) !== 0 && Oa(e.v, r), (a & on) !== 0 ? Oa(
    /** @type {Value<number>} */
    e.i,
    t
  ) : e.i = t;
}
function Dl(e, r, t, a, n, o, i, s, l, c) {
  var p = (l & nn) !== 0, u = (l & xs) === 0, _ = p ? u ? /* @__PURE__ */ ga(n) : je(n) : n, g = (l & on) === 0 ? i : je(i), m = {
    i: g,
    v: _,
    k: o,
    a: null,
    // @ts-expect-error
    e: null,
    prev: t,
    next: a
  };
  try {
    return m.e = Ue(() => s(e, _, g), dn), m.e.prev = t && t.e, m.e.next = a && a.e, t === null ? r.first = m : (t.next = m, t.e.next = m.e), a !== null && (a.prev = m, a.e.prev = m.e), m;
  } finally {
  }
}
function to(e, r, t) {
  for (var a = e.next ? (
    /** @type {TemplateNode} */
    e.next.e.nodes_start
  ) : t, n = r ? (
    /** @type {TemplateNode} */
    r.e.nodes_start
  ) : t, o = (
    /** @type {TemplateNode} */
    e.e.nodes_start
  ); o !== a; ) {
    var i = (
      /** @type {TemplateNode} */
      /* @__PURE__ */ ma(o)
    );
    n.before(o), o = i;
  }
}
function Pr(e, r, t) {
  r === null ? e.first = t : (r.next = t, r.e.next = t && t.e), t !== null && (t.prev = r, t.e.prev = r && r.e);
}
function Wr(e, r, t, a, n) {
  var o = e, i = "", s;
  Dr(() => {
    i !== (i = r() ?? "") && (s !== void 0 && (Ve(s), s = void 0), i !== "" && (s = Ue(() => {
      var l = i + "", c = fn(l);
      Ur(
        /** @type {TemplateNode} */
        /* @__PURE__ */ Br(c),
        /** @type {TemplateNode} */
        c.lastChild
      ), o.before(c);
    })));
  });
}
function Al(e, r, t, a, n) {
  var s;
  var o = (s = r.$$slots) == null ? void 0 : s[t], i = !1;
  o === !0 && (o = r.children, i = !0), o === void 0 || o(e, i ? () => a : a);
}
function ge(e, r, ...t) {
  var a = e, n = ne, o;
  Dr(() => {
    n !== (n = r()) && (o && (Ve(o), o = null), o = Ue(() => (
      /** @type {SnippetFn} */
      n(a, ...t)
    )));
  }, zr);
}
function Ml(e, r, t) {
  var a = e, n, o;
  Dr(() => {
    n !== (n = r()) && (o && (Rr(o), o = null), n && (o = Ue(() => t(a, n))));
  }, zr);
}
function ea(e, r, t, a, n, o) {
  var i, s, l = null, c = (
    /** @type {TemplateNode} */
    e
  ), p;
  Dr(() => {
    const u = r() || null;
    var _ = u === "svg" ? xt : null;
    u !== i && (p && (u === null ? Rr(p, () => {
      p = null, s = null;
    }) : u === s ? Pt(p) : (Ve(p), eo(!1))), u && u !== s && (p = Ue(() => {
      if (l = _ ? document.createElementNS(_, u) : document.createElement(u), Ur(l, l), a) {
        var g = (
          /** @type {TemplateNode} */
          l.appendChild(At())
        );
        a(l, g);
      }
      Z.nodes_end = l, c.before(l);
    })), i = u, i && (s = i), eo(!0));
  }, zr);
}
function R(e, r) {
  Hr(() => {
    var t = e.getRootNode(), a = (
      /** @type {ShadowRoot} */
      t.host ? (
        /** @type {ShadowRoot} */
        t
      ) : (
        /** @type {Document} */
        t.head ?? /** @type {Document} */
        t.ownerDocument.head
      )
    );
    if (!a.querySelector("#" + r.hash)) {
      const n = document.createElement("style");
      n.id = r.hash, n.textContent = r.code, a.appendChild(n);
    }
  });
}
function si(e) {
  var r, t, a = "";
  if (typeof e == "string" || typeof e == "number") a += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var n = e.length;
    for (r = 0; r < n; r++) e[r] && (t = si(e[r])) && (a && (a += " "), a += t);
  } else for (t in e) e[t] && (a && (a += " "), a += t);
  return a;
}
function jl() {
  for (var e, r, t = 0, a = "", n = arguments.length; t < n; t++) (e = arguments[t]) && (r = si(e)) && (a && (a += " "), a += r);
  return a;
}
function li(e) {
  return typeof e == "object" ? jl(e) : e ?? "";
}
function Nl(e, r) {
  r ? e.hasAttribute("selected") || e.setAttribute("selected", "") : e.removeAttribute("selected");
}
function j(e, r, t, a) {
  var n = e.__attributes ?? (e.__attributes = {});
  n[r] !== (n[r] = t) && (r === "style" && "__styles" in e && (e.__styles = {}), r === "loading" && (e[Xs] = t), t == null ? e.removeAttribute(r) : typeof t != "string" && ci(e).includes(r) ? e[r] = t : e.setAttribute(r, t));
}
function ra(e, r, t, a, n = !1, o = !1, i = !1) {
  var s = r || {}, l = e.tagName === "OPTION";
  for (var c in r)
    c in t || (t[c] = null);
  t.class && (t.class = li(t.class)), a !== void 0 && (t.class = t.class ? t.class + " " + a : a);
  var p = ci(e), u = (
    /** @type {Record<string, unknown>} **/
    e.__attributes ?? (e.__attributes = {})
  );
  for (const v in t) {
    let y = t[v];
    if (l && v === "value" && y == null) {
      e.value = e.__value = "", s[v] = y;
      continue;
    }
    var _ = s[v];
    if (y !== _) {
      s[v] = y;
      var g = v[0] + v[1];
      if (g !== "$$") {
        if (g === "on") {
          const x = {}, T = "$$" + v;
          let S = v.slice(2);
          var m = Ns(S);
          if (Ms(S) && (S = S.slice(0, -7), x.capture = !0), !m && _) {
            if (y != null) continue;
            e.removeEventListener(S, s[T], x), s[T] = null;
          }
          if (y != null)
            if (m)
              e[`__${S}`] = y, ha([S]);
            else {
              let z = function(C) {
                s[v].call(this, C);
              };
              s[T] = ii(S, e, z, x);
            }
          else m && (e[`__${S}`] = void 0);
        } else if (v === "style" && y != null)
          e.style.cssText = y + "";
        else if (v === "autofocus")
          El(
            /** @type {HTMLElement} */
            e,
            !!y
          );
        else if (v === "__value" || v === "value" && y != null)
          e.value = e[v] = e.__value = y;
        else if (v === "selected" && l)
          Nl(
            /** @type {HTMLOptionElement} */
            e,
            y
          );
        else {
          var f = v;
          n || (f = Os(f));
          var h = f === "defaultValue" || f === "defaultChecked";
          if (y == null && !o && !h)
            if (u[v] = null, f === "value" || f === "checked") {
              let x = (
                /** @type {HTMLInputElement} */
                e
              );
              if (f === "value") {
                let T = x.defaultValue;
                x.removeAttribute(f), x.defaultValue = T;
              } else {
                let T = x.defaultChecked;
                x.removeAttribute(f), x.defaultChecked = T;
              }
            } else
              e.removeAttribute(v);
          else h || p.includes(f) && (o || typeof y != "string") ? e[f] = y : typeof y != "function" && j(e, f, y);
        }
        v === "style" && "__styles" in e && (e.__styles = {});
      }
    }
  }
  return s;
}
var ao = /* @__PURE__ */ new Map();
function ci(e) {
  var r = ao.get(e.nodeName);
  if (r) return r;
  ao.set(e.nodeName, r = []);
  for (var t, a = e, n = Element.prototype; n !== a; ) {
    t = Do(a);
    for (var o in t)
      t[o].set && r.push(o);
    a = ln(a);
  }
  return r;
}
function Cl(e, r, t) {
  var a = e.__className, n = di(r, t);
  (a !== n || dn) && (n === "" ? e.removeAttribute("class") : e.setAttribute("class", n), e.__className = n);
}
function Fr(e, r, t) {
  var a = e.__className, n = di(r, t);
  (a !== n || dn) && (r == null && !t ? e.removeAttribute("class") : e.className = n, e.__className = n);
}
function di(e, r) {
  return (e ?? "") + (r ? " " + r : "");
}
function fr(e, r, t) {
  if (t) {
    if (e.classList.contains(r)) return;
    e.classList.add(r);
  } else {
    if (!e.classList.contains(r)) return;
    e.classList.remove(r);
  }
}
const Ol = () => performance.now(), mr = {
  // don't access requestAnimationFrame eagerly outside method
  // this allows basic testing of user code without JSDOM
  // bunder will eval and remove ternary when the user's app is built
  tick: (
    /** @param {any} _ */
    (e) => requestAnimationFrame(e)
  ),
  now: () => Ol(),
  tasks: /* @__PURE__ */ new Set()
};
function ui() {
  const e = mr.now();
  mr.tasks.forEach((r) => {
    r.c(e) || (mr.tasks.delete(r), r.f());
  }), mr.tasks.size !== 0 && mr.tick(ui);
}
function Ll(e) {
  let r;
  return mr.tasks.size === 0 && mr.tick(ui), {
    promise: new Promise((t) => {
      mr.tasks.add(r = { c: e, f: t });
    }),
    abort() {
      mr.tasks.delete(r);
    }
  };
}
function Ht(e, r) {
  e.dispatchEvent(new CustomEvent(r));
}
function Bl(e) {
  if (e === "float") return "cssFloat";
  if (e === "offset") return "cssOffset";
  if (e.startsWith("--")) return e;
  const r = e.split("-");
  return r.length === 1 ? r[0] : r[0] + r.slice(1).map(
    /** @param {any} word */
    (t) => t[0].toUpperCase() + t.slice(1)
  ).join("");
}
function no(e) {
  const r = {}, t = e.split(";");
  for (const a of t) {
    const [n, o] = a.split(":");
    if (!n || o === void 0) break;
    const i = Bl(n.trim());
    r[i] = o.trim();
  }
  return r;
}
const Rl = (e) => e;
function pi(e, r, t, a) {
  var n = (e & qs) !== 0, o = (e & Fs) !== 0, i = n && o, s = (e & zs) !== 0, l = i ? "both" : n ? "in" : "out", c, p = r.inert, u, _;
  function g() {
    var y = le, x = Z;
    He(null), qe(null);
    try {
      return c ?? (c = t()(r, (a == null ? void 0 : a()) ?? /** @type {P} */
      {}, {
        direction: l
      }));
    } finally {
      He(y), qe(x);
    }
  }
  var m = {
    is_global: s,
    in() {
      var y;
      if (r.inert = p, !n) {
        _ == null || _.abort(), (y = _ == null ? void 0 : _.reset) == null || y.call(_);
        return;
      }
      o || u == null || u.abort(), Ht(r, "introstart"), u = Ga(r, g(), _, 1, () => {
        Ht(r, "introend"), u == null || u.abort(), u = c = void 0;
      });
    },
    out(y) {
      if (!o) {
        y == null || y(), c = void 0;
        return;
      }
      r.inert = !0, Ht(r, "outrostart"), _ = Ga(r, g(), u, 0, () => {
        Ht(r, "outroend"), y == null || y();
      });
    },
    stop: () => {
      u == null || u.abort(), _ == null || _.abort();
    }
  }, f = (
    /** @type {Effect} */
    Z
  );
  if ((f.transitions ?? (f.transitions = [])).push(m), n && $t) {
    var h = s;
    if (!h) {
      for (var v = (
        /** @type {Effect | null} */
        f.parent
      ); v && (v.f & zr) !== 0; )
        for (; (v = v.parent) && (v.f & _a) === 0; )
          ;
      h = !v || (v.f & Mo) !== 0;
    }
    h && fa(() => {
      br(() => m.in());
    });
  }
}
function Ga(e, r, t, a, n) {
  var o = a === 1;
  if (Kr(r)) {
    var i, s = !1;
    return Hr(() => {
      if (!s) {
        var h = r({ direction: o ? "in" : "out" });
        i = Ga(e, h, t, a, n);
      }
    }), {
      abort: () => {
        s = !0, i == null || i.abort();
      },
      deactivate: () => i.deactivate(),
      reset: () => i.reset(),
      t: () => i.t()
    };
  }
  if (t == null || t.deactivate(), !(r != null && r.duration))
    return n(), {
      abort: ne,
      deactivate: ne,
      reset: ne,
      t: () => a
    };
  const { delay: l = 0, css: c, tick: p, easing: u = Rl } = r;
  var _ = [];
  if (o && t === void 0 && (p && p(0, 1), c)) {
    var g = no(c(0, 1));
    _.push(g, g);
  }
  var m = () => 1 - a, f = e.animate(_, { duration: l });
  return f.onfinish = () => {
    var h = (t == null ? void 0 : t.t()) ?? 1 - a;
    t == null || t.abort();
    var v = a - h, y = (
      /** @type {number} */
      r.duration * Math.abs(v)
    ), x = [];
    if (y > 0) {
      if (c)
        for (var T = Math.ceil(y / 16.666666666666668), S = 0; S <= T; S += 1) {
          var z = h + v * u(S / T), C = c(z, 1 - z);
          x.push(no(C));
        }
      m = () => {
        var k = (
          /** @type {number} */
          /** @type {globalThis.Animation} */
          f.currentTime
        );
        return h + v * u(k / y);
      }, p && Ll(() => {
        if (f.playState !== "running") return !1;
        var k = m();
        return p(k, 1 - k), !0;
      });
    }
    f = e.animate(x, { duration: y, fill: "forwards" }), f.onfinish = () => {
      m = () => a, p == null || p(a, 1 - a), n();
    };
  }, {
    abort: () => {
      f && (f.cancel(), f.effect = null, f.onfinish = ne);
    },
    deactivate: () => {
      n = ne;
    },
    reset: () => {
      a === 0 && (p == null || p(1, 0));
    },
    t: () => m()
  };
}
function oo(e, r) {
  return e === r || (e == null ? void 0 : e[Er]) === r;
}
function _i(e = {}, r, t, a) {
  return fa(() => {
    var n, o;
    return ya(() => {
      n = o, o = [], br(() => {
        e !== t(...o) && (r(e, ...o), n && oo(t(...n), e) && r(null, ...n));
      });
    }), () => {
      Hr(() => {
        o && oo(t(...o), e) && r(null, ...o);
      });
    };
  }), e;
}
function Qe(e = !1) {
  const r = (
    /** @type {ComponentContextLegacy} */
    $
  ), t = r.l.u;
  if (!t) return;
  let a = () => Va(r.s);
  if (e) {
    let n = 0, o = (
      /** @type {Record<string, any>} */
      {}
    );
    const i = /* @__PURE__ */ E(() => {
      let s = !1;
      const l = r.s;
      for (const c in l)
        l[c] !== o[c] && (o[c] = l[c], s = !0);
      return s && n++, n;
    });
    a = () => d(i);
  }
  t.b.length && dl(() => {
    io(r, a), Na(t.b);
  }), at(() => {
    const n = br(() => t.m.map(Ws));
    return () => {
      for (const o of n)
        typeof o == "function" && o();
    };
  }), t.a.length && at(() => {
    io(r, a), Na(t.a);
  });
}
function io(e, r) {
  if (e.l.s)
    for (const t of e.l.s) d(t);
  r();
}
function gi(e, r) {
  var o;
  var t = (
    /** @type {Record<string, Function[] | Function>} */
    (o = e.$$events) == null ? void 0 : o[r.type]
  ), a = pa(t) ? t.slice() : t == null ? [] : [t];
  for (var n of a)
    n.call(this, r);
}
function We(e) {
  $ === null && _n(), lt && $.l !== null ? Ul($).m.push(e) : at(() => {
    const r = br(e);
    if (typeof r == "function") return (
      /** @type {() => void} */
      r
    );
  });
}
function Nt(e) {
  $ === null && _n(), We(() => () => br(e));
}
function Ul(e) {
  var r = (
    /** @type {ComponentContextLegacy} */
    e.l
  );
  return r.u ?? (r.u = { a: [], b: [], m: [] });
}
function Vl(e, r, t) {
  if (e == null)
    return r(void 0), ne;
  const a = br(
    () => e.subscribe(
      r,
      // @ts-expect-error
      t
    )
  );
  return a.unsubscribe ? () => a.unsubscribe() : a;
}
let Wt = !1;
function ze(e, r, t) {
  const a = t[r] ?? (t[r] = {
    store: null,
    source: /* @__PURE__ */ ga(void 0),
    unsubscribe: ne
  });
  if (a.store !== e)
    if (a.unsubscribe(), a.store = e ?? null, e == null)
      a.source.v = void 0, a.unsubscribe = ne;
    else {
      var n = !0;
      a.unsubscribe = Vl(e, (o) => {
        n ? a.source.v = o : D(a.source, o);
      }), n = !1;
    }
  return d(a.source);
}
function De() {
  const e = {};
  return Go(() => {
    for (var r in e)
      e[r].unsubscribe();
  }), e;
}
function Hl(e) {
  var r = Wt;
  try {
    return Wt = !1, [e(), Wt];
  } finally {
    Wt = r;
  }
}
const Wl = {
  get(e, r) {
    if (!e.exclude.includes(r))
      return e.props[r];
  },
  set(e, r) {
    return !1;
  },
  getOwnPropertyDescriptor(e, r) {
    if (!e.exclude.includes(r) && r in e.props)
      return {
        enumerable: !0,
        configurable: !0,
        value: e.props[r]
      };
  },
  has(e, r) {
    return e.exclude.includes(r) ? !1 : r in e.props;
  },
  ownKeys(e) {
    return Reflect.ownKeys(e.props).filter((r) => !e.exclude.includes(r));
  }
};
// @__NO_SIDE_EFFECTS__
function Ar(e, r, t) {
  return new Proxy(
    { props: e, exclude: r },
    Wl
  );
}
const Yl = {
  get(e, r) {
    let t = e.props.length;
    for (; t--; ) {
      let a = e.props[t];
      if (Kr(a) && (a = a()), typeof a == "object" && a !== null && r in a) return a[r];
    }
  },
  set(e, r, t) {
    let a = e.props.length;
    for (; a--; ) {
      let n = e.props[a];
      Kr(n) && (n = n());
      const o = Sr(n, r);
      if (o && o.set)
        return o.set(t), !0;
    }
    return !1;
  },
  getOwnPropertyDescriptor(e, r) {
    let t = e.props.length;
    for (; t--; ) {
      let a = e.props[t];
      if (Kr(a) && (a = a()), typeof a == "object" && a !== null && r in a) {
        const n = Sr(a, r);
        return n && !n.configurable && (n.configurable = !0), n;
      }
    }
  },
  has(e, r) {
    if (r === Er || r === No) return !1;
    for (let t of e.props)
      if (Kr(t) && (t = t()), t != null && r in t) return !0;
    return !1;
  },
  ownKeys(e) {
    const r = [];
    for (let t of e.props) {
      Kr(t) && (t = t());
      for (const a in t)
        r.includes(a) || r.push(a);
    }
    return r;
  }
};
function hr(...e) {
  return new Proxy({ props: e }, Yl);
}
function so(e) {
  for (var r = Z, t = Z; r !== null && (r.f & (Ke | zt)) === 0; )
    r = r.parent;
  try {
    return qe(r), e();
  } finally {
    qe(t);
  }
}
function U(e, r, t, a) {
  var C;
  var n = (t & Ps) !== 0, o = !lt || (t & Ss) !== 0, i = (t & Ts) !== 0, s = (t & Is) !== 0, l = !1, c;
  i ? [c, l] = Hl(() => (
    /** @type {V} */
    e[r]
  )) : c = /** @type {V} */
  e[r];
  var p = Er in e || No in e, u = ((C = Sr(e, r)) == null ? void 0 : C.set) ?? (p && i && r in e ? (k) => e[r] = k : void 0), _ = (
    /** @type {V} */
    a
  ), g = !0, m = !1, f = () => (m = !0, g && (g = !1, s ? _ = br(
    /** @type {() => V} */
    a
  ) : _ = /** @type {V} */
  a), _);
  c === void 0 && a !== void 0 && (u && o && $s(), c = f(), u && u(c));
  var h;
  if (o)
    h = () => {
      var k = (
        /** @type {V} */
        e[r]
      );
      return k === void 0 ? f() : (g = !0, m = !1, k);
    };
  else {
    var v = so(
      () => (n ? E : et)(() => (
        /** @type {V} */
        e[r]
      ))
    );
    v.f |= Ys, h = () => {
      var k = d(v);
      return k !== void 0 && (_ = /** @type {V} */
      void 0), k === void 0 ? _ : k;
    };
  }
  if ((t & Es) === 0)
    return h;
  if (u) {
    var y = e.$$legacy;
    return function(k, w) {
      return arguments.length > 0 ? ((!o || !w || y || l) && u(w ? h() : k), k) : h();
    };
  }
  var x = !1, T = !1, S = /* @__PURE__ */ ga(c), z = so(
    () => /* @__PURE__ */ E(() => {
      var k = h(), w = d(S);
      return x ? (x = !1, T = !0, w) : (T = !1, S.v = k);
    })
  );
  return n || (z.equals = cn), function(k, w) {
    if (arguments.length > 0) {
      const q = w ? d(z) : o && i ? B(k) : k;
      return z.equals(q) || (x = !0, D(S, q), m && _ !== void 0 && (_ = q), br(() => d(z))), k;
    }
    return d(z);
  };
}
function lo(e, r) {
  var t = Z, a = le, n = $;
  qe(e), He(e), $n(e.ctx);
  try {
    r();
  } finally {
    qe(t), He(a), $n(n);
  }
}
function Gl(e, r, t) {
  var a = e, n;
  Dr(() => {
    var o = (
      /** @type {Effect} */
      Z
    ), i = !1;
    o.fn = (s) => {
      var l = r.onerror;
      let c = r.failed;
      if (!l && !c || i)
        throw s;
      var p = () => {
        Rr(n), lo(o, () => {
          i = !1, n = Ue(() => t(a)), Ta();
        });
      };
      l == null || l(s, p), n && Ve(n), c && Hr(() => {
        lo(o, () => {
          i = !0;
          try {
            n = Ue(() => {
              c(
                a,
                () => s,
                () => p
              );
            });
          } catch (u) {
            Mt(u, o, null, o.ctx);
          }
          Ta(), i = !1;
        });
      });
    }, n = Ue(() => t(a)), Ta();
  }, zr | Zt);
}
var he = /* @__PURE__ */ ((e) => (e[e.UnknownError = 0] = "UnknownError", e[e.UserCancelledError = 1] = "UserCancelledError", e[e.StoreProblemError = 2] = "StoreProblemError", e[e.PurchaseNotAllowedError = 3] = "PurchaseNotAllowedError", e[e.PurchaseInvalidError = 4] = "PurchaseInvalidError", e[e.ProductNotAvailableForPurchaseError = 5] = "ProductNotAvailableForPurchaseError", e[e.ProductAlreadyPurchasedError = 6] = "ProductAlreadyPurchasedError", e[e.ReceiptAlreadyInUseError = 7] = "ReceiptAlreadyInUseError", e[e.InvalidReceiptError = 8] = "InvalidReceiptError", e[e.MissingReceiptFileError = 9] = "MissingReceiptFileError", e[e.NetworkError = 10] = "NetworkError", e[e.InvalidCredentialsError = 11] = "InvalidCredentialsError", e[e.UnexpectedBackendResponseError = 12] = "UnexpectedBackendResponseError", e[e.InvalidAppUserIdError = 14] = "InvalidAppUserIdError", e[e.OperationAlreadyInProgressError = 15] = "OperationAlreadyInProgressError", e[e.UnknownBackendError = 16] = "UnknownBackendError", e[e.InvalidAppleSubscriptionKeyError = 17] = "InvalidAppleSubscriptionKeyError", e[e.IneligibleError = 18] = "IneligibleError", e[e.InsufficientPermissionsError = 19] = "InsufficientPermissionsError", e[e.PaymentPendingError = 20] = "PaymentPendingError", e[e.InvalidSubscriberAttributesError = 21] = "InvalidSubscriberAttributesError", e[e.LogOutWithAnonymousUserError = 22] = "LogOutWithAnonymousUserError", e[e.ConfigurationError = 23] = "ConfigurationError", e[e.UnsupportedError = 24] = "UnsupportedError", e[e.EmptySubscriberAttributesError = 25] = "EmptySubscriberAttributesError", e[e.CustomerInfoError = 28] = "CustomerInfoError", e[e.SignatureVerificationError = 36] = "SignatureVerificationError", e[e.InvalidEmailError = 38] = "InvalidEmailError", e))(he || {});
class kt {
  // This is the message shown to developers. It is not intended to be displayed to end customers.
  static getPublicMessage(r) {
    switch (r) {
      case 0:
        return "Unknown error.";
      case 1:
        return "Purchase was cancelled.";
      case 2:
        return "There was a problem with the store.";
      case 3:
        return "The device or user is not allowed to make the purchase.";
      case 4:
        return "One or more of the arguments provided are invalid.";
      case 5:
        return "The product is not available for purchase.";
      case 6:
        return "This product is already active for the user.";
      case 7:
        return "There is already another active subscriber using the same receipt.";
      case 8:
        return "The receipt is not valid.";
      case 9:
        return "The receipt is missing.";
      case 10:
        return "Error performing request. Please check your network connection and try again.";
      case 11:
        return "There was a credentials issue. Check the underlying error for more details.";
      case 12:
        return "Received unexpected response from the backend.";
      case 14:
        return "The app user id is not valid.";
      case 15:
        return "The operation is already in progress.";
      case 16:
        return "There was an unknown backend error.";
      case 17:
        return "Apple Subscription Key is invalid or not present. In order to provide subscription offers, you must first generate a subscription key. Please see https://docs.revenuecat.com/docs/ios-subscription-offers for more info.";
      case 18:
        return "The User is ineligible for that action.";
      case 19:
        return "App does not have sufficient permissions to make purchases.";
      case 20:
        return "The payment is pending.";
      case 21:
        return "One or more of the attributes sent could not be saved.";
      case 22:
        return "Called logOut but the current user is anonymous.";
      case 23:
        return "There is an issue with your configuration. Check the underlying error for more details.";
      case 24:
        return "There was a problem with the operation. Looks like we doesn't support that yet. Check the underlying error for more details.";
      case 25:
        return "A request for subscriber attributes returned none.";
      case 28:
        return "There was a problem related to the customer info.";
      case 36:
        return "Request failed signature verification. Please see https://rev.cat/trusted-entitlements for more info.";
      case 38:
        return "Email is not valid. Please provide a valid email address.";
    }
  }
  static getErrorCodeForBackendErrorCode(r) {
    switch (r) {
      case 7101:
      case 7773:
      case 7898:
      case 7899:
      case 7900:
      case 7901:
        return 2;
      case 7102:
        return 7;
      case 7103:
        return 8;
      case 7107:
      case 7224:
      case 7225:
        return 11;
      case 7105:
      case 7106:
      case 7814:
      case 7877:
      case 7878:
        return 4;
      case 7772:
        return 6;
      case 7220:
        return 14;
      case 7259:
        return 28;
      case 7229:
        return 2;
      case 7230:
      case 7e3:
        return 23;
      case 7231:
        return 2;
      case 7232:
        return 18;
      case 7263:
      case 7264:
        return 21;
      case 7104:
      case 7234:
      case 7226:
      case 7110:
        return 12;
      case 7662:
        return 24;
      case 7012:
      case 7834:
      case 7879:
        return 38;
    }
  }
  static convertCodeToBackendErrorCode(r) {
    return r in wt ? r : null;
  }
  static convertPurchaseFlowErrorCodeToErrorCode(r) {
    switch (r) {
      case oe.ErrorSettingUpPurchase:
        return 2;
      case oe.ErrorChargingPayment:
        return 20;
      case oe.NetworkError:
        return 10;
      case oe.MissingEmailError:
        return 4;
      case oe.AlreadyPurchasedError:
        return 6;
      default:
        return 0;
    }
  }
}
var wt = /* @__PURE__ */ ((e) => (e[e.BackendInvalidPlatform = 7e3] = "BackendInvalidPlatform", e[e.BackendInvalidEmail = 7012] = "BackendInvalidEmail", e[e.BackendStoreProblem = 7101] = "BackendStoreProblem", e[e.BackendCannotTransferPurchase = 7102] = "BackendCannotTransferPurchase", e[e.BackendInvalidReceiptToken = 7103] = "BackendInvalidReceiptToken", e[e.BackendInvalidAppStoreSharedSecret = 7104] = "BackendInvalidAppStoreSharedSecret", e[e.BackendInvalidPaymentModeOrIntroPriceNotProvided = 7105] = "BackendInvalidPaymentModeOrIntroPriceNotProvided", e[e.BackendProductIdForGoogleReceiptNotProvided = 7106] = "BackendProductIdForGoogleReceiptNotProvided", e[e.BackendInvalidPlayStoreCredentials = 7107] = "BackendInvalidPlayStoreCredentials", e[e.BackendInternalServerError = 7110] = "BackendInternalServerError", e[e.BackendEmptyAppUserId = 7220] = "BackendEmptyAppUserId", e[e.BackendInvalidAuthToken = 7224] = "BackendInvalidAuthToken", e[e.BackendInvalidAPIKey = 7225] = "BackendInvalidAPIKey", e[e.BackendBadRequest = 7226] = "BackendBadRequest", e[e.BackendPlayStoreQuotaExceeded = 7229] = "BackendPlayStoreQuotaExceeded", e[e.BackendPlayStoreInvalidPackageName = 7230] = "BackendPlayStoreInvalidPackageName", e[e.BackendPlayStoreGenericError = 7231] = "BackendPlayStoreGenericError", e[e.BackendUserIneligibleForPromoOffer = 7232] = "BackendUserIneligibleForPromoOffer", e[e.BackendInvalidAppleSubscriptionKey = 7234] = "BackendInvalidAppleSubscriptionKey", e[e.BackendSubscriberNotFound = 7259] = "BackendSubscriberNotFound", e[e.BackendInvalidSubscriberAttributes = 7263] = "BackendInvalidSubscriberAttributes", e[e.BackendInvalidSubscriberAttributesBody = 7264] = "BackendInvalidSubscriberAttributesBody", e[e.BackendProductIDsMalformed = 7662] = "BackendProductIDsMalformed", e[e.BackendAlreadySubscribedError = 7772] = "BackendAlreadySubscribedError", e[e.BackendPaymentGatewayGenericError = 7773] = "BackendPaymentGatewayGenericError", e[e.BackendOfferNotFound = 7814] = "BackendOfferNotFound", e[e.BackendNoMXRecordsFound = 7834] = "BackendNoMXRecordsFound", e[e.BackendInvalidOperationSession = 7877] = "BackendInvalidOperationSession", e[e.BackendPurchaseCannotBeCompleted = 7878] = "BackendPurchaseCannotBeCompleted", e[e.BackendEmailIsRequired = 7879] = "BackendEmailIsRequired", e[e.BackendGatewaySetupErrorStripeTaxNotActive = 7898] = "BackendGatewaySetupErrorStripeTaxNotActive", e[e.BackendGatewaySetupErrorInvalidTaxOriginAddress = 7899] = "BackendGatewaySetupErrorInvalidTaxOriginAddress", e[e.BackendGatewaySetupErrorMissingRequiredPermission = 7900] = "BackendGatewaySetupErrorMissingRequiredPermission", e[e.BackendGatewaySetupErrorSandboxModeOnly = 7901] = "BackendGatewaySetupErrorSandboxModeOnly", e))(wt || {});
class _e extends Error {
  constructor(t, a, n, o) {
    super(a);
    M(this, "toString", () => `PurchasesError(code: ${he[this.errorCode]}, message: ${this.message})`);
    this.errorCode = t, this.underlyingErrorMessage = n, this.extra = o;
  }
  /** @internal */
  static getForBackendError(t, a) {
    const n = kt.getErrorCodeForBackendErrorCode(t);
    return new _e(
      n,
      kt.getPublicMessage(n),
      a,
      { backendErrorCode: t }
    );
  }
  /** @internal */
  static getForPurchasesFlowError(t) {
    return new _e(
      kt.convertPurchaseFlowErrorCodeToErrorCode(
        t.errorCode
      ),
      t.message,
      t.underlyingErrorMessage
    );
  }
}
class Xl extends Error {
  constructor() {
    super("Purchases must be configured before calling getInstance");
  }
}
var yt = /* @__PURE__ */ ((e) => (e.Started = "started", e.InProgress = "in_progress", e.Succeeded = "succeeded", e.Failed = "failed", e))(yt || {}), Jr = /* @__PURE__ */ ((e) => (e[e.SetupIntentCreationFailed = 1] = "SetupIntentCreationFailed", e[e.PaymentMethodCreationFailed = 2] = "PaymentMethodCreationFailed", e[e.PaymentChargeFailed = 3] = "PaymentChargeFailed", e[e.SetupIntentCompletionFailed = 4] = "SetupIntentCompletionFailed", e[e.AlreadyPurchased = 5] = "AlreadyPurchased", e))(Jr || {}), Ae = /* @__PURE__ */ ((e) => (e[e.Silent = 0] = "Silent", e[e.Error = 1] = "Error", e[e.Warn = 2] = "Warn", e[e.Info = 3] = "Info", e[e.Debug = 4] = "Debug", e[e.Verbose = 5] = "Verbose", e))(Ae || {});
class K {
  static setLogLevel(r) {
    this.logLevel = r;
  }
  static log(r, t = this.logLevel) {
    const a = `[Purchases] ${r}`;
    if (!(this.logLevel < t || t === Ae.Silent))
      switch (t) {
        case Ae.Error:
          console.error(a);
          break;
        case Ae.Warn:
          console.warn(a);
          break;
        case Ae.Info:
          console.info(a);
          break;
        case Ae.Debug:
          console.debug(a);
          break;
        case Ae.Verbose:
          console.debug(a);
          break;
      }
  }
  static errorLog(r) {
    this.log(r, Ae.Error);
  }
  static warnLog(r) {
    this.log(r, Ae.Warn);
  }
  static infoLog(r) {
    this.log(r, Ae.Info);
  }
  static debugLog(r) {
    this.log(r, Ae.Debug);
  }
  static verboseLog(r) {
    this.log(r, Ae.Verbose);
  }
}
M(K, "logLevel", Ae.Silent);
function Zl(e) {
  var r;
  return e.operation.redemption_info ? {
    redeemUrl: ((r = e.operation.redemption_info) == null ? void 0 : r.redeem_url) ?? null
  } : null;
}
var oe = /* @__PURE__ */ ((e) => (e[e.ErrorSettingUpPurchase = 0] = "ErrorSettingUpPurchase", e[e.ErrorChargingPayment = 1] = "ErrorChargingPayment", e[e.UnknownError = 2] = "UnknownError", e[e.NetworkError = 3] = "NetworkError", e[e.MissingEmailError = 4] = "MissingEmailError", e[e.AlreadyPurchasedError = 5] = "AlreadyPurchasedError", e[e.StripeTaxNotActive = 6] = "StripeTaxNotActive", e[e.StripeInvalidTaxOriginAddress = 7] = "StripeInvalidTaxOriginAddress", e[e.StripeMissingRequiredPermission = 8] = "StripeMissingRequiredPermission", e))(oe || {});
class de extends Error {
  constructor(r, t, a, n, o) {
    super(t), this.errorCode = r, this.underlyingErrorMessage = a, this.purchasesErrorCode = n, this.extra = o;
  }
  getErrorCode() {
    var r;
    return ((r = this.extra) == null ? void 0 : r.backendErrorCode) ?? this.purchasesErrorCode ?? this.errorCode;
  }
  static fromPurchasesError(r, t) {
    var n;
    let a;
    return r.errorCode === he.ProductAlreadyPurchasedError ? a = 5 : r.errorCode === he.InvalidEmailError ? a = 4 : r.errorCode === he.NetworkError ? a = 3 : a = de.fromBackendErrorCode((n = r.extra) == null ? void 0 : n.backendErrorCode) ?? t, new de(
      a,
      r.message,
      r.underlyingErrorMessage,
      r.errorCode,
      r.extra
    );
  }
  static fromBackendErrorCode(r) {
    switch (r) {
      case wt.BackendGatewaySetupErrorStripeTaxNotActive:
        return 6;
      case wt.BackendGatewaySetupErrorInvalidTaxOriginAddress:
        return 7;
      case wt.BackendGatewaySetupErrorMissingRequiredPermission:
        return 8;
      default:
        return null;
    }
  }
}
class Kl {
  constructor(r, t, a = 10) {
    M(this, "operationSessionId", null);
    M(this, "backend");
    M(this, "eventsTracker");
    M(this, "maxNumberAttempts");
    M(this, "waitMSBetweenAttempts", 1e3);
    this.backend = r, this.eventsTracker = t, this.maxNumberAttempts = a;
  }
  async checkoutStart(r, t, a, n, o, i) {
    try {
      const s = this.eventsTracker.getTraceId(), l = await this.backend.postCheckoutStart(
        r,
        t,
        n,
        a,
        s,
        o,
        i
      );
      return this.operationSessionId = l.operation_session_id, l;
    } catch (s) {
      if (s instanceof _e)
        throw de.fromPurchasesError(
          s,
          0
          /* ErrorSettingUpPurchase */
        );
      {
        const l = "Unknown error starting purchase: " + String(s);
        throw K.errorLog(l), new de(
          2,
          l
        );
      }
    }
  }
  async checkoutCalculateTax(r, t, a) {
    const n = this.operationSessionId;
    if (!n)
      throw new de(
        0,
        "No purchase started"
      );
    try {
      return await this.backend.postCheckoutCalculateTax(
        n,
        r,
        t,
        a
      );
    } catch (o) {
      if (o instanceof _e)
        throw de.fromPurchasesError(
          o,
          0
          /* ErrorSettingUpPurchase */
        );
      {
        const i = "Unknown error calculating tax: " + String(o);
        throw K.errorLog(i), new de(
          2,
          i
        );
      }
    }
  }
  async checkoutComplete(r) {
    const t = this.operationSessionId;
    if (!t)
      throw new de(
        0,
        "No purchase started"
      );
    try {
      return await this.backend.postCheckoutComplete(
        t,
        r
      );
    } catch (a) {
      if (a instanceof _e)
        throw de.fromPurchasesError(
          a,
          0
          /* ErrorSettingUpPurchase */
        );
      {
        const n = "Unknown error starting purchase: " + String(a);
        throw K.errorLog(n), new de(
          2,
          n
        );
      }
    }
  }
  async pollCurrentPurchaseForCompletion() {
    const r = this.operationSessionId;
    if (!r)
      throw new de(
        0,
        "No purchase in progress"
      );
    return new Promise((t, a) => {
      const n = (o = 1) => {
        if (o > this.maxNumberAttempts) {
          this.clearPurchaseInProgress(), a(
            new de(
              2,
              "Max attempts reached trying to get successful purchase status"
            )
          );
          return;
        }
        this.backend.getCheckoutStatus(r).then((i) => {
          switch (i.operation.status) {
            case yt.Started:
            case yt.InProgress:
              setTimeout(
                () => n(o + 1),
                this.waitMSBetweenAttempts
              );
              break;
            case yt.Succeeded:
              this.clearPurchaseInProgress(), t({
                redemptionInfo: Zl(i),
                operationSessionId: r
              });
              return;
            case yt.Failed:
              this.clearPurchaseInProgress(), this.handlePaymentError(
                i.operation.error,
                a
              );
          }
        }).catch((i) => {
          const s = de.fromPurchasesError(
            i,
            3
            /* NetworkError */
          );
          a(s);
        });
      };
      n();
    });
  }
  clearPurchaseInProgress() {
    this.operationSessionId = null;
  }
  handlePaymentError(r, t) {
    if (r == null) {
      t(
        new de(
          2,
          "Got an error status but error field is empty."
        )
      );
      return;
    }
    switch (r.code) {
      case Jr.SetupIntentCreationFailed:
        t(
          new de(
            0,
            "Setup intent creation failed"
          )
        );
        return;
      case Jr.PaymentMethodCreationFailed:
        t(
          new de(
            0,
            "Payment method creation failed"
          )
        );
        return;
      case Jr.PaymentChargeFailed:
        t(
          new de(
            1,
            "Payment charge failed"
          )
        );
        return;
      case Jr.SetupIntentCompletionFailed:
        t(
          new de(
            0,
            "Setup intent completion failed"
          )
        );
        return;
      case Jr.AlreadyPurchased:
        t(
          new de(
            5,
            "Purchased was already completed"
          )
        );
        return;
      default:
        t(
          new de(
            2,
            "Unknown error code received"
          )
        );
        return;
    }
  }
}
const Ne = "rcb-ui-translator", tt = "en", Jl = {
  "periods.week": "{{amount}} week",
  "periods.month": "{{amount}} month",
  "periods.year": "{{amount}} year",
  "periods.day": "{{amount}} day",
  "periods.weekShort": "{{amount}}wk",
  "periods.monthShort": "{{amount}}mo",
  "periods.yearShort": "{{amount}}yr",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "lifetime",
  "periods.weekPlural": "{{amount}} weeks",
  "periods.monthPlural": "{{amount}} months",
  "periods.yearPlural": "{{amount}} years",
  "periods.dayPlural": "{{amount}} days",
  "periods.weekFrequency": "weekly",
  "periods.monthFrequency": "monthly",
  "periods.yearFrequency": "yearly",
  "periods.dayFrequency": "daily",
  "periods.perWeekFrequency": "per week",
  "periods.perMonthFrequency": "per month",
  "periods.perYearFrequency": "per year",
  "periods.perDayFrequency": "per day",
  "periods.unknownFrequency": "unknown",
  "periods.weekFrequencyPlural": "every {{amount}} weeks",
  "periods.monthFrequencyPlural": "every {{amount}} months",
  "periods.yearFrequencyPlural": "every {{amount}} years",
  "periods.dayFrequencyPlural": "every {{amount}} days",
  "product_info.subscribe_to": "Subscribe to",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "Free for {{trialDuration}}",
  "product_info.price_after_free_trial": "After trial ends, on {{renewalDate}}",
  "product_info.total_due_today": "Total due today",
  "product_info.renewal_frequency": "Renews {{frequency}}",
  "product_info.continues_until_cancelled": "Continues until cancelled",
  "product_info.cancel_anytime": "Cancel anytime",
  "payment_entry_page.payment_step_title": "Secure checkout by RevenueCat",
  "payment_entry_page.terms_info": "By providing your card information you allow {{appName}} to charge your card for future payments in accordance with their terms.",
  "payment_entry_page.trial_info": "After your trial ends, you will be charged {{price}} {{perFrequency}} plus any applicable taxes starting {{renewalDate}}. You can always cancel before then.",
  "payment_entry_page.button_pay": "Pay now",
  "payment_entry_page.button_start_trial": "Start trial",
  "payment_entry_page.button_with_price": "Pay {{formattedPrice}}",
  "payment_entry_page.button_payment_method": "Pay {{formattedPrice}} with {{paymentMethod}}",
  "payment_entry_page.express_checkout_divider": "OR PAY BY CARD",
  "success_page.purchase_successful": "Payment complete",
  "success_page.button_close": "Continue",
  "error_page.close_button_title": "Go to {{appName}}",
  "error_page.if_error_persists": "If it persists, please contact ",
  "error_page.trouble_accessing": "If you're having trouble accessing your purchase, reach out to support on ",
  "error_page.error_title_already_subscribed": "You already subscribed to {{productTitle}}",
  "error_page.error_title_already_purchased": "You already purchased {{productTitle}}",
  "error_page.error_title_other_errors": "Something went wrong",
  "error_page.error_message_already_subscribed": "You can't subscribe to this product again.",
  "error_page.error_message_already_purchased": "You can't purchase this product again.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax not active",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Invalid tax origin address",
  "error_page.error_title_stripe_missing_required_permission": "Missing Stripe permission",
  "error_page.error_message_missing_email_error": "Email is required to complete the purchase.",
  "error_page.error_message_invalid_email_error": "The email address {{email}} couldn't be verified. Please provide a valid email address.",
  "error_page.error_message_network_error": "Network error. Please check your internet connection.",
  "error_page.error_message_error_charging_payment": "Payment failed.",
  "error_page.error_message_error_setting_up_purchase": "Purchase not started due to an error (error code: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "We couldn't verify your billing address. Please double-check that the postal code and country are correct.",
  "error_page.error_message_unknown_error": "An unknown error occurred (error code: {{errorCode}}).",
  "error_page.error_message_stripe_tax_not_active": "The purchase failed because Stripe Tax isn’t enabled. In production, purchases will work without taxes applied.",
  "error_page.error_message_stripe_invalid_tax_origin_address": "The purchase failed because the tax origin address is invalid. In production, purchases will work without taxes applied.",
  "error_page.error_message_stripe_missing_required_permission": "The purchase failed because the Stripe app lacks a required permission. In production, purchases will work without taxes applied.",
  "error_page.error_only_in_sandbox": "This message appears only in sandbox.",
  "error_page.button_try_again": "Try again",
  "error_page.button_close": "Close",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% off",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "pricing_dropdown.show_details": "Show details",
  "pricing_dropdown.hide_details": "Hide details",
  "pricing_table.trial_ends": "After trial ends, on {{formattedTrialEndDate}}",
  "pricing_table.total_excluding_tax": "Total excluding tax",
  "pricing_table.total_due_today": "Total due today",
  "pricing_table.tax": "Tax",
  "pricing_table.enter_billing_address_to_calculate": "Enter billing address to calculate",
  "pricing_table.enter_postal_code_to_calculate": "Enter zip code to calculate",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Enter state or postal code to calculate",
  "navbar_header.details": "Details",
  "navbar_header.back_button": "Back",
  "price_update.title": "Price update",
  "price_update.base_message": "The total price was updated with tax based on your billing address. Please review and try again. Your card will only be charged once.",
  "price_update.trial_message": "The subscription price was updated to include tax based on your billing address. Free trial still applies. Review and try again.",
  "apple_pay.free_trial": "Free Trial"
}, Ql = {
  "periods.week": "{{amount}} semana",
  "periods.month": "{{amount}} mes",
  "periods.year": "{{amount}} año",
  "periods.day": "{{amount}} día",
  "periods.weekShort": "{{amount}} sem",
  "periods.monthShort": "{{amount}}mes",
  "periods.yearShort": "{{amount}}año",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "de por vida",
  "periods.weekPlural": "{{amount}} semanas",
  "periods.monthPlural": "{{amount}} meses",
  "periods.yearPlural": "{{amount}} años",
  "periods.dayPlural": "{{amount}} días",
  "periods.weekFrequency": "semanal",
  "periods.monthFrequency": "mensual",
  "periods.yearFrequency": "anual",
  "periods.dayFrequency": "diaria",
  "periods.perWeekFrequency": "por semana",
  "periods.perMonthFrequency": "por mes",
  "periods.perYearFrequency": "por año",
  "periods.perDayFrequency": "por día",
  "periods.unknownFrequency": "desconocida",
  "periods.weekFrequencyPlural": "cada {{amount}} semanas",
  "periods.monthFrequencyPlural": "cada {{amount}} meses",
  "periods.yearFrequencyPlural": "cada {{amount}} años",
  "periods.dayFrequencyPlural": "cada {{amount}} días",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} prueba gratuita",
  "product_info.price_after_free_trial": "Después de que termine el periodo de prueba, el {{renewalDate}}",
  "product_info.renewal_frequency": "Se renueva {{frequency}}",
  "product_info.continues_until_cancelled": "Continua hasta que se cancele",
  "product_info.cancel_anytime": "Cancelar en cualquier momento",
  "payment_entry_page.payment_step_title": "Pago seguro mediante RevenueCat",
  "payment_entry_page.terms_info": "Al proporcionar la información de tu tarjeta, permites que {{appName}} cobre en tu tarjeta por pagos futuros de acuerdo con sus términos.",
  "payment_entry_page.button_pay": "Pagar ahora",
  "payment_entry_page.button_start_trial": "Comenzar prueba",
  "success_page.purchase_successful": "Pago completado",
  "success_page.button_close": "Continuar",
  "error_page.if_error_persists": "Si el error persiste, contacta con ",
  "error_page.error_title_already_subscribed": "Ya te has suscrito a {{productTitle}}",
  "error_page.error_title_already_purchased": "Ya has comprado {{productTitle}}",
  "error_page.error_title_other_errors": "Algo salió mal",
  "error_page.error_message_already_subscribed": "No puedes suscribirte a este producto de nuevo.",
  "error_page.error_message_already_purchased": "No puedes comprar este producto de nuevo.",
  "error_page.error_message_missing_email_error": "Se requiere un correo electrónico para completar la compra.",
  "error_page.error_message_network_error": "Error de red. Por favor, comprueba tu conexión a internet.",
  "error_page.error_message_error_charging_payment": "Pago fallido.",
  "error_page.error_message_error_setting_up_purchase": "No se pudo iniciar la compra debido a un error (código de error: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "No pudimos verificar tu dirección de facturación. Por favor, verifica que el código postal y el país sean correctos.",
  "error_page.error_message_unknown_error": "Ocurrió un error desconocido (código de error: {{errorCode}}).",
  "error_page.button_try_again": "Intentar de nuevo",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% de descuento",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Total a pagar hoy",
  "product_info.subscribe_to": "Suscribirse a",
  "payment_entry_page.trial_info": "Una vez finalizado el período de prueba, se le cobrará {{price}} {{perFrequency}} a partir del {{renewalDate}}. Puede cancelar en cualquier momento antes de esa fecha.",
  "navbar_header.details": "Detalles",
  "navbar_header.back_button": "Atrás",
  "pricing_dropdown.show_details": "Mostrar detalles",
  "pricing_dropdown.hide_details": "Ocultar detalles",
  "pricing_table.tax": "Impuestos",
  "pricing_table.trial_ends": "Después de que finalice la prueba, el {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Total a pagar hoy",
  "pricing_table.total_excluding_tax": "Total sin impuestos",
  "pricing_table.enter_billing_address_to_calculate": "Introduce la dirección de facturación para calcular",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Introduce el estado o el código postal para calcular",
  "pricing_table.enter_postal_code_to_calculate": "Introduce el código postal para calcular",
  "error_page.error_message_invalid_email_error": "La dirección de correo electrónico {{email}} no se pudo verificar. Por favor, proporciona una dirección de correo electrónico válida.",
  "payment_entry_page.button_payment_method": "Pagar {{formattedPrice}} con {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Pagar {{formattedPrice}}",
  "price_update.title": "Actualización de precio",
  "price_update.base_message": "El precio total se actualizó con impuestos según su dirección de facturación. Revise e intente nuevamente. Solo se efectuará un cobro en su tarjeta.",
  "price_update.trial_message": "El precio de la suscripción se actualizó para incluir impuestos según su dirección de facturación. La prueba gratuita sigue aplicándose. Revise e intente nuevamente.",
  "payment_entry_page.express_checkout_divider": "O PAGA CON TARJETA",
  "error_page.trouble_accessing": "Si tiene problemas para acceder a su compra, póngase en contacto con el servicio de asistencia en ",
  "error_page.close_button_title": "Ir a {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Falta permiso de Stripe",
  "error_page.button_close": "Cerrar",
  "error_page.error_message_stripe_invalid_tax_origin_address": "La compra falló porque la dirección de origen fiscal no es válida. En producción, las compras funcionarán sin impuestos aplicados.",
  "error_page.error_message_stripe_tax_not_active": "La compra falló porque Stripe Tax no está habilitado. En producción, las compras funcionarán sin impuestos aplicados.",
  "error_page.error_only_in_sandbox": "Este mensaje aparece solo en el entorno de pruebas.",
  "error_page.error_message_stripe_missing_required_permission": "La compra falló porque la aplicación Stripe carece de un permiso necesario. En producción, las compras funcionarán sin impuestos aplicados.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax no está activo",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Dirección de origen fiscal no válida",
  "apple_pay.free_trial": "Prueba gratuita"
}, $l = {
  "periods.week": "{{amount}} settimana",
  "periods.month": "{{amount}} mese",
  "periods.year": "{{amount}} anno",
  "periods.day": "{{amount}} giorno",
  "periods.weekShort": "{{amount}}sett",
  "periods.monthShort": "{{amount}}mese",
  "periods.yearShort": "{{amount}}anno",
  "periods.dayShort": "{{amount}}g",
  "periods.lifetime": "a vita",
  "periods.weekPlural": "{{amount}} settimane",
  "periods.monthPlural": "{{amount}} mesi",
  "periods.yearPlural": "{{amount}} anni",
  "periods.dayPlural": "{{amount}} giorni",
  "periods.weekFrequency": "settimanale",
  "periods.monthFrequency": "mensile",
  "periods.yearFrequency": "annuale",
  "periods.dayFrequency": "giornaliero",
  "periods.perWeekFrequency": "a settimana",
  "periods.perMonthFrequency": "al mese",
  "periods.perYearFrequency": "all'anno",
  "periods.perDayFrequency": "al giorno",
  "periods.unknownFrequency": "sconosciuto",
  "periods.weekFrequencyPlural": "ogni {{amount}} settimane",
  "periods.monthFrequencyPlural": "ogni {{amount}} mesi",
  "periods.yearFrequencyPlural": "ogni {{amount}} anni",
  "periods.dayFrequencyPlural": "ogni {{amount}} giorni",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} prova gratuita",
  "product_info.price_after_free_trial": "Dopo la fine della prova, il {{renewalDate}}",
  "product_info.renewal_frequency": "Si rinnova {{frequency}}",
  "product_info.continues_until_cancelled": "Continua fino a disdetta",
  "product_info.cancel_anytime": "Disdici in qualsiasi momento",
  "payment_entry_page.payment_step_title": "Pagamento sicuro tramite RevenueCat",
  "payment_entry_page.terms_info": "Fornendo i dati della tua carta, autorizzi {{appName}} ad addebitare sulla tua carta i pagamenti futuri in conformità con i suoi termini.",
  "payment_entry_page.button_pay": "Paga ora",
  "payment_entry_page.button_start_trial": "Inizia la prova",
  "success_page.purchase_successful": "Pagamento completato",
  "success_page.button_close": "Continua",
  "error_page.if_error_persists": "Se l'errore persiste, contatta ",
  "error_page.error_title_already_subscribed": "Hai già un abbonamento a {{productTitle}}",
  "error_page.error_title_already_purchased": "Hai già acquistato {{productTitle}}",
  "error_page.error_title_other_errors": "Qualcosa è andato storto",
  "error_page.error_message_already_subscribed": "Non puoi abbonarti di nuovo a questo prodotto.",
  "error_page.error_message_already_purchased": "Non puoi acquistare di nuovo questo prodotto.",
  "error_page.error_message_missing_email_error": "L'email è necessaria per completare l'acquisto.",
  "error_page.error_message_network_error": "Errore di rete. Verifica la connessione internet.",
  "error_page.error_message_error_charging_payment": "Pagamento fallito.",
  "error_page.error_message_error_setting_up_purchase": "Acquisto non avviato a causa di un errore (codice errore: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Non siamo riusciti a verificare il tuo indirizzo di fatturazione. Per favore, controlla che il codice postale e il paese siano corretti.",
  "error_page.error_message_unknown_error": "Si è verificato un errore sconosciuto (codice errore: {{errorCode}}).",
  "error_page.button_try_again": "Riprova",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% di sconto",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Totale dovuto oggi",
  "product_info.subscribe_to": "Abbonati a",
  "payment_entry_page.trial_info": "Al termine del periodo di prova, ti verranno addebitati {{price}} {{perFrequency}} a partire dal {{renewalDate}}. Puoi annullare in qualsiasi momento prima di allora.",
  "navbar_header.details": "Dettagli",
  "navbar_header.back_button": "Indietro",
  "pricing_dropdown.show_details": "Mostra dettagli",
  "pricing_dropdown.hide_details": "Nascondi dettagli",
  "pricing_table.tax": "Tasse",
  "pricing_table.trial_ends": "Al termine del periodo di prova, il {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Totale dovuto oggi",
  "pricing_table.total_excluding_tax": "Totale tasse escluse",
  "pricing_table.enter_billing_address_to_calculate": "Inserisci l'indirizzo di fatturazione per calcolare",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Inserisci la regione o il codice postale per calcolare",
  "pricing_table.enter_postal_code_to_calculate": "Inserisci il codice postale per calcolare",
  "error_page.error_message_invalid_email_error": "L'indirizzo email {{email}} non può essere verificato. Si prega di fornire un indirizzo email valido.",
  "payment_entry_page.button_payment_method": "Paga {{formattedPrice}} con {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Paga {{formattedPrice}}",
  "price_update.title": "Aggiornamento prezzo",
  "price_update.base_message": "Il prezzo totale è stato aggiornato con le tasse in base al tuo indirizzo di fatturazione. Rivedi e riprova. L'addebito sulla tua carta avverrà solo una volta.",
  "price_update.trial_message": "Il prezzo dell'abbonamento è stato aggiornato per includere le tasse in base al tuo indirizzo di fatturazione. La prova gratuita è ancora valida. Controlla e riprova.",
  "payment_entry_page.express_checkout_divider": "OPPURE PAGA CON CARTA",
  "error_page.trouble_accessing": "Se hai problemi ad accedere al tuo acquisto, contatta l'assistenza all'indirizzo ",
  "error_page.close_button_title": "Vai a {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Autorizzazione Stripe mancante",
  "error_page.button_close": "Chiudi",
  "error_page.error_message_stripe_invalid_tax_origin_address": "L'acquisto non è andato a buon fine perché l'indirizzo di origine fiscale non è valido. In produzione, gli acquisti verranno effettuati senza l'applicazione delle imposte e questo errore non sarà visibile.",
  "error_page.error_message_stripe_tax_not_active": "L'acquisto non è andato a buon fine perché Stripe Tax non è abilitato. In produzione, gli acquisti verranno effettuati senza l'applicazione delle imposte e questo errore non sarà visibile.",
  "error_page.error_only_in_sandbox": "Questo messaggio viene visualizzato solo in sandbox.",
  "error_page.error_message_stripe_missing_required_permission": "L'acquisto non è andato a buon fine perché l'app Stripe non dispone dell'autorizzazione necessaria. In produzione, gli acquisti verranno effettuati senza l'applicazione delle imposte e questo errore non sarà visibile.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax non attivo",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Indirizzo di origine fiscale non valido",
  "apple_pay.free_trial": "Prova gratuita"
}, ec = {
  "periods.week": "{{amount}} أسبوع",
  "periods.month": "{{amount}} شهر",
  "periods.year": "{{amount}} سنة",
  "periods.day": "{{amount}} يوم",
  "periods.weekShort": "{{amount}}أسبوع",
  "periods.monthShort": "{{amount}}شهر",
  "periods.yearShort": "{{amount}}سنة",
  "periods.dayShort": "{{amount}}يوم",
  "periods.lifetime": "مدى الحياة",
  "periods.weekPlural": "{{amount}} أسابيع",
  "periods.monthPlural": "{{amount}} أشهر",
  "periods.yearPlural": "{{amount}} سنوات",
  "periods.dayPlural": "{{amount}} أيام",
  "periods.weekFrequency": "أسبوعيًا",
  "periods.monthFrequency": "شهريًا",
  "periods.yearFrequency": "سنويًا",
  "periods.dayFrequency": "يوميًا",
  "periods.perWeekFrequency": "في الأسبوع",
  "periods.perMonthFrequency": "في الشهر",
  "periods.perYearFrequency": "في السنة",
  "periods.perDayFrequency": "في اليوم",
  "periods.unknownFrequency": "غير معروف",
  "periods.weekFrequencyPlural": "كل {{amount}} أسابيع",
  "periods.monthFrequencyPlural": "كل {{amount}} أشهر",
  "periods.yearFrequencyPlural": "كل {{amount}} سنوات",
  "periods.dayFrequencyPlural": "كل {{amount}} أيام",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} تجربة مجانية",
  "product_info.price_after_free_trial": "بعد انتهاء التجربة، في {{renewalDate}}",
  "product_info.renewal_frequency": "يتم التجديد {{frequency}}",
  "product_info.continues_until_cancelled": "يستمر حتى يتم إلغاؤه",
  "product_info.cancel_anytime": "يمكن الإلغاء في أي وقت",
  "payment_entry_page.payment_step_title": "الدفع الآمن عبر RevenueCat",
  "payment_entry_page.terms_info": "بتقديم معلومات بطاقتك، فإنك تسمح لـ {{appName}} بتحصيل الرسوم من بطاقتك مقابل المدفوعات المستقبلية وفقًا لشروطها.",
  "payment_entry_page.button_pay": "ادفع الآن",
  "payment_entry_page.button_start_trial": "ابدأ التجربة",
  "success_page.purchase_successful": "تم الدفع بنجاح",
  "success_page.button_close": "متابعة",
  "error_page.if_error_persists": "إذا استمرت المشكلة، يرجى الاتصال بـ ",
  "error_page.error_title_already_subscribed": "أنت مشترك بالفعل في {{productTitle}}",
  "error_page.error_title_already_purchased": "لقد اشتريت {{productTitle}} بالفعل",
  "error_page.error_title_other_errors": "حدث خطأ ما",
  "error_page.error_message_already_subscribed": "لا يمكنك الاشتراك في هذا المنتج مرة أخرى.",
  "error_page.error_message_already_purchased": "لا يمكنك شراء هذا المنتج مرة أخرى.",
  "error_page.error_message_missing_email_error": "يُطلب البريد الإلكتروني لإتمام عملية الشراء.",
  "error_page.error_message_network_error": "خطأ في الشبكة. يرجى التحقق من اتصال الإنترنت.",
  "error_page.error_message_error_charging_payment": "فشل الدفع.",
  "error_page.error_message_error_setting_up_purchase": "لم تبدأ عملية الشراء بسبب خطأ (رمز الخطأ: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "لم نتمكن من التحقق من عنوان الفوترة الخاص بك. يرجى التحقق مرة أخرى من الرمز البريدي والبلد للتأكد من صحتهما.",
  "error_page.error_message_unknown_error": "حدث خطأ غير معروف (رمز الخطأ: {{errorCode}}).",
  "error_page.button_try_again": "حاول مرة أخرى",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% خصم",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "إجمالي المبلغ المستحق اليوم",
  "product_info.subscribe_to": "اشترك في",
  "payment_entry_page.trial_info": "بعد انتهاء الفترة التجريبية، سيتم محاسبتك بمبلغ {{price}} {{perFrequency}} بدءًا من {{renewalDate}}. يمكنك الإلغاء دائمًا قبل ذلك.",
  "navbar_header.details": "تفاصيل",
  "navbar_header.back_button": "عودة",
  "pricing_dropdown.show_details": "إظهار التفاصيل",
  "pricing_dropdown.hide_details": "إخفاء التفاصيل",
  "pricing_table.tax": "الضريبة",
  "pricing_table.trial_ends": "بعد انتهاء الفترة التجريبية، في {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "الإجمالي المستحق اليوم",
  "pricing_table.total_excluding_tax": "الإجمالي باستثناء الضريبة",
  "pricing_table.enter_billing_address_to_calculate": "أدخل عنوان إرسال الفواتير لحسابها",
  "pricing_table.enter_state_or_postal_code_to_calculate": "أدخل الولاية أو الرمز البريدي للحساب",
  "pricing_table.enter_postal_code_to_calculate": "أدخل الرمز البريدي للحساب",
  "error_page.error_message_invalid_email_error": "تعذر التحقق من عنوان البريد الإلكتروني {{email}}. يرجى تقديم عنوان بريد إلكتروني صالح.",
  "payment_entry_page.button_payment_method": "ادفع {{formattedPrice}} باستخدام {{paymentMethod}}",
  "payment_entry_page.button_with_price": "ادفع {{formattedPrice}}",
  "price_update.title": "تحديث السعر",
  "price_update.base_message": "تم تحديث السعر الإجمالي مع الضريبة بناءً على عنوان إرسال الفواتير الخاص بك. يرجى المراجعة والمحاولة مرة أخرى. لن يتم تحصيل رسوم من بطاقتك إلا مرة واحدة.",
  "price_update.trial_message": "تم تحديث سعر الاشتراك ليشمل الضرائب بناءً على عنوان الفوترة الخاص بك. فترة التجربة المجانية لا تزال سارية. يرجى التحقق والمحاولة مرة أخرى.",
  "payment_entry_page.express_checkout_divider": "أو ادفع بواسطة البطاقة",
  "error_page.trouble_accessing": "إذا كنت تواجه مشكلة في الوصول إلى عملية الشراء، فتواصل مع الدعم على ",
  "error_page.close_button_title": "اذهب إلى {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "إذن Stripe مفقود",
  "error_page.button_close": "إغلاق",
  "error_page.error_message_stripe_invalid_tax_origin_address": "فشلت عملية الشراء لأن عنوان المنشأ الضريبي غير صالح. في مرحلة الإنتاج، ستعمل عمليات الشراء بدون تطبيق الضرائب.",
  "error_page.error_message_stripe_tax_not_active": "فشلت عملية الشراء لأن ضريبة Stripe غير مفعلة. في مرحلة الإنتاج، ستعمل عمليات الشراء بدون تطبيق الضرائب.",
  "error_page.error_only_in_sandbox": "تظهر هذه الرسالة فقط في البيئة التجريبية.",
  "error_page.error_message_stripe_missing_required_permission": "فشلت عملية الشراء لأن تطبيق Stripe يفتقر إلى إذن مطلوب. في مرحلة الإنتاج، ستعمل عمليات الشراء بدون تطبيق الضرائب.",
  "error_page.error_title_stripe_tax_not_active": "ضريبة Stripe غير نشطة",
  "error_page.error_title_stripe_invalid_tax_origin_address": "عنوان منشأ ضريبي غير صالح",
  "apple_pay.free_trial": "تجربة مجانية"
}, rc = {
  "periods.week": "{{amount}} setmana",
  "periods.month": "{{amount}} mes",
  "periods.year": "{{amount}} any",
  "periods.day": "{{amount}} dia",
  "periods.weekShort": "{{amount}}set",
  "periods.monthShort": "{{amount}}mes",
  "periods.yearShort": "{{amount}}any",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "de per vida",
  "periods.weekPlural": "{{amount}} setmanes",
  "periods.monthPlural": "{{amount}} mesos",
  "periods.yearPlural": "{{amount}} anys",
  "periods.dayPlural": "{{amount}} dies",
  "periods.weekFrequency": "setmanal",
  "periods.monthFrequency": "mensual",
  "periods.yearFrequency": "anual",
  "periods.dayFrequency": "diari",
  "periods.perWeekFrequency": "per setmana",
  "periods.perMonthFrequency": "per mes",
  "periods.perYearFrequency": "per any",
  "periods.perDayFrequency": "per dia",
  "periods.unknownFrequency": "desconeguda",
  "periods.weekFrequencyPlural": "cada {{amount}} setmanes",
  "periods.monthFrequencyPlural": "cada {{amount}} mesos",
  "periods.yearFrequencyPlural": "cada {{amount}} anys",
  "periods.dayFrequencyPlural": "cada {{amount}} dies",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} de prova gratuïta",
  "product_info.price_after_free_trial": "Després del període de prova, el {{renewalDate}}",
  "product_info.renewal_frequency": "Es renova {{frequency}}",
  "product_info.continues_until_cancelled": "Continua fins que es cancel·li",
  "product_info.cancel_anytime": "Cancel·la en qualsevol moment",
  "payment_entry_page.payment_step_title": "Pagament segur amb RevenueCat",
  "payment_entry_page.terms_info": "En proporcionar la teva informació de targeta, permets a {{appName}} carregar la teva targeta per a futurs pagaments d'acord amb els seus termes.",
  "payment_entry_page.button_pay": "Paga ara",
  "payment_entry_page.button_start_trial": "Comença la prova",
  "success_page.purchase_successful": "Pagament complet",
  "success_page.button_close": "Continua",
  "error_page.if_error_persists": "Si l'error persisteix, contacta amb ",
  "error_page.error_title_already_subscribed": "Ja us heu subscrit a {{productTitle}}",
  "error_page.error_title_already_purchased": "Ja heu comprat {{productTitle}}",
  "error_page.error_title_other_errors": "Alguna cosa ha anat malament",
  "error_page.error_message_already_subscribed": "No us podeu subscriure a aquest producte de nou.",
  "error_page.error_message_already_purchased": "No podeu comprar aquest producte de nou.",
  "error_page.error_message_missing_email_error": "Es necessita un correu electrònic per completar la compra.",
  "error_page.error_message_network_error": "Error de xarxa. Comprova la teva connexió a internet.",
  "error_page.error_message_error_charging_payment": "El pagament ha fallat.",
  "error_page.error_message_error_setting_up_purchase": "No s'ha iniciat la compra a causa d'un error (codi d'error: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "No hem pogut verificar la vostra adreça de facturació. Si us plau, verifiqueu de nou el codi postal i el país per assegurar-vos que són correctes.",
  "error_page.error_message_unknown_error": "S'ha produït un error desconegut (codi d'error: {{errorCode}}).",
  "error_page.button_try_again": "Torna a intentar-ho",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% de descompte",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Total a pagar avui",
  "product_info.subscribe_to": "Subscriu-te a",
  "payment_entry_page.trial_info": "Un cop finalitzi el període de prova, se us cobrarà {{price}} {{perFrequency}} a partir del {{renewalDate}}. Sempre podeu cancel·lar abans d'aquesta data.",
  "navbar_header.details": "Detalls",
  "navbar_header.back_button": "Enrere",
  "pricing_dropdown.show_details": "Mostra detalls",
  "pricing_dropdown.hide_details": "Amaga detalls",
  "pricing_table.tax": "Impostos",
  "pricing_table.trial_ends": "Després que finalitzi la prova, el {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Total a pagar avui",
  "pricing_table.total_excluding_tax": "Total sense impostos",
  "pricing_table.enter_billing_address_to_calculate": "Introduïu l'adreça de facturació per calcular",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Introduïu la província o el codi postal per calcular",
  "pricing_table.enter_postal_code_to_calculate": "Introduïu el codi postal per calcular",
  "error_page.error_message_invalid_email_error": "No s'ha pogut verificar l'adreça de correu electrònic {{email}}. Si us plau, proporcioneu una adreça de correu electrònic vàlida.",
  "payment_entry_page.button_payment_method": "Paga {{formattedPrice}} amb {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Paga {{formattedPrice}}",
  "price_update.title": "Actualització de preu",
  "price_update.base_message": "El preu total s'ha actualitzat amb els impostos segons la vostra adreça de facturació. Reviseu-ho i torneu-ho a provar. Només es carregarà la vostra targeta una vegada.",
  "price_update.trial_message": "El preu de la subscripció s'ha actualitzat per incloure els impostos segons la seva adreça de facturació. El període de prova gratuït segueix vigent. Si us plau, comprovi-ho i torni-ho a provar.",
  "payment_entry_page.express_checkout_divider": "O PAGUEU AMB TARGETA",
  "error_page.trouble_accessing": "Si teniu problemes per accedir a la vostra compra, poseu-vos en contacte amb el servei d'assistència a ",
  "error_page.close_button_title": "Vés a {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Falta el permís de Stripe",
  "error_page.button_close": "Tanca",
  "error_page.error_message_stripe_invalid_tax_origin_address": "La compra ha fallat perquè l'adreça d'origen fiscal no és vàlida. En producció, les compres funcionaran sense impostos aplicats.",
  "error_page.error_message_stripe_tax_not_active": "La compra ha fallat perquè Stripe Tax no està activat. En producció, les compres funcionaran sense impostos aplicats.",
  "error_page.error_only_in_sandbox": "Aquest missatge apareix només a l'entorn de proves.",
  "error_page.error_message_stripe_missing_required_permission": "La compra ha fallat perquè l'aplicació Stripe no té un permís necessari. En producció, les compres funcionaran sense impostos aplicats.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax no està actiu",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Adreça d'origen fiscal no vàlida",
  "apple_pay.free_trial": "Prova gratuïta"
}, tc = {
  "periods.week": "{{amount}} 周",
  "periods.month": "{{amount}} 月",
  "periods.year": "{{amount}} 年",
  "periods.day": "{{amount}} 天",
  "periods.weekShort": "{{amount}}周",
  "periods.monthShort": "{{amount}}月",
  "periods.yearShort": "{{amount}}年",
  "periods.dayShort": "{{amount}}天",
  "periods.lifetime": "终身",
  "periods.weekPlural": "{{amount}} 周",
  "periods.monthPlural": "{{amount}} 个月",
  "periods.yearPlural": "{{amount}} 年",
  "periods.dayPlural": "{{amount}} 天",
  "periods.weekFrequency": "每周",
  "periods.monthFrequency": "每月",
  "periods.yearFrequency": "每年",
  "periods.dayFrequency": "每天",
  "periods.perWeekFrequency": "每周",
  "periods.perMonthFrequency": "每月",
  "periods.perYearFrequency": "每年",
  "periods.perDayFrequency": "每天",
  "periods.unknownFrequency": "未知",
  "periods.weekFrequencyPlural": "每 {{amount}} 周",
  "periods.monthFrequencyPlural": "每 {{amount}} 个月",
  "periods.yearFrequencyPlural": "每 {{amount}} 年",
  "periods.dayFrequencyPlural": "每 {{amount}} 天",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} 天免费试用",
  "product_info.price_after_free_trial": "试用期结束后，于 {{renewalDate}}",
  "product_info.renewal_frequency": "续订 {{frequency}}",
  "product_info.continues_until_cancelled": "持续到取消",
  "product_info.cancel_anytime": "随时取消",
  "payment_entry_page.payment_step_title": "RevenueCat 安全结账",
  "payment_entry_page.terms_info": "通过提供您的卡信息，您允许 {{appName}} 根据其条款向您的卡收取未来付款。",
  "payment_entry_page.button_pay": "立即支付",
  "payment_entry_page.button_start_trial": "开始试用",
  "success_page.purchase_successful": "支付完成",
  "success_page.button_close": "继续",
  "error_page.if_error_persists": "如果错误仍然存在，请联系 ",
  "error_page.error_title_already_subscribed": "您已订阅 {{productTitle}}",
  "error_page.error_title_already_purchased": "您已购买 {{productTitle}}",
  "error_page.error_title_other_errors": "出现错误",
  "error_page.error_message_already_subscribed": "您不能再次订阅此产品。",
  "error_page.error_message_already_purchased": "您不能再次购买此产品。",
  "error_page.error_message_missing_email_error": "完成购买需要邮箱地址。",
  "error_page.error_message_network_error": "网络错误。请检查您的互联网连接。",
  "error_page.error_message_error_charging_payment": "支付失败。",
  "error_page.error_message_error_setting_up_purchase": "由于错误，购买未启动（错误代码：{{errorCode}}）。",
  "error_page.error_message_invalid_tax_location": "我们无法验证您的账单地址。请仔细检查邮政编码和国家是否正确。",
  "error_page.error_message_unknown_error": "发生未知错误（错误代码：{{errorCode}}）。",
  "error_page.button_try_again": "重试",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% 折扣",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "今天应付总额",
  "product_info.subscribe_to": "订阅",
  "payment_entry_page.trial_info": "试用期结束后，您将被收取 {{price}} {{perFrequency}}，从 {{renewalDate}} 开始。您可以随时在此之前取消。",
  "navbar_header.details": "详情",
  "navbar_header.back_button": "返回",
  "pricing_dropdown.show_details": "显示详情",
  "pricing_dropdown.hide_details": "隐藏详情",
  "pricing_table.tax": "税",
  "pricing_table.trial_ends": "试用期结束后，于{{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "今日应付总额",
  "pricing_table.total_excluding_tax": "总计（不含税）",
  "pricing_table.enter_billing_address_to_calculate": "输入账单地址以计算",
  "pricing_table.enter_state_or_postal_code_to_calculate": "输入州或邮政编码以计算",
  "pricing_table.enter_postal_code_to_calculate": "输入邮政编码以计算",
  "error_page.error_message_invalid_email_error": "无法验证电子邮件地址{{email}}。请提供有效的电子邮件地址。",
  "payment_entry_page.button_payment_method": "使用{{paymentMethod}}支付{{formattedPrice}}",
  "payment_entry_page.button_with_price": "支付{{formattedPrice}}",
  "price_update.title": "价格更新",
  "price_update.base_message": "总价已根据您的账单地址更新了税费。请查看并重试。您的银行卡只会扣款一次。",
  "price_update.trial_message": "根据您的账单地址，订阅价格已更新为含税价格。免费试用仍然有效。请查看并重试。",
  "payment_entry_page.express_checkout_divider": "或使用银行卡支付",
  "error_page.trouble_accessing": "如果您在访问购买项目时遇到问题，请通过以下方式联系支持：",
  "error_page.close_button_title": "前往{{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "缺少Stripe权限",
  "error_page.button_close": "关闭",
  "error_page.error_message_stripe_invalid_tax_origin_address": "购买失败，因为税务起始地址无效。在生产环境中，购买将在不应用税款的情况下进行。",
  "error_page.error_message_stripe_tax_not_active": "购买失败，因为Stripe Tax未启用。在生产环境中，购买将在不应用税款的情况下进行。",
  "error_page.error_only_in_sandbox": "此消息仅在沙盒中显示。",
  "error_page.error_message_stripe_missing_required_permission": "购买失败，因为Stripe应用程序缺少必需的权限。在生产环境中，购买将在不应用税款的情况下进行。",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax未激活",
  "error_page.error_title_stripe_invalid_tax_origin_address": "税务起始地址无效",
  "apple_pay.free_trial": "免费试用"
}, ac = {
  "periods.week": "{{amount}} 週",
  "periods.month": "{{amount}} 個月",
  "periods.year": "{{amount}} 年",
  "periods.day": "{{amount}} 天",
  "periods.weekShort": "{{amount}}週",
  "periods.monthShort": "{{amount}}月",
  "periods.yearShort": "{{amount}}年",
  "periods.dayShort": "{{amount}}天",
  "periods.lifetime": "終身",
  "periods.weekPlural": "{{amount}} 週",
  "periods.monthPlural": "{{amount}} 個月",
  "periods.yearPlural": "{{amount}} 年",
  "periods.dayPlural": "{{amount}} 天",
  "periods.weekFrequency": "每週",
  "periods.monthFrequency": "每月",
  "periods.yearFrequency": "每年",
  "periods.dayFrequency": "每天",
  "periods.perWeekFrequency": "每週",
  "periods.perMonthFrequency": "每月",
  "periods.perYearFrequency": "每年",
  "periods.perDayFrequency": "每天",
  "periods.unknownFrequency": "未知",
  "periods.weekFrequencyPlural": "每 {{amount}} 週",
  "periods.monthFrequencyPlural": "每 {{amount}} 個月",
  "periods.yearFrequencyPlural": "每 {{amount}} 年",
  "periods.dayFrequencyPlural": "每 {{amount}} 天",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} 天免費試用",
  "product_info.price_after_free_trial": "試用期結束後，於 {{renewalDate}}",
  "product_info.renewal_frequency": "每 {{frequency}} 續約",
  "product_info.continues_until_cancelled": "持續到取消",
  "product_info.cancel_anytime": "隨時取消",
  "payment_entry_page.payment_step_title": "RevenueCat 安全結帳",
  "payment_entry_page.terms_info": "提供您的卡號即表示您允許 {{appName}} 依照其條款向您的卡收取未來付款。",
  "payment_entry_page.button_pay": "立即付款",
  "payment_entry_page.button_start_trial": "開始試用",
  "success_page.purchase_successful": "付款完成",
  "success_page.button_close": "繼續",
  "error_page.if_error_persists": "如果錯誤持續存在，請聯絡 ",
  "error_page.error_title_already_subscribed": "您已經訂閱 {{productTitle}}",
  "error_page.error_title_already_purchased": "您已經購買 {{productTitle}}",
  "error_page.error_title_other_errors": "發生錯誤",
  "error_page.error_message_already_subscribed": "您無法再次訂閱此產品。",
  "error_page.error_message_already_purchased": "您無法再次購買此產品。",
  "error_page.error_message_missing_email_error": "完成購買需要電子郵件地址。",
  "error_page.error_message_network_error": "網路錯誤。請檢查您的網路連線。",
  "error_page.error_message_error_charging_payment": "付款失敗。",
  "error_page.error_message_error_setting_up_purchase": "由於發生錯誤，購買未啟動（錯誤代碼：{{errorCode}}）。",
  "error_page.error_message_invalid_tax_location": "我們無法驗證您的帳單地址。請仔細檢查郵遞區號和國家是否正確。",
  "error_page.error_message_unknown_error": "發生不明錯誤（錯誤代碼：{{errorCode}}）。",
  "error_page.button_try_again": "再試一次",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% 折扣",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}} ({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "今日應付總額",
  "product_info.subscribe_to": "訂閱",
  "payment_entry_page.trial_info": "在您的試用期結束後，您將從 {{renewalDate}} 開始被收取 {{price}} {{perFrequency}} 的費用。您隨時可以在此之前取消。",
  "navbar_header.details": "詳細資訊",
  "navbar_header.back_button": "返回",
  "pricing_dropdown.show_details": "顯示詳細資訊",
  "pricing_dropdown.hide_details": "隱藏詳細資訊",
  "pricing_table.tax": "稅金",
  "pricing_table.trial_ends": "試用期結束後，於 {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "今日應付總額",
  "pricing_table.total_excluding_tax": "總計（不含稅）",
  "pricing_table.enter_billing_address_to_calculate": "輸入帳單地址以計算",
  "pricing_table.enter_state_or_postal_code_to_calculate": "輸入州或郵政編碼以計算",
  "pricing_table.enter_postal_code_to_calculate": "輸入郵政編碼以計算",
  "error_page.error_message_invalid_email_error": "無法驗證電子郵件地址 {{email}}。請提供有效的電子郵件地址。",
  "payment_entry_page.button_payment_method": "使用 {{paymentMethod}} 支付 {{formattedPrice}}",
  "payment_entry_page.button_with_price": "支付 {{formattedPrice}}",
  "price_update.title": "價格更新",
  "price_update.base_message": "總價已根據您的帳單地址更新稅金。請檢查後重試。您的信用卡只會被收取一次費用。",
  "price_update.trial_message": "根據您的帳單地址，訂閱價格已更新為含稅價格。免費試用仍然有效。請查看並重試。",
  "payment_entry_page.express_checkout_divider": "或以信用卡付款",
  "error_page.trouble_accessing": "如果您在存取購買項目時遇到問題，請透過以下方式聯絡支援人員：",
  "error_page.close_button_title": "前往{{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "缺少 Stripe 權限",
  "error_page.button_close": "關閉",
  "error_page.error_message_stripe_invalid_tax_origin_address": "購買失敗，因為稅務起始地址無效。在正式環境中，購買將在不套用稅金的情況下運作。",
  "error_page.error_message_stripe_tax_not_active": "購買失敗，因為 Stripe Tax 未啟用。在正式環境中，購買將在不套用稅金的情況下運作。",
  "error_page.error_only_in_sandbox": "此訊息僅在沙盒中顯示。",
  "error_page.error_message_stripe_missing_required_permission": "購買失敗，因為 Stripe 應用程式缺少必要的權限。在正式環境中，購買將在不套用稅金的情況下運作。",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax 未啟用",
  "error_page.error_title_stripe_invalid_tax_origin_address": "無效的稅務起始地址",
  "apple_pay.free_trial": "免費試用"
}, nc = {
  "periods.week": "{{amount}} tjedan",
  "periods.month": "{{amount}} mjesec",
  "periods.year": "{{amount}} godina",
  "periods.day": "{{amount}} dan",
  "periods.weekShort": "{{amount}}tj",
  "periods.monthShort": "{{amount}}mj",
  "periods.yearShort": "{{amount}}g",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "doživotno",
  "periods.weekPlural": "{{amount}} tjedana",
  "periods.monthPlural": "{{amount}} mjeseci",
  "periods.yearPlural": "{{amount}} godina",
  "periods.dayPlural": "{{amount}} dana",
  "periods.weekFrequency": "tjedno",
  "periods.monthFrequency": "mjesečno",
  "periods.yearFrequency": "godišnje",
  "periods.dayFrequency": "dnevno",
  "periods.perWeekFrequency": "tjedno",
  "periods.perMonthFrequency": "mjesečno",
  "periods.perYearFrequency": "godišnje",
  "periods.perDayFrequency": "dnevno",
  "periods.unknownFrequency": "nepoznato",
  "periods.weekFrequencyPlural": "svakih {{amount}} tjedana",
  "periods.monthFrequencyPlural": "svakih {{amount}} mjeseci",
  "periods.yearFrequencyPlural": "svakih {{amount}} godina",
  "periods.dayFrequencyPlural": "svakih {{amount}} dana",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} besplatno probno razdoblje",
  "product_info.price_after_free_trial": "Nakon isteka probnog razdoblja, {{renewalDate}}",
  "product_info.renewal_frequency": "Obnavlja se {{frequency}}",
  "product_info.continues_until_cancelled": "Nastavlja se dok se ne otkaže",
  "product_info.cancel_anytime": "Otkažite u bilo kojem trenutku",
  "payment_entry_page.payment_step_title": "Sigurna naplata putem RevenueCat",
  "payment_entry_page.terms_info": "Davanjem podataka o kartici dopuštate {{appName}} naplatu s vaše kartice za buduće uplate u skladu s njihovim uvjetima.",
  "payment_entry_page.button_pay": "Plati sada",
  "payment_entry_page.button_start_trial": "Počni probno razdoblje",
  "success_page.purchase_successful": "Uplata je uspješna",
  "success_page.button_close": "Nastavi",
  "error_page.if_error_persists": "Ako se pogreška nastavi, obratite se ",
  "error_page.error_title_already_subscribed": "Već ste pretplaćeni na {{productTitle}}",
  "error_page.error_title_already_purchased": "Već ste kupili {{productTitle}}",
  "error_page.error_title_other_errors": "Nešto je pošlo po zlu",
  "error_page.error_message_already_subscribed": "Ne možete se ponovno pretplatiti na ovaj proizvod.",
  "error_page.error_message_already_purchased": "Ne možete ponovno kupiti ovaj proizvod.",
  "error_page.error_message_missing_email_error": "E-pošta je potrebna za dovršetak kupnje.",
  "error_page.error_message_network_error": "Mrežna pogreška. Provjerite internetsku vezu.",
  "error_page.error_message_error_charging_payment": "Plaćanje nije uspjelo.",
  "error_page.error_message_error_setting_up_purchase": "Kupnja nije započela zbog pogreške (kod pogreške: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Nismo mogli potvrditi vašu adresu za naplatu. Molimo provjerite poštanski broj i državu kako biste bili sigurni da su točni.",
  "error_page.error_message_unknown_error": "Došlo je do nepoznate pogreške (kod pogreške: {{errorCode}}).",
  "error_page.button_try_again": "Pokušaj ponovno",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% popusta",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Ukupno dospijeće danas",
  "product_info.subscribe_to": "Pretplatite se",
  "payment_entry_page.trial_info": "Nakon završetka probnog razdoblja, bit će vam naplaćeno {{price}} {{perFrequency}} počevši od {{renewalDate}}. Uvijek možete otkazati prije toga.",
  "navbar_header.details": "Detalji",
  "navbar_header.back_button": "Natrag",
  "pricing_dropdown.show_details": "Prikaži detalje",
  "pricing_dropdown.hide_details": "Sakrij detalje",
  "pricing_table.tax": "Porez",
  "pricing_table.trial_ends": "Nakon isteka probnog razdoblja, {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Ukupan iznos dospijeća danas",
  "pricing_table.total_excluding_tax": "Ukupno bez poreza",
  "pricing_table.enter_billing_address_to_calculate": "Unesite adresu za naplatu za izračun",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Unesite državu ili poštanski broj za izračun",
  "pricing_table.enter_postal_code_to_calculate": "Unesite poštanski broj za izračun",
  "error_page.error_message_invalid_email_error": "Adresa e-pošte {{email}} nije se mogla potvrditi. Molimo unesite valjanu adresu e-pošte.",
  "payment_entry_page.button_payment_method": "Plati {{formattedPrice}} putem {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Plati {{formattedPrice}}",
  "price_update.title": "Ažuriranje cijene",
  "price_update.base_message": "Ukupna cijena je ažurirana s porezom na temelju vaše adrese za naplatu. Pregledajte i pokušajte ponovo. Vaša kartica bit će naplaćena samo jednom.",
  "price_update.trial_message": "Cijena pretplate je ažurirana da uključi poreze na temelju vaše adrese za naplatu. Besplatno probno razdoblje i dalje vrijedi. Molimo provjerite i pokušajte ponovno.",
  "payment_entry_page.express_checkout_divider": "ILI PLATITE KARTICOM",
  "error_page.trouble_accessing": "Ako imate problema s pristupom kupnji, obratite se podršci na ",
  "error_page.close_button_title": "Idi na {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Nedostaje Stripe dopuštenje",
  "error_page.button_close": "Zatvori",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Kupnja nije uspjela jer je adresa poreznog podrijetla nevažeća. U produkciji će kupnje funkcionirati bez primijenjenih poreza.",
  "error_page.error_message_stripe_tax_not_active": "Kupnja nije uspjela jer Stripe Tax nije omogućen. U produkciji će kupnje funkcionirati bez primijenjenih poreza.",
  "error_page.error_only_in_sandbox": "Ova se poruka pojavljuje samo u sandboxu.",
  "error_page.error_message_stripe_missing_required_permission": "Kupnja nije uspjela jer Stripe aplikaciji nedostaje potrebno dopuštenje. U produkciji će kupnje funkcionirati bez primijenjenih poreza.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax nije aktivan",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Nevažeća adresa poreznog podrijetla",
  "apple_pay.free_trial": "Besplatna proba"
}, oc = {
  "periods.week": "{{amount}} týden",
  "periods.month": "{{amount}} měsíc",
  "periods.year": "{{amount}} rok",
  "periods.day": "{{amount}} den",
  "periods.weekShort": "{{amount}}týd",
  "periods.monthShort": "{{amount}}měs",
  "periods.yearShort": "{{amount}}rok",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "doživotně",
  "periods.weekPlural": "{{amount}} týdnů",
  "periods.monthPlural": "{{amount}} měsíců",
  "periods.yearPlural": "{{amount}} let",
  "periods.dayPlural": "{{amount}} dnů",
  "periods.weekFrequency": "týdně",
  "periods.monthFrequency": "měsíčně",
  "periods.yearFrequency": "ročně",
  "periods.dayFrequency": "denně",
  "periods.perWeekFrequency": "týdně",
  "periods.perMonthFrequency": "měsíčně",
  "periods.perYearFrequency": "ročně",
  "periods.perDayFrequency": "denně",
  "periods.unknownFrequency": "neznámé",
  "periods.weekFrequencyPlural": "každých {{amount}} týdnů",
  "periods.monthFrequencyPlural": "každých {{amount}} měsíců",
  "periods.yearFrequencyPlural": "každých {{amount}} let",
  "periods.dayFrequencyPlural": "každých {{amount}} dnů",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} zkušební verze zdarma",
  "product_info.price_after_free_trial": "Po skončení zkušební verze, {{renewalDate}}",
  "product_info.renewal_frequency": "Obnovuje se {{frequency}}",
  "product_info.continues_until_cancelled": "Pokračuje, dokud není zrušeno",
  "product_info.cancel_anytime": "Zrušit kdykoli",
  "payment_entry_page.payment_step_title": "Bezpečné placení přes RevenueCat",
  "payment_entry_page.terms_info": "Poskytnutím informací o vaší kartě umožňujete aplikaci {{appName}} účtovat vaši kartu za budoucí platby v souladu s jejich podmínkami.",
  "payment_entry_page.button_pay": "Platit nyní",
  "payment_entry_page.button_start_trial": "Spustit zkušební verzi",
  "success_page.purchase_successful": "Platba dokončena",
  "success_page.button_close": "Pokračovat",
  "error_page.if_error_persists": "Pokud chyba přetrvává, kontaktujte ",
  "error_page.error_title_already_subscribed": "Již máte předplatné pro {{productTitle}}",
  "error_page.error_title_already_purchased": "Již jste zakoupili {{productTitle}}",
  "error_page.error_title_other_errors": "Něco se pokazilo",
  "error_page.error_message_already_subscribed": "Nemůžete si znovu předplatit tento produkt.",
  "error_page.error_message_already_purchased": "Tento produkt si nemůžete znovu zakoupit.",
  "error_page.error_message_missing_email_error": "Pro dokončení nákupu je vyžadován e-mail.",
  "error_page.error_message_network_error": "Síťová chyba. Zkontrolujte prosím své internetové připojení.",
  "error_page.error_message_error_charging_payment": "Platba selhala.",
  "error_page.error_message_error_setting_up_purchase": "Nákup nebyl zahájen z důvodu chyby (kód chyby: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Nemohli jsme ověřit vaši fakturační adresu. Zkontrolujte prosím, zda je poštovní směrovací číslo a země správné.",
  "error_page.error_message_unknown_error": "Došlo k neznámé chybě (kód chyby: {{errorCode}}).",
  "error_page.button_try_again": "Zkusit znovu",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% sleva",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Celkem dnes k zaplacení",
  "product_info.subscribe_to": "Předplatit",
  "payment_entry_page.trial_info": "Po skončení zkušební verze vám bude účtováno {{price}} {{perFrequency}} počínaje {{renewalDate}}. Předtím můžete kdykoli zrušit.",
  "navbar_header.details": "Podrobnosti",
  "navbar_header.back_button": "Zpět",
  "pricing_dropdown.show_details": "Zobrazit podrobnosti",
  "pricing_dropdown.hide_details": "Skrýt podrobnosti",
  "pricing_table.tax": "Daň",
  "pricing_table.trial_ends": "Po skončení zkušební doby, dne {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Celkem splatné dnes",
  "pricing_table.total_excluding_tax": "Celkem bez daně",
  "pricing_table.enter_billing_address_to_calculate": "Zadejte fakturační adresu pro výpočet",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Zadejte stát nebo PSČ pro výpočet",
  "pricing_table.enter_postal_code_to_calculate": "Zadejte PSČ pro výpočet",
  "error_page.error_message_invalid_email_error": "E-mailová adresa {{email}} nemohla být ověřena. Zadejte prosím platnou e-mailovou adresu.",
  "payment_entry_page.button_payment_method": "Zaplatit {{formattedPrice}} pomocí {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Zaplatit {{formattedPrice}}",
  "price_update.title": "Aktualizace ceny",
  "price_update.base_message": "Celková cena byla aktualizována o daň na základě vaší fakturační adresy. Zkontrolujte ji a zkuste to znovu. Vaše karta bude stržena pouze jednou.",
  "price_update.trial_message": "Cena předplatného byla aktualizována včetně daní na základě vaší fakturační adresy. Bezplatná zkušební doba stále platí. Prosím, zkontrolujte a zkuste to znovu.",
  "payment_entry_page.express_checkout_divider": "NEBO ZAPLATIT KARTOU",
  "error_page.trouble_accessing": "Pokud máte potíže s přístupem k zakoupenému obsahu, kontaktujte podporu na ",
  "error_page.close_button_title": "Přejít na {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Chybí oprávnění Stripe",
  "error_page.button_close": "Zavřít",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Nákup se nezdařil, protože adresa původu daně je neplatná. V produkčním prostředí budou nákupy fungovat bez uplatnění daní.",
  "error_page.error_message_stripe_tax_not_active": "Nákup se nezdařil, protože Stripe Tax není aktivní. V produkčním prostředí budou nákupy fungovat bez uplatnění daní.",
  "error_page.error_only_in_sandbox": "Tato zpráva se zobrazuje pouze v sandboxu.",
  "error_page.error_message_stripe_missing_required_permission": "Nákup se nezdařil, protože aplikaci Stripe chybí požadované oprávnění. V produkčním prostředí budou nákupy fungovat bez uplatnění daní.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax není aktivní",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Neplatná adresa původu daně",
  "apple_pay.free_trial": "Zkušební verze zdarma"
}, ic = {
  "periods.week": "{{amount}} uge",
  "periods.month": "{{amount}} måned",
  "periods.year": "{{amount}} år",
  "periods.day": "{{amount}} dag",
  "periods.weekShort": "{{amount}}ug",
  "periods.monthShort": "{{amount}}md",
  "periods.yearShort": "{{amount}}år",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "livstid",
  "periods.weekPlural": "{{amount}} uger",
  "periods.monthPlural": "{{amount}} måneder",
  "periods.yearPlural": "{{amount}} år",
  "periods.dayPlural": "{{amount}} dage",
  "periods.weekFrequency": "ugentligt",
  "periods.monthFrequency": "månedligt",
  "periods.yearFrequency": "årligt",
  "periods.dayFrequency": "dagligt",
  "periods.perWeekFrequency": "pr. uge",
  "periods.perMonthFrequency": "pr. måned",
  "periods.perYearFrequency": "pr. år",
  "periods.perDayFrequency": "pr. dag",
  "periods.unknownFrequency": "ukendt",
  "periods.weekFrequencyPlural": "hver {{amount}} uger",
  "periods.monthFrequencyPlural": "hver {{amount}} måneder",
  "periods.yearFrequencyPlural": "hver {{amount}} år",
  "periods.dayFrequencyPlural": "hver {{amount}} dage",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} gratis prøveperiode",
  "product_info.price_after_free_trial": "Efter prøveperioden slutter, den {{renewalDate}}",
  "product_info.renewal_frequency": "Fornyes {{frequency}}",
  "product_info.continues_until_cancelled": "Fortsætter indtil annulleret",
  "product_info.cancel_anytime": "Annuller når som helst",
  "payment_entry_page.payment_step_title": "Sikker betaling via RevenueCat",
  "payment_entry_page.terms_info": "Ved at angive dine kortinformationer giver du {{appName}} tilladelse til at trække beløb på dit kort for fremtidige betalinger i overensstemmelse med deres vilkår.",
  "payment_entry_page.button_pay": "Betal nu",
  "payment_entry_page.button_start_trial": "Start prøveperiode",
  "success_page.purchase_successful": "Betaling gennemført",
  "success_page.button_close": "Fortsæt",
  "error_page.if_error_persists": "Hvis fejlen fortsætter, kontakt venligst ",
  "error_page.error_title_already_subscribed": "Du abonnerer allerede på {{productTitle}}",
  "error_page.error_title_already_purchased": "Du har allerede købt {{productTitle}}",
  "error_page.error_title_other_errors": "Noget gik galt",
  "error_page.error_message_already_subscribed": "Du kan ikke abonnere på dette produkt igen.",
  "error_page.error_message_already_purchased": "Du kan ikke købe dette produkt igen.",
  "error_page.error_message_missing_email_error": "Email er påkrævet for at gennemføre købet.",
  "error_page.error_message_network_error": "Netværksfejl. Kontroller din internetforbindelse.",
  "error_page.error_message_error_charging_payment": "Betalingen mislykkedes.",
  "error_page.error_message_error_setting_up_purchase": "Køb ikke startet på grund af en fejl (fejlkode: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Vi kunne ikke bekræfte din faktureringsadresse. Kontroller venligst, at postnummeret og landet er korrekte.",
  "error_page.error_message_unknown_error": "Der opstod en ukendt fejl (fejlkode: {{errorCode}}).",
  "error_page.button_try_again": "Prøv igen",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% rabat",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Samlet beløb for i dag",
  "product_info.subscribe_to": "Abonner på",
  "payment_entry_page.trial_info": "Efter din prøveperiode slutter, vil du blive opkrævet {{price}} {{perFrequency}} fra {{renewalDate}}. Du kan altid opsige før da.",
  "navbar_header.details": "Detaljer",
  "navbar_header.back_button": "Tilbage",
  "pricing_dropdown.show_details": "Vis detaljer",
  "pricing_dropdown.hide_details": "Skjul detaljer",
  "pricing_table.tax": "Moms",
  "pricing_table.trial_ends": "Efter prøveperioden slutter, den {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Samlet beløb forfalden i dag",
  "pricing_table.total_excluding_tax": "Samlet beløb eksklusive moms",
  "pricing_table.enter_billing_address_to_calculate": "Indtast faktureringsadresse for at beregne",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Indtast stat eller postnummer for at beregne",
  "pricing_table.enter_postal_code_to_calculate": "Indtast postnummer for at beregne",
  "error_page.error_message_invalid_email_error": "E-mailadressen {{email}} kunne ikke bekræftes. Angiv en gyldig e-mailadresse.",
  "payment_entry_page.button_payment_method": "Betal {{formattedPrice}} med {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Betal {{formattedPrice}}",
  "price_update.title": "Prisopdatering",
  "price_update.base_message": "Den samlede pris er blevet opdateret med moms baseret på din faktureringsadresse. Gennemgå og prøv igen. Dit kort vil kun blive debiteret én gang.",
  "price_update.trial_message": "Abonnementsprisen er opdateret for at inkludere skatter baseret på din faktureringsadresse. Den gratis prøveperiode gælder stadig. Kontroller venligst og prøv igen.",
  "payment_entry_page.express_checkout_divider": "ELLER BETAL MED KORT",
  "error_page.trouble_accessing": "Hvis du har problemer med at få adgang til dit køb, kan du kontakte support på ",
  "error_page.close_button_title": "Gå til {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Manglende Stripe-tilladelse",
  "error_page.button_close": "Luk",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Købet mislykkedes, fordi skatteoprindelsesadressen er ugyldig. I produktion vil køb fungere uden påførte skatter.",
  "error_page.error_message_stripe_tax_not_active": "Købet mislykkedes, fordi Stripe Tax ikke er aktiveret. I produktion vil køb fungere uden påførte skatter.",
  "error_page.error_only_in_sandbox": "Denne meddelelse vises kun i sandkassen.",
  "error_page.error_message_stripe_missing_required_permission": "Købet mislykkedes, fordi Stripe-appen mangler en påkrævet tilladelse. I produktion vil køb fungere uden påførte skatter.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax er ikke aktiv",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Ugyldig skatteoprindelsesadresse",
  "apple_pay.free_trial": "Gratis prøveperiode"
}, sc = {
  "periods.week": "{{amount}} week",
  "periods.month": "{{amount}} maand",
  "periods.year": "{{amount}} jaar",
  "periods.day": "{{amount}} dag",
  "periods.weekShort": "{{amount}}wk",
  "periods.monthShort": "{{amount}}maand",
  "periods.yearShort": "{{amount}}jr",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "levenslang",
  "periods.weekPlural": "{{amount}} weken",
  "periods.monthPlural": "{{amount}} maanden",
  "periods.yearPlural": "{{amount}} jaren",
  "periods.dayPlural": "{{amount}} dagen",
  "periods.weekFrequency": "wekelijks",
  "periods.monthFrequency": "maandelijks",
  "periods.yearFrequency": "jaarlijks",
  "periods.dayFrequency": "dagelijks",
  "periods.perWeekFrequency": "per week",
  "periods.perMonthFrequency": "per maand",
  "periods.perYearFrequency": "per jaar",
  "periods.perDayFrequency": "per dag",
  "periods.unknownFrequency": "onbekend",
  "periods.weekFrequencyPlural": "elke {{amount}} weken",
  "periods.monthFrequencyPlural": "elke {{amount}} maanden",
  "periods.yearFrequencyPlural": "elke {{amount}} jaren",
  "periods.dayFrequencyPlural": "elke {{amount}} dagen",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} gratis proefperiode",
  "product_info.price_after_free_trial": "Na afloop van de proefperiode, op {{renewalDate}}",
  "product_info.renewal_frequency": "Wordt verlengd {{frequency}}",
  "product_info.continues_until_cancelled": "Wordt voortgezet tot annulering",
  "product_info.cancel_anytime": "Annuleer op elk gewenst moment",
  "payment_entry_page.payment_step_title": "Veilige afrekening via RevenueCat",
  "payment_entry_page.terms_info": "Door uw kaartgegevens te verstrekken, staat u {{appName}} toe om uw kaart te belasten voor toekomstige betalingen in overeenstemming met hun voorwaarden.",
  "payment_entry_page.button_pay": "Nu betalen",
  "payment_entry_page.button_start_trial": "Start proefperiode",
  "success_page.purchase_successful": "Betaling voltooid",
  "success_page.button_close": "Doorgaan",
  "error_page.if_error_persists": "Neem contact op met  als de fout aanhoudt",
  "error_page.error_title_already_subscribed": "Je bent al geabonneerd op {{productTitle}}",
  "error_page.error_title_already_purchased": "Je hebt {{productTitle}} al gekocht",
  "error_page.error_title_other_errors": "Er is iets misgegaan",
  "error_page.error_message_already_subscribed": "Je kunt je niet opnieuw abonneren op dit product.",
  "error_page.error_message_already_purchased": "Je kunt dit product niet opnieuw kopen.",
  "error_page.error_message_missing_email_error": "Een e-mailadres is vereist om de aankoop te voltooien.",
  "error_page.error_message_network_error": "Netwerkfout. Controleer uw internetverbinding.",
  "error_page.error_message_error_charging_payment": "Betaling mislukt.",
  "error_page.error_message_error_setting_up_purchase": "Aankoop niet gestart vanwege een fout (foutcode: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "We konden uw factuuradres niet verifiëren. Controleer of de postcode en het land correct zijn.",
  "error_page.error_message_unknown_error": "Er is een onbekende fout opgetreden (foutcode: {{errorCode}}).",
  "error_page.button_try_again": "Opnieuw proberen",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% korting",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Totaal te betalen vandaag",
  "product_info.subscribe_to": "Abonneren op",
  "payment_entry_page.trial_info": "Na afloop van je proefperiode wordt {{price}} {{perFrequency}} in rekening gebracht vanaf {{renewalDate}}. Je kunt altijd eerder annuleren.",
  "navbar_header.details": "Details",
  "navbar_header.back_button": "Terug",
  "pricing_dropdown.show_details": "Toon details",
  "pricing_dropdown.hide_details": "Verberg details",
  "pricing_table.tax": "Btw",
  "pricing_table.trial_ends": "Na afloop van de proefperiode, op {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Totaal vandaag te betalen",
  "pricing_table.total_excluding_tax": "Totaal exclusief btw",
  "pricing_table.enter_billing_address_to_calculate": "Voer het factuuradres in om te berekenen",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Voer provincie of postcode in om te berekenen",
  "pricing_table.enter_postal_code_to_calculate": "Voer postcode in om te berekenen",
  "error_page.error_message_invalid_email_error": "Het e-mailadres {{email}} kon niet worden geverifieerd. Geef een geldig e-mailadres op.",
  "payment_entry_page.button_payment_method": "Betaal {{formattedPrice}} met {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Betaal {{formattedPrice}}",
  "price_update.title": "Prijsupdate",
  "price_update.base_message": "De totale prijs is bijgewerkt met belasting op basis van uw factuuradres. Controleer en probeer het opnieuw. Uw kaart wordt slechts één keer belast.",
  "price_update.trial_message": "De abonnementsprijs is bijgewerkt om belastingen op te nemen op basis van uw factuuradres. De gratis proefperiode blijft van toepassing. Controleer en probeer het opnieuw.",
  "payment_entry_page.express_checkout_divider": "OF BETAAL MET EEN KAART",
  "error_page.trouble_accessing": "Als je problemen hebt met het verkrijgen van toegang tot je aankoop, neem dan contact op met de ondersteuning via ",
  "error_page.close_button_title": "Ga naar {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Ontbrekende Stripe-toestemming",
  "error_page.button_close": "Sluiten",
  "error_page.error_message_stripe_invalid_tax_origin_address": "De aankoop is mislukt omdat het belastingoorsprongadres ongeldig is. In productie werken aankopen zonder toegepaste belastingen.",
  "error_page.error_message_stripe_tax_not_active": "De aankoop is mislukt omdat Stripe Tax niet is ingeschakeld. In productie werken aankopen zonder toegepaste belastingen.",
  "error_page.error_only_in_sandbox": "Dit bericht verschijnt alleen in de sandbox.",
  "error_page.error_message_stripe_missing_required_permission": "De aankoop is mislukt omdat de Stripe-app een vereiste toestemming mist. In productie werken aankopen zonder toegepaste belastingen.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax niet actief",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Ongeldig belastingoorsprongadres",
  "apple_pay.free_trial": "Gratis proefperiode"
}, lc = {
  "periods.week": "{{amount}} viikko",
  "periods.month": "{{amount}} kuukausi",
  "periods.year": "{{amount}} vuosi",
  "periods.day": "{{amount}} päivä",
  "periods.weekShort": "{{amount}}vk",
  "periods.monthShort": "{{amount}}kk",
  "periods.yearShort": "{{amount}}v",
  "periods.dayShort": "{{amount}}p",
  "periods.lifetime": "elämäaika",
  "periods.weekPlural": "{{amount}} viikkoa",
  "periods.monthPlural": "{{amount}} kuukautta",
  "periods.yearPlural": "{{amount}} vuotta",
  "periods.dayPlural": "{{amount}} päivää",
  "periods.weekFrequency": "viikoittain",
  "periods.monthFrequency": "kuukausittain",
  "periods.yearFrequency": "vuosittain",
  "periods.dayFrequency": "päivittäin",
  "periods.perWeekFrequency": "viikossa",
  "periods.perMonthFrequency": "kuukaudessa",
  "periods.perYearFrequency": "vuodessa",
  "periods.perDayFrequency": "päivässä",
  "periods.unknownFrequency": "tuntematon",
  "periods.weekFrequencyPlural": "joka {{amount}} viikko",
  "periods.monthFrequencyPlural": "joka {{amount}} kuukausi",
  "periods.yearFrequencyPlural": "joka {{amount}} vuosi",
  "periods.dayFrequencyPlural": "joka {{amount}} päivä",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} ilmainen kokeilujakso",
  "product_info.price_after_free_trial": "Kokeilujakson päätyttyä, {{renewalDate}}",
  "product_info.renewal_frequency": "Uusiutuu {{frequency}}",
  "product_info.continues_until_cancelled": "Jatkuu, kunnes peruutetaan",
  "product_info.cancel_anytime": "Peruuta milloin tahansa",
  "payment_entry_page.payment_step_title": "Suojautunut kassatoiminto RevenueCatin kautta",
  "payment_entry_page.terms_info": "Antamalla korttitietosi annat {{appName}} -sovellukselle luvan veloittaa korttiasi tulevien maksujen osalta heidän ehtojensa mukaisesti.",
  "payment_entry_page.button_pay": "Maksa nyt",
  "payment_entry_page.button_start_trial": "Aloita kokeilujakso",
  "success_page.purchase_successful": "Maksaminen onnistui",
  "success_page.button_close": "Jatka",
  "error_page.if_error_persists": "Jos virhe jatkuu, ota yhteyttä ",
  "error_page.error_title_already_subscribed": "Olet jo tilannut tuotteen {{productTitle}}",
  "error_page.error_title_already_purchased": "Olet jo ostanut tuotteen {{productTitle}}",
  "error_page.error_title_other_errors": "Jokin meni pieleen",
  "error_page.error_message_already_subscribed": "Et voi tilata tätä tuotetta uudelleen.",
  "error_page.error_message_already_purchased": "Et voi ostaa tätä tuotetta uudelleen.",
  "error_page.error_message_missing_email_error": "Sähköpostiosoite tarvitaan ostoksen loppuun saattamiseksi.",
  "error_page.error_message_network_error": "Verkkovirhe. Tarkista internet-yhteytesi.",
  "error_page.error_message_error_charging_payment": "Maksaminen epäonnistui.",
  "error_page.error_message_error_setting_up_purchase": "Ostoa ei aloitettu virheen vuoksi (virhekoodi: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Emme voineet vahvistaa laskutusosoitettasi. Tarkista, että postinumero ja maa ovat oikein.",
  "error_page.error_message_unknown_error": "Tapahtui tuntematon virhe (virhekoodi: {{errorCode}}).",
  "error_page.button_try_again": "Yritä uudelleen",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% alennus",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}} ({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Maksettava summa tänään",
  "product_info.subscribe_to": "Tilaa",
  "payment_entry_page.trial_info": "Kokeilujakson päätyttyä sinulta veloitetaan {{price}} {{perFrequency}} alkaen {{renewalDate}}. Voit peruuttaa tilauksen milloin tahansa ennen sitä.",
  "navbar_header.details": "Yksityiskohdat",
  "navbar_header.back_button": "Takaisin",
  "pricing_dropdown.show_details": "Näytä tiedot",
  "pricing_dropdown.hide_details": "Piilota tiedot",
  "pricing_table.tax": "Vero",
  "pricing_table.trial_ends": "Kokeilujakson päätyttyä, {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Maksettava summa tänään",
  "pricing_table.total_excluding_tax": "Veroton kokonaissumma",
  "pricing_table.enter_billing_address_to_calculate": "Syötä laskutusosoite laskeaksesi",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Syötä osavaltio tai postinumero laskeaksesi",
  "pricing_table.enter_postal_code_to_calculate": "Syötä postinumero laskeaksesi",
  "error_page.error_message_invalid_email_error": "Sähköpostiosoitetta {{email}} ei voitu vahvistaa. Anna kelvollinen sähköpostiosoite.",
  "payment_entry_page.button_payment_method": "Maksa {{formattedPrice}} käyttämällä {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Maksa {{formattedPrice}}",
  "price_update.title": "Hinnan päivitys",
  "price_update.base_message": "Kokonaishinta on päivitetty verolla laskutusosoitteesi perusteella. Tarkista ja yritä uudelleen. Korttiasi veloitetaan vain kerran.",
  "price_update.trial_message": "Tilauksen hinta on päivitetty sisältämään verot laskutusosoitteesi perusteella. Ilmainen kokeilujakso on edelleen voimassa. Tarkista ja yritä uudelleen.",
  "payment_entry_page.express_checkout_divider": "TAI MAKSA KORTILLA",
  "error_page.trouble_accessing": "Jos sinulla on ongelmia ostoksesi käyttämisessä, ota yhteyttä tukeen osoitteessa ",
  "error_page.close_button_title": "Siirry sovellukseen {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Puuttuva Stripe-käyttöoikeus",
  "error_page.button_close": "Sulje",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Osto epäonnistui, koska veron alkuperäosoite on virheellinen. Tuotantoympäristössä ostot toimivat ilman veroja.",
  "error_page.error_message_stripe_tax_not_active": "Osto epäonnistui, koska Stripe Tax ei ole käytössä. Tuotantoympäristössä ostot toimivat ilman veroja.",
  "error_page.error_only_in_sandbox": "Tämä viesti näkyy vain hiekkalaatikossa.",
  "error_page.error_message_stripe_missing_required_permission": "Osto epäonnistui, koska Stripe-sovellukselta puuttuu vaadittu käyttöoikeus. Tuotantoympäristössä ostot toimivat ilman veroja.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax ei ole aktiivinen",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Virheellinen veron alkuperäosoite",
  "apple_pay.free_trial": "Ilmainen kokeilu"
}, cc = {
  "periods.week": "{{amount}} semaine",
  "periods.month": "{{amount}} mois",
  "periods.year": "{{amount}} an",
  "periods.day": "{{amount}} jour",
  "periods.weekShort": "{{amount}}sem",
  "periods.monthShort": "{{amount}}mois",
  "periods.yearShort": "{{amount}}an",
  "periods.dayShort": "{{amount}}j",
  "periods.lifetime": "à vie",
  "periods.weekPlural": "{{amount}} semaines",
  "periods.monthPlural": "{{amount}} mois",
  "periods.yearPlural": "{{amount}} ans",
  "periods.dayPlural": "{{amount}} jours",
  "periods.weekFrequency": "hebdomadaire",
  "periods.monthFrequency": "mensuel",
  "periods.yearFrequency": "annuel",
  "periods.dayFrequency": "quotidien",
  "periods.perWeekFrequency": "par semaine",
  "periods.perMonthFrequency": "par mois",
  "periods.perYearFrequency": "par an",
  "periods.perDayFrequency": "par jour",
  "periods.unknownFrequency": "inconnu",
  "periods.weekFrequencyPlural": "toutes les {{amount}} semaines",
  "periods.monthFrequencyPlural": "tous les {{amount}} mois",
  "periods.yearFrequencyPlural": "tous les {{amount}} ans",
  "periods.dayFrequencyPlural": "tous les {{amount}} jours",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} essai gratuit",
  "product_info.price_after_free_trial": "Après la fin de l'essai, le {{renewalDate}}",
  "product_info.renewal_frequency": "Renouvellement {{frequency}}",
  "product_info.continues_until_cancelled": "Continue jusqu'à annulation",
  "product_info.cancel_anytime": "Annulez à tout moment",
  "payment_entry_page.payment_step_title": "Paiement sécurisé par RevenueCat",
  "payment_entry_page.terms_info": "En fournissant vos informations de carte, vous autorisez {{appName}} à débiter votre carte pour les paiements futurs conformément à ses conditions.",
  "payment_entry_page.button_pay": "Payer maintenant",
  "payment_entry_page.button_start_trial": "Commencer l'essai",
  "success_page.purchase_successful": "Paiement effectué",
  "success_page.button_close": "Continuer",
  "error_page.if_error_persists": "Si l'erreur persiste, veuillez contacter ",
  "error_page.error_title_already_subscribed": "Vous êtes déjà abonné à {{productTitle}}",
  "error_page.error_title_already_purchased": "Vous avez déjà acheté {{productTitle}}",
  "error_page.error_title_other_errors": "Une erreur s'est produite",
  "error_page.error_message_already_subscribed": "Vous ne pouvez pas vous abonner à nouveau à ce produit.",
  "error_page.error_message_already_purchased": "Vous ne pouvez pas acheter ce produit à nouveau.",
  "error_page.error_message_missing_email_error": "L'adresse e-mail est requise pour effectuer l'achat.",
  "error_page.error_message_network_error": "Erreur réseau. Veuillez vérifier votre connexion Internet.",
  "error_page.error_message_error_charging_payment": "Échec du paiement.",
  "error_page.error_message_error_setting_up_purchase": "L'achat n'a pas pu démarrer en raison d'une erreur (code d'erreur : {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Nous n'avons pas pu vérifier votre adresse de facturation. Veuillez vérifier que le code postal et le pays sont corrects.",
  "error_page.error_message_unknown_error": "Une erreur inconnue s'est produite (code d'erreur : {{errorCode}}).",
  "error_page.button_try_again": "Réessayer",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% de réduction",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}} ({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Total dû aujourd'hui",
  "product_info.subscribe_to": "S'abonner à",
  "payment_entry_page.trial_info": "Après la fin de votre essai, vous serez facturé {{price}} {{perFrequency}} à partir du {{renewalDate}}. Vous pouvez annuler à tout moment avant cette date.",
  "navbar_header.details": "Détails",
  "navbar_header.back_button": "Retour",
  "pricing_dropdown.show_details": "Afficher les détails",
  "pricing_dropdown.hide_details": "Masquer les détails",
  "pricing_table.tax": "Taxe",
  "pricing_table.trial_ends": "Après la fin de l'essai, le {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Total dû aujourd'hui",
  "pricing_table.total_excluding_tax": "Total hors taxes",
  "pricing_table.enter_billing_address_to_calculate": "Saisir l'adresse de facturation pour calculer",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Entrez l'état ou le code postal pour calculer",
  "pricing_table.enter_postal_code_to_calculate": "Entrez le code postal pour calculer",
  "error_page.error_message_invalid_email_error": "L'adresse e-mail {{email}} n'a pas pu être vérifiée. Veuillez fournir une adresse e-mail valide.",
  "payment_entry_page.button_payment_method": "Payer {{formattedPrice}} avec {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Payer {{formattedPrice}}",
  "price_update.title": "Mise à jour du prix",
  "price_update.base_message": "Le prix total a été mis à jour avec la taxe en fonction de votre adresse de facturation. Veuillez vérifier et réessayer. Votre carte ne sera débitée qu'une seule fois.",
  "price_update.trial_message": "Le prix de l'abonnement a été mis à jour pour inclure les taxes en fonction de votre adresse de facturation. La période d'essai gratuit reste applicable. Veuillez vérifier et réessayer.",
  "payment_entry_page.express_checkout_divider": "OU PAYER PAR CARTE",
  "error_page.trouble_accessing": "Si vous avez des difficultés à accéder à votre achat, contactez le support à l'adresse suivante : ",
  "error_page.close_button_title": "Aller sur {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Autorisation Stripe manquante",
  "error_page.button_close": "Fermer",
  "error_page.error_message_stripe_invalid_tax_origin_address": "L'achat a échoué car l'adresse d'origine de la taxe n'est pas valide. En production, les achats fonctionneront sans taxes appliquées.",
  "error_page.error_message_stripe_tax_not_active": "L'achat a échoué car Stripe Tax n'est pas activé. En production, les achats fonctionneront sans taxes appliquées.",
  "error_page.error_only_in_sandbox": "Ce message apparaît uniquement dans l'environnement de test.",
  "error_page.error_message_stripe_missing_required_permission": "L'achat a échoué car l'application Stripe ne dispose pas d'une autorisation requise. En production, les achats fonctionneront sans taxes appliquées.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax non actif",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Adresse d'origine de la taxe non valide",
  "apple_pay.free_trial": "Essai gratuit"
}, dc = {
  "periods.week": "{{amount}} Woche",
  "periods.month": "{{amount}} Monat",
  "periods.year": "{{amount}} Jahr",
  "periods.day": "{{amount}} Tag",
  "periods.weekShort": "{{amount}}Wo",
  "periods.monthShort": "{{amount}}Mo",
  "periods.yearShort": "{{amount}}J",
  "periods.dayShort": "{{amount}}T",
  "periods.lifetime": "lebenslang",
  "periods.weekPlural": "{{amount}} Wochen",
  "periods.monthPlural": "{{amount}} Monate",
  "periods.yearPlural": "{{amount}} Jahre",
  "periods.dayPlural": "{{amount}} Tage",
  "periods.weekFrequency": "wöchentlich",
  "periods.monthFrequency": "monatlich",
  "periods.yearFrequency": "jährlich",
  "periods.dayFrequency": "täglich",
  "periods.perWeekFrequency": "pro Woche",
  "periods.perMonthFrequency": "pro Monat",
  "periods.perYearFrequency": "pro Jahr",
  "periods.perDayFrequency": "pro Tag",
  "periods.unknownFrequency": "unbekannt",
  "periods.weekFrequencyPlural": "alle {{amount}} Wochen",
  "periods.monthFrequencyPlural": "alle {{amount}} Monate",
  "periods.yearFrequencyPlural": "alle {{amount}} Jahre",
  "periods.dayFrequencyPlural": "alle {{amount}} Tage",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} kostenlose Testversion",
  "product_info.price_after_free_trial": "Nach Ablauf der Testversion, am {{renewalDate}}",
  "product_info.renewal_frequency": "Verlängert sich {{frequency}}",
  "product_info.continues_until_cancelled": "Läuft bis zur Kündigung",
  "product_info.cancel_anytime": "Jederzeit kündbar",
  "payment_entry_page.payment_step_title": "Sicherer Checkout über RevenueCat",
  "payment_entry_page.terms_info": "Durch die Angabe Ihrer Karteninformationen erlauben Sie {{appName}}, Ihre Karte gemäß deren Bedingungen für zukünftige Zahlungen zu belasten.",
  "payment_entry_page.button_pay": "Jetzt bezahlen",
  "payment_entry_page.button_start_trial": "Testversion starten",
  "success_page.purchase_successful": "Zahlung abgeschlossen",
  "success_page.button_close": "Weiter",
  "error_page.if_error_persists": "Wenn der Fehler weiterhin besteht, wenden Sie sich bitte an ",
  "error_page.error_title_already_subscribed": "Du hast {{productTitle}} bereits abonniert",
  "error_page.error_title_already_purchased": "Du hast {{productTitle}} bereits gekauft",
  "error_page.error_title_other_errors": "Etwas ist schief gelaufen",
  "error_page.error_message_already_subscribed": "Du kannst dieses Produkt nicht erneut abonnieren.",
  "error_page.error_message_already_purchased": "Du kannst dieses Produkt nicht erneut kaufen.",
  "error_page.error_message_missing_email_error": "Für den Kauf ist eine E-Mail-Adresse erforderlich.",
  "error_page.error_message_network_error": "Netzwerkfehler. Bitte überprüfen Sie Ihre Internetverbindung.",
  "error_page.error_message_error_charging_payment": "Zahlung fehlgeschlagen.",
  "error_page.error_message_error_setting_up_purchase": "Der Kauf wurde aufgrund eines Fehlers nicht gestartet (Fehlercode: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Wir konnten Ihre Rechnungsadresse nicht überprüfen. Bitte überprüfen Sie, ob die Postleitzahl und das Land korrekt sind.",
  "error_page.error_message_unknown_error": "Ein unbekannter Fehler ist aufgetreten (Fehlercode: {{errorCode}}).",
  "error_page.button_try_again": "Erneut versuchen",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% Rabatt",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}} ({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Heute fälliger Gesamtbetrag",
  "product_info.subscribe_to": "Abonnieren",
  "payment_entry_page.trial_info": "Nach Ablauf Ihres Testzeitraums werden Ihnen {{price}} {{perFrequency}} ab dem {{renewalDate}} berechnet. Sie können jederzeit vorher kündigen.",
  "navbar_header.details": "Details",
  "navbar_header.back_button": "Zurück",
  "pricing_dropdown.show_details": "Details anzeigen",
  "pricing_dropdown.hide_details": "Details ausblenden",
  "pricing_table.tax": "Steuer",
  "pricing_table.trial_ends": "Nach Ablauf der Testphase, am {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Heute fälliger Gesamtbetrag",
  "pricing_table.total_excluding_tax": "Gesamtbetrag ohne Steuer",
  "pricing_table.enter_billing_address_to_calculate": "Rechnungsadresse eingeben, um zu berechnen",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Bundesland oder Postleitzahl zur Berechnung eingeben",
  "pricing_table.enter_postal_code_to_calculate": "Postleitzahl zur Berechnung eingeben",
  "error_page.error_message_invalid_email_error": "Die E-Mail-Adresse {{email}} konnte nicht verifiziert werden. Bitte gib eine gültige E-Mail-Adresse an.",
  "payment_entry_page.button_payment_method": "Mit {{paymentMethod}} für {{formattedPrice}} bezahlen",
  "payment_entry_page.button_with_price": "{{formattedPrice}} bezahlen",
  "price_update.title": "Preisaktualisierung",
  "price_update.base_message": "Der Gesamtpreis wurde basierend auf Ihrer Rechnungsadresse mit Steuern aktualisiert. Bitte überprüfen Sie ihn und versuchen Sie es erneut. Ihre Karte wird erst belastet, wenn alles korrekt ist.",
  "price_update.trial_message": "Der Abonnementpreis wurde aktualisiert, um Steuern basierend auf Ihrer Rechnungsadresse einzuschließen. Die kostenlose Testphase gilt weiterhin. Bitte überprüfen Sie und versuchen Sie es erneut.",
  "payment_entry_page.express_checkout_divider": "ODER MIT KARTE ZAHLEN",
  "error_page.trouble_accessing": "Wenn Sie Probleme beim Zugriff auf Ihren Kauf haben, wenden Sie sich an den Support unter ",
  "error_page.close_button_title": "Zu {{appName}} gehen",
  "error_page.error_title_stripe_missing_required_permission": "Fehlende Stripe-Berechtigung",
  "error_page.button_close": "Schließen",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Der Kauf ist fehlgeschlagen, da die Steuerursprungsadresse ungültig ist. In der Produktion funktionieren Käufe ohne angewendete Steuern.",
  "error_page.error_message_stripe_tax_not_active": "Der Kauf ist fehlgeschlagen, da Stripe Tax nicht aktiviert ist. In der Produktion funktionieren Käufe ohne angewendete Steuern.",
  "error_page.error_only_in_sandbox": "Diese Meldung wird nur in der Sandbox angezeigt.",
  "error_page.error_message_stripe_missing_required_permission": "Der Kauf ist fehlgeschlagen, da der Stripe-App eine erforderliche Berechtigung fehlt. In der Produktion funktionieren Käufe ohne angewendete Steuern.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax ist nicht aktiv",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Ungültige Steuerursprungsadresse",
  "apple_pay.free_trial": "Kostenlose Testversion"
}, uc = {
  "periods.week": "{{amount}} εβδομάδα",
  "periods.month": "{{amount}} μήνας",
  "periods.year": "{{amount}} χρόνος",
  "periods.day": "{{amount}} ημέρα",
  "periods.weekShort": "{{amount}} εβδ.",
  "periods.monthShort": "{{amount}} μήν.",
  "periods.yearShort": "{{amount}} έτ.",
  "periods.dayShort": "{{amount}} ημ.",
  "periods.lifetime": "διάρκεια ζωής",
  "periods.weekPlural": "{{amount}} εβδομάδες",
  "periods.monthPlural": "{{amount}} μήνες",
  "periods.yearPlural": "{{amount}} χρόνια",
  "periods.dayPlural": "{{amount}} ημέρες",
  "periods.weekFrequency": "εβδομαδιαία",
  "periods.monthFrequency": "μηνιαία",
  "periods.yearFrequency": "ετήσια",
  "periods.dayFrequency": "καθημερινά",
  "periods.perWeekFrequency": "ανά εβδομάδα",
  "periods.perMonthFrequency": "ανά μήνα",
  "periods.perYearFrequency": "ανά έτος",
  "periods.perDayFrequency": "ανά ημέρα",
  "periods.unknownFrequency": "άγνωστο",
  "periods.weekFrequencyPlural": "κάθε {{amount}} εβδομάδες",
  "periods.monthFrequencyPlural": "κάθε {{amount}} μήνες",
  "periods.yearFrequencyPlural": "κάθε {{amount}} χρόνια",
  "periods.dayFrequencyPlural": "κάθε {{amount}} ημέρες",
  "product_info.subscribe_to": "Εγγραφείτε στο",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "Δωρεάν για {{trialDuration}}",
  "product_info.price_after_free_trial": "Μετά τη λήξη της δοκιμής, στις {{renewalDate}}",
  "product_info.total_due_today": "Σύνολο πληρωτέο σήμερα",
  "product_info.renewal_frequency": "Ανανεώνεται {{frequency}}",
  "product_info.continues_until_cancelled": "Συνεχίζεται μέχρι την ακύρωση",
  "product_info.cancel_anytime": "Ακύρωση ανά πάσα στιγμή",
  "payment_entry_page.payment_step_title": "Ασφαλής ολοκλήρωση αγοράς από την RevenueCat",
  "payment_entry_page.terms_info": "Με την παροχή των στοιχείων της κάρτας σας, επιτρέπετε στην {{appName}} να χρεώσει την κάρτα σας για μελλοντικές πληρωμές σύμφωνα με τους όρους της.",
  "payment_entry_page.button_pay": "Πληρωμή τώρα",
  "payment_entry_page.button_start_trial": "Έναρξη δοκιμής",
  "success_page.purchase_successful": "Η πληρωμή ολοκληρώθηκε",
  "success_page.button_close": "Συνέχεια",
  "error_page.if_error_persists": "Εάν το σφάλμα παραμένει, επικοινωνήστε με ",
  "error_page.error_title_already_subscribed": "Έχετε ήδη εγγραφεί στο {{productTitle}}",
  "error_page.error_title_already_purchased": "Έχετε ήδη αγοράσει το {{productTitle}}",
  "error_page.error_title_other_errors": "Κάτι πήγε στραβά",
  "error_page.error_message_already_subscribed": "Δεν μπορείτε να εγγραφείτε ξανά σε αυτό το προϊόν.",
  "error_page.error_message_already_purchased": "Δεν μπορείτε να αγοράσετε ξανά αυτό το προϊόν.",
  "error_page.error_message_missing_email_error": "Απαιτείται email για την ολοκλήρωση της αγοράς.",
  "error_page.error_message_network_error": "Σφάλμα δικτύου. Ελέγξτε τη σύνδεσή σας στο διαδίκτυο.",
  "error_page.error_message_error_charging_payment": "Η πληρωμή απέτυχε.",
  "error_page.error_message_error_setting_up_purchase": "Η αγορά δεν ξεκίνησε λόγω σφάλματος (κωδικός σφάλματος: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Δεν μπορέσαμε να επαληθεύσουμε τη διεύθυνση χρέωσής σας. Παρακαλούμε ελέγξτε ξανά τον ταχυδρομικό κώδικα και τη χώρα για να βεβαιωθείτε ότι είναι σωστά.",
  "error_page.error_message_unknown_error": "Παρουσιάστηκε ένα άγνωστο σφάλμα (κωδικός σφάλματος: {{errorCode}}).",
  "error_page.button_try_again": "Προσπαθήστε ξανά",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% έκπτωση",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "payment_entry_page.trial_info": "Μετά τη λήξη της δοκιμαστικής περιόδου, θα χρεωθείτε {{price}} {{perFrequency}} ξεκινώντας από {{renewalDate}}. Μπορείτε να ακυρώσετε ανά πάσα στιγμή πριν από αυτό.",
  "navbar_header.details": "Λεπτομέρειες",
  "navbar_header.back_button": "Πίσω",
  "pricing_dropdown.show_details": "Εμφάνιση λεπτομερειών",
  "pricing_dropdown.hide_details": "Απόκρυψη λεπτομερειών",
  "pricing_table.tax": "Φόρος",
  "pricing_table.trial_ends": "Μετά τη λήξη της δοκιμαστικής περιόδου, στις {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Σύνολο πληρωτέο σήμερα",
  "pricing_table.total_excluding_tax": "Σύνολο χωρίς φόρο",
  "pricing_table.enter_billing_address_to_calculate": "Εισαγάγετε τη διεύθυνση χρέωσης για να υπολογιστεί",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Εισαγάγετε την πολιτεία ή τον ταχυδρομικό κώδικα για να υπολογιστεί",
  "pricing_table.enter_postal_code_to_calculate": "Εισαγάγετε τον ταχυδρομικό κώδικα για να υπολογιστεί",
  "error_page.error_message_invalid_email_error": "Η διεύθυνση email {{email}} δεν μπόρεσε να επαληθευτεί. Παρακαλώ δώστε μια έγκυρη διεύθυνση email.",
  "payment_entry_page.button_payment_method": "Πληρωμή {{formattedPrice}} με {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Πληρωμή {{formattedPrice}}",
  "price_update.title": "Ενημέρωση τιμής",
  "price_update.base_message": "Η συνολική τιμή ενημερώθηκε με τον φόρο βάσει της διεύθυνσης χρέωσής σας. Ελέγξτε και δοκιμάστε ξανά. Η κάρτα σας θα χρεωθεί μόνο μία φορά.",
  "price_update.trial_message": "Η τιμή της συνδρομής ενημερώθηκε για να συμπεριλάβει τους φόρους βάσει της διεύθυνσης χρέωσής σας. Η δωρεάν δοκιμαστική περίοδος εξακολουθεί να ισχύει. Παρακαλώ ελέγξτε και δοκιμάστε ξανά.",
  "payment_entry_page.express_checkout_divider": "Ή ΠΛΗΡΩΣΤΕ ΜΕ ΚΑΡΤΑ",
  "error_page.trouble_accessing": "Εάν αντιμετωπίζετε προβλήματα πρόσβασης στην αγορά σας, επικοινωνήστε με την υποστήριξη στο ",
  "error_page.close_button_title": "Μετάβαση στο {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Λείπει άδεια Stripe",
  "error_page.button_close": "Κλείσιμο",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Η αγορά απέτυχε επειδή η διεύθυνση προέλευσης φόρου δεν είναι έγκυρη. Στην παραγωγή, οι αγορές θα λειτουργούν χωρίς να εφαρμόζονται φόροι.",
  "error_page.error_message_stripe_tax_not_active": "Η αγορά απέτυχε επειδή το Stripe Tax δεν είναι ενεργοποιημένο. Στην παραγωγή, οι αγορές θα λειτουργούν χωρίς να εφαρμόζονται φόροι.",
  "error_page.error_only_in_sandbox": "Αυτό το μήνυμα εμφανίζεται μόνο στο sandbox.",
  "error_page.error_message_stripe_missing_required_permission": "Η αγορά απέτυχε επειδή η εφαρμογή Stripe δεν διαθέτει την απαιτούμενη άδεια. Στην παραγωγή, οι αγορές θα λειτουργούν χωρίς να εφαρμόζονται φόροι.",
  "error_page.error_title_stripe_tax_not_active": "Το Stripe Tax δεν είναι ενεργό",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Μη έγκυρη διεύθυνση προέλευσης φόρου",
  "apple_pay.free_trial": "Δωρεάν δοκιμή"
}, pc = {
  "periods.week": "{{amount}} שבוע",
  "periods.month": "{{amount}} חודש",
  "periods.year": "{{amount}} שנה",
  "periods.day": "{{amount}} יום",
  "periods.weekShort": "{{amount}}wk",
  "periods.monthShort": "{{amount}}mo",
  "periods.yearShort": "{{amount}}yr",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "למשך כל החיים",
  "periods.weekPlural": "{{amount}} שבועות",
  "periods.monthPlural": "{{amount}} חודשים",
  "periods.yearPlural": "{{amount}} שנים",
  "periods.dayPlural": "{{amount}} ימים",
  "periods.weekFrequency": "שבועי",
  "periods.monthFrequency": "חודשי",
  "periods.yearFrequency": "שנתי",
  "periods.dayFrequency": "יומי",
  "periods.perWeekFrequency": "לשבוע",
  "periods.perMonthFrequency": "לחודש",
  "periods.perYearFrequency": "לשנה",
  "periods.perDayFrequency": "ליום",
  "periods.unknownFrequency": "לא ידוע",
  "periods.weekFrequencyPlural": "כל {{amount}} שבועות",
  "periods.monthFrequencyPlural": "כל {{amount}} חודשים",
  "periods.yearFrequencyPlural": "כל {{amount}} שנים",
  "periods.dayFrequencyPlural": "כל {{amount}} ימים",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} ניסיון חינם",
  "product_info.price_after_free_trial": "לאחר סיום הניסיון, ב-{{renewalDate}}",
  "product_info.renewal_frequency": "מתחדש {{frequency}}",
  "product_info.continues_until_cancelled": "נמשך עד ביטול",
  "product_info.cancel_anytime": "ניתן לבטל בכל עת",
  "payment_entry_page.payment_step_title": "קופה מאובטחת באמצעות RevenueCat",
  "payment_entry_page.terms_info": "על ידי מתן פרטי הכרטיס שלך אתה מאפשר ל-{{appName}} לחייב את הכרטיס שלך עבור תשלומים עתידיים בהתאם לתנאים שלהם.",
  "payment_entry_page.button_pay": "שלם עכשיו",
  "payment_entry_page.button_start_trial": "התחל ניסיון",
  "success_page.purchase_successful": "התשלום הושלם",
  "success_page.button_close": "המשך",
  "error_page.if_error_persists": "אם השגיאה נמשכת, אנא פנה אל ",
  "error_page.error_title_already_subscribed": "כבר נרשמת כמנוי ל-{{productTitle}}",
  "error_page.error_title_already_purchased": "כבר רכשת את {{productTitle}}",
  "error_page.error_title_other_errors": "משהו השתבש",
  "error_page.error_message_already_subscribed": "אינך יכול להירשם כמנוי למוצר זה שוב.",
  "error_page.error_message_already_purchased": "אינך יכול לרכוש מוצר זה שוב.",
  "error_page.error_message_missing_email_error": 'דוא"ל נדרש כדי להשלים את הרכישה.',
  "error_page.error_message_network_error": "שגיאת רשת. אנא בדוק את חיבור האינטרנט שלך.",
  "error_page.error_message_error_charging_payment": "התשלום נכשל.",
  "error_page.error_message_error_setting_up_purchase": "הרכישה לא הופעלה עקב שגיאה (קוד שגיאה: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "לא הצלחנו לאמת את כתובת החיוב שלך. אנא בדוק שוב את המיקוד והמדינה כדי לוודא שהם נכונים.",
  "error_page.error_message_unknown_error": "אירעה שגיאה לא ידועה (קוד שגיאה: {{errorCode}}).",
  "error_page.button_try_again": "נסה שוב",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% הנחה",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": 'סה"כ לתשלום היום',
  "product_info.subscribe_to": "הירשם כמנוי ל-",
  "payment_entry_page.trial_info": "לאחר סיום תקופת הניסיון שלך, תחויב בסך {{price}} {{perFrequency}} החל מ-{{renewalDate}}. תמיד תוכל לבטל לפני כן.",
  "navbar_header.details": "פרטים",
  "navbar_header.back_button": "חזרה",
  "pricing_dropdown.show_details": "הצג פרטים",
  "pricing_dropdown.hide_details": "הסתר פרטים",
  "pricing_table.tax": "מס",
  "pricing_table.trial_ends": "לאחר סיום תקופת הניסיון, בתאריך {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "סך הכל לתשלום היום",
  "pricing_table.total_excluding_tax": "סך הכל לא כולל מס",
  "pricing_table.enter_billing_address_to_calculate": "הזן כתובת לחיוב כדי לחשב",
  "pricing_table.enter_state_or_postal_code_to_calculate": "הזן מדינה או מיקוד לחישוב",
  "pricing_table.enter_postal_code_to_calculate": "הזן מיקוד לחישוב",
  "error_page.error_message_invalid_email_error": "לא ניתן לאמת את כתובת האימייל {{email}}. אנא ספק כתובת אימייל חוקית.",
  "payment_entry_page.button_payment_method": "שלם {{formattedPrice}} באמצעות {{paymentMethod}}",
  "payment_entry_page.button_with_price": "שלם {{formattedPrice}}",
  "price_update.title": "עדכון מחיר",
  "price_update.base_message": "המחיר הכולל עודכן עם מס בהתבסס על כתובת החיוב שלך. אנא בדוק שוב ונסה שוב. החיוב יתבצע רק פעם אחת.",
  "price_update.trial_message": "מחיר המנוי עודכן כדי לכלול מיסים בהתבסס על כתובת החיוב שלך. תקופת הניסיון החינמית עדיין תקפה. אנא בדוק ונסה שוב.",
  "payment_entry_page.express_checkout_divider": "או שלם באמצעות כרטיס",
  "error_page.trouble_accessing": "אם אתה מתקשה לגשת לרכישה שלך, פנה לתמיכה בכתובת ",
  "error_page.close_button_title": "עבור אל {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "חסרה הרשאה של Stripe",
  "error_page.button_close": "סגור",
  "error_page.error_message_stripe_invalid_tax_origin_address": "הרכישה נכשלה מכיוון שכתובת מקור המס אינה חוקית. בייצור, רכישות יעבדו ללא מסים.",
  "error_page.error_message_stripe_tax_not_active": "הרכישה נכשלה מכיוון שמס Stripe אינו מופעל. בייצור, רכישות יעבדו ללא מסים.",
  "error_page.error_only_in_sandbox": "הודעה זו מופיעה רק בארגז חול.",
  "error_page.error_message_stripe_missing_required_permission": "הרכישה נכשלה מכיוון שלאפליקציית Stripe חסרה הרשאה נדרשת. בייצור, רכישות יעבדו ללא מסים.",
  "error_page.error_title_stripe_tax_not_active": "מס Stripe לא פעיל",
  "error_page.error_title_stripe_invalid_tax_origin_address": "כתובת מקור מס לא חוקית",
  "apple_pay.free_trial": "תקופת ניסיון בחינם"
}, _c = {
  "periods.week": "{{amount}} सप्ताह",
  "periods.month": "{{amount}} महीना",
  "periods.year": "{{amount}} वर्ष",
  "periods.day": "{{amount}} दिन",
  "periods.weekShort": "{{amount}}सप्ताह",
  "periods.monthShort": "{{amount}}महीना",
  "periods.yearShort": "{{amount}}वर्ष",
  "periods.dayShort": "{{amount}}दिन",
  "periods.lifetime": "लाइफ़टाइम",
  "periods.weekPlural": "{{amount}} सप्ताह",
  "periods.monthPlural": "{{amount}} महीने",
  "periods.yearPlural": "{{amount}} वर्ष",
  "periods.dayPlural": "{{amount}} दिन",
  "periods.weekFrequency": "साप्ताहिक",
  "periods.monthFrequency": "मासिक",
  "periods.yearFrequency": "वार्षिक",
  "periods.dayFrequency": "दैनिक",
  "periods.perWeekFrequency": "प्रति सप्ताह",
  "periods.perMonthFrequency": "प्रति माह",
  "periods.perYearFrequency": "प्रति वर्ष",
  "periods.perDayFrequency": "प्रति दिन",
  "periods.unknownFrequency": "अज्ञात",
  "periods.weekFrequencyPlural": "प्रत्येक {{amount}} सप्ताह",
  "periods.monthFrequencyPlural": "प्रत्येक {{amount}} महीने",
  "periods.yearFrequencyPlural": "प्रत्येक {{amount}} वर्ष",
  "periods.dayFrequencyPlural": "प्रत्येक {{amount}} दिन",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} निःशुल्क परीक्षण",
  "product_info.price_after_free_trial": "परीक्षण समाप्त होने के बाद, {{renewalDate}} को",
  "product_info.renewal_frequency": "{{frequency}} पर नवीनीकृत होता है",
  "product_info.continues_until_cancelled": "रद्द होने तक जारी रहता है",
  "product_info.cancel_anytime": "किसी भी समय रद्द करें",
  "payment_entry_page.payment_step_title": "RevenueCat द्वारा सुरक्षित चेकआउट",
  "payment_entry_page.terms_info": "अपनी कार्ड जानकारी प्रदान करके आप {{appName}} को उनकी शर्तों के अनुसार भविष्य के भुगतानों के लिए आपके कार्ड से शुल्क लेने की अनुमति देते हैं।",
  "payment_entry_page.button_pay": "अभी भुगतान करें",
  "payment_entry_page.button_start_trial": "परीक्षण प्रारंभ करें",
  "success_page.purchase_successful": "भुगतान पूर्ण",
  "success_page.button_close": "जारी रखें",
  "error_page.if_error_persists": "यदि त्रुटि बनी रहती है, तो कृपया संपर्क करें ",
  "error_page.error_title_already_subscribed": "आपने पहले ही {{productTitle}} की सदस्यता ले ली है",
  "error_page.error_title_already_purchased": "आपने पहले ही {{productTitle}} खरीद लिया है",
  "error_page.error_title_other_errors": "कुछ गलत हो गया",
  "error_page.error_message_already_subscribed": "आप इस उत्पाद की सदस्यता फिर से नहीं ले सकते.",
  "error_page.error_message_already_purchased": "आप इस उत्पाद को फिर से नहीं खरीद सकते.",
  "error_page.error_message_missing_email_error": "खरीद को पूरा करने के लिए ईमेल आवश्यक है।",
  "error_page.error_message_network_error": "नेटवर्क त्रुटि। कृपया अपना इंटरनेट कनेक्शन जांचें।",
  "error_page.error_message_error_charging_payment": "भुगतान विफल।",
  "error_page.error_message_error_setting_up_purchase": "किसी त्रुटि के कारण खरीदारी शुरू नहीं हुई (त्रुटि कोड: {{errorCode}})।",
  "error_page.error_message_invalid_tax_location": "हम आपके बिलिंग पते को सत्यापित नहीं कर सके। कृपया सुनिश्चित करें कि पिन कोड और देश सही हैं।",
  "error_page.error_message_unknown_error": "एक अज्ञात त्रुटि हुई (त्रुटि कोड: {{errorCode}})।",
  "error_page.button_try_again": "फिर से कोशिश करें",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% छूट",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "आज देय कुल राशि",
  "product_info.subscribe_to": "सदस्यता लें",
  "payment_entry_page.trial_info": "आपकी परीक्षण अवधि समाप्त होने के बाद, आपसे {{renewalDate}} से शुरू होकर {{price}} {{perFrequency}} शुल्क लिया जाएगा. आप तब से पहले हमेशा रद्द कर सकते हैं.",
  "navbar_header.details": "विवरण",
  "navbar_header.back_button": "वापस",
  "pricing_dropdown.show_details": "विवरण दिखाएँ",
  "pricing_dropdown.hide_details": "विवरण छिपाएँ",
  "pricing_table.tax": "कर",
  "pricing_table.trial_ends": "{{formattedTrialEndDate}} पर परीक्षण समाप्त होने के बाद",
  "pricing_table.total_due_today": "आज देय कुल",
  "pricing_table.total_excluding_tax": "कर को छोड़कर कुल",
  "pricing_table.enter_billing_address_to_calculate": "गणना करने के लिए बिलिंग पता दर्ज करें",
  "pricing_table.enter_state_or_postal_code_to_calculate": "गणना करने के लिए राज्य या ज़िप कोड दर्ज करें",
  "pricing_table.enter_postal_code_to_calculate": "गणना करने के लिए ज़िप कोड दर्ज करें",
  "error_page.error_message_invalid_email_error": "ईमेल पता {{email}} सत्यापित नहीं किया जा सका. कृपया एक मान्य ईमेल पता प्रदान करें.",
  "payment_entry_page.button_payment_method": "{{paymentMethod}} के साथ {{formattedPrice}} का भुगतान करें",
  "payment_entry_page.button_with_price": "{{formattedPrice}} का भुगतान करें",
  "price_update.title": "मूल्य अपडेट",
  "price_update.base_message": "आप के बिलिंग पते के आधार पर कुल कीमत कर के साथ अपडेट की गई थी। कृपया समीक्षा करें और फिर से प्रयास करें। आपके कार्ड से केवल एक बार शुल्क लिया जाएगा।",
  "price_update.trial_message": "सदस्यता मूल्य आपके बिलिंग पते के आधार पर करों को शामिल करने के लिए अपडेट किया गया है। निःशुल्क परीक्षण अवधि अभी भी लागू है। कृपया जांचें और पुनः प्रयास करें।",
  "payment_entry_page.express_checkout_divider": "या कार्ड से भुगतान करें",
  "error_page.trouble_accessing": "यदि आपको अपनी खरीदारी तक पहुंचने में परेशानी हो रही है, तो पर समर्थन के लिए संपर्क करें",
  "error_page.close_button_title": "{{appName}} पर जाएं",
  "error_page.error_title_stripe_missing_required_permission": "स्ट्राइप अनुमति गुम है",
  "error_page.button_close": "बंद करें",
  "error_page.error_message_stripe_invalid_tax_origin_address": "खरीदारी विफल रही क्योंकि कर उत्पत्ति पता अमान्य है. उत्पादन में, खरीदारी बिना करों के लागू किए काम करेगी.",
  "error_page.error_message_stripe_tax_not_active": "खरीदारी विफल रही क्योंकि स्ट्राइप टैक्स सक्षम नहीं है. उत्पादन में, खरीदारी बिना करों के लागू किए काम करेगी.",
  "error_page.error_only_in_sandbox": "यह संदेश केवल सैंडबॉक्स में दिखाई देता है.",
  "error_page.error_message_stripe_missing_required_permission": "खरीदारी विफल रही क्योंकि स्ट्राइप ऐप में आवश्यक अनुमति नहीं है. उत्पादन में, खरीदारी बिना करों के लागू किए काम करेगी.",
  "error_page.error_title_stripe_tax_not_active": "स्ट्राइप टैक्स सक्रिय नहीं है",
  "error_page.error_title_stripe_invalid_tax_origin_address": "अमान्य कर उत्पत्ति पता",
  "apple_pay.free_trial": "मुफ़्त ट्रायल"
}, gc = {
  "periods.week": "{{amount}} hét",
  "periods.month": "{{amount}} hónap",
  "periods.year": "{{amount}} év",
  "periods.day": "{{amount}} nap",
  "periods.weekShort": "{{amount}}hét",
  "periods.monthShort": "{{amount}}hó",
  "periods.yearShort": "{{amount}}év",
  "periods.dayShort": "{{amount}}n",
  "periods.lifetime": "életre szóló",
  "periods.weekPlural": "{{amount}} hét",
  "periods.monthPlural": "{{amount}} hónap",
  "periods.yearPlural": "{{amount}} év",
  "periods.dayPlural": "{{amount}} nap",
  "periods.weekFrequency": "heti",
  "periods.monthFrequency": "havi",
  "periods.yearFrequency": "éves",
  "periods.dayFrequency": "napi",
  "periods.perWeekFrequency": "hetente",
  "periods.perMonthFrequency": "havonta",
  "periods.perYearFrequency": "évente",
  "periods.perDayFrequency": "naponta",
  "periods.unknownFrequency": "ismeretlen",
  "periods.weekFrequencyPlural": "minden {{amount}} hétben",
  "periods.monthFrequencyPlural": "minden {{amount}} hónapban",
  "periods.yearFrequencyPlural": "minden {{amount}} évben",
  "periods.dayFrequencyPlural": "minden {{amount}} napban",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} próbaidőszak",
  "product_info.price_after_free_trial": "A próbaidőszak vége után, {{renewalDate}}-kor",
  "product_info.renewal_frequency": "{{frequency}} gyakorisággal megújul",
  "product_info.continues_until_cancelled": "Folytatódik, amíg le nem mondják",
  "product_info.cancel_anytime": "Bármikor lemondható",
  "payment_entry_page.payment_step_title": "Biztonságos fizetés a RevenueCat-en keresztül",
  "payment_entry_page.terms_info": "A kártyaadataid megadásával engedélyezed a {{appName}} számára, hogy a feltételeiknek megfelelően a jövőbeni fizetésekhez terhelje a kártyádat.",
  "payment_entry_page.button_pay": "Fizetés most",
  "payment_entry_page.button_start_trial": "Próbaidőszak indítása",
  "success_page.purchase_successful": "Fizetés sikeres",
  "success_page.button_close": "Tovább",
  "error_page.if_error_persists": "Ha a hiba továbbra is fennáll, kérjük, vedd fel a kapcsolatot ",
  "error_page.error_title_already_subscribed": "Már előfizettél a(z) {{productTitle}} termékre",
  "error_page.error_title_already_purchased": "Már megvásároltad a(z) {{productTitle}} terméket",
  "error_page.error_title_other_errors": "Valami hiba történt",
  "error_page.error_message_already_subscribed": "Nem fizethetsz elő újra erre a termékre.",
  "error_page.error_message_already_purchased": "Nem vásárolhatod meg újra ezt a terméket.",
  "error_page.error_message_missing_email_error": "Az email cím szükséges a vásárlás befejezéséhez.",
  "error_page.error_message_network_error": "Hálózati hiba. Kérjük, ellenőrizd az internetkapcsolatodat.",
  "error_page.error_message_error_charging_payment": "A fizetés sikertelen volt.",
  "error_page.error_message_error_setting_up_purchase": "Hiba miatt nem indult el a vásárlás (hibakód: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Nem tudtuk ellenőrizni a számlázási címét. Kérjük, ellenőrizze, hogy az irányítószám és az ország helyes-e.",
  "error_page.error_message_unknown_error": "Ismeretlen hiba történt (hibakód: {{errorCode}}).",
  "error_page.button_try_again": "Újrapróbálkozás",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% kedvezmény",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Ma fizetendő összesen",
  "product_info.subscribe_to": "Feliratkozás erre:",
  "payment_entry_page.trial_info": "A próbaidőszak lejárta után {{price}} {{perFrequency}} összeget számítunk fel {{renewalDate}} napjától kezdődően. Bármikor lemondhatja addig.",
  "navbar_header.details": "Részletek",
  "navbar_header.back_button": "Vissza",
  "pricing_dropdown.show_details": "Részletek mutatása",
  "pricing_dropdown.hide_details": "Részletek elrejtése",
  "pricing_table.tax": "Adó",
  "pricing_table.trial_ends": "A próbaidőszak vége: {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Ma fizetendő összeg",
  "pricing_table.total_excluding_tax": "Összesen adó nélkül",
  "pricing_table.enter_billing_address_to_calculate": "Adja meg a számlázási címet a számításhoz",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Adja meg az államot vagy az irányítószámot a számításhoz",
  "pricing_table.enter_postal_code_to_calculate": "Adja meg az irányítószámot a számításhoz",
  "error_page.error_message_invalid_email_error": "A(z) {{email}} e-mail címet nem sikerült ellenőrizni. Kérjük, adj meg egy érvényes e-mail címet.",
  "payment_entry_page.button_payment_method": "Fizetés {{formattedPrice}} összeggel a következővel: {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Fizetés {{formattedPrice}}",
  "price_update.title": "Ár frissítése",
  "price_update.base_message": "A teljes ár frissítve lett az adóval a számlázási címed alapján. Kérjük, tekintsd át és próbáld újra. A kártyádat csak egyszer terheljük meg.",
  "price_update.trial_message": "Az előfizetés ára adókkal együtt frissítésre került a számlázási címének megfelelően. Az ingyenes próbaidőszak továbbra is érvényes. Kérjük, ellenőrizze és próbálja újra.",
  "payment_entry_page.express_checkout_divider": "VAGY FIZESSEN KÁRTYÁVAL",
  "error_page.trouble_accessing": "Ha problémái vannak a vásárláshoz való hozzáféréssel, forduljon az ügyfélszolgálathoz a következő címen: ",
  "error_page.close_button_title": "Ugrás a(z) {{appName}} alkalmazáshoz",
  "error_page.error_title_stripe_missing_required_permission": "Hiányzó Stripe engedély",
  "error_page.button_close": "Bezárás",
  "error_page.error_message_stripe_invalid_tax_origin_address": "A vásárlás sikertelen volt, mert az adókiindulási cím érvénytelen. Éles környezetben a vásárlások adók alkalmazása nélkül fognak működni.",
  "error_page.error_message_stripe_tax_not_active": "A vásárlás sikertelen volt, mert a Stripe adó nincs engedélyezve. Éles környezetben a vásárlások adók alkalmazása nélkül fognak működni.",
  "error_page.error_only_in_sandbox": "Ez az üzenet csak a tesztkörnyezetben jelenik meg.",
  "error_page.error_message_stripe_missing_required_permission": "A vásárlás sikertelen volt, mert a Stripe alkalmazásból hiányzik egy szükséges engedély. Éles környezetben a vásárlások adók alkalmazása nélkül fognak működni.",
  "error_page.error_title_stripe_tax_not_active": "A Stripe adó nincs aktiválva",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Érvénytelen adókiindulási cím",
  "apple_pay.free_trial": "Ingyenes próbaidőszak"
}, mc = {
  "periods.week": "{{amount}} minggu",
  "periods.month": "{{amount}} bulan",
  "periods.year": "{{amount}} tahun",
  "periods.day": "{{amount}} hari",
  "periods.weekShort": "{{amount}}mg",
  "periods.monthShort": "{{amount}}bl",
  "periods.yearShort": "{{amount}}th",
  "periods.dayShort": "{{amount}}h",
  "periods.lifetime": "seumur hidup",
  "periods.weekPlural": "{{amount}} minggu",
  "periods.monthPlural": "{{amount}} bulan",
  "periods.yearPlural": "{{amount}} tahun",
  "periods.dayPlural": "{{amount}} hari",
  "periods.weekFrequency": "mingguan",
  "periods.monthFrequency": "bulanan",
  "periods.yearFrequency": "tahunan",
  "periods.dayFrequency": "harian",
  "periods.perWeekFrequency": "per minggu",
  "periods.perMonthFrequency": "per bulan",
  "periods.perYearFrequency": "per tahun",
  "periods.perDayFrequency": "per hari",
  "periods.unknownFrequency": "tidak diketahui",
  "periods.weekFrequencyPlural": "setiap {{amount}} minggu",
  "periods.monthFrequencyPlural": "setiap {{amount}} bulan",
  "periods.yearFrequencyPlural": "setiap {{amount}} tahun",
  "periods.dayFrequencyPlural": "setiap {{amount}} hari",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} uji coba gratis",
  "product_info.price_after_free_trial": "Setelah uji coba berakhir, pada {{renewalDate}}",
  "product_info.renewal_frequency": "Diperbarui {{frequency}}",
  "product_info.continues_until_cancelled": "Berlanjut hingga dibatalkan",
  "product_info.cancel_anytime": "Batalkan kapan saja",
  "payment_entry_page.payment_step_title": "Pembayaran aman oleh RevenueCat",
  "payment_entry_page.terms_info": "Dengan memberikan informasi kartu Anda, Anda mengizinkan {{appName}} untuk menagih kartu Anda untuk pembayaran di masa mendatang sesuai dengan ketentuan mereka.",
  "payment_entry_page.button_pay": "Bayar sekarang",
  "payment_entry_page.button_start_trial": "Mulai Uji Coba",
  "success_page.purchase_successful": "Pembayaran selesai",
  "success_page.button_close": "Lanjutkan",
  "error_page.if_error_persists": "Jika kesalahan berlanjut, silakan hubungi ",
  "error_page.error_title_already_subscribed": "Anda sudah berlangganan ke {{productTitle}}",
  "error_page.error_title_already_purchased": "Anda sudah membeli {{productTitle}}",
  "error_page.error_title_other_errors": "Terjadi kesalahan",
  "error_page.error_message_already_subscribed": "Anda tidak dapat berlangganan produk ini lagi.",
  "error_page.error_message_already_purchased": "Anda tidak dapat membeli produk ini lagi.",
  "error_page.error_message_missing_email_error": "Email diperlukan untuk menyelesaikan pembelian.",
  "error_page.error_message_network_error": "Kesalahan jaringan. Periksa koneksi internet Anda.",
  "error_page.error_message_error_charging_payment": "Pembayaran gagal.",
  "error_page.error_message_error_setting_up_purchase": "Pembelian tidak dimulai karena kesalahan (kode kesalahan: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Kami tidak dapat memverifikasi alamat penagihan Anda. Harap periksa kembali kode pos dan negara untuk memastikan keduanya benar.",
  "error_page.error_message_unknown_error": "Terjadi kesalahan yang tidak diketahui (kode kesalahan: {{errorCode}}).",
  "error_page.button_try_again": "Coba lagi",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% diskon",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Total yang harus dibayar hari ini",
  "product_info.subscribe_to": "Berlangganan ke",
  "payment_entry_page.trial_info": "Setelah masa percobaan Anda berakhir, Anda akan dikenakan biaya {{price}} {{perFrequency}} mulai {{renewalDate}}. Anda selalu dapat membatalkan sebelum itu.",
  "navbar_header.details": "Detail",
  "navbar_header.back_button": "Kembali",
  "pricing_dropdown.show_details": "Tampilkan detail",
  "pricing_dropdown.hide_details": "Sembunyikan detail",
  "pricing_table.tax": "Pajak",
  "pricing_table.trial_ends": "Setelah masa percobaan berakhir, pada {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Total yang harus dibayar hari ini",
  "pricing_table.total_excluding_tax": "Total belum termasuk pajak",
  "pricing_table.enter_billing_address_to_calculate": "Masukkan alamat penagihan untuk menghitung",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Masukkan negara bagian atau kode pos untuk menghitung",
  "pricing_table.enter_postal_code_to_calculate": "Masukkan kode pos untuk menghitung",
  "error_page.error_message_invalid_email_error": "Alamat email {{email}} tidak dapat diverifikasi. Harap berikan alamat email yang valid.",
  "payment_entry_page.button_payment_method": "Bayar {{formattedPrice}} dengan {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Bayar {{formattedPrice}}",
  "price_update.title": "Pembaruan harga",
  "price_update.base_message": "Total harga telah diperbarui dengan pajak berdasarkan alamat penagihan Anda. Harap tinjau dan coba lagi. Kartu Anda hanya akan dikenakan biaya sekali.",
  "price_update.trial_message": "Harga langganan telah diperbarui untuk menyertakan pajak berdasarkan alamat penagihan Anda. Masa percobaan gratis masih berlaku. Silakan periksa dan coba lagi.",
  "payment_entry_page.express_checkout_divider": "ATAU BAYAR DENGAN KARTU",
  "error_page.trouble_accessing": "Jika Anda mengalami masalah dalam mengakses pembelian, hubungi dukungan di ",
  "error_page.close_button_title": "Pergi ke {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Izin Stripe tidak ada",
  "error_page.button_close": "Tutup",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Pembelian gagal karena alamat asal pajak tidak valid. Dalam produksi, pembelian akan berfungsi tanpa pajak yang diterapkan.",
  "error_page.error_message_stripe_tax_not_active": "Pembelian gagal karena Stripe Tax tidak diaktifkan. Dalam produksi, pembelian akan berfungsi tanpa pajak yang diterapkan.",
  "error_page.error_only_in_sandbox": "Pesan ini hanya muncul di sandbox.",
  "error_page.error_message_stripe_missing_required_permission": "Pembelian gagal karena aplikasi Stripe tidak memiliki izin yang diperlukan. Dalam produksi, pembelian akan berfungsi tanpa pajak yang diterapkan.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax tidak aktif",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Alamat asal pajak tidak valid",
  "apple_pay.free_trial": "Uji Coba Gratis"
}, fc = {
  "periods.week": "{{amount}}週間",
  "periods.month": "{{amount}}ヶ月",
  "periods.year": "{{amount}}年",
  "periods.day": "{{amount}}日",
  "periods.weekShort": "{{amount}}週",
  "periods.monthShort": "{{amount}}ヶ月",
  "periods.yearShort": "{{amount}}年",
  "periods.dayShort": "{{amount}}日",
  "periods.lifetime": "生涯",
  "periods.weekPlural": "{{amount}}週間",
  "periods.monthPlural": "{{amount}}ヶ月",
  "periods.yearPlural": "{{amount}}年",
  "periods.dayPlural": "{{amount}}日",
  "periods.weekFrequency": "毎週",
  "periods.monthFrequency": "毎月",
  "periods.yearFrequency": "毎年",
  "periods.dayFrequency": "毎日",
  "periods.perWeekFrequency": "週ごと",
  "periods.perMonthFrequency": "月ごと",
  "periods.perYearFrequency": "年ごと",
  "periods.perDayFrequency": "日ごと",
  "periods.unknownFrequency": "不明",
  "periods.weekFrequencyPlural": "{{amount}}週間ごと",
  "periods.monthFrequencyPlural": "{{amount}}ヶ月ごと",
  "periods.yearFrequencyPlural": "{{amount}}年ごと",
  "periods.dayFrequencyPlural": "{{amount}}日ごと",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}}日間無料トライアル",
  "product_info.price_after_free_trial": "トライアル終了後、{{renewalDate}}に",
  "product_info.renewal_frequency": "{{frequency}}で更新",
  "product_info.continues_until_cancelled": "キャンセルされるまで継続されます",
  "product_info.cancel_anytime": "いつでもキャンセルできます",
  "payment_entry_page.payment_step_title": "RevenueCatによる安全なチェックアウト",
  "payment_entry_page.terms_info": "カード情報を入力することにより、{{appName}}が利用規約に従って今後の支払いを請求することを許可します。",
  "payment_entry_page.button_pay": "今すぐ支払う",
  "payment_entry_page.button_start_trial": "トライアルを開始",
  "success_page.purchase_successful": "支払いが完了しました",
  "success_page.button_close": "続行",
  "error_page.if_error_persists": "エラーが続く場合は、ご連絡ください。",
  "error_page.error_title_already_subscribed": "すでに{{productTitle}}を購読しています",
  "error_page.error_title_already_purchased": "すでに{{productTitle}}を購入しています",
  "error_page.error_title_other_errors": "エラーが発生しました",
  "error_page.error_message_already_subscribed": "この商品を再度購読することはできません。",
  "error_page.error_message_already_purchased": "この商品を再度購入することはできません。",
  "error_page.error_message_missing_email_error": "購入を完了するにはメールアドレスが必要です。",
  "error_page.error_message_network_error": "ネットワークエラーです。インターネット接続を確認してください。",
  "error_page.error_message_error_charging_payment": "支払いに失敗しました。",
  "error_page.error_message_error_setting_up_purchase": "エラーが発生したため、購入を開始できませんでした（エラーコード：{{errorCode}}）。",
  "error_page.error_message_invalid_tax_location": "請求先住所を確認できませんでした。郵便番号と国が正しいかご確認ください。",
  "error_page.error_message_unknown_error": "不明なエラーが発生しました（エラーコード：{{errorCode}}）。",
  "error_page.button_try_again": "再試行",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%オフ",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "本日のお支払い合計",
  "product_info.subscribe_to": "購読する",
  "payment_entry_page.trial_info": "{{renewalDate}}から{{price}} {{perFrequency}}で開始され、トライアル終了後に請求されます。いつでもキャンセルできます。",
  "navbar_header.details": "詳細",
  "navbar_header.back_button": "戻る",
  "pricing_dropdown.show_details": "詳細を表示",
  "pricing_dropdown.hide_details": "詳細を隠す",
  "pricing_table.tax": "税金",
  "pricing_table.trial_ends": "トライアル終了後、{{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "本日お支払いいただく合計金額",
  "pricing_table.total_excluding_tax": "税抜き合計",
  "pricing_table.enter_billing_address_to_calculate": "請求先住所を入力して計算",
  "pricing_table.enter_state_or_postal_code_to_calculate": "計算するには州または郵便番号を入力してください",
  "pricing_table.enter_postal_code_to_calculate": "計算するには郵便番号を入力してください",
  "error_page.error_message_invalid_email_error": "メールアドレス{{email}}を確認できませんでした。有効なメールアドレスを入力してください。",
  "payment_entry_page.button_payment_method": "{{paymentMethod}}で{{formattedPrice}}を支払う",
  "payment_entry_page.button_with_price": "{{formattedPrice}}を支払う",
  "price_update.title": "価格の更新",
  "price_update.base_message": "合計金額が、お客様の請求先住所に基づいて税金とともに更新されました。再度ご確認ください。カードへの請求は1回のみです。",
  "price_update.trial_message": "請求先住所に基づいて税金を含むサブスクリプション料金が更新されました。無料トライアルは引き続き適用されます。確認して再度お試しください。",
  "payment_entry_page.express_checkout_divider": "カードで支払う",
  "error_page.trouble_accessing": "購入へのアクセスに問題がある場合は、サポートにお問い合わせください: ",
  "error_page.close_button_title": "{{appName}} に移動",
  "error_page.error_title_stripe_missing_required_permission": "必要なStripeの権限がありません",
  "error_page.button_close": "閉じる",
  "error_page.error_message_stripe_invalid_tax_origin_address": "税の原産地住所が無効なため、購入に失敗しました。 本番環境では、税金が適用されなくても購入は可能です。",
  "error_page.error_message_stripe_tax_not_active": "Stripe Taxが有効になっていないため、購入に失敗しました。 本番環境では、税金が適用されなくても購入は可能です。",
  "error_page.error_only_in_sandbox": "このメッセージはサンドボックスでのみ表示されます。",
  "error_page.error_message_stripe_missing_required_permission": "Stripeアプリに必要な権限がないため、購入に失敗しました。 本番環境では、税金が適用されなくても購入は可能です。",
  "error_page.error_title_stripe_tax_not_active": "Stripe Taxが有効ではありません",
  "error_page.error_title_stripe_invalid_tax_origin_address": "税の原産地住所が無効です",
  "apple_pay.free_trial": "無料トライアル"
}, yc = {
  "periods.week": "{{amount}}주",
  "periods.month": "{{amount}}개월",
  "periods.year": "{{amount}}년",
  "periods.day": "{{amount}}일",
  "periods.weekShort": "{{amount}}주",
  "periods.monthShort": "{{amount}}개월",
  "periods.yearShort": "{{amount}}년",
  "periods.dayShort": "{{amount}}일",
  "periods.lifetime": "평생",
  "periods.weekPlural": "{{amount}}주",
  "periods.monthPlural": "{{amount}}개월",
  "periods.yearPlural": "{{amount}}년",
  "periods.dayPlural": "{{amount}}일",
  "periods.weekFrequency": "매주",
  "periods.monthFrequency": "매달",
  "periods.yearFrequency": "매년",
  "periods.dayFrequency": "매일",
  "periods.perWeekFrequency": "주당",
  "periods.perMonthFrequency": "월별",
  "periods.perYearFrequency": "연간",
  "periods.perDayFrequency": "매일",
  "periods.unknownFrequency": "알 수 없음",
  "periods.weekFrequencyPlural": "{{amount}}주마다",
  "periods.monthFrequencyPlural": "{{amount}}개월마다",
  "periods.yearFrequencyPlural": "{{amount}}년마다",
  "periods.dayFrequencyPlural": "{{amount}}일마다",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}}일 무료 체험",
  "product_info.price_after_free_trial": "체험 종료 후, {{renewalDate}}에",
  "product_info.renewal_frequency": "{{frequency}}마다 갱신",
  "product_info.continues_until_cancelled": "취소될 때까지 계속됩니다.",
  "product_info.cancel_anytime": "언제든지 취소 가능",
  "payment_entry_page.payment_step_title": "RevenueCat을 통한 안전한 결제",
  "payment_entry_page.terms_info": "{{appName}}의 약관에 따라 향후 결제를 위해 귀하의 카드 정보를 제공함으로써 귀하의 카드에 요금을 청구할 수 있도록 허용합니다.",
  "payment_entry_page.button_pay": "지금 결제",
  "payment_entry_page.button_start_trial": "체험 시작",
  "success_page.purchase_successful": "결제가 완료되었습니다.",
  "success_page.button_close": "계속",
  "error_page.if_error_persists": "오류가 지속되면 다음으로 문의하십시오.",
  "error_page.error_title_already_subscribed": "이미 {{productTitle}}을 구독하셨습니다",
  "error_page.error_title_already_purchased": "이미 {{productTitle}}을 구매하셨습니다",
  "error_page.error_title_other_errors": "문제가 발생했습니다.",
  "error_page.error_message_already_subscribed": "이 제품을 다시 구독할 수 없습니다.",
  "error_page.error_message_already_purchased": "이 제품을 다시 구매할 수 없습니다.",
  "error_page.error_message_missing_email_error": "구매를 완료하려면 이메일이 필요합니다.",
  "error_page.error_message_network_error": "네트워크 오류입니다. 인터넷 연결을 확인하십시오.",
  "error_page.error_message_error_charging_payment": "결제에 실패했습니다.",
  "error_page.error_message_error_setting_up_purchase": "오류로 인해 구매가 시작되지 않았습니다(오류 코드: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "청구 주소를 확인할 수 없습니다. 우편번호와 국가가 정확한지 다시 한번 확인해 주세요.",
  "error_page.error_message_unknown_error": "알 수 없는 오류가 발생했습니다(오류 코드: {{errorCode}}).",
  "error_page.button_try_again": "다시 시도",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% 할인",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "오늘 총 결제 금액",
  "product_info.subscribe_to": "구독하기",
  "payment_entry_page.trial_info": "체험 기간이 종료되면 {{renewalDate}}부터 {{price}} {{perFrequency}}가 청구됩니다. 그 전에 언제든지 취소할 수 있습니다.",
  "navbar_header.details": "세부 정보",
  "navbar_header.back_button": "뒤로",
  "pricing_dropdown.show_details": "세부 정보 표시",
  "pricing_dropdown.hide_details": "세부 정보 숨기기",
  "pricing_table.tax": "세금",
  "pricing_table.trial_ends": "체험판 종료 후, {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "오늘 지불해야 할 총액",
  "pricing_table.total_excluding_tax": "세금 제외 총액",
  "pricing_table.enter_billing_address_to_calculate": "계산을 위해 청구지 주소를 입력하세요",
  "pricing_table.enter_state_or_postal_code_to_calculate": "주 또는 우편 번호를 입력하여 계산",
  "pricing_table.enter_postal_code_to_calculate": "우편 번호를 입력하여 계산",
  "error_page.error_message_invalid_email_error": "이메일 주소 {{email}}을(를) 확인할 수 없습니다. 유효한 이메일 주소를 제공해 주세요.",
  "payment_entry_page.button_payment_method": "{{paymentMethod}}으로 {{formattedPrice}} 결제",
  "payment_entry_page.button_with_price": "{{formattedPrice}} 결제",
  "price_update.title": "가격 업데이트",
  "price_update.base_message": "청구지 주소를 기준으로 세금이 포함된 총 가격이 업데이트되었습니다. 다시 확인하고 시도해 주세요. 카드는 한 번만 청구됩니다.",
  "price_update.trial_message": "청구 주소에 따라 세금이 포함된 구독 가격이 업데이트되었습니다. 무료 체험은 계속 적용됩니다. 확인하고 다시 시도해 주세요.",
  "payment_entry_page.express_checkout_divider": "또는 카드 결제",
  "error_page.trouble_accessing": "구매에 문제가 있는 경우 다음 주소로 지원팀에 문의하세요. ",
  "error_page.close_button_title": "{{appName}}으로 이동",
  "error_page.error_title_stripe_missing_required_permission": "필수 Stripe 권한 누락",
  "error_page.button_close": "닫기",
  "error_page.error_message_stripe_invalid_tax_origin_address": "세금 원산지 주소가 잘못되어 구매에 실패했습니다. 프로덕션 환경에서는 세금이 적용되지 않은 상태로 구매가 진행됩니다.",
  "error_page.error_message_stripe_tax_not_active": "Stripe Tax가 활성화되지 않아 구매에 실패했습니다. 프로덕션 환경에서는 세금이 적용되지 않은 상태로 구매가 진행됩니다.",
  "error_page.error_only_in_sandbox": "이 메시지는 샌드박스에서만 표시됩니다.",
  "error_page.error_message_stripe_missing_required_permission": "Stripe 앱에 필요한 권한이 없어 구매에 실패했습니다. 프로덕션 환경에서는 세금이 적용되지 않은 상태로 구매가 진행됩니다.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax가 활성화되지 않음",
  "error_page.error_title_stripe_invalid_tax_origin_address": "잘못된 세금 원산지 주소",
  "apple_pay.free_trial": "무료 체험"
}, bc = {
  "periods.week": "{{amount}} minggu",
  "periods.month": "{{amount}} bulan",
  "periods.year": "{{amount}} tahun",
  "periods.day": "{{amount}} hari",
  "periods.weekShort": "{{amount}}mg",
  "periods.monthShort": "{{amount}}bl",
  "periods.yearShort": "{{amount}}th",
  "periods.dayShort": "{{amount}}h",
  "periods.lifetime": "seumur hidup",
  "periods.weekPlural": "{{amount}} minggu",
  "periods.monthPlural": "{{amount}} bulan",
  "periods.yearPlural": "{{amount}} tahun",
  "periods.dayPlural": "{{amount}} hari",
  "periods.weekFrequency": "mingguan",
  "periods.monthFrequency": "bulanan",
  "periods.yearFrequency": "tahunan",
  "periods.dayFrequency": "harian",
  "periods.perWeekFrequency": "setiap minggu",
  "periods.perMonthFrequency": "setiap bulan",
  "periods.perYearFrequency": "setiap tahun",
  "periods.perDayFrequency": "setiap hari",
  "periods.unknownFrequency": "tidak diketahui",
  "periods.weekFrequencyPlural": "setiap {{amount}} minggu",
  "periods.monthFrequencyPlural": "setiap {{amount}} bulan",
  "periods.yearFrequencyPlural": "setiap {{amount}} tahun",
  "periods.dayFrequencyPlural": "setiap {{amount}} hari",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} percubaan percuma",
  "product_info.price_after_free_trial": "Selepas tamat percubaan, pada {{renewalDate}}",
  "product_info.renewal_frequency": "Diperbaharui {{frequency}}",
  "product_info.continues_until_cancelled": "Berterusan sehingga dibatalkan",
  "product_info.cancel_anytime": "Batal bila-bila masa",
  "payment_entry_page.payment_step_title": "Pembayaran selamat oleh RevenueCat",
  "payment_entry_page.terms_info": "Dengan memberikan maklumat kad anda, anda membenarkan {{appName}} untuk mengenakan bayaran pada kad anda untuk pembayaran masa hadapan mengikut terma mereka.",
  "payment_entry_page.button_pay": "Bayar sekarang",
  "payment_entry_page.button_start_trial": "Mula Percubaan",
  "success_page.purchase_successful": "Pembayaran selesai",
  "success_page.button_close": "Teruskan",
  "error_page.if_error_persists": "Jika ralat berterusan, sila hubungi ",
  "error_page.error_title_already_subscribed": "Anda sudah melanggan {{productTitle}}",
  "error_page.error_title_already_purchased": "Anda sudah membeli {{productTitle}}",
  "error_page.error_title_other_errors": "Ada sesuatu yang tidak kena",
  "error_page.error_message_already_subscribed": "Anda tidak boleh melanggan produk ini lagi.",
  "error_page.error_message_already_purchased": "Anda tidak boleh membeli produk ini lagi.",
  "error_page.error_message_missing_email_error": "Emel diperlukan untuk menyelesaikan pembelian.",
  "error_page.error_message_network_error": "Ralat rangkaian. Sila semak sambungan internet anda.",
  "error_page.error_message_error_charging_payment": "Pembayaran gagal.",
  "error_page.error_message_error_setting_up_purchase": "Pembelian tidak dimulakan disebabkan ralat (kod ralat: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Kami tidak dapat mengesahkan alamat bil anda. Sila semak sama ada poskod dan negara adalah betul.",
  "error_page.error_message_unknown_error": "Ralat yang tidak diketahui telah berlaku (kod ralat: {{errorCode}}).",
  "error_page.button_try_again": "Cuba lagi",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% diskaun",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Jumlah yang perlu dibayar hari ini",
  "product_info.subscribe_to": "Langgan",
  "payment_entry_page.trial_info": "Selepas tempoh percubaan anda tamat, anda akan dikenakan bayaran sebanyak {{price}} {{perFrequency}} bermula {{renewalDate}}. Anda sentiasa boleh membatalkan sebelum itu.",
  "navbar_header.details": "Butiran",
  "navbar_header.back_button": "Kembali",
  "pricing_dropdown.show_details": "Tunjukkan butiran",
  "pricing_dropdown.hide_details": "Sembunyikan butiran",
  "pricing_table.tax": "Cukai",
  "pricing_table.trial_ends": "Selepas tempoh percubaan tamat, pada {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Jumlah yang perlu dibayar hari ini",
  "pricing_table.total_excluding_tax": "Jumlah tidak termasuk cukai",
  "pricing_table.enter_billing_address_to_calculate": "Masukkan alamat pengebilan untuk mengira",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Masukkan negeri atau poskod untuk mengira",
  "pricing_table.enter_postal_code_to_calculate": "Masukkan poskod untuk mengira",
  "error_page.error_message_invalid_email_error": "Alamat e-mel {{email}} tidak dapat disahkan. Sila berikan alamat e-mel yang sah.",
  "payment_entry_page.button_payment_method": "Bayar {{formattedPrice}} dengan {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Bayar {{formattedPrice}}",
  "price_update.title": "Kemaskini harga",
  "price_update.base_message": "Jumlah harga telah dikemas kini dengan cukai berdasarkan alamat pengebilan anda. Sila semak dan cuba lagi. Kad anda hanya akan dicaj sekali.",
  "price_update.trial_message": "Harga langganan telah dikemas kini untuk memasukkan cukai berdasarkan alamat bil anda. Tempoh percubaan percuma masih terpakai. Sila semak dan cuba lagi.",
  "payment_entry_page.express_checkout_divider": "ATAU BAYAR DENGAN KAD",
  "error_page.trouble_accessing": "Jika anda menghadapi masalah untuk mengakses pembelian anda, hubungi sokongan di ",
  "error_page.close_button_title": "Pergi ke {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Kebenaran Stripe hilang",
  "error_page.button_close": "Tutup",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Pembelian gagal kerana alamat asal cukai tidak sah. Dalam pengeluaran, pembelian akan berfungsi tanpa cukai dikenakan.",
  "error_page.error_message_stripe_tax_not_active": "Pembelian gagal kerana Cukai Stripe tidak didayakan. Dalam pengeluaran, pembelian akan berfungsi tanpa cukai dikenakan.",
  "error_page.error_only_in_sandbox": "Mesej ini hanya muncul dalam kotak pasir.",
  "error_page.error_message_stripe_missing_required_permission": "Pembelian gagal kerana aplikasi Stripe kekurangan kebenaran yang diperlukan. Dalam pengeluaran, pembelian akan berfungsi tanpa cukai dikenakan.",
  "error_page.error_title_stripe_tax_not_active": "Cukai Stripe tidak aktif",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Alamat asal cukai Stripe tidak sah",
  "apple_pay.free_trial": "Percubaan Percuma"
}, hc = {
  "periods.week": "{{amount}} uke",
  "periods.month": "{{amount}} måned",
  "periods.year": "{{amount}} år",
  "periods.day": "{{amount}} dag",
  "periods.weekShort": "{{amount}}uk",
  "periods.monthShort": "{{amount}}md",
  "periods.yearShort": "{{amount}}år",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "livstid",
  "periods.weekPlural": "{{amount}} uker",
  "periods.monthPlural": "{{amount}} måneder",
  "periods.yearPlural": "{{amount}} år",
  "periods.dayPlural": "{{amount}} dager",
  "periods.weekFrequency": "ukentlig",
  "periods.monthFrequency": "månedlig",
  "periods.yearFrequency": "årlig",
  "periods.dayFrequency": "daglig",
  "periods.perWeekFrequency": "per uke",
  "periods.perMonthFrequency": "per måned",
  "periods.perYearFrequency": "per år",
  "periods.perDayFrequency": "per dag",
  "periods.unknownFrequency": "ukjent",
  "periods.weekFrequencyPlural": "hver {{amount}} uker",
  "periods.monthFrequencyPlural": "hver {{amount}} måneder",
  "periods.yearFrequencyPlural": "hver {{amount}} år",
  "periods.dayFrequencyPlural": "hver {{amount}} dager",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} gratis prøveperiode",
  "product_info.price_after_free_trial": "Etter prøveperioden slutter, den {{renewalDate}}",
  "product_info.renewal_frequency": "Fornyes {{frequency}}",
  "product_info.continues_until_cancelled": "Varer til den avbestilles",
  "product_info.cancel_anytime": "Avbestille når som helst",
  "payment_entry_page.payment_step_title": "Sikker betaling via RevenueCat",
  "payment_entry_page.terms_info": "Ved å oppgi kortinformasjonen din, tillater du {{appName}} å belaste kortet ditt for fremtidige betalinger i henhold til deres vilkår.",
  "payment_entry_page.button_pay": "Betal nå",
  "payment_entry_page.button_start_trial": "Start prøveperiode",
  "success_page.purchase_successful": "Betalingen er fullført",
  "success_page.button_close": "Fortsett",
  "error_page.if_error_persists": "Hvis feilen vedvarer, vennligst kontakt ",
  "error_page.error_title_already_subscribed": "Du abonnerer allerede på {{productTitle}}",
  "error_page.error_title_already_purchased": "Du har allerede kjøpt {{productTitle}}",
  "error_page.error_title_other_errors": "Noe gikk galt",
  "error_page.error_message_already_subscribed": "Du kan ikke abonnere på dette produktet igjen.",
  "error_page.error_message_already_purchased": "Du kan ikke kjøpe dette produktet igjen.",
  "error_page.error_message_missing_email_error": "E-post er nødvendig for å fullføre kjøpet.",
  "error_page.error_message_network_error": "Nettverksfeil. Vennligst sjekk internettforbindelsen din.",
  "error_page.error_message_error_charging_payment": "Betalingen mislyktes.",
  "error_page.error_message_error_setting_up_purchase": "Kjøpet ble ikke startet på grunn av en feil (feilkode: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Vi kunne ikke bekrefte faktureringsadressen din. Vennligst sjekk at postnummeret og landet er korrekte.",
  "error_page.error_message_unknown_error": "En ukjent feil oppstod (feilkode: {{errorCode}}).",
  "error_page.button_try_again": "Prøv igjen",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% rabatt",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}} ({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Totalt forfaller i dag",
  "product_info.subscribe_to": "Abonner på",
  "payment_entry_page.trial_info": "Etter at prøveperioden din er over, blir du belastet {{price}} {{perFrequency}} fra og med {{renewalDate}}. Du kan når som helst kansellere før det.",
  "navbar_header.details": "Detaljer",
  "navbar_header.back_button": "Tilbake",
  "pricing_dropdown.show_details": "Vis detaljer",
  "pricing_dropdown.hide_details": "Skjul detaljer",
  "pricing_table.tax": "Skatt",
  "pricing_table.trial_ends": "Etter prøveperioden slutter, den {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Totalt forfaller i dag",
  "pricing_table.total_excluding_tax": "Total eksklusive skatt",
  "pricing_table.enter_billing_address_to_calculate": "Oppgi faktureringsadresse for å beregne",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Skriv inn stat eller postnummer for å beregne",
  "pricing_table.enter_postal_code_to_calculate": "Skriv inn postnummer for å beregne",
  "error_page.error_message_invalid_email_error": "E-postadressen {{email}} kunne ikke bekreftes. Vennligst oppgi en gyldig e-postadresse.",
  "payment_entry_page.button_payment_method": "Betal {{formattedPrice}} med {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Betal {{formattedPrice}}",
  "price_update.title": "Prisoppdatering",
  "price_update.base_message": "Totalprisen er oppdatert med skatt basert på fakturaadressen din. Vennligst se gjennom og prøv igjen. Kortet ditt vil kun bli belastet én gang.",
  "price_update.trial_message": "Abonnementsprisen er oppdatert for å inkludere skatter basert på din fakturaadresse. Den gratis prøveperioden gjelder fortsatt. Vennligst sjekk og prøv igjen.",
  "payment_entry_page.express_checkout_divider": "ELLER BETAL MED KORT",
  "error_page.trouble_accessing": "Hvis du har problemer med å få tilgang til kjøpet ditt, kan du kontakte support på ",
  "error_page.close_button_title": "Gå til {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Mangler Stripe-tillatelse",
  "error_page.button_close": "Lukk",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Kjøpet mislyktes fordi skatteopprinnelsesadressen er ugyldig. I produksjon vil kjøp fungere uten at skatter brukes.",
  "error_page.error_message_stripe_tax_not_active": "Kjøpet mislyktes fordi Stripe Tax ikke er aktivert. I produksjon vil kjøp fungere uten at skatter brukes.",
  "error_page.error_only_in_sandbox": "Denne meldingen vises bare i sandkassen.",
  "error_page.error_message_stripe_missing_required_permission": "Kjøpet mislyktes fordi Stripe-appen mangler en nødvendig tillatelse. I produksjon vil kjøp fungere uten at skatter brukes.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax er ikke aktivt",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Ugyldig skatteopprinnelsesadresse",
  "apple_pay.free_trial": "Gratis prøveperiode"
}, vc = {
  "periods.week": "{{amount}} tydzień",
  "periods.month": "{{amount}} miesiąc",
  "periods.year": "{{amount}} rok",
  "periods.day": "{{amount}} dzień",
  "periods.weekShort": "{{amount}}tydz",
  "periods.monthShort": "{{amount}}mies",
  "periods.yearShort": "{{amount}}rok",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "dożywotnio",
  "periods.weekPlural": "{{amount}} tygodni",
  "periods.monthPlural": "{{amount}} miesięcy",
  "periods.yearPlural": "{{amount}} lat",
  "periods.dayPlural": "{{amount}} dni",
  "periods.weekFrequency": "tygodniowo",
  "periods.monthFrequency": "miesięcznie",
  "periods.yearFrequency": "rocznie",
  "periods.dayFrequency": "dziennie",
  "periods.perWeekFrequency": "na tydzień",
  "periods.perMonthFrequency": "na miesiąc",
  "periods.perYearFrequency": "na rok",
  "periods.perDayFrequency": "na dzień",
  "periods.unknownFrequency": "nieznany",
  "periods.weekFrequencyPlural": "co {{amount}} tygodni",
  "periods.monthFrequencyPlural": "co {{amount}} miesięcy",
  "periods.yearFrequencyPlural": "co {{amount}} lat",
  "periods.dayFrequencyPlural": "co {{amount}} dni",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} dni próbnych",
  "product_info.price_after_free_trial": "Po zakończeniu okresu próbnego, dnia {{renewalDate}}",
  "product_info.renewal_frequency": "Odnawialny co {{frequency}}",
  "product_info.continues_until_cancelled": "Kontynuowane do momentu anulowania",
  "product_info.cancel_anytime": "Możesz anulować w dowolnym momencie",
  "payment_entry_page.payment_step_title": "Bezpieczna płatność przez RevenueCat",
  "payment_entry_page.terms_info": "Podając dane swojej karty, zezwalasz {{appName}} na obciążanie Twojej karty za przyszłe płatności zgodnie z ich regulaminem.",
  "payment_entry_page.button_pay": "Zapłać teraz",
  "payment_entry_page.button_start_trial": "Rozpocznij okres próbny",
  "success_page.purchase_successful": "Płatność zakończona",
  "success_page.button_close": "Kontynuuj",
  "error_page.if_error_persists": "Jeśli błąd będzie się powtarzał, skontaktuj się z ",
  "error_page.error_title_already_subscribed": "Już subskrybujesz {{productTitle}}",
  "error_page.error_title_already_purchased": "Już zakupiłeś/aś {{productTitle}}",
  "error_page.error_title_other_errors": "Coś poszło nie tak",
  "error_page.error_message_already_subscribed": "Nie możesz ponownie subskrybować tego produktu.",
  "error_page.error_message_already_purchased": "Nie możesz ponownie zakupić tego produktu.",
  "error_page.error_message_missing_email_error": "Adres e-mail jest wymagany do dokonania zakupu.",
  "error_page.error_message_network_error": "Błąd sieci. Sprawdź połączenie internetowe.",
  "error_page.error_message_error_charging_payment": "Płatność nieudana.",
  "error_page.error_message_error_setting_up_purchase": "Zakup nie został rozpoczęty z powodu błędu (kod błędu: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Nie mogliśmy zweryfikować Twojego adresu rozliczeniowego. Sprawdź, czy kod pocztowy i kraj są poprawne.",
  "error_page.error_message_unknown_error": "Wystąpił nieznany błąd (kod błędu: {{errorCode}}).",
  "error_page.button_try_again": "Spróbuj ponownie",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% zniżki",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Do zapłaty dzisiaj",
  "product_info.subscribe_to": "Subskrybuj",
  "payment_entry_page.trial_info": "Po zakończeniu okresu próbnego zostanie pobrana opłata w wysokości {{price}} {{perFrequency}} począwszy od {{renewalDate}}. Zawsze możesz anulować wcześniej.",
  "navbar_header.details": "Szczegóły",
  "navbar_header.back_button": "Wstecz",
  "pricing_dropdown.show_details": "Pokaż szczegóły",
  "pricing_dropdown.hide_details": "Ukryj szczegóły",
  "pricing_table.tax": "Podatek",
  "pricing_table.trial_ends": "Po zakończeniu okresu próbnego, {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Suma należna dzisiaj",
  "pricing_table.total_excluding_tax": "Suma bez podatku",
  "pricing_table.enter_billing_address_to_calculate": "Wprowadź adres rozliczeniowy, aby obliczyć",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Wprowadź stan lub kod pocztowy, aby obliczyć",
  "pricing_table.enter_postal_code_to_calculate": "Wprowadź kod pocztowy, aby obliczyć",
  "error_page.error_message_invalid_email_error": "Nie można zweryfikować adresu e-mail {{email}}. Proszę podać prawidłowy adres e-mail.",
  "payment_entry_page.button_payment_method": "Zapłać {{formattedPrice}} przez {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Zapłać {{formattedPrice}}",
  "price_update.title": "Aktualizacja ceny",
  "price_update.base_message": "Cena całkowita została zaktualizowana o podatek na podstawie Twojego adresu rozliczeniowego. Sprawdź i spróbuj ponownie. Twoja karta zostanie obciążona tylko raz.",
  "price_update.trial_message": "Cena subskrypcji została zaktualizowana o podatki na podstawie Twojego adresu rozliczeniowego. Okres próbny nadal obowiązuje. Sprawdź i spróbuj ponownie.",
  "payment_entry_page.express_checkout_divider": "LUB ZAPŁAĆ KARTĄ",
  "error_page.trouble_accessing": "Jeśli masz problemy z dostępem do zakupu, skontaktuj się z działem pomocy pod adresem ",
  "error_page.close_button_title": "Przejdź do {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Brakujące uprawnienie Stripe",
  "error_page.button_close": "Zamknij",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Zakup nie powiódł się, ponieważ adres pochodzenia podatku jest nieprawidłowy. W środowisku produkcyjnym zakupy będą działać bez naliczania podatków.",
  "error_page.error_message_stripe_tax_not_active": "Zakup nie powiódł się, ponieważ Stripe Tax nie jest włączony. W środowisku produkcyjnym zakupy będą działać bez naliczania podatków.",
  "error_page.error_only_in_sandbox": "Ta wiadomość pojawia się tylko w środowisku testowym.",
  "error_page.error_message_stripe_missing_required_permission": "Zakup nie powiódł się, ponieważ aplikacja Stripe nie ma wymaganego uprawnienia. W środowisku produkcyjnym zakupy będą działać bez naliczania podatków.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax nieaktywny",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Nieprawidłowy adres pochodzenia podatku",
  "apple_pay.free_trial": "Okres próbny"
}, kc = {
  "periods.week": "{{amount}} semana",
  "periods.month": "{{amount}} mês",
  "periods.year": "{{amount}} ano",
  "periods.day": "{{amount}} dia",
  "periods.weekShort": "{{amount}}sem",
  "periods.monthShort": "{{amount}}mês",
  "periods.yearShort": "{{amount}}ano",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "vitalício",
  "periods.weekPlural": "{{amount}} semanas",
  "periods.monthPlural": "{{amount}} meses",
  "periods.yearPlural": "{{amount}} anos",
  "periods.dayPlural": "{{amount}} dias",
  "periods.weekFrequency": "semanal",
  "periods.monthFrequency": "mensal",
  "periods.yearFrequency": "anual",
  "periods.dayFrequency": "diário",
  "periods.perWeekFrequency": "por semana",
  "periods.perMonthFrequency": "por mês",
  "periods.perYearFrequency": "por ano",
  "periods.perDayFrequency": "por dia",
  "periods.unknownFrequency": "desconhecido",
  "periods.weekFrequencyPlural": "a cada {{amount}} semanas",
  "periods.monthFrequencyPlural": "a cada {{amount}} meses",
  "periods.yearFrequencyPlural": "a cada {{amount}} anos",
  "periods.dayFrequencyPlural": "a cada {{amount}} dias",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} teste grátis",
  "product_info.price_after_free_trial": "Após o término do teste, em {{renewalDate}}",
  "product_info.renewal_frequency": "Renova {{frequency}}",
  "product_info.continues_until_cancelled": "Continua até ser cancelado",
  "product_info.cancel_anytime": "Cancelar a qualquer momento",
  "payment_entry_page.payment_step_title": "Pagamento seguro pela RevenueCat",
  "payment_entry_page.terms_info": "Ao fornecer suas informações de cartão, você permite que o {{appName}} cobre seu cartão para pagamentos futuros de acordo com seus termos.",
  "payment_entry_page.button_pay": "Pagar agora",
  "payment_entry_page.button_start_trial": "Iniciar Teste",
  "success_page.purchase_successful": "Pagamento concluído",
  "success_page.button_close": "Continuar",
  "error_page.if_error_persists": "Se o erro persistir, entre em contato com ",
  "error_page.error_title_already_subscribed": "Você já se inscreveu em {{productTitle}}",
  "error_page.error_title_already_purchased": "Você já comprou {{productTitle}}",
  "error_page.error_title_other_errors": "Algo deu errado",
  "error_page.error_message_already_subscribed": "Você não pode se inscrever neste produto novamente.",
  "error_page.error_message_already_purchased": "Você não pode comprar este produto novamente.",
  "error_page.error_message_missing_email_error": "Email é necessário para concluir a compra.",
  "error_page.error_message_network_error": "Erro de rede. Verifique sua conexão com a internet.",
  "error_page.error_message_error_charging_payment": "Pagamento falhou.",
  "error_page.error_message_error_setting_up_purchase": "Compra não iniciada devido a um erro (código de erro: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Não conseguimos verificar seu endereço de cobrança. Por favor, verifique se o código postal e o país estão corretos.",
  "error_page.error_message_unknown_error": "Ocorreu um erro desconhecido (código de erro: {{errorCode}}).",
  "error_page.button_try_again": "Tentar novamente",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% de desconto",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Total a pagar hoje",
  "product_info.subscribe_to": "Subscrever",
  "payment_entry_page.trial_info": "Após o término do seu período de avaliação, será cobrado o valor de {{price}} {{perFrequency}} a partir de {{renewalDate}}. Você pode cancelar a qualquer momento antes disso.",
  "navbar_header.details": "Detalhes",
  "navbar_header.back_button": "Voltar",
  "pricing_dropdown.show_details": "Mostrar detalhes",
  "pricing_dropdown.hide_details": "Ocultar detalhes",
  "pricing_table.tax": "Imposto",
  "pricing_table.trial_ends": "Após o término do período de avaliação, em {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Total a pagar hoje",
  "pricing_table.total_excluding_tax": "Total sem impostos",
  "pricing_table.enter_billing_address_to_calculate": "Insira o endereço de cobrança para calcular",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Insira o estado ou o CEP para calcular",
  "pricing_table.enter_postal_code_to_calculate": "Insira o CEP para calcular",
  "error_page.error_message_invalid_email_error": "O endereço de e-mail {{email}} não pôde ser verificado. Por favor, forneça um endereço de e-mail válido.",
  "payment_entry_page.button_payment_method": "Pagar {{formattedPrice}} com {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Pagar {{formattedPrice}}",
  "price_update.title": "Atualização de preço",
  "price_update.base_message": "O preço total foi atualizado com impostos com base no seu endereço de cobrança. Por favor, revise e tente novamente. Seu cartão só será cobrado uma vez.",
  "price_update.trial_message": "O preço da assinatura foi atualizado para incluir impostos com base no seu endereço de faturação. O período de teste gratuito continua válido. Por favor, verifique e tente novamente.",
  "payment_entry_page.express_checkout_divider": "OU PAGUE COM CARTÃO",
  "error_page.trouble_accessing": "Se estiver com problemas para acessar sua compra, entre em contato com o suporte em ",
  "error_page.close_button_title": "Ir para {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Permissão do Stripe em falta",
  "error_page.button_close": "Fechar",
  "error_page.error_message_stripe_invalid_tax_origin_address": "A compra falhou porque o endereço de origem fiscal é inválido. Em produção, as compras funcionarão sem impostos aplicados.",
  "error_page.error_message_stripe_tax_not_active": "A compra falhou porque o Stripe Tax não está ativado. Em produção, as compras funcionarão sem impostos aplicados.",
  "error_page.error_only_in_sandbox": "Esta mensagem aparece apenas na sandbox.",
  "error_page.error_message_stripe_missing_required_permission": "A compra falhou porque o aplicativo Stripe não tem uma permissão necessária. Em produção, as compras funcionarão sem impostos aplicados.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax não está ativo",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Endereço de origem fiscal inválido",
  "apple_pay.free_trial": "Teste Gratuito"
}, wc = {
  "periods.week": "{{amount}} săptămână",
  "periods.month": "{{amount}} lună",
  "periods.year": "{{amount}} an",
  "periods.day": "{{amount}} zi",
  "periods.weekShort": "{{amount}}săpt",
  "periods.monthShort": "{{amount}}lun",
  "periods.yearShort": "{{amount}}an",
  "periods.dayShort": "{{amount}}z",
  "periods.lifetime": "pe viață",
  "periods.weekPlural": "{{amount}} săptămâni",
  "periods.monthPlural": "{{amount}} luni",
  "periods.yearPlural": "{{amount}} ani",
  "periods.dayPlural": "{{amount}} zile",
  "periods.weekFrequency": "săptămânal",
  "periods.monthFrequency": "lunar",
  "periods.yearFrequency": "anual",
  "periods.dayFrequency": "zilnic",
  "periods.perWeekFrequency": "pe săptămână",
  "periods.perMonthFrequency": "pe lună",
  "periods.perYearFrequency": "pe an",
  "periods.perDayFrequency": "pe zi",
  "periods.unknownFrequency": "necunoscut",
  "periods.weekFrequencyPlural": "la fiecare {{amount}} săptămâni",
  "periods.monthFrequencyPlural": "la fiecare {{amount}} luni",
  "periods.yearFrequencyPlural": "la fiecare {{amount}} ani",
  "periods.dayFrequencyPlural": "la fiecare {{amount}} zile",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} perioadă de probă gratuită",
  "product_info.price_after_free_trial": "După terminarea perioadei de probă, pe {{renewalDate}}",
  "product_info.renewal_frequency": "Se reînnoiește {{frequency}}",
  "product_info.continues_until_cancelled": "Continuă până la anulare",
  "product_info.cancel_anytime": "Anulare oricând",
  "payment_entry_page.payment_step_title": "Plata securizată prin RevenueCat",
  "payment_entry_page.terms_info": "Prin furnizarea informațiilor dvs. despre card, permiteți aplicației {{appName}} să vă încarce cardul pentru plăți viitoare, în conformitate cu termenii acesteia.",
  "payment_entry_page.button_pay": "Plătește acum",
  "payment_entry_page.button_start_trial": "Începe perioada de probă",
  "success_page.purchase_successful": "Plata efectuată",
  "success_page.button_close": "Continuă",
  "error_page.if_error_persists": "Dacă eroarea persistă, vă rugăm să contactați ",
  "error_page.error_title_already_subscribed": "Sunteți deja abonat la {{productTitle}}",
  "error_page.error_title_already_purchased": "Ați achiziționat deja {{productTitle}}",
  "error_page.error_title_other_errors": "A apărut o eroare",
  "error_page.error_message_already_subscribed": "Nu vă puteți abona din nou la acest produs.",
  "error_page.error_message_already_purchased": "Nu puteți achiziționa din nou acest produs.",
  "error_page.error_message_missing_email_error": "Adresa de e-mail este necesară pentru a finaliza achiziția.",
  "error_page.error_message_network_error": "Eroare de rețea. Verificați conexiunea la internet.",
  "error_page.error_message_error_charging_payment": "Plata a eșuat.",
  "error_page.error_message_error_setting_up_purchase": "Achiziția nu a putut fi inițiată din cauza unei erori (cod de eroare: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Nu am putut verifica adresa de facturare. Vă rugăm să verificați dacă codul poștal și țara sunt corecte.",
  "error_page.error_message_unknown_error": "A apărut o eroare necunoscută (cod de eroare: {{errorCode}}).",
  "error_page.button_try_again": "Încearcă din nou",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% reducere",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Total de plată astăzi",
  "product_info.subscribe_to": "Abonare la",
  "payment_entry_page.trial_info": "După ce perioada de probă se termină, veți fi taxat cu {{price}} {{perFrequency}} începând cu {{renewalDate}}. Puteți anula oricând înainte de această dată.",
  "navbar_header.details": "Detalii",
  "navbar_header.back_button": "Înapoi",
  "pricing_dropdown.show_details": "Arată detalii",
  "pricing_dropdown.hide_details": "Ascunde detalii",
  "pricing_table.tax": "Taxă",
  "pricing_table.trial_ends": "După ce perioada de probă se termină, pe {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Total de plătit astăzi",
  "pricing_table.total_excluding_tax": "Total fără taxe",
  "pricing_table.enter_billing_address_to_calculate": "Introduceți adresa de facturare pentru a calcula",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Introduceți statul sau codul poștal pentru a calcula",
  "pricing_table.enter_postal_code_to_calculate": "Introduceți codul poștal pentru a calcula",
  "error_page.error_message_invalid_email_error": "Adresa de e-mail {{email}} nu a putut fi verificată. Vă rugăm să furnizați o adresă de e-mail validă.",
  "payment_entry_page.button_payment_method": "Plătește {{formattedPrice}} cu {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Plătește {{formattedPrice}}",
  "price_update.title": "Actualizare preț",
  "price_update.base_message": "Prețul total a fost actualizat cu taxe, în funcție de adresa dumneavoastră de facturare. Vă rugăm să revizuiți și să încercați din nou. Cardul dumneavoastră va fi debitat o singură dată.",
  "price_update.trial_message": "Prețul abonamentului a fost actualizat pentru a include taxele bazate pe adresa dvs. de facturare. Perioada de probă gratuită rămâne valabilă. Vă rugăm să verificați și să încercați din nou.",
  "payment_entry_page.express_checkout_divider": "SAU PLĂTEȘTE CU CARDUL",
  "error_page.trouble_accessing": "Dacă întâmpini probleme în accesarea achiziției tale, contactează serviciul de asistență la ",
  "error_page.close_button_title": "Mergi la {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Permisiune Stripe lipsă",
  "error_page.button_close": "Închide",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Achiziția a eșuat deoarece adresa de origine fiscală este nevalidă. În producție, achizițiile vor funcționa fără taxe aplicate.",
  "error_page.error_message_stripe_tax_not_active": "Achiziția a eșuat deoarece Stripe Tax nu este activat. În producție, achizițiile vor funcționa fără taxe aplicate.",
  "error_page.error_only_in_sandbox": "Acest mesaj apare doar în sandbox.",
  "error_page.error_message_stripe_missing_required_permission": "Achiziția a eșuat deoarece aplicației Stripe îi lipsește o permisiune necesară. În producție, achizițiile vor funcționa fără taxe aplicate.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax nu este activ",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Adresă de origine fiscală Stripe nevalidă",
  "apple_pay.free_trial": "Perioadă de probă gratuită"
}, xc = {
  "periods.week": "{{amount}} неделя",
  "periods.month": "{{amount}} месяц",
  "periods.year": "{{amount}} год",
  "periods.day": "{{amount}} день",
  "periods.weekShort": "{{amount}}нед",
  "periods.monthShort": "{{amount}}мес",
  "periods.yearShort": "{{amount}}г",
  "periods.dayShort": "{{amount}}д",
  "periods.lifetime": "пожизненно",
  "periods.weekPlural": "{{amount}} недель",
  "periods.monthPlural": "{{amount}} месяцев",
  "periods.yearPlural": "{{amount}} лет",
  "periods.dayPlural": "{{amount}} дней",
  "periods.weekFrequency": "еженедельно",
  "periods.monthFrequency": "ежемесячно",
  "periods.yearFrequency": "ежегодно",
  "periods.dayFrequency": "ежедневно",
  "periods.perWeekFrequency": "в неделю",
  "periods.perMonthFrequency": "в месяц",
  "periods.perYearFrequency": "в год",
  "periods.perDayFrequency": "в день",
  "periods.unknownFrequency": "неизвестно",
  "periods.weekFrequencyPlural": "каждые {{amount}} недель",
  "periods.monthFrequencyPlural": "каждые {{amount}} месяцев",
  "periods.yearFrequencyPlural": "каждые {{amount}} лет",
  "periods.dayFrequencyPlural": "каждые {{amount}} дней",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} бесплатная пробная версия",
  "product_info.price_after_free_trial": "После окончания пробного периода, {{renewalDate}}",
  "product_info.renewal_frequency": "Продлевается {{frequency}}",
  "product_info.continues_until_cancelled": "Продолжается до отмены",
  "product_info.cancel_anytime": "Отменить в любое время",
  "payment_entry_page.payment_step_title": "Безопасная оплата через RevenueCat",
  "payment_entry_page.terms_info": "Предоставляя данные вашей карты, вы разрешаете {{appName}} списывать средства с вашей карты для будущих платежей в соответствии с их условиями.",
  "payment_entry_page.button_pay": "Оплатить сейчас",
  "payment_entry_page.button_start_trial": "Начать пробный период",
  "success_page.purchase_successful": "Оплата завершена",
  "success_page.button_close": "Продолжить",
  "error_page.if_error_persists": "Если ошибка сохраняется, пожалуйста, свяжитесь с ",
  "error_page.error_title_already_subscribed": "Вы уже подписаны на {{productTitle}}",
  "error_page.error_title_already_purchased": "Вы уже приобрели {{productTitle}}",
  "error_page.error_title_other_errors": "Что-то пошло не так",
  "error_page.error_message_already_subscribed": "Вы не можете подписаться на этот продукт повторно.",
  "error_page.error_message_already_purchased": "Вы не можете приобрести этот продукт повторно.",
  "error_page.error_message_missing_email_error": "Для завершения покупки необходим адрес электронной почты.",
  "error_page.error_message_network_error": "Ошибка сети. Проверьте ваше интернет-соединение.",
  "error_page.error_message_error_charging_payment": "Оплата не прошла.",
  "error_page.error_message_error_setting_up_purchase": "Покупка не была начата из-за ошибки (код ошибки: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Мы не смогли проверить ваш платежный адрес. Пожалуйста, проверьте, что почтовый индекс и страна указаны правильно.",
  "error_page.error_message_unknown_error": "Произошла неизвестная ошибка (код ошибки: {{errorCode}}).",
  "error_page.button_try_again": "Повторить попытку",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% скидки",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Всего к оплате сегодня",
  "product_info.subscribe_to": "Подписаться",
  "payment_entry_page.trial_info": "После окончания пробного периода с вас будет взиматься {{price}} {{perFrequency}} начиная с {{renewalDate}}. Вы всегда можете отменить подписку до этого времени.",
  "navbar_header.details": "Детали",
  "navbar_header.back_button": "Назад",
  "pricing_dropdown.show_details": "Показать детали",
  "pricing_dropdown.hide_details": "Скрыть детали",
  "pricing_table.tax": "Налог",
  "pricing_table.trial_ends": "После окончания пробного периода, {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Итого к оплате сегодня",
  "pricing_table.total_excluding_tax": "Итого без учета налога",
  "pricing_table.enter_billing_address_to_calculate": "Введите платежный адрес для расчета",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Введите штат или почтовый индекс для расчета",
  "pricing_table.enter_postal_code_to_calculate": "Введите почтовый индекс для расчета",
  "error_page.error_message_invalid_email_error": "Не удалось проверить адрес электронной почты {{email}}. Пожалуйста, укажите действительный адрес электронной почты.",
  "payment_entry_page.button_payment_method": "Оплатить {{formattedPrice}} через {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Оплатить {{formattedPrice}}",
  "price_update.title": "Обновление цены",
  "price_update.base_message": "Общая цена была обновлена с учетом налога на основе вашего платежного адреса. Пожалуйста, проверьте и повторите попытку. С вашей карты будет списано только один раз.",
  "price_update.trial_message": "Цена подписки была обновлена с учетом налогов на основе вашего платежного адреса. Пробный период остается бесплатным. Пожалуйста, проверьте и попробуйте снова.",
  "payment_entry_page.express_checkout_divider": "ИЛИ ОПЛАТИТЕ КАРТОЙ",
  "error_page.trouble_accessing": "Если у вас возникли проблемы с доступом к вашей покупке, обратитесь в службу поддержки по адресу ",
  "error_page.close_button_title": "Перейти в {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Отсутствует разрешение Stripe",
  "error_page.button_close": "Закрыть",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Покупка не удалась, так как адрес отправления налога недействителен. В рабочей среде покупки будут работать без применения налогов.",
  "error_page.error_message_stripe_tax_not_active": "Покупка не удалась, так как Stripe Tax не включен. В рабочей среде покупки будут работать без применения налогов.",
  "error_page.error_only_in_sandbox": "Это сообщение появляется только в песочнице.",
  "error_page.error_message_stripe_missing_required_permission": "Покупка не удалась, так как у приложения Stripe отсутствует необходимое разрешение. В рабочей среде покупки будут работать без применения налогов.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax не активен",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Недействительный адрес отправления налога",
  "apple_pay.free_trial": "Бесплатная пробная версия"
}, Pc = {
  "periods.week": "{{amount}} týždeň",
  "periods.month": "{{amount}} mesiac",
  "periods.year": "{{amount}} rok",
  "periods.day": "{{amount}} deň",
  "periods.weekShort": "{{amount}}týž",
  "periods.monthShort": "{{amount}}mes",
  "periods.yearShort": "{{amount}}rok",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "doživotne",
  "periods.weekPlural": "{{amount}} týždňov",
  "periods.monthPlural": "{{amount}} mesiacov",
  "periods.yearPlural": "{{amount}} rokov",
  "periods.dayPlural": "{{amount}} dní",
  "periods.weekFrequency": "týždenne",
  "periods.monthFrequency": "mesačne",
  "periods.yearFrequency": "ročne",
  "periods.dayFrequency": "denne",
  "periods.perWeekFrequency": "týždenne",
  "periods.perMonthFrequency": "mesačne",
  "periods.perYearFrequency": "ročne",
  "periods.perDayFrequency": "denne",
  "periods.unknownFrequency": "neznáme",
  "periods.weekFrequencyPlural": "každých {{amount}} týždňov",
  "periods.monthFrequencyPlural": "každých {{amount}} mesiacov",
  "periods.yearFrequencyPlural": "každých {{amount}} rokov",
  "periods.dayFrequencyPlural": "každých {{amount}} dní",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} bezplatné skúšobné obdobie",
  "product_info.price_after_free_trial": "Po skončení skúšobného obdobia, dňa {{renewalDate}}",
  "product_info.renewal_frequency": "Obnovuje sa {{frequency}}",
  "product_info.continues_until_cancelled": "Pokračuje, kým sa nezruší",
  "product_info.cancel_anytime": "Kedykoľvek zrušiť",
  "payment_entry_page.payment_step_title": "Bezpečný nákup prostredníctvom RevenueCat",
  "payment_entry_page.terms_info": "Poskytnutím údajov o vašej karte povoľujete {{appName}} účtovať vašu kartu za budúce platby v súlade s ich podmienkami.",
  "payment_entry_page.button_pay": "Zaplatiť teraz",
  "payment_entry_page.button_start_trial": "Spustiť skúšobné obdobie",
  "success_page.purchase_successful": "Platba dokončená",
  "success_page.button_close": "Pokračovať",
  "error_page.if_error_persists": "Ak chyba pretrváva, kontaktujte ",
  "error_page.error_title_already_subscribed": "Už ste si predplatili {{productTitle}}",
  "error_page.error_title_already_purchased": "Už ste si zakúpili {{productTitle}}",
  "error_page.error_title_other_errors": "Niečo sa pokazilo",
  "error_page.error_message_already_subscribed": "Na tento produkt sa nemôžete znova prihlásiť na odber.",
  "error_page.error_message_already_purchased": "Tento produkt si nemôžete znova zakúpiť.",
  "error_page.error_message_missing_email_error": "Na dokončenie nákupu je potrebný e-mail.",
  "error_page.error_message_network_error": "Chyba siete. Skontrolujte svoje internetové pripojenie.",
  "error_page.error_message_error_charging_payment": "Platba zlyhala.",
  "error_page.error_message_error_setting_up_purchase": "Nákup sa nespustil kvôli chybe (kód chyby: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Nepodarilo sa nám overiť vašu fakturačnú adresu. Skontrolujte, prosím, či je PSČ a krajina správne.",
  "error_page.error_message_unknown_error": "Vyskytla sa neznáma chyba (kód chyby: {{errorCode}}).",
  "error_page.button_try_again": "Skúsiť znova",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% zľava",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Celková suma splatná dnes",
  "product_info.subscribe_to": "Prihlásiť sa na odber",
  "payment_entry_page.trial_info": "Po skončení skúšobného obdobia vám bude účtovaná suma {{price}} {{perFrequency}} počnúc dňom {{renewalDate}}. Predtým môžete kedykoľvek zrušiť.",
  "navbar_header.details": "Podrobnosti",
  "navbar_header.back_button": "Späť",
  "pricing_dropdown.show_details": "Zobraziť podrobnosti",
  "pricing_dropdown.hide_details": "Skryť podrobnosti",
  "pricing_table.tax": "Daň",
  "pricing_table.trial_ends": "Po skončení skúšobnej verzie, dňa {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Celková suma splatná dnes",
  "pricing_table.total_excluding_tax": "Celkom bez dane",
  "pricing_table.enter_billing_address_to_calculate": "Zadajte fakturačnú adresu pre výpočet",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Zadajte štát alebo PSČ pre výpočet",
  "pricing_table.enter_postal_code_to_calculate": "Zadajte PSČ pre výpočet",
  "error_page.error_message_invalid_email_error": "E-mailová adresa {{email}} sa nedala overiť. Zadajte platnú e-mailovú adresu.",
  "payment_entry_page.button_payment_method": "Zaplatiť sumu {{formattedPrice}} pomocou {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Zaplatiť {{formattedPrice}}",
  "price_update.title": "Aktualizácia ceny",
  "price_update.base_message": "Celková cena bola aktualizovaná o daň na základe vašej fakturačnej adresy. Skontrolujte to a skúste znova. Vaša karta bude zaťažená iba raz.",
  "price_update.trial_message": "Cena predplatného bola aktualizovaná o daňe na základe vašej fakturačnej adresy. Bezplatná skúšobná doba stále platí. Prosím, skontrolujte a skúste znova.",
  "payment_entry_page.express_checkout_divider": "ALEBO ZAPLATIŤ KARTOU",
  "error_page.trouble_accessing": "Ak máte problémy s prístupom k svojmu nákupu, kontaktujte podporu na ",
  "error_page.close_button_title": "Prejsť na {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Chýbajúce povolenie Stripe",
  "error_page.button_close": "Zavrieť",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Nákup sa nepodaril, pretože adresa pôvodu dane je neplatná. V produkčnom prostredí budú nákupy fungovať bez uplatnenia daní.",
  "error_page.error_message_stripe_tax_not_active": "Nákup sa nepodaril, pretože Stripe Tax nie je povolený. V produkčnom prostredí budú nákupy fungovať bez uplatnenia daní.",
  "error_page.error_only_in_sandbox": "Táto správa sa zobrazuje iba v testovacom prostredí (sandbox).",
  "error_page.error_message_stripe_missing_required_permission": "Nákup sa nepodaril, pretože aplikácii Stripe chýba požadované povolenie. V produkčnom prostredí budú nákupy fungovať bez uplatnenia daní.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax nie je aktívny",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Neplatná adresa pôvodu dane",
  "apple_pay.free_trial": "Skúšobná verzia zdarma"
}, Sc = {
  "periods.week": "{{amount}} vecka",
  "periods.month": "{{amount}} månad",
  "periods.year": "{{amount}} år",
  "periods.day": "{{amount}} dag",
  "periods.weekShort": "{{amount}}v",
  "periods.monthShort": "{{amount}}mån",
  "periods.yearShort": "{{amount}}år",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "livstid",
  "periods.weekPlural": "{{amount}} veckor",
  "periods.monthPlural": "{{amount}} månader",
  "periods.yearPlural": "{{amount}} år",
  "periods.dayPlural": "{{amount}} dagar",
  "periods.weekFrequency": "veckovis",
  "periods.monthFrequency": "månadsvis",
  "periods.yearFrequency": "årligen",
  "periods.dayFrequency": "dagligen",
  "periods.perWeekFrequency": "per vecka",
  "periods.perMonthFrequency": "per månad",
  "periods.perYearFrequency": "per år",
  "periods.perDayFrequency": "per dag",
  "periods.unknownFrequency": "okänd",
  "periods.weekFrequencyPlural": "varje {{amount}} veckor",
  "periods.monthFrequencyPlural": "varje {{amount}} månader",
  "periods.yearFrequencyPlural": "varje {{amount}} år",
  "periods.dayFrequencyPlural": "varje {{amount}} dagar",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} gratis provperiod",
  "product_info.price_after_free_trial": "Efter provperioden slutar, den {{renewalDate}}",
  "product_info.renewal_frequency": "Förnyas {{frequency}}",
  "product_info.continues_until_cancelled": "Gäller tills avbokad",
  "product_info.cancel_anytime": "Avboka när som helst",
  "payment_entry_page.payment_step_title": "Säker betalning via RevenueCat",
  "payment_entry_page.terms_info": "Genom att ange dina kortuppgifter tillåter du {{appName}} att debitera ditt kort för framtida betalningar i enlighet med deras villkor.",
  "payment_entry_page.button_pay": "Betala nu",
  "payment_entry_page.button_start_trial": "Starta provperiod",
  "success_page.purchase_successful": "Betalningen är klar",
  "success_page.button_close": "Fortsätt",
  "error_page.if_error_persists": "Om felet kvarstår, vänligen kontakta ",
  "error_page.error_title_already_subscribed": "Du prenumererar redan på {{productTitle}}",
  "error_page.error_title_already_purchased": "Du har redan köpt {{productTitle}}",
  "error_page.error_title_other_errors": "Något gick fel",
  "error_page.error_message_already_subscribed": "Du kan inte prenumerera på den här produkten igen.",
  "error_page.error_message_already_purchased": "Du kan inte köpa den här produkten igen.",
  "error_page.error_message_missing_email_error": "E-post krävs för att slutföra köpet.",
  "error_page.error_message_network_error": "Nätverksfel. Kontrollera din internetanslutning.",
  "error_page.error_message_error_charging_payment": "Betalningen misslyckades.",
  "error_page.error_message_error_setting_up_purchase": "Köp kunde inte startas på grund av ett fel (felkod: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Vi kunde inte verifiera din faktureringsadress. Kontrollera att postnummer och land är korrekta.",
  "error_page.error_message_unknown_error": "Ett okänt fel inträffade (felkod: {{errorCode}}).",
  "error_page.button_try_again": "Försök igen",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% rabatt",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}} ({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Totalt att betala idag",
  "product_info.subscribe_to": "Prenumerera på",
  "payment_entry_page.trial_info": "Efter din provperiod avslutas debiteras du {{price}} {{perFrequency}} från och med {{renewalDate}}. Du kan alltid avbryta innan dess.",
  "navbar_header.details": "Detaljer",
  "navbar_header.back_button": "Tillbaka",
  "pricing_dropdown.show_details": "Visa detaljer",
  "pricing_dropdown.hide_details": "Dölj detaljer",
  "pricing_table.tax": "Moms",
  "pricing_table.trial_ends": "Efter provperiodens slut, den {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Total summa att betala idag",
  "pricing_table.total_excluding_tax": "Totalt exklusive moms",
  "pricing_table.enter_billing_address_to_calculate": "Ange faktureringsadress för att beräkna",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Ange delstat eller postnummer för att beräkna",
  "pricing_table.enter_postal_code_to_calculate": "Ange postnummer för att beräkna",
  "error_page.error_message_invalid_email_error": "E-postadressen {{email}} kunde inte verifieras. Ange en giltig e-postadress.",
  "payment_entry_page.button_payment_method": "Betala {{formattedPrice}} med {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Betala {{formattedPrice}}",
  "price_update.title": "Prisuppdatering",
  "price_update.base_message": "Det totala priset har uppdaterats med moms baserat på din faktureringsadress. Granska och försök igen. Ditt kort kommer endast att debiteras en gång.",
  "price_update.trial_message": "Prenumerationspriset har uppdaterats för att inkludera skatter baserat på din fakturaadress. Den kostnadsfria provperioden gäller fortfarande. Kontrollera och försök igen.",
  "payment_entry_page.express_checkout_divider": "ELLER BETALA MED KORT",
  "error_page.trouble_accessing": "Om du har problem med att komma åt ditt köp, kontakta support på ",
  "error_page.close_button_title": "Gå till {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Saknar Stripe-behörighet",
  "error_page.button_close": "Stäng",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Köpet misslyckades eftersom skatteursprungsadressen är ogiltig. I produktion kommer köp att fungera utan att skatter tillämpas.",
  "error_page.error_message_stripe_tax_not_active": "Köpet misslyckades eftersom Stripe Tax inte är aktiverat. I produktion kommer köp att fungera utan att skatter tillämpas.",
  "error_page.error_only_in_sandbox": "Det här meddelandet visas bara i sandlådan.",
  "error_page.error_message_stripe_missing_required_permission": "Köpet misslyckades eftersom Stripe-appen saknar en nödvändig behörighet. I produktion kommer köp att fungera utan att skatter tillämpas.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax är inte aktivt",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Ogiltig skatteursprungsadress",
  "apple_pay.free_trial": "Gratis provperiod"
}, Ec = {
  "periods.week": "{{amount}} สัปดาห์",
  "periods.month": "{{amount}} เดือน",
  "periods.year": "{{amount}} ปี",
  "periods.day": "{{amount}} วัน",
  "periods.weekShort": "{{amount}} สัปดาห์",
  "periods.monthShort": "{{amount}} เดือน",
  "periods.yearShort": "{{amount}} ปี",
  "periods.dayShort": "{{amount}} วัน",
  "periods.lifetime": "ตลอดชีพ",
  "periods.weekPlural": "{{amount}} สัปดาห์",
  "periods.monthPlural": "{{amount}} เดือน",
  "periods.yearPlural": "{{amount}} ปี",
  "periods.dayPlural": "{{amount}} วัน",
  "periods.weekFrequency": "รายสัปดาห์",
  "periods.monthFrequency": "รายเดือน",
  "periods.yearFrequency": "รายปี",
  "periods.dayFrequency": "รายวัน",
  "periods.perWeekFrequency": "ต่อสัปดาห์",
  "periods.perMonthFrequency": "ต่อเดือน",
  "periods.perYearFrequency": "ต่อปี",
  "periods.perDayFrequency": "ต่อวัน",
  "periods.unknownFrequency": "ไม่รู้จัก",
  "periods.weekFrequencyPlural": "ทุกๆ {{amount}} สัปดาห์",
  "periods.monthFrequencyPlural": "ทุกๆ {{amount}} เดือน",
  "periods.yearFrequencyPlural": "ทุกๆ {{amount}} ปี",
  "periods.dayFrequencyPlural": "ทุกๆ {{amount}} วัน",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} ทดลองใช้ฟรี",
  "product_info.price_after_free_trial": "หลังจากสิ้นสุดการทดลองใช้ ในวันที่ {{renewalDate}}",
  "product_info.renewal_frequency": "ต่ออายุ {{frequency}}",
  "product_info.continues_until_cancelled": "ต่อเนื่องจนกว่าจะยกเลิก",
  "product_info.cancel_anytime": "ยกเลิกได้ตลอดเวลา",
  "payment_entry_page.payment_step_title": "การชำระเงินอย่างปลอดภัยโดย RevenueCat",
  "payment_entry_page.terms_info": "โดยการให้ข้อมูลบัตรของคุณ คุณอนุญาตให้ {{appName}} เรียกเก็บเงินจากบัตรของคุณสำหรับการชำระเงินในอนาคตตามข้อกำหนดของพวกเขา",
  "payment_entry_page.button_pay": "ชำระเงินตอนนี้",
  "payment_entry_page.button_start_trial": "เริ่มทดลองใช้",
  "success_page.purchase_successful": "การชำระเงินเสร็จสมบูรณ์",
  "success_page.button_close": "ดำเนินการต่อ",
  "error_page.if_error_persists": "หากข้อผิดพลาดยังคงอยู่ โปรดติดต่อ ",
  "error_page.error_title_already_subscribed": "คุณได้สมัครสมาชิก {{productTitle}} แล้ว",
  "error_page.error_title_already_purchased": "คุณได้ซื้อ {{productTitle}} แล้ว",
  "error_page.error_title_other_errors": "มีบางอย่างผิดพลาด",
  "error_page.error_message_already_subscribed": "คุณไม่สามารถสมัครสมาชิกผลิตภัณฑ์นี้ได้อีก",
  "error_page.error_message_already_purchased": "คุณไม่สามารถซื้อผลิตภัณฑ์นี้ได้อีก",
  "error_page.error_message_missing_email_error": "ต้องใช้อีเมลเพื่อทำการซื้อให้เสร็จสมบูรณ์",
  "error_page.error_message_network_error": "ข้อผิดพลาดของเครือข่าย โปรดตรวจสอบการเชื่อมต่ออินเทอร์เน็ตของคุณ",
  "error_page.error_message_error_charging_payment": "การชำระเงินล้มเหลว",
  "error_page.error_message_error_setting_up_purchase": "ไม่สามารถเริ่มการซื้อได้เนื่องจากข้อผิดพลาด (รหัสข้อผิดพลาด: {{errorCode}})",
  "error_page.error_message_invalid_tax_location": "เราไม่สามารถยืนยันที่อยู่สำหรับออกใบแจ้งหนี้ของคุณได้ กรุณาตรวจสอบรหัสไปรษณีย์และประเทศให้ถูกต้อง",
  "error_page.error_message_unknown_error": "เกิดข้อผิดพลาดที่ไม่รู้จัก (รหัสข้อผิดพลาด: {{errorCode}})",
  "error_page.button_try_again": "ลองอีกครั้ง",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% ลด",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "ยอดรวมที่ต้องชำระวันนี้",
  "product_info.subscribe_to": "สมัครสมาชิก",
  "payment_entry_page.trial_info": "หลังจากช่วงทดลองใช้ของคุณสิ้นสุดลง คุณจะถูกเรียกเก็บเงิน {{price}} {{perFrequency}} โดยเริ่มในวันที่ {{renewalDate}} คุณสามารถยกเลิกได้ตลอดเวลาก่อนหน้านั้น",
  "navbar_header.details": "รายละเอียด",
  "navbar_header.back_button": "ย้อนกลับ",
  "pricing_dropdown.show_details": "แสดงรายละเอียด",
  "pricing_dropdown.hide_details": "ซ่อนรายละเอียด",
  "pricing_table.tax": "ภาษี",
  "pricing_table.trial_ends": "หลังจากช่วงทดลองใช้สิ้นสุด ในวันที่ {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "ยอดรวมที่ต้องชำระวันนี้",
  "pricing_table.total_excluding_tax": "ราคารวมก่อนภาษี",
  "pricing_table.enter_billing_address_to_calculate": "กรุณากรอกที่อยู่สำหรับเรียกเก็บเงินเพื่อคำนวณ",
  "pricing_table.enter_state_or_postal_code_to_calculate": "ใส่รัฐหรือรหัสไปรษณีย์เพื่อคำนวณ",
  "pricing_table.enter_postal_code_to_calculate": "ใส่รหัสไปรษณีย์เพื่อคำนวณ",
  "error_page.error_message_invalid_email_error": "ไม่สามารถยืนยันที่อยู่อีเมล {{email}} ได้ โปรดระบุที่อยู่อีเมลที่ถูกต้อง",
  "payment_entry_page.button_payment_method": "ชำระเงิน {{formattedPrice}} ด้วย {{paymentMethod}}",
  "payment_entry_page.button_with_price": "ชำระเงิน {{formattedPrice}}",
  "price_update.title": "อัปเดตราคา",
  "price_update.base_message": "ราคารวมได้รับการอัปเดตพร้อมภาษีตามที่อยู่สำหรับการเรียกเก็บเงินของคุณ โปรดตรวจสอบและลองอีกครั้ง บัตรของคุณจะถูกเรียกเก็บเงินเพียงครั้งเดียวเท่านั้น",
  "price_update.trial_message": "ราคาการสมัครสมาชิกได้รับการอัปเดตเพื่อรวมภาษีตามที่อยู่สำหรับการเรียกเก็บเงินของคุณ ระยะเวลาทดลองใช้ฟรียังคงมีผล โปรดตรวจสอบและลองอีกครั้ง",
  "payment_entry_page.express_checkout_divider": "หรือชำระด้วยบัตร",
  "error_page.trouble_accessing": "หากคุณมีปัญหาในการเข้าถึงการซื้อ โปรดติดต่อฝ่ายสนับสนุนที่ ",
  "error_page.close_button_title": "ไปที่ {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "ขาดสิทธิ์ Stripe ที่จำเป็น",
  "error_page.button_close": "ปิด",
  "error_page.error_message_stripe_invalid_tax_origin_address": "การซื้อล้มเหลวเนื่องจากที่อยู่ต้นทางภาษีไม่ถูกต้อง ในสภาพแวดล้อมจริง การซื้อจะทำงานได้โดยไม่มีการเรียกเก็บภาษี",
  "error_page.error_message_stripe_tax_not_active": "การซื้อล้มเหลวเนื่องจากไม่ได้เปิดใช้งาน Stripe Tax ในสภาพแวดล้อมจริง การซื้อจะทำงานได้โดยไม่มีการเรียกเก็บภาษี",
  "error_page.error_only_in_sandbox": "ข้อความนี้จะปรากฏเฉพาะใน sandbox เท่านั้น",
  "error_page.error_message_stripe_missing_required_permission": "การซื้อล้มเหลวเนื่องจากแอป Stripe ขาดสิทธิ์ที่จำเป็น ในสภาพแวดล้อมจริง การซื้อจะทำงานได้โดยไม่มีการเรียกเก็บภาษี",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax ไม่เปิดใช้งาน",
  "error_page.error_title_stripe_invalid_tax_origin_address": "ที่อยู่ต้นทางภาษีไม่ถูกต้อง",
  "apple_pay.free_trial": "ทดลองใช้ฟรี"
}, Tc = {
  "periods.week": "{{amount}} hafta",
  "periods.month": "{{amount}} ay",
  "periods.year": "{{amount}} yıl",
  "periods.day": "{{amount}} gün",
  "periods.weekShort": "{{amount}}hf",
  "periods.monthShort": "{{amount}}ay",
  "periods.yearShort": "{{amount}}yl",
  "periods.dayShort": "{{amount}}g",
  "periods.lifetime": "ömür boyu",
  "periods.weekPlural": "{{amount}} hafta",
  "periods.monthPlural": "{{amount}} ay",
  "periods.yearPlural": "{{amount}} yıl",
  "periods.dayPlural": "{{amount}} gün",
  "periods.weekFrequency": "haftalık",
  "periods.monthFrequency": "aylık",
  "periods.yearFrequency": "yıllık",
  "periods.dayFrequency": "günlük",
  "periods.perWeekFrequency": "haftada",
  "periods.perMonthFrequency": "ayda",
  "periods.perYearFrequency": "yılda",
  "periods.perDayFrequency": "günde",
  "periods.unknownFrequency": "bilinmiyor",
  "periods.weekFrequencyPlural": "her {{amount}} haftada",
  "periods.monthFrequencyPlural": "her {{amount}} ayda",
  "periods.yearFrequencyPlural": "her {{amount}} yılda",
  "periods.dayFrequencyPlural": "her {{amount}} günde",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} ücretsiz deneme",
  "product_info.price_after_free_trial": "Deneme süresi sona erdiğinde, {{renewalDate}} tarihinde",
  "product_info.renewal_frequency": "{{frequency}} sıklığında yenilenir",
  "product_info.continues_until_cancelled": "İptal edilene kadar devam eder",
  "product_info.cancel_anytime": "İstediğiniz zaman iptal edebilirsiniz",
  "payment_entry_page.payment_step_title": "RevenueCat ile güvenli ödeme",
  "payment_entry_page.terms_info": "Kart bilgilerinizi vererek, {{appName}}'nin şartlarına uygun olarak gelecekteki ödemeler için kartınızdan ücret almasına izin verirsiniz.",
  "payment_entry_page.button_pay": "Şimdi öde",
  "payment_entry_page.button_start_trial": "Denemeyi başlat",
  "success_page.purchase_successful": "Ödeme tamamlandı",
  "success_page.button_close": "Devam et",
  "error_page.if_error_persists": "Hata devam ederse lütfen iletişime geçin ",
  "error_page.error_title_already_subscribed": "{{productTitle}} ürününe zaten abone oldunuz",
  "error_page.error_title_already_purchased": "{{productTitle}} ürününü zaten satın aldınız",
  "error_page.error_title_other_errors": "Bir şeyler ters gitti",
  "error_page.error_message_already_subscribed": "Bu ürüne tekrar abone olamazsınız.",
  "error_page.error_message_already_purchased": "Bu ürünü tekrar satın alamazsınız.",
  "error_page.error_message_missing_email_error": "Satın almayı tamamlamak için e-posta gereklidir.",
  "error_page.error_message_network_error": "Ağ hatası. Lütfen internet bağlantınızı kontrol edin.",
  "error_page.error_message_error_charging_payment": "Ödeme başarısız oldu.",
  "error_page.error_message_error_setting_up_purchase": "Bir hata nedeniyle satın alma başlatılamadı (hata kodu: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Fatura adresinizi doğrulayamadık. Lütfen posta kodu ve ülkenin doğru olduğunu kontrol edin.",
  "error_page.error_message_unknown_error": "Bilinmeyen bir hata oluştu (hata kodu: {{errorCode}}).",
  "error_page.button_try_again": "Tekrar dene",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% indirim",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Bugün ödenecek toplam tutar",
  "product_info.subscribe_to": "Abone Ol",
  "payment_entry_page.trial_info": "Deneme süreniz sona erdikten sonra, {{renewalDate}} tarihinden itibaren {{price}} {{perFrequency}} ücretlendirileceksiniz. O zamana kadar istediğiniz zaman iptal edebilirsiniz.",
  "navbar_header.details": "Detaylar",
  "navbar_header.back_button": "Geri",
  "pricing_dropdown.show_details": "Detayları göster",
  "pricing_dropdown.hide_details": "Detayları gizle",
  "pricing_table.tax": "Vergi",
  "pricing_table.trial_ends": "Deneme süresi sona erdikten sonra, {{formattedTrialEndDate}} tarihinde",
  "pricing_table.total_due_today": "Bugün ödenecek toplam",
  "pricing_table.total_excluding_tax": "Vergi hariç toplam",
  "pricing_table.enter_billing_address_to_calculate": "Hesaplamak için fatura adresini girin",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Hesaplamak için eyalet veya posta kodunu girin",
  "pricing_table.enter_postal_code_to_calculate": "Hesaplamak için posta kodunu girin",
  "error_page.error_message_invalid_email_error": "{{email}} e-posta adresi doğrulanamadı. Lütfen geçerli bir e-posta adresi girin.",
  "payment_entry_page.button_payment_method": "{{paymentMethod}} ile {{formattedPrice}} öde",
  "payment_entry_page.button_with_price": "{{formattedPrice}} öde",
  "price_update.title": "Fiyat güncellemesi",
  "price_update.base_message": "Toplam fiyat, fatura adresinize göre vergi dahil olacak şekilde güncellendi. Lütfen inceleyip tekrar deneyin. Kartınızdan yalnızca bir kez ücret alınacaktır.",
  "price_update.trial_message": "Abonelik fiyatı, fatura adresinize göre vergileri içerecek şekilde güncellendi. Ücretsiz deneme süresi hala geçerli. Lütfen kontrol edin ve tekrar deneyin.",
  "payment_entry_page.express_checkout_divider": "VEYA KARTLA ÖDEYİN",
  "error_page.trouble_accessing": "Satın alımınıza erişmekte sorun yaşıyorsanız, şu adresten destek ekibine ulaşın: ",
  "error_page.close_button_title": "{{appName}}'e Git",
  "error_page.error_title_stripe_missing_required_permission": "Eksik Stripe izni",
  "error_page.button_close": "Kapat",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Vergi başlangıç adresi geçersiz olduğu için satın alma başarısız oldu. Üretimde, satın alımlar vergi uygulanmadan çalışacaktır.",
  "error_page.error_message_stripe_tax_not_active": "Stripe Vergi etkinleştirilmediği için satın alma başarısız oldu. Üretimde, satın alımlar vergi uygulanmadan çalışacaktır.",
  "error_page.error_only_in_sandbox": "Bu mesaj yalnızca sanal ortamda görünür.",
  "error_page.error_message_stripe_missing_required_permission": "Stripe uygulamasında gerekli bir izin eksik olduğu için satın alma başarısız oldu. Üretimde, satın alımlar vergi uygulanmadan çalışacaktır.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Vergi aktif değil",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Geçersiz vergi başlangıç adresi",
  "apple_pay.free_trial": "Ücretsiz Deneme"
}, Ic = {
  "periods.week": "{{amount}} тиждень",
  "periods.month": "{{amount}} місяць",
  "periods.year": "{{amount}} рік",
  "periods.day": "{{amount}} день",
  "periods.weekShort": "{{amount}}тиж",
  "periods.monthShort": "{{amount}}міс",
  "periods.yearShort": "{{amount}}рік",
  "periods.dayShort": "{{amount}}дн",
  "periods.lifetime": "пожиттєво",
  "periods.weekPlural": "{{amount}} тижнів",
  "periods.monthPlural": "{{amount}} місяців",
  "periods.yearPlural": "{{amount}} років",
  "periods.dayPlural": "{{amount}} днів",
  "periods.weekFrequency": "щотижня",
  "periods.monthFrequency": "щомісяця",
  "periods.yearFrequency": "щороку",
  "periods.dayFrequency": "щодня",
  "periods.perWeekFrequency": "на тиждень",
  "periods.perMonthFrequency": "на місяць",
  "periods.perYearFrequency": "на рік",
  "periods.perDayFrequency": "на день",
  "periods.unknownFrequency": "невідомо",
  "periods.weekFrequencyPlural": "кожні {{amount}} тижнів",
  "periods.monthFrequencyPlural": "кожні {{amount}} місяців",
  "periods.yearFrequencyPlural": "кожні {{amount}} років",
  "periods.dayFrequencyPlural": "кожні {{amount}} днів",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} безкоштовний пробний період",
  "product_info.price_after_free_trial": "Після закінчення пробного періоду, {{renewalDate}}",
  "product_info.renewal_frequency": "Продовжується {{frequency}}",
  "product_info.continues_until_cancelled": "Триває до скасування",
  "product_info.cancel_anytime": "Можна скасувати в будь-який час",
  "payment_entry_page.payment_step_title": "Безпечна оплата через RevenueCat",
  "payment_entry_page.terms_info": "Надаючи дані вашої картки, ви дозволяєте {{appName}} стягувати кошти з вашої картки для майбутніх платежів відповідно до їхніх умов.",
  "payment_entry_page.button_pay": "Оплатити зараз",
  "payment_entry_page.button_start_trial": "Розпочати пробний період",
  "success_page.purchase_successful": "Оплата завершена",
  "success_page.button_close": "Продовжити",
  "error_page.if_error_persists": "Якщо помилка повторюється, зверніться до ",
  "error_page.error_title_already_subscribed": "Ви вже підписалися на {{productTitle}}",
  "error_page.error_title_already_purchased": "Ви вже придбали {{productTitle}}",
  "error_page.error_title_other_errors": "Щось пішло не так",
  "error_page.error_message_already_subscribed": "Ви не можете підписатися на цей продукт знову.",
  "error_page.error_message_already_purchased": "Ви не можете придбати цей продукт знову.",
  "error_page.error_message_missing_email_error": "Для завершення покупки потрібна електронна пошта.",
  "error_page.error_message_network_error": "Помилка мережі. Перевірте підключення до інтернету.",
  "error_page.error_message_error_charging_payment": "Оплата не пройшла.",
  "error_page.error_message_error_setting_up_purchase": "Помилка при ініціалізації покупки (код помилки: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Ми не змогли перевірити вашу платіжну адресу. Будь ласка, перевірте, чи правильні поштовий індекс та країна.",
  "error_page.error_message_unknown_error": "Сталася невідома помилка (код помилки: {{errorCode}}).",
  "error_page.button_try_again": "Спробувати ще раз",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% знижки",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Всього до сплати сьогодні",
  "product_info.subscribe_to": "Підписатися на",
  "payment_entry_page.trial_info": "Після закінчення вашого пробного періоду з вас буде стягнуто {{price}} {{perFrequency}}, починаючи з {{renewalDate}}. Ви завжди можете скасувати підписку до цього часу.",
  "navbar_header.details": "Деталі",
  "navbar_header.back_button": "Назад",
  "pricing_dropdown.show_details": "Показати деталі",
  "pricing_dropdown.hide_details": "Приховати деталі",
  "pricing_table.tax": "Податок",
  "pricing_table.trial_ends": "Після закінчення пробного періоду, {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Загальна сума до сплати сьогодні",
  "pricing_table.total_excluding_tax": "Загальна сума без урахування податку",
  "pricing_table.enter_billing_address_to_calculate": "Введіть адресу виставлення рахунку для розрахунку",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Введіть штат або поштовий індекс для розрахунку",
  "pricing_table.enter_postal_code_to_calculate": "Введіть поштовий індекс для розрахунку",
  "error_page.error_message_invalid_email_error": "Електронну адресу {{email}} не вдалося підтвердити. Будь ласка, вкажіть дійсну електронну адресу.",
  "payment_entry_page.button_payment_method": "Сплатити {{formattedPrice}} за допомогою {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Сплатити {{formattedPrice}}",
  "price_update.title": "Оновлення ціни",
  "price_update.base_message": "Загальну ціну було оновлено з урахуванням податку на основі вашої платіжної адреси. Перегляньте та спробуйте ще раз. З вашої картки буде списано кошти лише один раз.",
  "price_update.trial_message": "Ціна підписки була оновлена для включення податків на основі вашої платіжної адреси. Безкоштовний пробний період все ще діє. Будь ласка, перевірте та спробуйте ще раз.",
  "payment_entry_page.express_checkout_divider": "АБО СПЛАТІТЬ КАРТКОЮ",
  "error_page.trouble_accessing": "Якщо у вас виникли проблеми з доступом до вашої покупки, зверніться до служби підтримки за адресою ",
  "error_page.close_button_title": "Перейти до {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Відсутній дозвіл Stripe",
  "error_page.button_close": "Закрити",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Покупка не вдалася, оскільки адреса походження податку недійсна. У виробництві покупки працюватимуть без застосування податків.",
  "error_page.error_message_stripe_tax_not_active": "Покупка не вдалася, оскільки Stripe Tax не ввімкнено. У виробництві покупки працюватимуть без застосування податків.",
  "error_page.error_only_in_sandbox": "Це повідомлення з’являється лише в пісочниці.",
  "error_page.error_message_stripe_missing_required_permission": "Покупка не вдалася, оскільки програмі Stripe не вистачає необхідного дозволу. У виробництві покупки працюватимуть без застосування податків.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax не активовано",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Недійсна адреса походження податку",
  "apple_pay.free_trial": "Безкоштовна пробна версія"
}, qc = {
  "periods.week": "{{amount}} tuần",
  "periods.month": "{{amount}} tháng",
  "periods.year": "{{amount}} năm",
  "periods.day": "{{amount}} ngày",
  "periods.weekShort": "{{amount}}tuần",
  "periods.monthShort": "{{amount}}tháng",
  "periods.yearShort": "{{amount}}năm",
  "periods.dayShort": "{{amount}}ngày",
  "periods.lifetime": "trọn đời",
  "periods.weekPlural": "{{amount}} tuần",
  "periods.monthPlural": "{{amount}} tháng",
  "periods.yearPlural": "{{amount}} năm",
  "periods.dayPlural": "{{amount}} ngày",
  "periods.weekFrequency": "hàng tuần",
  "periods.monthFrequency": "hàng tháng",
  "periods.yearFrequency": "hàng năm",
  "periods.dayFrequency": "hàng ngày",
  "periods.perWeekFrequency": "mỗi tuần",
  "periods.perMonthFrequency": "mỗi tháng",
  "periods.perYearFrequency": "mỗi năm",
  "periods.perDayFrequency": "mỗi ngày",
  "periods.unknownFrequency": "không xác định",
  "periods.weekFrequencyPlural": "cứ {{amount}} tuần",
  "periods.monthFrequencyPlural": "cứ {{amount}} tháng",
  "periods.yearFrequencyPlural": "cứ {{amount}} năm",
  "periods.dayFrequencyPlural": "cứ {{amount}} ngày",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} dùng thử miễn phí",
  "product_info.price_after_free_trial": "Sau khi dùng thử kết thúc, vào {{renewalDate}}",
  "product_info.renewal_frequency": "Gia hạn {{frequency}}",
  "product_info.continues_until_cancelled": "Tiếp tục cho đến khi hủy",
  "product_info.cancel_anytime": "Hủy bất cứ lúc nào",
  "payment_entry_page.payment_step_title": "Thanh toán an toàn bởi RevenueCat",
  "payment_entry_page.terms_info": "Bằng cách cung cấp thông tin thẻ của bạn, bạn cho phép {{appName}} tính phí thẻ của bạn cho các khoản thanh toán trong tương lai theo các điều khoản của họ.",
  "payment_entry_page.button_pay": "Thanh toán ngay",
  "payment_entry_page.button_start_trial": "Bắt đầu dùng thử",
  "success_page.purchase_successful": "Thanh toán hoàn tất",
  "success_page.button_close": "Tiếp tục",
  "error_page.if_error_persists": "Nếu lỗi vẫn tiếp diễn, vui lòng liên hệ ",
  "error_page.error_title_already_subscribed": "Bạn đã đăng ký {{productTitle}} rồi",
  "error_page.error_title_already_purchased": "Bạn đã mua {{productTitle}} rồi",
  "error_page.error_title_other_errors": "Có lỗi xảy ra",
  "error_page.error_message_already_subscribed": "Bạn không thể đăng ký sản phẩm này lần nữa.",
  "error_page.error_message_already_purchased": "Bạn không thể mua sản phẩm này lần nữa.",
  "error_page.error_message_missing_email_error": "Email bắt buộc để hoàn tất việc mua hàng.",
  "error_page.error_message_network_error": "Lỗi mạng. Vui lòng kiểm tra kết nối internet của bạn.",
  "error_page.error_message_error_charging_payment": "Thanh toán thất bại.",
  "error_page.error_message_error_setting_up_purchase": "Không thể bắt đầu mua do lỗi (mã lỗi: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Chúng tôi không thể xác minh địa chỉ thanh toán của bạn. Vui lòng kiểm tra lại mã bưu điện và quốc gia.",
  "error_page.error_message_unknown_error": "Đã xảy ra lỗi không xác định (mã lỗi: {{errorCode}}).",
  "error_page.button_try_again": "Thử lại",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% giảm",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Tổng số tiền phải trả hôm nay",
  "product_info.subscribe_to": "Đăng ký",
  "payment_entry_page.trial_info": "Sau khi thời gian dùng thử của bạn kết thúc, bạn sẽ bị tính phí {{price}} {{perFrequency}} bắt đầu từ {{renewalDate}}. Bạn luôn có thể hủy trước thời điểm đó.",
  "navbar_header.details": "Chi tiết",
  "navbar_header.back_button": "Quay lại",
  "pricing_dropdown.show_details": "Xem chi tiết",
  "pricing_dropdown.hide_details": "Ẩn chi tiết",
  "pricing_table.tax": "Thuế",
  "pricing_table.trial_ends": "Sau khi thời gian dùng thử kết thúc, vào {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Tổng số tiền phải trả hôm nay",
  "pricing_table.total_excluding_tax": "Tổng cộng chưa bao gồm thuế",
  "pricing_table.enter_billing_address_to_calculate": "Nhập địa chỉ thanh toán để tính toán",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Nhập tiểu bang hoặc mã bưu điện để tính toán",
  "pricing_table.enter_postal_code_to_calculate": "Nhập mã bưu điện để tính toán",
  "error_page.error_message_invalid_email_error": "Không thể xác minh địa chỉ email {{email}}. Vui lòng cung cấp một địa chỉ email hợp lệ.",
  "payment_entry_page.button_payment_method": "Thanh toán {{formattedPrice}} bằng {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Thanh toán {{formattedPrice}}",
  "price_update.title": "Cập nhật giá",
  "price_update.base_message": "Tổng giá đã được cập nhật với thuế dựa trên địa chỉ thanh toán của bạn. Vui lòng xem lại và thử lại. Thẻ của bạn sẽ chỉ bị tính phí một lần.",
  "price_update.trial_message": "Giá đăng ký đã được cập nhật để bao gồm thuế dựa trên địa chỉ thanh toán của bạn. Thời gian dùng thử miễn phí vẫn được áp dụng. Vui lòng kiểm tra và thử lại.",
  "payment_entry_page.express_checkout_divider": "HOẶC THANH TOÁN BẰNG THẺ",
  "error_page.trouble_accessing": "Nếu bạn gặp sự cố khi truy cập giao dịch mua của mình, hãy liên hệ với bộ phận hỗ trợ theo địa chỉ ",
  "error_page.close_button_title": "Đi đến {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Thiếu quyền Stripe",
  "error_page.button_close": "Đóng",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Giao dịch mua không thành công vì địa chỉ gốc thuế không hợp lệ. Trong môi trường thực tế, giao dịch mua sẽ hoạt động mà không áp dụng thuế.",
  "error_page.error_message_stripe_tax_not_active": "Giao dịch mua không thành công vì Thuế Stripe chưa được bật. Trong môi trường thực tế, giao dịch mua sẽ hoạt động mà không áp dụng thuế.",
  "error_page.error_only_in_sandbox": "Thông báo này chỉ xuất hiện trong môi trường thử nghiệm.",
  "error_page.error_message_stripe_missing_required_permission": "Giao dịch mua không thành công vì ứng dụng Stripe thiếu một quyền cần thiết. Trong môi trường thực tế, giao dịch mua sẽ hoạt động mà không áp dụng thuế.",
  "error_page.error_title_stripe_tax_not_active": "Thuế Stripe chưa hoạt động",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Địa chỉ gốc thuế không hợp lệ",
  "apple_pay.free_trial": "Dùng thử miễn phí"
};
var L = /* @__PURE__ */ ((e) => (e.PeriodsWeek = "periods.week", e.PeriodsMonth = "periods.month", e.PeriodsYear = "periods.year", e.PeriodsDay = "periods.day", e.PeriodsWeekShort = "periods.weekShort", e.PeriodsMonthShort = "periods.monthShort", e.PeriodsYearShort = "periods.yearShort", e.PeriodsDayShort = "periods.dayShort", e.PeriodsLifetime = "periods.lifetime", e.PeriodsWeekPlural = "periods.weekPlural", e.PeriodsMonthPlural = "periods.monthPlural", e.PeriodsYearPlural = "periods.yearPlural", e.PeriodsDayPlural = "periods.dayPlural", e.PeriodsWeekFrequency = "periods.weekFrequency", e.PeriodsMonthFrequency = "periods.monthFrequency", e.PeriodsYearFrequency = "periods.yearFrequency", e.PeriodsDayFrequency = "periods.dayFrequency", e.PeriodsPerWeekFrequency = "periods.perWeekFrequency", e.PeriodsPerMonthFrequency = "periods.perMonthFrequency", e.PeriodsPerYearFrequency = "periods.perYearFrequency", e.PeriodsPerDayFrequency = "periods.perDayFrequency", e.PeriodsUnknownFrequency = "periods.unknownFrequency", e.PeriodsWeekFrequencyPlural = "periods.weekFrequencyPlural", e.PeriodsMonthFrequencyPlural = "periods.monthFrequencyPlural", e.PeriodsYearFrequencyPlural = "periods.yearFrequencyPlural", e.PeriodsDayFrequencyPlural = "periods.dayFrequencyPlural", e.ProductInfoProductTitle = "product_info.product_title", e.ProductInfoProductDescription = "product_info.product_description", e.ProductInfoProductPrice = "product_info.product_price", e.ProductInfoFreeTrialDuration = "product_info.free_trial_duration", e.ProductInfoPriceAfterFreeTrial = "product_info.price_after_free_trial", e.ProductInfoPriceTotalDueToday = "product_info.total_due_today", e.ProductInfoSubscribeTo = "product_info.subscribe_to", e.ProductInfoRenewalFrequency = "product_info.renewal_frequency", e.ProductInfoContinuesUntilCancelled = "product_info.continues_until_cancelled", e.ProductInfoCancelAnytime = "product_info.cancel_anytime", e.PaymentEntryPagePaymentStepTitle = "payment_entry_page.payment_step_title", e.PaymentEntryPageTermsInfo = "payment_entry_page.terms_info", e.PaymentEntryPageTrialInfo = "payment_entry_page.trial_info", e.PaymentEntryPageButtonPay = "payment_entry_page.button_pay", e.PaymentEntryPageButtonStartTrial = "payment_entry_page.button_start_trial", e.PaymentEntryPageButtonWithPrice = "payment_entry_page.button_with_price", e.PaymentEntryPageButtonPaymentMethod = "payment_entry_page.button_payment_method", e.PaymentEntryPageExpressCheckoutDivider = "payment_entry_page.express_checkout_divider", e.SuccessPagePurchaseSuccessful = "success_page.purchase_successful", e.SuccessPageButtonClose = "success_page.button_close", e.ErrorPageCloseButtonTitle = "error_page.close_button_title", e.ErrorPageIfErrorPersists = "error_page.if_error_persists", e.ErrorPageTroubleAccessing = "error_page.trouble_accessing", e.ErrorPageErrorTitleAlreadySubscribed = "error_page.error_title_already_subscribed", e.ErrorPageErrorTitleAlreadyPurchased = "error_page.error_title_already_purchased", e.ErrorPageErrorTitleOtherErrors = "error_page.error_title_other_errors", e.ErrorPageErrorTitleStripeTaxNotActive = "error_page.error_title_stripe_tax_not_active", e.ErrorPageErrorTitleStripeInvalidTaxOriginAddress = "error_page.error_title_stripe_invalid_tax_origin_address", e.ErrorPageErrorTitleStripeMissingRequiredPermission = "error_page.error_title_stripe_missing_required_permission", e.ErrorPageErrorMessageAlreadySubscribed = "error_page.error_message_already_subscribed", e.ErrorPageErrorMessageAlreadyPurchased = "error_page.error_message_already_purchased", e.ErrorPageErrorMessageMissingEmailError = "error_page.error_message_missing_email_error", e.ErrorPageErrorMessageInvalidEmailError = "error_page.error_message_invalid_email_error", e.ErrorPageErrorMessageNetworkError = "error_page.error_message_network_error", e.ErrorPageErrorMessageErrorChargingPayment = "error_page.error_message_error_charging_payment", e.ErrorPageErrorMessageErrorSettingUpPurchase = "error_page.error_message_error_setting_up_purchase", e.ErrorPageErrorMessageUnknownError = "error_page.error_message_unknown_error", e.ErrorPageErrorMessageInvalidTaxLocation = "error_page.error_message_invalid_tax_location", e.ErrorPageErrorMessageStripeTaxNotActive = "error_page.error_message_stripe_tax_not_active", e.ErrorPageErrorMessageStripeInvalidTaxOriginAddress = "error_page.error_message_stripe_invalid_tax_origin_address", e.ErrorPageErrorMessageStripeMissingRequiredPermission = "error_page.error_message_stripe_missing_required_permission", e.ErrorPageErrorMessageOnlyInSandbox = "error_page.error_only_in_sandbox", e.ErrorButtonTryAgain = "error_page.button_try_again", e.ErrorButtonClose = "error_page.button_close", e.PaywallVariablesPricePerPeriod = "paywall_variables.price_per_period", e.PaywallVariablesSubRelativeDiscount = "paywall_variables.sub_relative_discount", e.PaywallVariablesTotalPriceAndPerMonth = "paywall_variables.total_price_and_per_month", e.PricingDropdownShowDetails = "pricing_dropdown.show_details", e.PricingDropdownHideDetails = "pricing_dropdown.hide_details", e.PricingTotalExcludingTax = "pricing_table.total_excluding_tax", e.PricingTableTrialEnds = "pricing_table.trial_ends", e.PricingTableTotalDueToday = "pricing_table.total_due_today", e.PricingTableTax = "pricing_table.tax", e.PricingTableEnterBillingAddressToCalculate = "pricing_table.enter_billing_address_to_calculate", e.PricingTableEnterStateOrPostalCodeToCalculate = "pricing_table.enter_state_or_postal_code_to_calculate", e.PricingTableEnterPostalCodeToCalculate = "pricing_table.enter_postal_code_to_calculate", e.NavbarHeaderDetails = "navbar_header.details", e.NavbarBackButton = "navbar_header.back_button", e.PriceUpdateTitle = "price_update.title", e.PriceUpdateBaseMessage = "price_update.base_message", e.PriceUpdateTrialMessage = "price_update.trial_message", e.ApplePayFreeTrial = "apple_pay.free_trial", e))(L || {});
const Fc = {
  en: Jl,
  es: Ql,
  it: $l,
  ar: ec,
  ca: rc,
  zh_Hans: tc,
  zh_Hant: ac,
  hr: nc,
  cs: oc,
  da: ic,
  nl: sc,
  fi: lc,
  fr: cc,
  de: dc,
  el: uc,
  he: pc,
  hi: _c,
  hu: gc,
  id: mc,
  ja: fc,
  ko: yc,
  ms: bc,
  no: hc,
  pl: vc,
  pt: kc,
  ro: wc,
  ru: xc,
  sk: Pc,
  sv: Sc,
  th: Ec,
  tr: Tc,
  uk: Ic,
  vi: qc
};
var xe = /* @__PURE__ */ ((e) => (e.Year = "year", e.Month = "month", e.Week = "week", e.Day = "day", e))(xe || {});
function mi(e) {
  const r = e.match(/^PT?([0-9]+)([MDYW])$/);
  if (!r || r.length < 3)
    return K.errorLog(`Invalid ISO 8601 duration format: ${e}`), null;
  const t = parseInt(r[1]);
  switch (r[2]) {
    case "Y":
      return {
        number: t,
        unit: "year"
        /* Year */
      };
    case "M":
      return {
        number: t,
        unit: "month"
        /* Month */
      };
    case "W":
      return {
        number: t,
        unit: "week"
        /* Week */
      };
    case "D":
      return {
        number: t,
        unit: "day"
        /* Day */
      };
    default:
      return K.errorLog(`Invalid ISO 8601 unit duration format: ${e}`), null;
  }
}
function Xa(e, r, t) {
  if (!t)
    return null;
  let a = new Date(e);
  switch (r.unit) {
    case "year":
      a.getDate() === 29 && a.getMonth() === 1 && r.number !== 4 ? a.setFullYear(
        a.getFullYear() + r.number,
        a.getMonth(),
        28
      ) : a.setFullYear(
        a.getFullYear() + r.number,
        a.getMonth(),
        a.getDate()
      );
      break;
    case "month":
      a.setMonth(a.getMonth() + r.number, a.getDate()), a.getDate() !== e.getDate() && (a = new Date(e), a.setMonth(a.getMonth() + r.number + 1, 0));
      break;
    case "week":
      a.setDate(a.getDate() + r.number * 7);
      break;
    case "day":
      a.setDate(a.getDate() + r.number);
      break;
  }
  return a;
}
const zc = (e) => e / 1e6, Ir = (e, r, t, a = {}) => {
  const n = zc(e), o = {
    style: "currency",
    currency: r,
    currencyDisplay: "symbol",
    ...a,
    // Some browsers require minimumFractionDigits to be set if maximumFractionDigits is set.
    minimumFractionDigits: a.maximumFractionDigits
  };
  return new Intl.NumberFormat(t, o).format(n).replace("US$", "$");
}, Dc = (e, r) => {
  const t = mi(e);
  return t ? r.translatePeriod(t.number, t.unit) || `${t.number} ${t.unit}s` : e;
}, Ac = (e) => {
  try {
    return e.charAt(0).toUpperCase() + e.slice(1);
  } catch {
    return e;
  }
}, Qr = {
  noWhitespace: !1,
  short: !1
}, fi = {
  useMultipleWords: !1
};
class va {
  constructor(r = {}, t = tt, a = tt) {
    M(this, "locales", {});
    this.selectedLocale = t, this.defaultLocale = a;
    const n = {};
    Object.entries(Fc).forEach(([o, i]) => {
      n[o] = new co(i, o);
    }), this.locales = n, r && this.override(r);
  }
  static fallback() {
    return new va();
  }
  override(r) {
    Object.entries(r).forEach(([t, a]) => {
      this.locales[t] = new co(
        {
          ...this.locales[t].labels || {},
          ...a
        },
        this.getLanguageCodeString(t)
      );
    });
  }
  formatPrice(r, t) {
    const a = { currencyDisplay: "narrowSymbol" };
    r === 0 && (a.maximumFractionDigits = 0);
    try {
      return Ir(
        r,
        t,
        this.locale,
        a
      );
    } catch {
      K.errorLog(
        `Failed to create a price formatter for locale: ${this.locale}`
      );
    }
    try {
      return Ir(
        r,
        t,
        this.fallbackLocale,
        a
      );
    } catch {
      K.errorLog(
        `Failed to create a price formatter for locale: ${this.fallbackLocale}`
      );
    }
    return Ir(
      r,
      t,
      tt,
      a
    );
  }
  get locale() {
    var r;
    return ((r = this.getLocaleInstance(this.selectedLocale)) == null ? void 0 : r.localeKey) || this.getLanguageCodeString(this.selectedLocale);
  }
  get fallbackLocale() {
    var r;
    return ((r = this.getLocaleInstance(this.defaultLocale)) == null ? void 0 : r.localeKey) || this.getLanguageCodeString(this.defaultLocale);
  }
  getLanguageCodeString(r) {
    return r.split("_")[0].split("-")[0];
  }
  getLocaleInstance(r) {
    const t = this.getLanguageCodeString(r);
    return this.locales[r] || this.locales[t];
  }
  translate(r, t) {
    const a = this.getLocaleInstance(this.selectedLocale), n = this.getLocaleInstance(this.defaultLocale);
    return (a == null ? void 0 : a.translate(r, t)) || (n == null ? void 0 : n.translate(r, t)) || "";
  }
  formatCountry(r) {
    return new Intl.DisplayNames([this.locale], { type: "region" }).of(
      r
    ) || r;
  }
  translatePeriod(r, t, a = Qr) {
    const n = this.getLocaleInstance(this.selectedLocale), o = this.getLocaleInstance(this.defaultLocale);
    return (n == null ? void 0 : n.translatePeriod(r, t, a)) || (o == null ? void 0 : o.translatePeriod(r, t, a));
  }
  translatePeriodUnit(r, t = Qr) {
    const a = this.getLocaleInstance(this.selectedLocale), n = this.getLocaleInstance(this.defaultLocale);
    return (a == null ? void 0 : a.translatePeriodUnit(r, t)) || (n == null ? void 0 : n.translatePeriodUnit(r, t));
  }
  translatePeriodFrequency(r, t, a = fi) {
    const n = this.getLocaleInstance(this.selectedLocale), o = this.getLocaleInstance(this.defaultLocale);
    return (n == null ? void 0 : n.translatePeriodFrequency(r, t, a)) || (o == null ? void 0 : o.translatePeriodFrequency(r, t, a));
  }
  translateDate(r, t = {}) {
    const a = this.getLocaleInstance(this.selectedLocale), n = this.getLocaleInstance(this.defaultLocale);
    return (a == null ? void 0 : a.translateDate(r, t)) || (n == null ? void 0 : n.translateDate(r, t));
  }
}
class co {
  constructor(r = {}, t) {
    this.labels = r, this.localeKey = t;
  }
  replaceVariables(r, t) {
    return Object.entries(t).reduce(
      (a, [n, o]) => a.replace(
        `{{${n}}}`,
        `${o ?? ""}`
      ),
      r
    );
  }
  translate(r, t) {
    const a = this.labels[r];
    if (a)
      return this.replaceVariables(a, t || {});
  }
  translatePeriod(r, t, a = Qr) {
    var s;
    const { noWhitespace: n, short: o } = {
      ...Qr,
      ...a
    }, i = o ? `periods.${t}Short` : Math.abs(r) === 1 ? `periods.${t}` : `periods.${t}Plural`;
    return (s = this.translate(i, {
      amount: r.toString()
    })) == null ? void 0 : s.replace(" ", n ? "" : " ");
  }
  translatePeriodUnit(r, t = Qr) {
    var i;
    const { noWhitespace: a, short: n } = {
      ...Qr,
      ...t
    }, o = `periods.${r}${n ? "Short" : ""}`;
    return (i = this.translate(o, { amount: "" })) == null ? void 0 : i.replace(
      " ",
      a ? "" : " "
    );
  }
  translatePeriodFrequency(r, t, a = fi) {
    const n = a == null ? void 0 : a.useMultipleWords, o = Math.abs(r) === 1 ? `periods.${n === !0 ? "per" : ""}${n ? Ac(t.toString()) : t}Frequency` : `periods.${t}FrequencyPlural`;
    return this.translate(o, {
      amount: r.toString()
    });
  }
  translateDate(r, t = {}) {
    return r.toLocaleDateString(this.localeKey, t);
  }
}
ol();
const Mc = `<svg viewBox="0 0 124 124" fill="var(--rc-color-grey-text-dark)" xmlns="http://www.w3.org/2000/svg">
    <circle cx="62" cy="62" r="62" fill="var(--rc-color-grey-text-dark)" opacity="0.2"/>
    <path d="M87.6668 41.504L82.4968 36.334L62.0002 56.8307L41.5035 36.334L36.3335 41.504L56.8302 62.0006L36.3335 82.4973L41.5035 87.6673L62.0002 67.1706L82.4968 87.6673L87.6668 82.4973L67.1702 62.0006L87.6668 41.504Z"
          />
</svg>
`;
var jc = /* @__PURE__ */ I('<div style="color:var(--rc-color-primary);"><!></div>');
function yi(e) {
  var r = jc(), t = P(r);
  Wr(t, () => Mc), b(e, r);
}
var Za;
(function(e) {
  e.body_s = "p", e.body_m = "p", e.body_l = "p", e.body_xl = "p", e.heading_xs = "h6", e.heading_s = "h5", e.heading_m = "h4", e.heading_l = "h3", e.heading_xl = "h2", e.heading_xxl = "h1";
})(Za || (Za = {}));
var ta;
(function(e) {
  e[e.extra_light = 100] = "extra_light", e[e.thin = 200] = "thin", e[e.light = 300] = "light", e[e.regular = 400] = "regular", e[e.medium = 500] = "medium", e[e.semibold = 600] = "semibold", e[e.bold = 700] = "bold", e[e.extra_bold = 800] = "extra_bold", e[e.black = 900] = "black";
})(ta || (ta = {}));
var aa;
(function(e) {
  e.body_s = "13px", e.body_m = "14px", e.body_l = "15px", e.body_xl = "16px", e.heading_xs = "14px", e.heading_s = "16px", e.heading_m = "18px", e.heading_l = "20px", e.heading_xl = "26px", e.heading_xxl = "32px";
})(aa || (aa = {}));
var na;
(function(e) {
  e.leading = "start", e.center = "center", e.trailing = "end";
})(na || (na = {}));
var Ka;
(function(e) {
  e.vertical = "column", e.horizontal = "row", e.zlayer = "zstack";
})(Ka || (Ka = {}));
var Ja;
(function(e) {
  e.top = "flex-start", e.leading = "flex-start", e.center = "center", e.bottom = "flex-end", e.trailing = "flex-end";
})(Ja || (Ja = {}));
var Qa;
(function(e) {
  e.space_between = "space-between", e.space_around = "space-around", e.space_evenly = "space-evenly", e.start = "flex-start", e.center = "center", e.end = "flex-end";
})(Qa || (Qa = {}));
const Nc = [
  "product_name",
  "price",
  "price_per_period",
  "price_per_period_full",
  "total_price_and_per_month",
  "total_price_and_per_month_full",
  "sub_price_per_month",
  "sub_price_per_week",
  "sub_duration",
  "sub_duration_in_months",
  "sub_period",
  "sub_period_length",
  "sub_period_abbreviated",
  "sub_offer_duration",
  "sub_offer_duration_2",
  "sub_offer_price",
  "sub_offer_price_2",
  "sub_relative_discount"
], Cc = ({ value: e = "", variableDictionary: r }) => r ? Nc.reduce((t, a) => {
  var o;
  return t.replaceAll(`{{ ${a} }}`, ((o = r[a]) == null ? void 0 : o.toString()) || "N/A");
}, e) : e;
function bi(e, r, t, a) {
  var o;
  if (!e)
    return "";
  const n = (o = a[t]) == null ? void 0 : o[e];
  return (a[r] || {})[e] ? a[r][e] : n;
}
function yn({ text_lid: e, locale: r, defaultLocale: t, labels: a, variableDictionary: n }) {
  if (!e)
    return "";
  const o = bi(e, r, t, a);
  return Cc({
    value: o,
    variableDictionary: n
  });
}
const Zr = [];
function Oc(e, r) {
  return {
    subscribe: hi(e, r).subscribe
  };
}
function hi(e, r = ne) {
  let t = null;
  const a = /* @__PURE__ */ new Set();
  function n(s) {
    if (Oo(e, s) && (e = s, t)) {
      const l = !Zr.length;
      for (const c of a)
        c[1](), Zr.push(c, e);
      if (l) {
        for (let c = 0; c < Zr.length; c += 2)
          Zr[c][0](Zr[c + 1]);
        Zr.length = 0;
      }
    }
  }
  function o(s) {
    n(s(
      /** @type {T} */
      e
    ));
  }
  function i(s, l = ne) {
    const c = [s, l];
    return a.add(c), a.size === 1 && (t = r(n, o) || ne), s(
      /** @type {T} */
      e
    ), () => {
      a.delete(c), a.size === 0 && t && (t(), t = null);
    };
  }
  return { set: n, update: o, subscribe: i };
}
const vi = Oc(!1, (e) => {
  if (typeof window < "u") {
    const r = window.matchMedia("(prefers-color-scheme: dark)");
    e(r.matches);
    const t = (a) => e(a.matches);
    return r.addEventListener("change", t), () => r.removeEventListener("change", t);
  }
  return () => {
  };
}), Re = "light", $a = "#000000", Lc = "#FFFFFF";
function uo(e, r) {
  const t = {
    [`--${r}-block-start`]: "0px",
    [`--${r}-inline-end`]: "0px",
    [`--${r}-block-end`]: "0px",
    [`--${r}-inline-start`]: "0px"
  };
  return !e || !r || Object.assign(t, {
    [`--${r}-block-start`]: `${e.top ?? 0}px`,
    [`--${r}-inline-end`]: `${e.trailing ?? 0}px`,
    [`--${r}-block-end`]: `${e.bottom ?? 0}px`,
    [`--${r}-inline-start`]: `${e.leading ?? 0}px`
  }), t;
}
function Bc(e) {
  return Za[e];
}
function yr({ colorMap: e, colorMode: r = Re, fallback: t = "FFFFFF" }) {
  if (!e)
    return t;
  const a = e[r] || e[Re];
  let n = "";
  switch (a.type) {
    case "hex":
    case "alias":
      return a.value ?? t;
    case "linear":
      return n = (a.points || []).map((o) => `${o.color} ${o.percent}%`).join(", "), `linear-gradient(${a.degrees}deg, ${n})`;
    case "radial":
      return n = (a.points || []).map((o) => `${o.color} ${o.percent}%`).join(", "), `radial-gradient(${n})`;
    default:
      return t;
  }
}
function ki(e, r = Re) {
  if (!e)
    return "";
  const t = yr({ colorMap: e.color, colorMode: r });
  return `${e.width}px solid ${t}`;
}
function oa(e) {
  return {
    "--border-start-start-radius": `${e.top_leading}px`,
    "--border-start-end-radius": `${e.top_trailing}px`,
    "--border-end-start-radius": `${e.bottom_leading}px`,
    "--border-end-end-radius": `${e.bottom_trailing}px`
  };
}
function ka({ background_color: e, border: r, margin: t, padding: a, color: n, colorMode: o = Re, shape: i, shadow: s }) {
  const l = {
    "--margin-block-start": "0px",
    "--margin-inline-end": "0px",
    "--margin-block-end": "0px",
    "--margin-inline-start": "0px",
    "--padding-block-start": "0px",
    "--padding-inline-end": "0px",
    "--padding-block-end": "0px",
    "--padding-inline-start": "0px",
    "--background": "initial",
    "--text-color": "initial",
    "--border": "none",
    "--border-end-start-radius": "0px",
    "--border-end-end-radius": "0px",
    "--border-start-start-radius": "0px",
    "--border-start-end-radius": "0px",
    "--shadow": "none"
  };
  return a && Object.assign(l, uo(a, "padding")), t && Object.assign(l, uo(t, "margin")), e && (l["--background"] = yr({
    colorMap: e,
    colorMode: o,
    fallback: "transparent"
  })), n && (l["--text-color"] = yr({
    colorMap: n,
    colorMode: o,
    fallback: $a
  })), r && (l["--border"] = ki(r, o)), (i == null ? void 0 : i.type) === "rectangle" && i.corners && Object.assign(l, oa(i.corners)), (i == null ? void 0 : i.type) === "pill" && Object.assign(l, oa({
    bottom_leading: 9999,
    bottom_trailing: 9999,
    top_leading: 9999,
    top_trailing: 9999
  })), s && (l["--shadow"] = `${s.x}px ${s.y}px ${s.radius}px 
      ${yr({ colorMap: s.color, colorMode: o, fallback: $a })}`), l;
}
function po(e) {
  return e.type === "fixed" ? `${e.value}px` : e.type === "fit" ? "fit-content" : e.type === "fill" ? navigator.userAgent.match(/firefox|fxios/i) ? "-moz-available" : "-webkit-fill-available" : "initial";
}
function Ct(e) {
  const r = {
    "--width": "initial",
    "--height": "initial",
    "--flex": "initial"
  }, t = po(e.width), a = po(e.height), n = e.width.type === "fill" || e.height.type === "fill";
  return Object.assign(r, {
    "--width": t,
    "--height": a,
    "--flex": n ? "initial" : "0 1 auto"
  }), r;
}
function wi(e) {
  const r = {
    "--inset": "initial",
    "--transform": "initial"
  };
  switch (e.alignment) {
    case "top_leading":
      r["--inset"] = "0 auto auto 0";
      break;
    case "top":
      r["--inset"] = "auto auto auto 50%", r["--transform"] = "translate(-50%, 0)";
      break;
    case "top_trailing":
      r["--inset"] = "0 0 auto auto";
      break;
    case "leading":
      r["--inset"] = "50% 0 50% 0", r["--transform"] = "translate(0, -50%)";
      break;
    case "center":
      r["--inset"] = "50% auto auto 50%", r["--transform"] = "translate(-50%, -50%)";
      break;
    case "trailing":
      r["--inset"] = "50% 0 50% auto", r["--transform"] = "translate(0, -50%)";
      break;
    case "bottom_leading":
      r["--inset"] = "auto auto 0 0";
      break;
    case "bottom":
      r["--inset"] = "auto 50% 0 auto", r["--transform"] = "translate(50%, 0)";
      break;
    case "bottom_trailing":
      r["--inset"] = "auto 0 0 auto";
      break;
  }
  return r;
}
function Rc(e) {
  const r = {
    "--direction": "initial",
    "--alignment": "initial",
    "--distribution": "initial",
    "--position": "relative",
    "--inset": "initial",
    "--transform": "initial"
  };
  return e.type !== "zlayer" && (Object.assign(r, {
    "--direction": Ka[e.type],
    "--alignment": Ja[e.alignment]
  }), e.distribution && Object.assign(r, {
    "--distribution": Qa[e.distribution]
  })), r;
}
function Uc(e, r = Re) {
  var l, c;
  const { font_size: t, horizontal_alignment: a, font_weight: n, font_name: o, color: i } = e, s = {
    "--text-align": "initial",
    "--font-weight": "initial",
    "--font-size": "initial",
    "--font-family": "sans-serif",
    "--background-clip": "none",
    "--text-fill-color": "none",
    "--background": "unset"
  };
  return Object.assign(s, {
    "--text-align": na[a] || na.leading,
    "--font-weight": ta[n] || ta.regular,
    "--font-size": aa[t] || aa.body_m,
    "--font-family": o || "sans-serif"
  }), i && (((l = i[r]) == null ? void 0 : l.type) === "linear" || ((c = i[r]) == null ? void 0 : c.type) === "radial") && Object.assign(s, {
    "--background-clip": "text",
    "--text-fill-color": "transparent",
    "--background": yr({ colorMap: i, colorMode: r })
  }), s;
}
function Ce(e) {
  return Object.entries(e).map(([r, t]) => `${r}: ${t}`).join("; ");
}
function Vc(e) {
  const r = (a) => {
    if (a.type === "package" && a.is_selected_by_default)
      return a;
    if (a.components && Array.isArray(a.components))
      for (const n of a.components) {
        const o = r(n);
        if (o)
          return o;
      }
    if (a.stack !== void 0) {
      const n = r(a.stack);
      if (n)
        return n;
    }
  }, t = r(e.components_config.base.stack);
  if (t !== void 0)
    return t.package_id;
}
const bn = (e, r) => r ? Hc(r).reduce((n, o) => {
  var i;
  if (e) {
    const s = ((i = e == null ? void 0 : e.states) == null ? void 0 : i[o]) || {};
    return { ...n, ...s };
  }
  return n;
}, {}) : {}, Hc = (e) => e ? Object.entries(e).reduce((t, [a, n]) => (n && t.push(a), t), []) : [];
function Ye(e, r) {
  return e ? r ? Object.entries(e).reduce((t, [a, n]) => {
    const o = a.replace(/^--/, `${r}-`);
    return t[`--${o}`] = n, t;
  }, {}) : e : {};
}
function Wc(e) {
  const { mask_shape: r, imageAspectRatio: t } = e;
  let a = "";
  return (r == null ? void 0 : r.type) === "concave" ? a = `M 0 0 
              H 100 
              V ${t * 100} 
              Q 50 ${t * 80} 0 ${t * 100} 
              Z` : (r == null ? void 0 : r.type) === "convex" ? a = `M 0 0 
              H 100 
              V ${t * 80} 
              Q 50 ${t * 120} 0 ${t * 80} 
              Z` : a = `M 0 0 H 100 V ${t * 100} H 0 Z`, a;
}
const Yc = (e) => {
  const r = {
    "--border-end-start-radius": "0px",
    "--border-end-end-radius": "0px",
    "--border-start-start-radius": "0px",
    "--border-start-end-radius": "0px"
  };
  return e != null && e.corners && Object.assign(r, oa(e.corners)), r;
};
function Gc(e) {
  var s, l, c;
  if (((l = (s = e.color_overlay) == null ? void 0 : s[e.purchaseState.colorMode]) == null ? void 0 : l.type) !== "linear")
    return { x1: "0%", y1: "0%", x2: "0%", y2: "0%" };
  const { color_overlay: r } = e, t = ((c = r == null ? void 0 : r[Re]) == null ? void 0 : c.degrees) || 0, a = "50%", n = "0%", o = `${Math.round(50 + Math.sin((t + 90) * Math.PI / 90) * 50)}%`, i = `${Math.round(50 - Math.cos((t + 90) * Math.PI / 90) * 50)}%`;
  return { x1: a, y1: n, x2: o, y2: i };
}
const xi = {
  light: { type: "hex", value: $a }
}, Xc = {
  light: { type: "hex", value: Lc }
}, hn = (e) => {
  const { font_size: r = "body_m", color: t = xi, background_color: a = Xc, padding: n, margin: o, size: i, purchaseState: s } = e, l = {
    "--width": "unset",
    "--height": "unset",
    "--text-align": "initial",
    "--font-weight": "initial",
    "--font-size": "initial",
    "--font-family": "sans-serif",
    "--background-clip": "unset",
    "--text-fill-color": "unset",
    "--margin-block-start": "0px",
    "--margin-inline-end": "0px",
    "--margin-block-end": "0px",
    "--margin-inline-start": "0px",
    "--padding-block-start": "0px",
    "--padding-inline-end": "0px",
    "--padding-block-end": "0px",
    "--padding-inline-start": "0px",
    "--background": "transparent",
    "--text-color": "inherit",
    "--border": "none",
    "--border-end-start-radius": "0px",
    "--border-end-end-radius": "0px",
    "--border-start-start-radius": "0px",
    "--border-start-end-radius": "0px",
    "--shadow": "none",
    "--flex": "0 1 auto"
  }, c = bn(e.overrides, e.componentState), p = Bc(r), u = Uc({ ...e, ...c }, s.colorMode), _ = ka({
    background_color: a,
    color: t,
    margin: o,
    padding: n,
    colorMode: s.colorMode,
    ...c
  }), g = Ct({ ...i, ...c }), m = {
    ...l,
    ..._,
    ...u,
    ...g
  };
  return {
    textStyles: Ye(m, "text"),
    tagToRender: p
  };
};
function Zc(e, r, t) {
  const a = {
    "--width": "unset",
    "--height": "unset",
    "--flex": "0 1 auto",
    "--margin-block-start": "0px",
    "--margin-inline-end": "0px",
    "--margin-block-end": "0px",
    "--margin-inline-start": "0px",
    "--padding-block-start": "0px",
    "--padding-inline-end": "0px",
    "--padding-block-end": "0px",
    "--padding-inline-start": "0px",
    "--background": "transparent",
    "--text-color": "inherit",
    "--border": "none",
    "--border-end-start-radius": "0px",
    "--border-end-end-radius": "0px",
    "--border-start-start-radius": "0px",
    "--border-start-end-radius": "0px",
    "--shadow": "none",
    "--position": "relative",
    "--inset": "0",
    "--transform": "initial"
  };
  Object.assign(a, ka({
    background_color: t,
    ...e
  }), Ct(r)), Object.assign(a, e.zStackChildStyles);
  const n = Ye(a, "text");
  return Ce(n);
}
function Kc(e) {
  const r = {
    "--text-margin-block-start": "0px",
    "--text-margin-inline-end": "0px",
    "--text-margin-block-end": "0px",
    "--text-margin-inline-start": "0px",
    "--text-padding-block-start": "0px",
    "--text-padding-inline-end": "0px",
    "--text-padding-block-end": "0px",
    "--text-padding-inline-start": "0px",
    "--text-background": "transparent",
    "--text-text-color": "inherit",
    "--text-border": "none",
    "--text-border-end-start-radius": "0px",
    "--text-border-end-end-radius": "0px",
    "--text-border-start-start-radius": "0px",
    "--text-border-start-end-radius": "0px",
    "--text-shadow": "none",
    "--text-text-align": "initial",
    "--text-font-weight": "initial",
    "--text-font-size": "initial",
    "--text-font-family": "sans-serif",
    "--text-background-clip": "initial",
    "--text-text-fill-color": "initial",
    "--text-width": "unset",
    "--text-height": "unset",
    "--text-flex": "0 1 auto"
  }, { tagToRender: t, textStyles: a } = hn(e);
  return Object.assign(r, a), { tagToRender: t, textStyles: Ce(r) };
}
function Jc(e) {
  return e ? Object.values({
    newLine: { regexp: /\\\n/g, output: "<br/>" },
    bold: { regexp: /\*\*(.*?)\*\*/g, output: "<b>$1</b>" },
    italic: { regexp: /\*(.*?)\*/g, output: "<i>$1</i>" },
    strikethrough: { regexp: /~(.*?)~/g, output: "<s>$1</s>" },
    code: {
      regexp: /`(.*?)`/g,
      output: "<span style='font-family: monospace'>$1</span>"
    },
    link: {
      regexp: /\[(.*?)\]\((.*?)\)/g,
      output: "<a href=$2 target='_blank' rel='noopener noreferrer'>$1</a>"
    }
  }).reduce((t, { regexp: a, output: n }) => t.replaceAll(a, n), e) : "";
}
const Qc = {
  hash: "svelte-1wz4si8",
  code: ".rc-pw-text-block.svelte-1wz4si8 {display:block;padding-block-start:var(--text-padding-block-start, initial);padding-inline-end:var(--text-padding-inline-end, initial);padding-block-end:var(--text-padding-block-end, initial);padding-inline-start:var(--text-padding-inline-start, initial);margin-block-start:var(--text-margin-block-start, initial);margin-inline-end:var(--text-margin-inline-end, initial);margin-block-end:var(--text-margin-block-end, initial);margin-inline-start:var(--text-margin-inline-start, initial);color:var(--text-text-color, #ffffff);background:var(--text-background, none);font-size:var(--text-font-size, 1rem);font-weight:var(--text-font-weight, normal);text-align:var(--text-text-align, center);font-family:var(--text-font-family, sans-serif);-webkit-background-clip:var(--text-background-clip, initial);background-clip:var(--text-background-clip, initial);-webkit-text-fill-color:var(--text-text-fill-color, initial);}"
};
function Pi(e, r) {
  V(r, !0), R(e, Qc);
  const t = U(r, "styleVariables", 3, ""), a = U(r, "component", 3, "p");
  var n = ee(), o = Y(n);
  ea(o, a, !1, (i, s) => {
    let l;
    A(() => l = ra(
      i,
      l,
      {
        id: r.id,
        style: t(),
        class: "rc-pw-text-block"
      },
      "svelte-1wz4si8",
      i.namespaceURI === xt,
      i.nodeName.includes("-")
    ));
    var c = ee(), p = Y(c);
    ge(p, () => r.children ?? ne), b(s, c);
  }), b(e, n), H();
}
var $c = /* @__PURE__ */ I('<span class="rc-pw-text-wrapper svelte-11gzifq"><!></span>');
const ed = {
  hash: "svelte-11gzifq",
  code: ".rc-pw-text-wrapper.svelte-11gzifq {display:block;height:var(--text-height, initial);width:var(--text-width, initial);background:var(--text-background, none);position:var(--text-position, relative);inset:var(--text-inset, 0);transform:var(--text-transform, initial);}"
};
function rd(e, r) {
  V(r, !0), R(e, ed);
  const t = /* @__PURE__ */ Ar(r, [
    "$$slots",
    "$$events",
    "$$legacy",
    "id",
    "labels",
    "text_lid",
    "purchaseState",
    "variableDictionary",
    "background_color",
    "size"
  ]), a = /* @__PURE__ */ E(() => Kc({
    id: r.id,
    labels: r.labels,
    text_lid: r.text_lid,
    purchaseState: r.purchaseState,
    background_color: r.background_color,
    size: r.size,
    ...t
  })), n = /* @__PURE__ */ E(() => d(a).tagToRender), o = /* @__PURE__ */ E(() => d(a).textStyles), i = /* @__PURE__ */ E(() => Zc(t, r.size, r.background_color)), s = /* @__PURE__ */ E(() => yn({
    text_lid: r.text_lid,
    locale: r.purchaseState.locale,
    defaultLocale: r.purchaseState.defaultLocale,
    labels: r.labels,
    variableDictionary: r.variableDictionary
  })), l = /* @__PURE__ */ E(() => Jc(d(s)));
  var c = $c(), p = P(c);
  Pi(p, {
    get styleVariables() {
      return d(o);
    },
    get component() {
      return d(n);
    },
    get id() {
      return r.id;
    },
    children: (u, _) => {
      var g = ee(), m = Y(g);
      Wr(m, () => d(l)), b(u, g);
    },
    $$slots: { default: !0 }
  }), A(() => j(c, "style", d(i))), b(e, c), H();
}
const td = (e) => {
  const { background_color: r, margin: t, padding: a, spacing: n, size: o, border: i, shape: s, shadow: l, dimension: c, componentState: p, overrides: u, purchaseState: _, zStackChildStyles: g } = e, m = {
    "--flex": "0 1 auto",
    "--height": "initial",
    "--width": "initial",
    "--spacing": `${n || 0}px`,
    "--direction": "unset",
    "--alignment": "unset",
    "--distribution": "flex-start",
    "--margin-block-start": "0px",
    "--margin-inline-end": "0px",
    "--margin-block-end": "0px",
    "--margin-inline-start": "0px",
    "--padding-block-start": "0px",
    "--padding-inline-end": "0px",
    "--padding-block-end": "0px",
    "--padding-inline-start": "0px",
    "--background": "unset",
    "--text-color": "inherit",
    "--border": "none",
    "--border-end-start-radius": "0px",
    "--border-end-end-radius": "0px",
    "--border-start-start-radius": "0px",
    "--border-start-end-radius": "0px",
    "--shadow": "none",
    "--position": "relative",
    "--transform": "initial",
    "--inset": "initial"
  }, f = bn(u, p);
  Object.assign(m, ka({
    background_color: r,
    margin: t,
    padding: a,
    border: i,
    colorMode: _.colorMode,
    shape: s,
    shadow: l,
    ...f
  }), Rc({
    ...c,
    ...f
  }), Ct({ ...o, ...f })), Object.assign(m, g);
  const h = Ye(m, "stack");
  return Ce(h);
};
function ad(e) {
  var n, o, i, s, l, c;
  const { badge: r } = e;
  if (!r)
    return "";
  const t = {
    "--inset": "unset",
    "--transform": "unset",
    "--margin-block-start": "0px",
    "--margin-inline-end": "0px",
    "--margin-block-end": "0px",
    "--margin-inline-start": "0px",
    "--padding-block-start": "0px",
    "--padding-inline-end": "0px",
    "--padding-block-end": "0px",
    "--padding-inline-start": "0px",
    "--background": "unset",
    "--text-color": "inherit",
    "--border": "none",
    "--border-end-start-radius": "0px",
    "--border-end-end-radius": "0px",
    "--border-start-start-radius": "0px",
    "--border-start-end-radius": "0px",
    "--shadow": "none",
    "--badge-width": "unset",
    "--z-index": "unset"
  };
  if (Object.assign(t, wi({
    type: "zlayer",
    alignment: r.alignment
  }), ka({
    ...r,
    background_color: r.background_color,
    color: r.color,
    colorMode: e.purchaseState.colorMode
  })), r.style === "overlay" && (t["--margin-block-start"] = "0px", t["--margin-block-end"] = "0px", t["--transform"] = Yt(r, 0, -(((n = e.border) == null ? void 0 : n.width) || 0))), r.style === "edge_to_edge")
    if (t["--margin-block-start"] = "0px", t["--margin-block-end"] = "0px", t["--margin-inline-start"] = "0px", t["--margin-inline-end"] = "0px", r.alignment === "top" || r.alignment === "bottom") {
      t["--badge-width"] = `calc(100% + ${(((o = e.border) == null ? void 0 : o.width) || 0) * 2}px)`, t["--z-index"] = "-1";
      const p = Math.max(((s = (i = e.shape) == null ? void 0 : i.corners) == null ? void 0 : s.top_leading) || 0, ((c = (l = e.shape) == null ? void 0 : l.corners) == null ? void 0 : c.top_trailing) || 0);
      r.alignment === "top" && (t["--padding-block-end"] = `${p + r.padding.bottom}px`, t["--transform"] = Yt(r, p)), r.alignment === "bottom" && (t["--padding-block-start"] = `${p + r.padding.top}px`, t["--transform"] = Yt(r, -p));
    } else
      t["--transform"] = Yt(r), Object.assign(t, nd(e));
  const a = Ye(t, "stack-badge");
  return Ce(a);
}
const _o = {
  top_leading: "bottom_trailing",
  top_trailing: "bottom_leading",
  bottom_leading: "top_trailing",
  bottom_trailing: "top_leading"
}, go = {
  top_leading: "--border-start-start-radius",
  top_trailing: "--border-start-end-radius",
  bottom_leading: "--border-end-start-radius",
  bottom_trailing: "--border-end-end-radius"
};
function nd(e) {
  var o, i, s;
  const r = {
    "--border-end-start-radius": "0px",
    "--border-end-end-radius": "0px",
    "--border-start-start-radius": "0px",
    "--border-start-end-radius": "0px"
  }, { badge: t } = e;
  if (!t)
    return r;
  const a = ((o = e.border) == null ? void 0 : o.width) || 0, n = t.alignment;
  return r[go[_o[n]]] = `${(i = t.shape) == null ? void 0 : i.corners[_o[n]]}px`, r[go[n]] = `${((s = e.shape) == null ? void 0 : s.corners[n]) - a}px`, r;
}
function Yt(e, r = 0, t = 0) {
  if (!e)
    return "";
  if (e.style === "overlay") {
    if (e.alignment === "top_leading")
      return `translate(${t}px, calc(-50% + ${r}px))`;
    if (e.alignment === "top_trailing")
      return `translate(calc(0% - ${t}px), calc(-50% + ${r}px))`;
    if (e.alignment === "bottom_leading")
      return `translate(${t}px, calc(50% + ${r}px))`;
    if (e.alignment === "bottom_trailing")
      return `translate(calc(0% - ${t}px), calc(50% + ${r}px))`;
    if (e.alignment === "top")
      return `translate(calc(-50% + ${t}px), calc(-50% + ${r}px))`;
    if (e.alignment === "bottom")
      return `translate(calc(50% + ${t}px), calc(50% + ${r}px))`;
  }
  if (e.style === "edge_to_edge") {
    if (e.alignment === "top")
      return `translate(calc(-50% + ${t}px), calc(-100% - ${r}px + 16px))`;
    if (e.alignment === "bottom")
      return `translate(calc(50% + ${t}px), calc(100% + ${r}px))`;
  }
  return "";
}
function od(e) {
  const { badge: r } = e;
  if (!r)
    return { tagToRender: "", textStyles: "" };
  const { tagToRender: t, textStyles: a } = hn({
    id: e.id,
    labels: e.labels,
    purchaseState: e.purchaseState,
    ...r,
    components: [],
    type: "text",
    size: {
      width: { type: "fit" },
      height: { type: "fit" }
    },
    color: r == null ? void 0 : r.color,
    name: e.name
  }), o = {
    ...a,
    ...{
      "--text-margin-block-start": "0px",
      "--text-margin-inline-end": "0px",
      "--text-margin-block-end": "0px",
      "--text-margin-inline-start": "0px",
      "--text-padding-block-start": "0px",
      "--text-padding-inline-end": "0px",
      "--text-padding-block-end": "0px",
      "--text-padding-inline-start": "0px"
    }
  }, i = Ce(o);
  return {
    tagToRender: t,
    textStyles: i
  };
}
function id(e) {
  const { dimension: r } = e, t = {
    "--inset": "initial",
    "--transform": "initial",
    "--position": "relative"
  };
  if (r.type !== "zlayer")
    return;
  const a = wi({ ...r, type: "zlayer" });
  return Object.assign(t, { ...a, "--position": "absolute" }), t;
}
var sd = /* @__PURE__ */ I('<span class="rc-pw-badge svelte-1b5bst5"><!></span>'), ld = /* @__PURE__ */ I('<div class="rc-pw-stack-wrapper svelte-1b5bst5"><!> <div class="rc-pw-stack svelte-1b5bst5"></div></div>');
const cd = {
  hash: "svelte-1b5bst5",
  code: `.rc-pw-stack-wrapper.svelte-1b5bst5 {display:block;box-sizing:border-box;width:var(--stack-width, unset);height:var(--stack-height, unset);box-shadow:var(--stack-shadow, none);background:var(--stack-background, unset);position:var(--stack-position, relative);transform:var(--stack-transform, initial);inset:var(--stack-inset, initial);margin-block-start:var(--stack-margin-block-start, 0);margin-inline-end:var(--stack-margin-inline-end, 0);margin-block-end:var(--stack-margin-block-end, 0);margin-inline-start:var(--stack-margin-inline-start, 0);border:var(--stack-border, none);border-end-start-radius:var(--stack-border-end-start-radius, 0px);border-end-end-radius:var(--stack-border-end-end-radius, 0px);border-start-start-radius:var(--stack-border-start-start-radius, 0px);border-start-end-radius:var(--stack-border-start-end-radius, 0px);}.rc-pw-stack.svelte-1b5bst5 {background:none;overflow:hidden;box-sizing:border-box;width:100%;height:100%;display:flex;gap:var(--stack-spacing, 0);flex:var(--stack-flex, 0 1 auto);flex-direction:var(--stack-direction, unset);justify-content:var(--stack-distribution, flex-start);align-items:var(--stack-alignment, flex-start);padding-block-start:var(--stack-padding-block-start, 0);padding-inline-end:var(--stack-padding-inline-end, 0);padding-block-end:var(--stack-padding-block-end, 0);padding-inline-start:var(--stack-padding-inline-start, 0);}.rc-pw-badge.svelte-1b5bst5 {box-sizing:border-box;font-family:var(--stack-badge-font-family, sans-serif);position:absolute;inset:var(--stack-badge-inset, unset);transform:var(--stack-badge-transform, initial);margin-block-start:var(--stack-badge-margin-block-start, 0px);margin-inline-end:var(--stack-badge-margin-inline-end, 0px);margin-block-end:var(--stack-badge-margin-block-end, 0px);margin-inline-start:var(--stack-badge-margin-inline-start, 0px);padding-block-start:var(--stack-badge-padding-block-start, 0px);padding-inline-end:var(--stack-badge-padding-inline-end, 0px);padding-block-end:var(--stack-badge-padding-block-end, 0px);padding-inline-start:var(--stack-badge-padding-inline-start, 0px);background:var(--stack-badge-background, initial);color:var(--stack-badge-text-color, inherit);border:var(--stack-badge-border, none);border-end-start-radius:var(--stack-badge-border-end-start-radius, 0px);border-end-end-radius:var(--stack-badge-border-end-end-radius, 0px);border-start-start-radius:var(
      --stack-badge-border-start-start-radius,
      0px
    );border-start-end-radius:var(--stack-badge-border-start-end-radius, 0px);box-shadow:var(--stack-badge-shadow, none);display:flex;align-items:center;justify-content:center;width:var(--stack-badge-badge-width, max-content);height:var(--stack-badge-badge-height, max-content);z-index:var(--stack-badge-z-index, 1);}`
};
function Ot(e, r) {
  V(r, !0), R(e, cd);
  const t = /* @__PURE__ */ Ar(r, [
    "$$slots",
    "$$events",
    "$$legacy",
    "id",
    "components",
    "labels",
    "onAction",
    "purchaseState",
    "variableDictionary",
    "badge",
    "zStackChildStyles"
  ]), a = /* @__PURE__ */ E(() => td({
    id: r.id,
    components: r.components,
    labels: r.labels,
    onAction: r.onAction,
    purchaseState: r.purchaseState,
    zStackChildStyles: r.zStackChildStyles,
    ...t
  })), n = /* @__PURE__ */ E(() => ad({
    id: r.id,
    components: r.components,
    labels: r.labels,
    onAction: r.onAction,
    purchaseState: r.purchaseState,
    badge: r.badge,
    ...t
  })), o = /* @__PURE__ */ E(() => id({
    id: r.id,
    components: r.components,
    labels: r.labels,
    onAction: r.onAction,
    purchaseState: r.purchaseState,
    ...t
  })), i = /* @__PURE__ */ E(() => {
    var m;
    return yn({
      defaultLocale: r.purchaseState.defaultLocale,
      locale: r.purchaseState.locale,
      labels: r.labels,
      variableDictionary: r.variableDictionary,
      text_lid: (m = r.badge) == null ? void 0 : m.text_lid
    });
  }), s = /* @__PURE__ */ E(() => od({
    id: r.id,
    components: r.components,
    labels: r.labels,
    onAction: r.onAction,
    purchaseState: r.purchaseState,
    variableDictionary: r.variableDictionary,
    badge: r.badge,
    ...t
  })), l = /* @__PURE__ */ E(() => d(s).tagToRender), c = /* @__PURE__ */ E(() => d(s).textStyles);
  var p = ld(), u = P(p);
  {
    var _ = (m) => {
      var f = sd(), h = P(f);
      Pi(h, {
        get styleVariables() {
          return d(c);
        },
        get component() {
          return d(l);
        },
        children: (v, y) => {
          var x = ie();
          A(() => te(x, d(i))), b(v, x);
        },
        $$slots: { default: !0 }
      }), A(() => j(f, "style", d(n))), b(m, f);
    };
    N(u, (m) => {
      r.badge && m(_);
    });
  }
  var g = O(u, 2);
  it(g, 21, () => r.components, ot, (m, f, h) => {
    var v = ee(), y = Y(v);
    {
      var x = (S) => {
        var z = /* @__PURE__ */ E(() => h > 0 ? d(o) : void 0);
        ia(S, {
          get nodeData() {
            return d(f);
          },
          get labels() {
            return r.labels;
          },
          get onAction() {
            return r.onAction;
          },
          get purchaseState() {
            return r.purchaseState;
          },
          get variableDictionary() {
            return r.variableDictionary;
          },
          get componentState() {
            return r.componentState;
          },
          get zStackChildStyles() {
            return d(z);
          }
        });
      }, T = (S) => {
        ia(S, {
          get nodeData() {
            return d(f);
          },
          get labels() {
            return r.labels;
          },
          get onAction() {
            return r.onAction;
          },
          get purchaseState() {
            return r.purchaseState;
          },
          get variableDictionary() {
            return r.variableDictionary;
          },
          get componentState() {
            return r.componentState;
          }
        });
      };
      N(y, (S) => {
        d(o) ? S(x) : S(T, !1);
      });
    }
    b(m, v);
  }), A(() => {
    j(p, "id", r.id), j(p, "style", d(a));
  }), b(e, p), H();
}
function dd({ stack: e, zStackChildStyles: r }) {
  var i, s;
  const t = ((s = (i = e == null ? void 0 : e.size) == null ? void 0 : i.width) == null ? void 0 : s.type) === "fill" ? "100%" : "fit-content", a = Ye(r || {}, "button");
  return Ce({
    ...a,
    ...{
      position: "var(--button-position, relative)",
      inset: "var(--button-inset, 0)",
      transform: "var(--button-transform, initial)",
      width: t
    }
  });
}
const ud = { hash: "svelte-mx8s0a", code: "" };
function pd(e, r) {
  V(r, !0), R(e, ud);
  const t = /* @__PURE__ */ Ar(r, [
    "$$slots",
    "$$events",
    "$$legacy",
    "stack",
    "action",
    "onAction",
    "labels",
    "purchaseState",
    "variableDictionary"
  ]), a = () => {
    r.onAction && r.onAction(r.action);
  }, n = /* @__PURE__ */ E(() => dd({
    stack: r.stack,
    action: r.action,
    onAction: r.onAction,
    labels: r.labels,
    purchaseState: r.purchaseState,
    variableDictionary: r.variableDictionary,
    ...t
  }));
  Ei(e, {
    onclick: a,
    get style() {
      return d(n);
    },
    class: "rc-pw-button",
    children: (o, i) => {
      Ot(o, hr(() => r.stack, {
        get labels() {
          return r.labels;
        },
        get purchaseState() {
          return r.purchaseState;
        },
        get variableDictionary() {
          return r.variableDictionary;
        }
      }));
    },
    $$slots: { default: !0 }
  }), H();
}
function ia(e, r) {
  V(r, !0);
  const t = De(), a = () => ze(vi, "$prefersDarkMode", t), n = {
    stack: Ot,
    text: rd,
    image: cu,
    button: pd,
    purchase_button: pu,
    package: fu,
    footer: Si,
    timeline: Pu
  }, o = (_) => {
    if (n[_.type])
      return [n[_.type], _];
    const { fallback: g } = _;
    if (g && n[g == null ? void 0 : g.type])
      return [n[g.type], g];
    throw new Error(`Invalid component type: ${_.type}`);
  }, i = /* @__PURE__ */ Ar(r, [
    "$$slots",
    "$$events",
    "$$legacy",
    "nodeData",
    "labels",
    "onAction",
    "purchaseState",
    "variableDictionary",
    "zStackChildStyles"
  ]), s = /* @__PURE__ */ E(() => o(r.nodeData)), l = /* @__PURE__ */ E(() => d(s)[0]), c = /* @__PURE__ */ E(() => d(s)[1]);
  var p = ee(), u = Y(p);
  return Ml(u, () => d(l), (_, g) => {
    g(_, hr(
      () => d(c) || {},
      {
        get labels() {
          return r.labels;
        },
        get prefersDarkMode() {
          return a();
        },
        get onAction() {
          return r.onAction;
        },
        get purchaseState() {
          return r.purchaseState;
        },
        get variableDictionary() {
          return r.variableDictionary;
        },
        get zStackChildStyles() {
          return r.zStackChildStyles;
        }
      },
      () => i,
      {
        children: (m, f) => {
          var h = ee(), v = Y(h);
          it(v, 17, () => r.nodeData.components, ot, (y, x) => {
            ia(y, hr(
              {
                get nodeData() {
                  return d(x);
                },
                get labels() {
                  return r.labels;
                },
                get onAction() {
                  return r.onAction;
                },
                get purchaseState() {
                  return r.purchaseState;
                },
                get variableDictionary() {
                  return r.variableDictionary;
                }
              },
              () => i
            ));
          }), b(m, h);
        },
        $$slots: { default: !0 }
      }
    ));
  }), b(e, p), H({ getComponentClass: o });
}
function _d({ background: e, colorMode: r }) {
  const t = { "--background": "initial" };
  (e == null ? void 0 : e.type) === "color" && Object.assign(t, {
    "--background": yr({
      colorMap: e.value,
      colorMode: r,
      fallback: "transparent"
    })
  });
  const a = Ye(t, "paywall");
  return Ce(a);
}
function gd(e, r) {
  var a, n, o, i;
  if (((n = (a = e.components_config.base) == null ? void 0 : a.background) == null ? void 0 : n.type) !== "image")
    return "";
  const t = e.components_config.base.background;
  return ((o = t.value[r]) == null ? void 0 : o.original) || ((i = t.value[Re]) == null ? void 0 : i.original);
}
var md = /* @__PURE__ */ I('<div class="rc-pw-footer svelte-pg5jlz"><!></div>');
const fd = {
  hash: "svelte-pg5jlz",
  code: ".rc-pw-footer.svelte-pg5jlz {position:sticky;bottom:0;transform:translateY(50%);width:100%;}"
};
function Si(e, r) {
  R(e, fd);
  var t = md(), a = P(t);
  Ot(a, hr(() => r.stack, {
    get labels() {
      return r.labels;
    },
    get purchaseState() {
      return r.purchaseState;
    },
    get variableDictionary() {
      return r.variableDictionary;
    },
    get onAction() {
      return r.onAction;
    }
  })), A(() => j(t, "id", r.id)), b(e, t);
}
var yd = /* @__PURE__ */ I('<div class="rc-pw-paywall-background svelte-14bszwq"></div>'), bd = /* @__PURE__ */ I('<div class="rc-pw-paywall-background rc-pw-image-container svelte-14bszwq"><img class="rc-pw-image svelte-14bszwq" alt=""></div>'), hd = /* @__PURE__ */ I('<div class="rc-pw-paywall svelte-14bszwq"><!> <!> <!></div>');
const vd = {
  hash: "svelte-14bszwq",
  code: `.rc-pw-paywall.svelte-14bszwq {position:relative;display:block;max-height:100%;}.rc-pw-paywall-background.svelte-14bszwq {position:absolute;top:0;left:0;width:100%;height:100%;background:var(--paywall-background, none);z-index:-1;}.rc-pw-image-container.svelte-14bszwq {overflow:hidden;background:none;}.rc-pw-image.svelte-14bszwq {width:100%;height:100%;object-fit:cover;display:block;}*,
    *::before,
    *::after {box-sizing:border-box;margin:0;padding:0;font-family:sans-serif;}body {line-height:1.5;-webkit-font-smoothing:antialiased;}img,
    picture,
    video,
    canvas,
    svg {display:block;max-width:100%;}input,
    button,
    textarea,
    select {font:inherit;}p,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {overflow-wrap:break-word;}p {text-wrap:pretty;}h1,
    h2,
    h3,
    h4,
    h5,
    h6 {text-wrap:balance;}#root,
    #__next {isolation:isolate;}`
};
function kd(e, r) {
  V(r, !0), R(e, vd);
  const t = De(), a = () => ze(vi, "$prefersDarkMode", t), n = U(r, "variablesPerPackage", 19, () => ({}));
  let o = B({
    selectedPackageId: Vc(r.paywallData),
    locale: r.selectedLocale || r.paywallData.default_locale,
    defaultLocale: r.paywallData.default_locale,
    variablesPerPackage: n(),
    colorMode: r.preferredColorMode || (a() ? "dark" : Re)
  }), i = X(B(n()[o.selectedPackageId || ""]));
  const s = (v, y) => {
    var x;
    (x = r.onRestorePurchasesClicked) == null || x.call(r);
  }, l = (v, y) => {
    var x;
    (x = r.onBackClicked) == null || x.call(r);
  }, c = (v, y) => {
    var T, S;
    if (v.destination === "customer_center" && ((T = r.onVisitCustomerCenterClicked) == null || T.call(r)), !v.url)
      return;
    const x = bi(v.url.url_lid, o.locale, o.defaultLocale, r.paywallData.components_localizations);
    x && ((S = r.onNavigateToUrlClicked) == null || S.call(r, x));
  }, p = (v, y) => {
    o.selectedPackageId = y == null ? void 0 : y.packageId, y != null && y.packageId && D(i, B(n()[y.packageId]));
  }, u = (v, y) => {
    var x;
    o.selectedPackageId !== void 0 && ((x = r.onPurchaseClicked) == null || x.call(r, o.selectedPackageId));
  }, _ = (v, y) => {
    switch (v.type) {
      case "select_package":
        p(v, y);
        break;
      case "navigate_to":
        c(v);
        break;
      case "navigate_back":
        l();
        break;
      case "restore_purchases":
        s();
        break;
      case "purchase":
        u();
        break;
    }
  }, g = /* @__PURE__ */ E(() => {
    var v;
    return _d({
      background: (v = r.paywallData.components_config.base) == null ? void 0 : v.background,
      colorMode: o.colorMode
    });
  }), m = /* @__PURE__ */ E(() => gd(r.paywallData, o.colorMode));
  var f = ee(), h = Y(f);
  Gl(
    h,
    {
      get onerror() {
        return r.onError;
      }
    },
    (v) => {
      var y = hd(), x = P(y);
      ia(x, {
        onAction: _,
        get nodeData() {
          return r.paywallData.components_config.base.stack;
        },
        get labels() {
          return r.paywallData.components_localizations;
        },
        get purchaseState() {
          return o;
        },
        get variableDictionary() {
          return d(i);
        }
      });
      var T = O(x, 2);
      {
        var S = (w) => {
          Si(w, hr(() => r.paywallData.components_config.base.sticky_footer, {
            get stack() {
              return r.paywallData.components_config.base.sticky_footer.stack;
            },
            get labels() {
              return r.paywallData.components_localizations;
            },
            get purchaseState() {
              return o;
            },
            get variableDictionary() {
              return d(i);
            },
            onAction: _
          }));
        };
        N(T, (w) => {
          r.paywallData.components_config.base.sticky_footer && w(S);
        });
      }
      var z = O(T, 2);
      {
        var C = (w) => {
          var q = yd();
          A(() => j(q, "style", d(g))), b(w, q);
        }, k = (w) => {
          var q = ee(), G = Y(q);
          {
            var W = (ae) => {
              var J = bd(), re = P(J);
              A(() => j(re, "src", d(m))), b(ae, J);
            };
            N(
              G,
              (ae) => {
                var J;
                ((J = r.paywallData.components_config.base.background) == null ? void 0 : J.type) === "image" && ae(W);
              },
              !0
            );
          }
          b(w, q);
        };
        N(z, (w) => {
          var q;
          ((q = r.paywallData.components_config.base.background) == null ? void 0 : q.type) === "color" ? w(C) : w(k, !1);
        });
      }
      b(v, y);
    }
  ), b(e, f), H();
}
const wd = (e, r) => {
  var t;
  (t = r.onclick) == null || t.call(r);
};
var xd = /* @__PURE__ */ I("<button><!></button>");
const Pd = {
  hash: "svelte-1wpam0z",
  code: "button.svelte-1wpam0z {border:none;cursor:pointer;background:transparent;width:fit-content;}"
};
function Ei(e, r) {
  V(r, !0), R(e, Pd);
  var t = xd();
  t.__click = [wd, r];
  var a = P(t);
  ge(a, () => r.children ?? ne), A(() => {
    Fr(t, li(r.class), "svelte-1wpam0z"), t.disabled = !r.onclick, j(t, "style", r.style);
  }), b(e, t), H();
}
ha(["click"]);
var Sd = /* @__PURE__ */ I('<div class="rcb-processing svelte-2j2b59"></div>');
const Ed = {
  hash: "svelte-2j2b59",
  code: `.rcb-processing.svelte-2j2b59 {width:var(--width, 12px);aspect-ratio:1;border-radius:50%;
    animation: svelte-2j2b59-l5 1.5s infinite linear;}

  @keyframes svelte-2j2b59-l5 {
    0% {
      box-shadow:
        var(--shadow-offset) 0 #fff2,
        calc(-1 * var(--shadow-offset)) 0 #fff2;
      background: #fff2;
    }
    25% {
      box-shadow:
        var(--shadow-offset) 0 #fff2,
        calc(-1 * var(--shadow-offset)) 0 #ffff;
      background: #fff2;
    }
    50% {
      box-shadow:
        var(--shadow-offset) 0 #fff2,
        calc(-1 * var(--shadow-offset)) 0 #fff2;
      background: #ffff;
    }
    75% {
      box-shadow:
        var(--shadow-offset) 0 #ffff,
        calc(-1 * var(--shadow-offset)) 0 #fff2;
      background: #fff2;
    }
    100% {
      box-shadow:
        var(--shadow-offset) 0 #fff2,
        calc(-1 * var(--shadow-offset)) 0 #fff2;
      background: #fff2;
    }
  }`
};
function Td(e, r) {
  R(e, Ed);
  let t = U(r, "size", 8, "medium");
  const a = {
    small: { width: "8px", offset: "10px" },
    medium: { width: "12px", offset: "20px" },
    large: { width: "16px", offset: "30px" }
  };
  var n = Sd();
  A(() => j(n, "style", `--shadow-offset: ${a[t()].offset ?? ""}; --width: ${a[t()].width ?? ""};`)), b(e, n);
}
var Id = /* @__PURE__ */ I("<span><!></span>");
const qd = {
  hash: "svelte-byrjto",
  code: `
  /* svelte-ignore css-unused-selector */.rcb-typography-heading-2xl.svelte-byrjto {font:var(--rc-text-heading2xl-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-heading-xl.svelte-byrjto {font:var(--rc-text-headingXl-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-heading-lg.svelte-byrjto {font:var(--rc-text-headingLg-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-heading-md.svelte-byrjto {font:var(--rc-text-headingMd-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-body-base.svelte-byrjto {font:var(--rc-text-bodyBase-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-body-small.svelte-byrjto {font:var(--rc-text-bodySmall-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-label-button.svelte-byrjto {font:var(--rc-text-labelButton-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-label-default.svelte-byrjto {font:var(--rc-text-labelDefault-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-caption-default.svelte-byrjto {font:var(--rc-text-captionDefault-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-caption-link.svelte-byrjto {font:var(--rc-text-captionLink-mobile);}

  @container layout-query-container (width >= 768px) {
    /* svelte-ignore css-unused-selector */.rcb-typography-heading-2xl.svelte-byrjto {font:var(--rc-text-heading2xl-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-heading-xl.svelte-byrjto {font:var(--rc-text-headingXl-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-heading-lg.svelte-byrjto {font:var(--rc-text-headingLg-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-heading-md.svelte-byrjto {font:var(--rc-text-headingMd-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-body-base.svelte-byrjto {font:var(--rc-text-bodyBase-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-body-small.svelte-byrjto {font:var(--rc-text-bodySmall-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-label-button.svelte-byrjto {font:var(--rc-text-labelButton-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-label-default.svelte-byrjto {font:var(--rc-text-labelDefault-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-caption-default.svelte-byrjto {font:var(--rc-text-captionDefault-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-caption-link.svelte-byrjto {font:var(--rc-text-captionLink-desktop);}
  }`
};
function Fd(e, r) {
  V(r, !0), R(e, qd);
  const t = U(r, "size", 3, "body-base");
  var a = Id(), n = P(a);
  ge(n, () => r.children ?? ne), A(() => Fr(a, `rcb-typography rcb-typography-${t() ?? ""} svelte-byrjto`)), b(e, a), H();
}
const zd = {
  error: "#B0171F",
  warning: "#f4e971",
  focus: "#1148B8",
  accent: "#767676",
  primary: "#576CDB",
  "primary-hover": "rgba(87, 108, 219, .8)",
  "primary-pressed": "rgba(87, 108, 219, .9)",
  "primary-text": "#ffffff",
  white: "#ffffff",
  "grey-text-dark": "rgba(0,0,0,1)",
  "grey-text-light": "rgba(0,0,0,0.7)",
  "grey-ui-dark": "rgba(0,0,0,0.3)",
  "grey-ui-light": "rgba(0,0,0,0.1)",
  "input-background": "white",
  background: "white"
}, Dd = {
  error: "#B0171F",
  warning: "#f4e971",
  focus: "#1148B8",
  accent: "#767676",
  primary: "#576CDB",
  "primary-hover": "rgba(87, 108, 219, .8)",
  "primary-pressed": "rgba(87, 108, 219, .9)",
  "primary-text": "#ffffff",
  white: "#ffffff",
  "grey-text-dark": "rgba(0,0,0,1)",
  "grey-text-light": "rgba(0,0,0,0.7)",
  "grey-ui-dark": "rgba(0,0,0,0.3)",
  "grey-ui-light": "rgba(0,0,0,0.1)",
  "input-background": "white",
  background: "#EFF3FA"
}, Ti = {
  error: "color_error",
  focus: "color_accent",
  accent: "color_accent",
  primary: "color_buttons_primary"
}, Ad = {
  ...Ti,
  "input-background": "color_form_bg",
  background: "color_form_bg"
}, Md = {
  ...Ti,
  "input-background": "color_product_info_bg",
  background: "color_product_info_bg"
}, Ii = {
  "input-border-radius": "4px",
  "input-button-border-radius": "8px"
}, jd = {
  "input-border-radius": "0px",
  "input-button-border-radius": "0px"
}, Nd = {
  "input-border-radius": "12px",
  "input-button-border-radius": "9999px"
}, mo = Ii, fo = "-apple-system, BlinkMacSystemFont, avenir next, avenir, segoe ui, helvetica neue, helvetica, Cantarell, Ubuntu, roboto, noto, arial, sans-serif", er = {
  regular: "400",
  medium: "500",
  semibold: "600"
}, Le = {
  10: "10px",
  12: "12px",
  14: "14px",
  16: "16px",
  18: "18px",
  20: "20px",
  24: "24px",
  28: "28px",
  32: "32px",
  36: "36px",
  40: "40px"
}, rr = {
  120: "120%",
  130: "130%",
  140: "140%"
}, tr = {
  tight: "0.20%",
  regular: "0",
  loose: "0.20%"
}, fe = {
  heading2xl: {
    fontSize: Le[28],
    lineHeight: rr[120],
    fontWeight: er.semibold,
    letterSpacing: tr.tight
  },
  headingXl: {
    fontSize: Le[24],
    lineHeight: rr[130],
    fontWeight: er.semibold,
    letterSpacing: tr.regular
  },
  headingLg: {
    fontSize: "20px",
    lineHeight: rr[130],
    fontWeight: er.semibold,
    letterSpacing: tr.regular
  },
  headingMd: {
    fontSize: "16px",
    lineHeight: rr[140],
    fontWeight: er.medium,
    letterSpacing: tr.regular
  },
  bodyBase: {
    fontSize: Le[16],
    lineHeight: rr[140],
    fontWeight: er.regular,
    letterSpacing: tr.regular
  },
  bodySmall: {
    fontSize: Le[14],
    lineHeight: rr[140],
    fontWeight: er.regular,
    letterSpacing: tr.regular
  },
  labelButton: {
    fontSize: Le[16],
    lineHeight: rr[140],
    fontWeight: er.regular,
    letterSpacing: tr.tight
  },
  labelDefault: {
    fontSize: Le[14],
    lineHeight: rr[140],
    fontWeight: er.regular,
    letterSpacing: tr.tight
  },
  captionDefault: {
    fontSize: Le[12],
    lineHeight: rr[140],
    fontWeight: er.regular,
    letterSpacing: tr.regular
  },
  captionLink: {
    fontSize: Le[12],
    lineHeight: rr[140],
    fontWeight: er.regular,
    letterSpacing: tr.regular
  }
}, ar = {
  heading2xl: {
    ...fe.heading2xl,
    fontSize: Le[36]
  },
  headingXl: {
    ...fe.headingXl,
    fontSize: Le[32]
  },
  headingLg: {
    ...fe.headingLg,
    fontSize: Le[24]
  },
  headingMd: {
    ...fe.headingMd,
    fontSize: Le[18]
  },
  bodyBase: {
    ...fe.bodyBase
  },
  bodySmall: {
    ...fe.bodySmall
  },
  labelButton: {
    ...fe.labelButton
  },
  labelDefault: {
    ...fe.labelDefault
  },
  captionDefault: {
    ...fe.captionDefault
  },
  captionLink: {
    ...fe.captionLink
  }
}, Cd = {
  heading2xl: {
    mobile: fe.heading2xl,
    desktop: ar.heading2xl
  },
  headingXl: {
    desktop: ar.headingXl,
    mobile: fe.headingXl
  },
  headingLg: {
    desktop: ar.headingLg,
    mobile: fe.headingLg
  },
  headingMd: {
    desktop: ar.headingMd,
    mobile: fe.headingMd
  },
  bodyBase: {
    desktop: ar.bodyBase,
    mobile: fe.bodyBase
  },
  bodySmall: {
    desktop: ar.bodySmall,
    mobile: fe.bodySmall
  },
  labelButton: {
    desktop: ar.labelButton,
    mobile: fe.labelButton
  },
  labelDefault: {
    desktop: ar.labelDefault,
    mobile: fe.labelDefault
  },
  captionDefault: {
    desktop: ar.captionDefault,
    mobile: fe.captionDefault
  },
  captionLink: {
    desktop: ar.captionLink,
    mobile: fe.captionLink
  }
}, Et = (e) => e.length == 7 ? {
  r: parseInt(e.slice(1, 3), 16),
  g: parseInt(e.slice(3, 5), 16),
  b: parseInt(e.slice(5, 7), 16)
} : e.length == 4 ? {
  r: parseInt(e[1], 16),
  g: parseInt(e[2], 16),
  b: parseInt(e[3], 16)
} : null, vn = ({ r: e, g: r, b: t, luminanceThreshold: a }) => {
  const n = (i) => (i = i / 255, i <= 0.03928 ? i / 12.92 : Math.pow((i + 0.055) / 1.055, 2.4));
  return 0.2126 * n(e) + 0.7152 * n(r) + 0.0722 * n(t) > a;
}, kn = 0.37, Od = (e, r = kn) => {
  const t = vn({ ...e, luminanceThreshold: r }) ? "0,0,0" : "255,255,255";
  return {
    "grey-text-dark": `rgb(${t})`,
    "grey-text-light": `rgba(${t},0.70)`,
    "grey-ui-dark": `rgba(${t},0.3)`,
    "grey-ui-light": `rgba(${t},0.1)`
  };
};
function Ld(e, r, t) {
  const a = Et(e) || { r: 0, g: 0, b: 0 }, n = Et(r) || { r: 255, g: 255, b: 255 }, o = Math.round(n.r * t + a.r * (1 - t)), i = Math.round(n.g * t + a.g * (1 - t)), s = Math.round(n.b * t + a.b * (1 - t));
  return `#${Fa(o)}${Fa(i)}${Fa(s)}`;
}
function yo(e, r) {
  const t = { r: 255, g: 255, b: 255 }, a = Math.max(0, Math.min(1, r));
  let n = e, o = Et(e) || t;
  (isNaN(o.r) || isNaN(o.g) || isNaN(o.b)) && (o = t, n = "#FFFFFF");
  const s = vn({
    ...o,
    luminanceThreshold: kn
  }) ? "#000000" : "#FFFFFF";
  return Ld(n, s, a);
}
function Fa(e) {
  return e.toString(16).padStart(2, "0").toUpperCase();
}
const Bd = (e, r, t, a = kn) => {
  const n = {
    "grey-text-dark": t["grey-text-dark"],
    "grey-text-light": t["grey-text-light"],
    "grey-ui-dark": t["grey-ui-dark"],
    "grey-ui-light": t["grey-ui-light"],
    "primary-text": t["primary-text"]
  };
  if (e != null && e.startsWith("#")) {
    const o = Et(e);
    o !== null && Object.assign(n, Od(o));
  }
  if (r != null && r.startsWith("#")) {
    const o = Et(r);
    o !== null && (n["primary-text"] = vn({ ...o, luminanceThreshold: a }) ? "black" : "white");
  }
  return n;
}, Rd = (e) => ({
  "primary-hover": yo(e, 0.1),
  "primary-pressed": yo(e, 0.15)
}), Ud = (e, r) => e || r, Vd = (e, r, t) => {
  const a = Object.entries(e).map(([n, o]) => [
    n,
    Ud(t ? t[o] : null, r[n])
  ]);
  return Object.fromEntries(a);
}, qi = (e, r, t) => {
  const a = Vd(e, r, t);
  return t ? {
    ...r,
    ...a,
    ...Bd(a.background, a.primary, r),
    ...Rd(a.primary)
  } : { ...r };
}, Hd = (e) => qi(Md, Dd, e), Fi = (e) => qi(Ad, zd, e), wn = (e) => {
  if (!e)
    return mo;
  switch (e.shapes) {
    case "rounded":
      return Ii;
    case "rectangle":
      return jd;
    case "pill":
      return Nd;
    default:
      return mo;
  }
}, sa = (e = "", r) => r.map(([t, a]) => `--rc-${e}-${t}: ${a}`).join("; "), Wd = (e) => {
  const r = sa("color", Object.entries(Hd(e))), t = sa("shape", Object.entries(wn(e)));
  return [r, t].join("; ");
}, Yd = (e) => {
  const r = sa("color", Object.entries(Fi(e))), t = sa("shape", Object.entries(wn(e)));
  return [r, t].join("; ");
}, Gd = (e = "", r) => Object.entries(r).flatMap(([t, { desktop: a, mobile: n }]) => [
  `--rc-${e}-${t}-desktop: normal normal ${a.fontWeight} ${a.fontSize}/${a.lineHeight} ${fo}`,
  `--rc-${e}-${t}-mobile: normal normal ${n.fontWeight} ${n.fontSize}/${n.lineHeight} ${fo}`,
  `--rc-${e}-${t}-desktop-font-size: ${a.fontSize}`,
  `--rc-${e}-${t}-mobile-font-size: ${n.fontSize}`
]).join("; "), Xd = (e = "", r) => Object.entries(r).map(([t, { mobile: a, desktop: n }]) => `--rc-${e}-${t}-mobile: ${a};  --rc-${e}-${t}-desktop: ${n};`).join(" "), Zd = {
  outerPadding: {
    mobile: "clamp(1.3125rem, 5.6vw, 1.5rem)",
    desktop: "clamp(1.5rem, 9.44vw, 5rem)"
  },
  outerPaddingSmall: {
    mobile: "clamp(0.75rem, 4.2vw, 1rem)",
    desktop: "clamp(1.5rem, 9.44vw, 5rem)"
  },
  gapSmall: {
    mobile: "0.25rem",
    desktop: "0.375rem"
  },
  gapMedium: {
    mobile: "0.5rem",
    desktop: "0.75rem"
  },
  gapLarge: {
    mobile: "0.75rem",
    desktop: "0.75rem"
  },
  gapXLarge: {
    mobile: "1rem",
    desktop: "1.5rem"
  },
  gapXXLarge: {
    mobile: "1.25rem",
    desktop: "2.25rem"
  },
  gapXXXLarge: {
    mobile: "2.25rem",
    desktop: "4.5rem"
  },
  inputHeight: {
    mobile: "3rem",
    desktop: "3rem"
  },
  gapStripeElement: {
    mobile: "0.70rem",
    desktop: "1rem"
  }
};
let Kd = class {
  constructor(r) {
    M(this, "brandingAppearance");
    r ? this.brandingAppearance = r : this.brandingAppearance = void 0;
  }
  get shape() {
    return wn(this.brandingAppearance);
  }
  get formColors() {
    return Fi(this.brandingAppearance);
  }
  get formStyleVars() {
    return Yd(this.brandingAppearance);
  }
  get productInfoStyleVars() {
    return Wd(this.brandingAppearance);
  }
  get spacing() {
    return Zd;
  }
  get textStyles() {
    return Cd;
  }
  get textStyleVars() {
    return Gd("text", this.textStyles);
  }
  get spacingStyleVars() {
    return Xd("spacing", this.spacing);
  }
};
var Jd = /* @__PURE__ */ I("<button><!></button>");
const Qd = {
  hash: "svelte-td7xvm",
  code: `button.svelte-td7xvm {border:none;border-radius:var(--rc-shape-input-button-border-radius);cursor:pointer;height:var(--rc-spacing-inputHeight-mobile);color:var(--rc-color-grey-text-dark);background-color:var(--rc-color-grey-ui-dark);display:flex;align-items:center;justify-content:center;-webkit-tap-highlight-color:rgba(0, 0, 0, 0);-webkit-tap-highlight-color:transparent;transition:background-color 0.15s ease-in-out;user-select:none;}

  @container layout-query-container (width >= 768px) {button.svelte-td7xvm {height:var(--rc-spacing-inputHeight-desktop);}
  }

  /* focus-visible is triggered only when focused with keyboard/reader */button.svelte-td7xvm:focus-visible {outline:2px solid var(--rc-color-focus);}button.intent-primary.svelte-td7xvm {background-color:var(--rc-color-primary);color:var(--rc-color-primary-text);}button.svelte-td7xvm:disabled {color:var(--rc-color-grey-text-light);background-color:var(--rc-color-grey-ui-dark);outline:none;}button.intent-primary.svelte-td7xvm:not(:disabled):hover {background-color:var(--rc-color-primary-hover);}button.intent-primary.svelte-td7xvm:not(:disabled):active,
  button.svelte-td7xvm:active {background-color:var(--rc-color-primary-pressed);outline:none;}button.intent-primary.svelte-td7xvm:disabled {color:var(--rc-color-grey-text-light);background-color:var(--rc-color-grey-ui-dark);}`
};
function zi(e, r) {
  V(r, !0), R(e, Qd);
  const t = U(r, "intent", 3, "primary"), a = U(r, "disabled", 3, !1), n = U(r, "loading", 3, !1), o = /* @__PURE__ */ E(() => new Kd(r.brandingAppearance)), i = /* @__PURE__ */ E(() => d(o).textStyleVars), s = /* @__PURE__ */ E(() => d(o).spacingStyleVars), l = /* @__PURE__ */ E(() => d(o).productInfoStyleVars), c = /* @__PURE__ */ E(() => d(o).formStyleVars), p = /* @__PURE__ */ E(() => [
    r.styleOverrides,
    d(i),
    d(s),
    d(l),
    d(c)
  ].join("; "));
  var u = Jd();
  u.__click = function(...f) {
    var h;
    (h = r.onclick) == null || h.apply(this, f);
  };
  var _ = P(u);
  {
    var g = (f) => {
      Td(f, { size: "small" });
    }, m = (f) => {
      Fd(f, {
        size: "body-base",
        children: (h, v) => {
          var y = ee(), x = Y(y);
          Al(x, r, "default", {}), b(h, y);
        },
        $$slots: { default: !0 }
      });
    };
    N(_, (f) => {
      n() ? f(g) : f(m, !1);
    });
  }
  A(() => {
    Fr(u, `${`intent-${t()}` ?? ""} svelte-td7xvm`), u.disabled = a(), j(u, "data-testid", r.testId), j(u, "type", r.type), j(u, "style", d(p));
  }), b(e, u), H();
}
ha(["click"]);
const $d = (e) => {
  const { size: r, overrides: t, componentState: a, zStackChildStyles: n } = e, o = {
    "--height": "unset",
    "--width": "unset",
    "--clip-path": "none",
    "--border-end-start-radius": "unset",
    "--border-end-end-radius": "unset",
    "--border-start-start-radius": "unset",
    "--border-start-end-radius": "unset",
    "--position": "relative",
    "--inset": "0",
    "--transform": "initial"
  }, i = bn(t, a);
  Object.assign(o, n), Object.assign(o, Ct({ ...r, ...i })), Object.assign(o, Yc(e.mask_shape));
  const s = Ye(o, "image"), l = Wc(e), c = Gc(e);
  return {
    imageStyles: Ce(s),
    maskPath: l,
    linearGradientAngle: c
  };
};
var eu = /* @__PURE__ */ pr('<ellipse cx="50" rx="50"></ellipse>'), ru = /* @__PURE__ */ pr("<path></path>"), tu = /* @__PURE__ */ pr("<stop></stop>"), au = /* @__PURE__ */ pr("<linearGradient></linearGradient>"), nu = /* @__PURE__ */ pr("<stop></stop>"), ou = /* @__PURE__ */ pr('<radialGradient cx="50%" cy="50%" r="50%" fx="50%" fy="50%"></radialGradient>'), iu = /* @__PURE__ */ pr('<linearGradient><stop offset="0%"></stop></linearGradient>'), su = /* @__PURE__ */ I('<img style="display: none;" alt=""> <svg class="rc-pw-image-container svelte-1esrvxg" preserveAspectRatio="xMidYMid slice"><defs><clipPath><!></clipPath><!></defs><image class="rc-pw-image svelte-1esrvxg" x="0" y="0" width="100" preserveAspectRatio="xMidYMid slice"></image><rect class="rc-pw-image-overlay svelte-1esrvxg" x="0" y="0" width="100"></rect></svg>', 1);
const lu = {
  hash: "svelte-1esrvxg",
  code: ".rc-pw-image-container.svelte-1esrvxg {border-end-start-radius:var(--image-border-end-start-radius, 0px);border-end-end-radius:var(--image-border-end-end-radius, 0px);border-start-start-radius:var(--image-border-start-start-radius, 0px);border-start-end-radius:var(--image-border-start-end-radius, 0px);position:relative;overflow:hidden;display:flex;flex:var(--image-flex, 1 1 auto);position:var(--image-position, relative);inset:var(--image-inset, 0);transform:var(--image-transform, initial);height:var(--image-height, initial);width:var(--image-width, initial);}.rc-pw-image.svelte-1esrvxg {width:100%;height:100%;object-fit:cover;display:block;}.rc-pw-image-overlay.svelte-1esrvxg {position:absolute;inset:0;}"
};
function cu(e, r) {
  V(r, !0), R(e, lu);
  const t = /* @__PURE__ */ Ar(r, [
    "$$slots",
    "$$events",
    "$$legacy",
    "id",
    "source",
    "purchaseState"
  ]);
  let a = X(0), n;
  function o() {
    n && D(a, n.naturalHeight / n.naturalWidth);
  }
  const i = /* @__PURE__ */ E(() => $d({
    id: r.id,
    colorMode: r.purchaseState.colorMode,
    source: r.source,
    purchaseState: r.purchaseState,
    ...t,
    imageAspectRatio: d(a)
  })), s = /* @__PURE__ */ E(() => d(i).imageStyles), l = /* @__PURE__ */ E(() => d(i).maskPath), c = /* @__PURE__ */ E(() => d(i).linearGradientAngle), p = /* @__PURE__ */ E(() => {
    var w, q;
    const k = r.purchaseState.colorMode;
    return (w = r.source[k]) != null && w.original ? r.source[k].original : (q = r.source[Re]) == null ? void 0 : q.original;
  });
  var u = su(), _ = Y(u);
  _i(_, (k) => n = k, () => n);
  var g = O(_, 2), m = P(g), f = P(m), h = P(f);
  {
    var v = (k) => {
      var w = eu();
      A(() => {
        j(w, "cy", d(a) * 50), j(w, "ry", d(a) * 50);
      }), b(k, w);
    }, y = (k) => {
      var w = ru();
      A(() => j(w, "d", d(l))), b(k, w);
    };
    N(h, (k) => {
      var w;
      ((w = r.mask_shape) == null ? void 0 : w.type) === "circle" ? k(v) : k(y, !1);
    });
  }
  var x = O(f);
  {
    var T = (k) => {
      var w = au();
      it(w, 21, () => {
        var q, G, W, ae;
        return ((G = (q = r.color_overlay) == null ? void 0 : q[r.purchaseState.colorMode]) == null ? void 0 : G.points) || ((ae = (W = r.color_overlay) == null ? void 0 : W[Re]) == null ? void 0 : ae.points) || [];
      }, ot, (q, G) => {
        var W = tu();
        A(() => {
          j(W, "offset", `${d(G).percent}%`), j(W, "style", `stop-color: ${d(G).color}`);
        }), b(q, W);
      }), A(() => {
        j(w, "id", `gradient-${r.id}`), j(w, "x1", d(c).x1), j(w, "y1", d(c).y1), j(w, "x2", d(c).x2), j(w, "y2", d(c).y2);
      }), b(k, w);
    }, S = (k) => {
      var w = ee(), q = Y(w);
      {
        var G = (ae) => {
          var J = ou();
          it(J, 21, () => {
            var re, pe, me, ce;
            return ((pe = (re = r.color_overlay) == null ? void 0 : re[r.purchaseState.colorMode]) == null ? void 0 : pe.points) || ((ce = (me = r.color_overlay) == null ? void 0 : me[Re]) == null ? void 0 : ce.points) || [];
          }, ot, (re, pe) => {
            var me = nu();
            A(() => {
              j(me, "offset", `${d(pe).percent}%`), j(me, "style", `stop-color: ${d(pe).color}`);
            }), b(re, me);
          }), A(() => j(J, "id", `gradient-${r.id}`)), b(ae, J);
        }, W = (ae) => {
          var J = ee(), re = Y(J);
          {
            var pe = (me) => {
              var ce = iu(), ke = P(ce);
              A(() => {
                var Pe, vr, _r;
                j(ce, "id", `gradient-${r.id}`), j(ke, "style", `stop-color: ${((Pe = r.color_overlay[r.purchaseState.colorMode]) == null ? void 0 : Pe.value) || ((_r = (vr = r.color_overlay) == null ? void 0 : vr[Re]) == null ? void 0 : _r.value)}`);
              }), b(me, ce);
            };
            N(
              re,
              (me) => {
                var ce, ke;
                ((ke = (ce = r.color_overlay) == null ? void 0 : ce[r.purchaseState.colorMode]) == null ? void 0 : ke.type) === "hex" && me(pe);
              },
              !0
            );
          }
          b(ae, J);
        };
        N(
          q,
          (ae) => {
            var J, re;
            ((re = (J = r.color_overlay) == null ? void 0 : J[r.purchaseState.colorMode]) == null ? void 0 : re.type) === "radial" ? ae(G) : ae(W, !1);
          },
          !0
        );
      }
      b(k, w);
    };
    N(x, (k) => {
      var w, q;
      ((q = (w = r.color_overlay) == null ? void 0 : w[r.purchaseState.colorMode]) == null ? void 0 : q.type) === "linear" ? k(T) : k(S, !1);
    });
  }
  var z = O(m), C = O(z);
  A(() => {
    j(_, "src", d(p)), j(g, "id", `rc-pw-image-container-${r.id}`), j(g, "style", d(s)), j(g, "viewBox", `0 0 100 ${d(a) * 100}`), j(f, "id", `clip-path-${r.id}`), j(z, "href", d(p)), j(z, "height", d(a) * 100), j(z, "clip-path", `url(#clip-path-${r.id})`), j(z, "id", r.id), j(C, "height", d(a) * 100), j(C, "clip-path", `url(#clip-path-${r.id})`), j(C, "fill", `url(#gradient-${r.id})`);
  }), nt("load", _, o), b(e, u), H();
}
function du({ stack: e, zStackChildStyles: r }) {
  const t = e.size.width.type === "fill" ? "100%" : "fit-content", a = Ye(r || {}, "purchase-button");
  return Ce({
    ...a,
    ...{
      position: "var(--purchase-button-position, relative)",
      inset: "var(--purchase-button-inset, 0)",
      transform: "var(--purchase-button-transform, initial)",
      width: t
    }
  });
}
const uu = { hash: "svelte-1x8zwdp", code: "" };
function pu(e, r) {
  V(r, !0), R(e, uu);
  const t = /* @__PURE__ */ Ar(r, [
    "$$slots",
    "$$events",
    "$$legacy",
    "stack",
    "labels",
    "onAction",
    "purchaseState",
    "variableDictionary",
    "zStackChildStyles"
  ]), a = () => {
    r.onAction && r.onAction({ type: "purchase" });
  }, n = /* @__PURE__ */ E(() => du({
    stack: r.stack,
    labels: r.labels,
    onAction: r.onAction,
    purchaseState: r.purchaseState,
    variableDictionary: r.variableDictionary,
    zStackChildStyles: r.zStackChildStyles,
    ...t
  }));
  Ei(e, {
    onclick: a,
    class: "rc-pw-purchase-button",
    get style() {
      return d(n);
    },
    children: (o, i) => {
      Ot(o, hr(() => r.stack, {
        get labels() {
          return r.labels;
        },
        get purchaseState() {
          return r.purchaseState;
        },
        get variableDictionary() {
          return r.variableDictionary;
        }
      }));
    },
    $$slots: { default: !0 }
  }), H();
}
const _u = (e, r) => {
  e.preventDefault(), e.stopPropagation(), r.onAction && r.onAction({ type: "select_package" }, { packageId: r.package_id });
};
var gu = /* @__PURE__ */ I('<button class="rc-pw-package svelte-123kamd"><!></button>');
const mu = {
  hash: "svelte-123kamd",
  code: ".rc-pw-package.svelte-123kamd {width:100%;display:flex;margin:0;padding:0;background:initial;border:initial;text-align:initial;position:var(--package-position, relative);inset:var(--package-inset, 0);transform:var(--package-transform, initial);}"
};
function fu(e, r) {
  V(r, !0), R(e, mu);
  const t = /* @__PURE__ */ E(() => {
    var s;
    return ((s = r.purchaseState.variablesPerPackage) == null ? void 0 : s[r.package_id]) || r.variableDictionary;
  }), a = /* @__PURE__ */ E(() => {
    var s;
    return {
      selected: ((s = r.purchaseState) == null ? void 0 : s.selectedPackageId) === r.package_id
    };
  }), n = /* @__PURE__ */ E(() => Ce(Ye(r.zStackChildStyles, "package")));
  var o = gu();
  o.__click = [_u, r];
  var i = P(o);
  Ot(i, hr(() => r.stack, {
    get labels() {
      return r.labels;
    },
    get onAction() {
      return r.onAction;
    },
    get purchaseState() {
      return r.purchaseState;
    },
    get componentState() {
      return d(a);
    },
    get variableDictionary() {
      return d(t);
    }
  })), A(() => {
    j(o, "id", r.id), j(o, "style", d(n)), fr(o, "selected", d(a).selected);
  }), b(e, o), H();
}
ha(["click"]);
function yu(e) {
  const r = {
    "--item-spacing": `${e.item_spacing}px`,
    "--width": "initial",
    "--height": "initial",
    "--flex": "0 1 auto",
    "--position": "relative",
    "--inset": "0",
    "--transform": "initial"
  };
  Object.assign(r, Ct(e.size)), Object.assign(r, e.zStackChildStyles);
  const t = Ye(r, "timeline");
  return Ce(t);
}
function bu(e) {
  var a, n, o, i, s, l, c, p, u, _;
  const r = {
    "--icon-size": `${e.icon.width_and_height}px`,
    "--icon-padding": `${e.icon.padding}px`,
    "--icon-color": yr({
      colorMap: e.icon.color,
      colorMode: (a = e.purchaseState) == null ? void 0 : a.colorMode
    }),
    "--icon-background-color": yr({
      colorMap: (n = e.icon_background) == null ? void 0 : n.color,
      colorMode: e.purchaseState.colorMode
    }),
    "--icon-border": ki((o = e.icon_background) == null ? void 0 : o.border, (i = e.purchaseState) == null ? void 0 : i.colorMode),
    "--text-spacing": `${e.text_spacing}px`,
    "--border-start-start-radius": "0px",
    "--border-start-end-radius": "0px",
    "--border-end-start-radius": "0px",
    "--border-end-end-radius": "0px",
    "--connector-color": yr({
      colorMap: (s = e.connector) == null ? void 0 : s.color,
      colorMode: e.purchaseState.colorMode
    }),
    "--connector-width": `${((l = e.connector) == null ? void 0 : l.width) || 0}px`,
    "--connector-top": "0px",
    "--connector-height": `${e.item_spacing}px`
  };
  if (Object.assign(r, ((p = (c = e.icon_background) == null ? void 0 : c.shape) == null ? void 0 : p.type) === "rectangle" ? oa((_ = (u = e.icon_background) == null ? void 0 : u.shape) == null ? void 0 : _.corners) : {
    "--border-start-start-radius": "50%",
    "--border-start-end-radius": "50%",
    "--border-end-start-radius": "50%",
    "--border-end-end-radius": "50%"
  }), e.connector) {
    const g = e.connector.margin.top !== 0, m = e.connector.margin.bottom !== 0, f = e.icon.padding + e.icon.width_and_height / 2;
    !g && !m && (r["--connector-height"] = `${e.item_spacing + f * 2}px`, r["--connector-top"] = "50%"), g && m && (r["--connector-height"] = `${e.item_spacing - e.connector.margin.top - e.connector.margin.bottom}px`, r["--connector-top"] = `calc(100% + ${e.connector.margin.top}px)`), !g && m && (r["--connector-height"] = `${e.item_spacing - e.connector.margin.bottom + f}px`, r["--connector-top"] = "50%"), g && !m && (r["--connector-height"] = `${e.item_spacing + f}px`, r["--connector-top"] = `calc(100% + ${e.connector.margin.top}px)`);
  }
  const t = Ye(r, "timeline-item");
  return Ce(t);
}
function bo(e, r = "title") {
  var l, c, p, u, _;
  const t = {
    "--text-color": "inherit",
    "--text-font-size": "initial",
    "--text-font-weight": "initial",
    "--text-horizontal-alignment": "initial",
    "--text-margin-block-start": "0px",
    "--text-margin-inline-end": "0px",
    "--text-margin-block-end": "0px",
    "--text-margin-inline-start": "0px",
    "--text-padding-block-start": "0px",
    "--text-padding-inline-end": "0px",
    "--text-padding-block-end": "0px",
    "--text-padding-inline-start": "0px"
  }, a = {
    color: ((l = e[r]) == null ? void 0 : l.color) || xi,
    font_size: ((c = e[r]) == null ? void 0 : c.font_size) || "body_m",
    font_weight: ((p = e[r]) == null ? void 0 : p.font_weight) || "regular",
    horizontal_alignment: ((u = e[r]) == null ? void 0 : u.horizontal_alignment) || "leading"
  }, { tagToRender: n, textStyles: o } = hn({
    ...e,
    components: [],
    ...a,
    size: { width: { type: "fit" }, height: { type: "fit" } },
    type: "text",
    margin: { top: 0, bottom: 0, leading: 0, trailing: 0 },
    padding: { top: 0, bottom: 0, leading: 0, trailing: 0 },
    text_lid: ""
  });
  Object.assign(t, o);
  const i = Ce(Ye(t, "timeline-item")), s = yn({
    text_lid: (_ = e[r]) == null ? void 0 : _.text_lid,
    locale: e.purchaseState.locale,
    defaultLocale: e.purchaseState.defaultLocale,
    labels: e.labels,
    variableDictionary: e.variableDictionary
  });
  return {
    textStyles: i,
    tagToRender: n,
    textLabel: s
  };
}
var hu = /* @__PURE__ */ I('<div class="rc-pw-timeline-item svelte-gjmo4g"><div class="rc-pw-timeline-item-icon-container svelte-gjmo4g"><div class="rc-pw-timeline-item-icon svelte-gjmo4g"></div></div> <div class="rc-pw-timeline-item-content svelte-gjmo4g"><!> <!></div></div>');
const vu = {
  hash: "svelte-gjmo4g",
  code: `.rc-pw-timeline-item.svelte-gjmo4g {display:flex;align-items:center;gap:var(--timeline-item-spacing, 0px);}.rc-pw-timeline-item-icon-container.svelte-gjmo4g {position:relative;border-end-start-radius:var(--timeline-item-border-end-start-radius, 0px);border-end-end-radius:var(--timeline-item-border-end-end-radius, 0px);border-start-start-radius:var(
      --timeline-item-border-start-start-radius,
      0px
    );border-start-end-radius:var(--timeline-item-border-start-end-radius, 0px);width:var(--timeline-item-icon-size, 16px);height:var(--timeline-item-icon-size, 16px);flex-shrink:0;background-color:var(--timeline-item-icon-background-color, #ffffff);border:var(--timeline-item-icon-border, initial);display:flex;align-items:center;justify-content:center;padding:var(--timeline-item-icon-padding, 0px);box-sizing:content-box;}.rc-pw-timeline-item-icon-container.svelte-gjmo4g::before {position:absolute;content:"";z-index:-1;top:var(--timeline-item-connector-top, 0px);height:var(--timeline-item-connector-height, 0px);width:var(--timeline-item-connector-width, 0px);background:var(--timeline-item-connector-color, transparent);}.rc-pw-timeline-item-icon.svelte-gjmo4g {width:var(--timeline-item-icon-size, 10px);height:var(--timeline-item-icon-size, 10px);color:var(--timeline-item-icon-color, #ffffff);display:flex;align-items:center;justify-content:center;}.rc-pw-timeline-item-content.svelte-gjmo4g {display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;gap:var(--timeline-item-text-spacing, 0px);height:fit-content;}.rc-pw-timeline-item-content-title.svelte-gjmo4g,
  .rc-pw-timeline-item-content-description.svelte-gjmo4g {margin-block-start:var(--timeline-item-text-margin-block-start, 0px);margin-inline-end:var(--timeline-item-text-margin-inline-end, 0px);margin-block-end:var(--timeline-item-text-margin-block-end, 0px);margin-inline-start:var(--timeline-item-text-margin-inline-start, 0px);padding-block-start:var(--timeline-item-text-padding-block-start, 0);padding-inline-end:var(--timeline-item-text-padding-inline-end, 0);padding-block-end:var(--timeline-item-text-padding-block-end, 0);padding-inline-start:var(--timeline-item-text-padding-inline-start, 0);font-family:var(--timeline-item-text-font-family, sans-serif);}`
};
function ku(e, r) {
  V(r, !0), R(e, vu);
  const t = /* @__PURE__ */ Ar(r, ["$$slots", "$$events", "$$legacy"]), a = /* @__PURE__ */ E(() => bu(t)), n = /* @__PURE__ */ E(() => bo(t, "title")), o = /* @__PURE__ */ E(() => d(n).tagToRender), i = /* @__PURE__ */ E(() => d(n).textStyles), s = /* @__PURE__ */ E(() => d(n).textLabel), l = /* @__PURE__ */ E(() => bo(t, "description")), c = /* @__PURE__ */ E(() => d(l).tagToRender), p = /* @__PURE__ */ E(() => d(l).textStyles), u = /* @__PURE__ */ E(() => d(l).textLabel);
  var _ = hu(), g = O(P(_), 2), m = P(g);
  ea(m, () => d(o), !1, (v, y) => {
    let x;
    A(() => x = ra(
      v,
      x,
      {
        class: "rc-pw-timeline-item-content-title",
        style: d(i)
      },
      "svelte-gjmo4g",
      v.namespaceURI === xt,
      v.nodeName.includes("-")
    ));
    var T = ie();
    A(() => te(T, d(s))), b(y, T);
  });
  var f = O(m, 2);
  {
    var h = (v) => {
      var y = ee(), x = Y(y);
      ea(x, () => d(c), !1, (T, S) => {
        let z;
        A(() => z = ra(
          T,
          z,
          {
            class: "rc-pw-timeline-item-content-description",
            style: d(p)
          },
          "svelte-gjmo4g",
          T.namespaceURI === xt,
          T.nodeName.includes("-")
        ));
        var C = ie();
        A(() => te(C, d(u))), b(S, C);
      }), b(v, y);
    };
    N(f, (v) => {
      d(u) && v(h);
    });
  }
  A(() => j(_, "style", d(a))), b(e, _), H();
}
var wu = /* @__PURE__ */ I('<div class="rc-pw-timeline-container svelte-12g27vu"></div>');
const xu = {
  hash: "svelte-12g27vu",
  code: ".rc-pw-timeline-container.svelte-12g27vu {display:flex;flex:var(--timeline-flex, 0 1 auto);flex-direction:column;gap:var(--timeline-item-spacing, 0);width:var(--timeline-width, initial);height:var(--timeline-height, initial);position:var(--timeline-position, relative);inset:var(--timeline-inset, 0);transform:var(--timeline-transform, initial);}"
};
function Pu(e, r) {
  V(r, !0), R(e, xu);
  const t = /* @__PURE__ */ Ar(r, ["$$slots", "$$events", "$$legacy", "items"]), a = /* @__PURE__ */ E(() => yu({ items: r.items, ...t }));
  var n = ee(), o = Y(n);
  {
    var i = (s) => {
      var l = wu();
      it(l, 21, () => r.items, ot, (c, p, u) => {
        var _ = /* @__PURE__ */ E(() => `${r.id}-${u}`), g = /* @__PURE__ */ E(() => `${r.name}-${u}`);
        ku(c, hr(() => d(p), {
          get labels() {
            return r.labels;
          },
          get id() {
            return d(_);
          },
          get name() {
            return d(g);
          },
          type: "timeline",
          get purchaseState() {
            return r.purchaseState;
          },
          get text_spacing() {
            return r.text_spacing;
          },
          get item_spacing() {
            return r.item_spacing;
          }
        }));
      }), A(() => j(l, "style", d(a))), b(s, l);
    };
    N(o, (s) => {
      r.items.length && s(i);
    });
  }
  b(e, n), H();
}
var Su = /* @__PURE__ */ I('<footer class="rcb-modal-footer svelte-1f9z0o8"><!></footer>');
const Eu = {
  hash: "svelte-1f9z0o8",
  code: "footer.svelte-1f9z0o8 {display:flex;flex-direction:column;}"
};
function Tu(e, r) {
  V(r, !1), R(e, Eu);
  let t = U(r, "children", 8);
  Qe();
  var a = Su(), n = P(a);
  ge(n, () => t() ?? ne), b(e, a), H();
}
const Iu = {
  hash: "svelte-1bzqb13",
  code: ".rcb-modal-section.svelte-1bzqb13 {padding:8px 0px;display:flex;}section.rcb-modal-section.svelte-1bzqb13 {flex-grow:1;}.rcb-modal-section.svelte-1bzqb13:last-of-type {padding:0;}"
};
function qu(e, r) {
  V(r, !1), R(e, Iu);
  let t = U(r, "as", 8, "section"), a = U(r, "children", 8);
  Qe();
  var n = ee(), o = Y(n);
  ea(o, t, !1, (i, s) => {
    ra(i, null, { class: "rcb-modal-section" }, "svelte-1bzqb13", i.namespaceURI === xt, i.nodeName.includes("-"));
    var l = ee(), c = Y(l);
    ge(c, () => a() ?? ne), b(s, l);
  }), b(e, n), H();
}
var Fu = /* @__PURE__ */ I("<div><!></div>");
const zu = {
  hash: "svelte-b5dygi",
  code: `.rcb-column.svelte-b5dygi {display:flex;flex-direction:column;justify-content:flex-start;flex-grow:1;min-width:100%;}.rcb-column.align-center.svelte-b5dygi {justify-content:center;}.rcb-column.align-end.svelte-b5dygi {justify-content:flex-end;}.rcb-column.gap-small.svelte-b5dygi {gap:var(--rc-spacing-gapSmall-mobile);}.rcb-column.gap-medium.svelte-b5dygi {gap:var(--rc-spacing-gapXLarge-mobile);}.rcb-column.gap-large.svelte-b5dygi {gap:var(--rc-spacing-gapXXLarge-mobile);}

  @container layout-query-container (width >= 768px) {.rcb-column.gap-small.svelte-b5dygi {gap:var(--rc-spacing-gapSmall-desktop);}.rcb-column.gap-medium.svelte-b5dygi {gap:var(--rc-spacing-gapLarge-desktop);}.rcb-column.gap-large.svelte-b5dygi {gap:var(--rc-spacing-gapXXLarge-desktop);}
  }`
};
function Di(e, r) {
  V(r, !1), R(e, zu);
  let t = U(r, "gap", 8, "small"), a = U(r, "align", 8, "start"), n = U(r, "children", 8);
  Qe();
  var o = Fu(), i = P(o);
  ge(i, () => n() ?? ne), A(() => Fr(o, `rcb-column gap-${t() ?? ""} align-${a() ?? ""} svelte-b5dygi`)), b(e, o), H();
}
var Du = /* @__PURE__ */ I('<div class="rcb-row svelte-1seeuxq"><!></div>');
const Au = {
  hash: "svelte-1seeuxq",
  code: ".rcb-row.svelte-1seeuxq {display:flex;flex-direction:row;justify-content:flex-start;}"
};
function Mu(e, r) {
  V(r, !1), R(e, Au);
  let t = U(r, "children", 8);
  Qe();
  var a = Du(), n = P(a);
  ge(n, () => t() ?? ne), b(e, a), H();
}
var ju = /* @__PURE__ */ I("<span><!></span>");
const Nu = {
  hash: "svelte-orw2sj",
  code: `.rcb-typography.svelte-orw2sj {display:inline-block;line-height:normal;}

  /* svelte-ignore css-unused-selector */.rcb-typography-heading-2xl.svelte-orw2sj {font:var(--rc-text-heading2xl-mobile);}.rcb-typography-heading-2xl.rcb-typography-branded.svelte-orw2sj {font:var(--rc-text-heading2xl-branded-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-heading-xl.svelte-orw2sj {font:var(--rc-text-headingXl-mobile);}.rcb-typography-heading-xl.rcb-typography-branded.svelte-orw2sj {font:var(--rc-text-headingXl-branded-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-heading-lg.svelte-orw2sj {font:var(--rc-text-headingLg-mobile);}.rcb-typography-heading-lg.rcb-typography-branded.svelte-orw2sj {font:var(--rc-text-headingLg-branded-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-heading-md.svelte-orw2sj {font:var(--rc-text-headingMd-mobile);}.rcb-typography-heading-md.rcb-typography-branded.svelte-orw2sj {font:var(--rc-text-headingMd-branded-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-body-base.svelte-orw2sj {font:var(--rc-text-bodyBase-mobile);}.rcb-typography-body-base.rcb-typography-branded.svelte-orw2sj {font:var(--rc-text-bodyBase-branded-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-body-small.svelte-orw2sj {font:var(--rc-text-bodySmall-mobile);}.rcb-typography-body-small.rcb-typography-branded.svelte-orw2sj {font:var(--rc-text-bodySmall-branded-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-label-button.svelte-orw2sj {font:var(--rc-text-labelButton-mobile);}.rcb-typography-label-button.rcb-typography-branded.svelte-orw2sj {font:var(--rc-text-labelButton-branded-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-label-default.svelte-orw2sj {font:var(--rc-text-labelDefault-mobile);}.rcb-typography-label-default.rcb-typography-branded.svelte-orw2sj {font:var(--rc-text-labelDefault-branded-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-caption-default.svelte-orw2sj {font:var(--rc-text-captionDefault-mobile);}.rcb-typography-caption-default.rcb-typography-branded.svelte-orw2sj {font:var(--rc-text-captionDefault-branded-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-caption-link.svelte-orw2sj {font:var(--rc-text-captionLink-mobile);}.rcb-typography-caption-link.rcb-typography-branded.svelte-orw2sj {font:var(--rc-text-captionLink-branded-mobile);}

  @container layout-query-container (width >= 768px) {span.rcb-typography-branded.svelte-orw2sj {font:var(--rc-text-brandedText-font-style-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-heading-2xl.svelte-orw2sj {font:var(--rc-text-heading2xl-desktop);}.rcb-typography-heading-2xl.rcb-typography-branded.svelte-orw2sj {font:var(--rc-text-heading2xl-branded-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-heading-xl.svelte-orw2sj {font:var(--rc-text-headingXl-desktop);}.rcb-typography-heading-xl.rcb-typography-branded.svelte-orw2sj {font:var(--rc-text-headingXl-branded-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-heading-lg.svelte-orw2sj {font:var(--rc-text-headingLg-desktop);}.rcb-typography-heading-lg.rcb-typography-branded.svelte-orw2sj {font:var(--rc-text-headingLg-branded-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-heading-md.svelte-orw2sj {font:var(--rc-text-headingMd-desktop);}.rcb-typography-heading-md.rcb-typography-branded.svelte-orw2sj {font:var(--rc-text-headingMd-branded-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-body-base.svelte-orw2sj {font:var(--rc-text-bodyBase-desktop);}.rcb-typography-body-base.rcb-typography-branded.svelte-orw2sj {font:var(--rc-text-bodyBase-branded-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-body-small.svelte-orw2sj {font:var(--rc-text-bodySmall-desktop);}.rcb-typography-body-small.rcb-typography-branded.svelte-orw2sj {font:var(--rc-text-bodySmall-branded-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-label-button.svelte-orw2sj {font:var(--rc-text-labelButton-desktop);}.rcb-typography-label-button.rcb-typography-branded.svelte-orw2sj {font:var(--rc-text-labelButton-branded-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-label-default.svelte-orw2sj {font:var(--rc-text-labelDefault-desktop);}.rcb-typography-label-default.rcb-typography-branded.svelte-orw2sj {font:var(--rc-text-labelDefault-branded-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-caption-default.svelte-orw2sj {font:var(--rc-text-captionDefault-desktop);}.rcb-typography-caption-default.rcb-typography-branded.svelte-orw2sj {font:var(--rc-text-captionDefault-branded-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-caption-link.svelte-orw2sj {font:var(--rc-text-captionLink-desktop);}.rcb-typography-caption-link.rcb-typography-branded.svelte-orw2sj {font:var(--rc-text-captionLink-branded-desktop);}
  }`
};
function se(e, r) {
  V(r, !0), R(e, Nu);
  const t = U(r, "size", 3, "body-base"), a = U(r, "branded", 3, !1);
  var n = ju(), o = P(n);
  ge(o, () => r.children ?? ne), A(() => Fr(n, `rcb-typography rcb-typography-${t() ?? ""} ${(a() ? "rcb-typography-branded" : "") ?? ""} svelte-orw2sj`)), b(e, n), H();
}
var Cu = /* @__PURE__ */ I("<div><!></div>"), Ou = /* @__PURE__ */ I('<span style="display: block;"><!></span>'), Lu = /* @__PURE__ */ I("<!> <!>", 1), Bu = /* @__PURE__ */ I("<!> <!>", 1), Ru = /* @__PURE__ */ I('<div class="rcb-modal-message svelte-w46z5s" data-type="error"><!></div>');
const Uu = {
  hash: "svelte-w46z5s",
  code: `.rcb-modal-message-icon.svelte-w46z5s {flex-shrink:0;align-self:center;margin-right:16px;}.rcb-modal-message.svelte-w46z5s {width:100%;min-height:160px;display:flex;justify-content:center;align-items:center;flex-direction:column;text-align:left;margin-top:4px;}.rcb-modal-message[data-has-title="false"].svelte-w46z5s {margin-top:var(--rc-spacing-gapXXLarge-mobile);}.rcb-modal-message-icon.small.svelte-w46z5s {height:var(--rc-text-headingLg-mobile-font-size);width:var(--rc-text-headingLg-mobile-font-size);}.rcb-modal-message-icon.large.svelte-w46z5s {height:calc(2 * var(--rc-text-headingMd-mobile-font-size));width:calc(2 * var(--rc-text-headingMd-mobile-font-size));}

  @container layout-query-container (width >= 768px) {.rcb-modal-message-icon.small.svelte-w46z5s {height:var(--rc-text-headingLg-desktop-font-size);width:var(--rc-text-headingLg-desktop-font-size);}.rcb-modal-message-icon.large.svelte-w46z5s {height:calc(2 * var(--rc-text-headingMd-desktop-font-size));width:calc(2 * var(--rc-text-headingMd-desktop-font-size));}.rcb-modal-message[data-has-title="false"].svelte-w46z5s {margin-top:var(--rc-spacing-gapXXLarge-desktop);}
  }`
};
function Vu(e, r) {
  V(r, !0), R(e, Uu);
  const t = U(r, "title", 3, null), a = U(r, "icon", 3, null), n = 32;
  let o = X(null), i = X(!1), s;
  We(() => (d(o) && (s = new ResizeObserver(() => {
    var p;
    D(i, (((p = d(o)) == null ? void 0 : p.offsetHeight) ?? 0) > n);
  }), s.observe(d(o))), () => {
    s == null || s.disconnect();
  }));
  var l = Ru(), c = P(l);
  Di(c, {
    gap: "medium",
    align: "start",
    children: (p, u) => {
      var _ = Bu(), g = Y(_);
      Mu(g, {
        children: (h, v) => {
          var y = Lu(), x = Y(y);
          {
            var T = (C) => {
              var k = Cu(), w = P(k);
              ge(w, a), A(() => Fr(k, `rcb-modal-message-icon ${(d(i) ? "large" : "small") ?? ""} svelte-w46z5s`)), b(C, k);
            };
            N(x, (C) => {
              a() && C(T);
            });
          }
          var S = O(x, 2);
          {
            var z = (C) => {
              var k = Ou(), w = P(k);
              se(w, {
                size: "heading-md",
                children: (q, G) => {
                  var W = ie();
                  A(() => te(W, t())), b(q, W);
                },
                $$slots: { default: !0 }
              }), _i(k, (q) => D(o, q), () => d(o)), b(C, k);
            };
            N(S, (C) => {
              t() && C(z);
            });
          }
          b(h, y);
        },
        $$slots: { default: !0 }
      });
      var m = O(g, 2);
      {
        var f = (h) => {
          se(h, {
            size: "body-small",
            children: (v, y) => {
              var x = ee(), T = Y(x);
              ge(T, () => r.message ?? ne), b(v, x);
            },
            $$slots: { default: !0 }
          });
        };
        N(m, (h) => {
          r.message && h(f);
        });
      }
      b(p, _);
    },
    $$slots: { default: !0 }
  }), A(() => j(l, "data-has-title", !!t())), b(e, l), H();
}
var Hu = /* @__PURE__ */ I('<div class="rcb-modal-message-icon svelte-c8cuu5"><!></div>'), Wu = /* @__PURE__ */ I("<!> <!>", 1), Yu = /* @__PURE__ */ I('<div class="rcb-modal-message svelte-c8cuu5" data-type="success"><!></div>');
const Gu = {
  hash: "svelte-c8cuu5",
  code: `.rcb-modal-message-icon.svelte-c8cuu5 {height:54px;width:54px;margin:0 auto;}.rcb-modal-message[data-has-title="false"].svelte-c8cuu5 {margin-top:var(--rc-spacing-gapXXLarge-mobile);}.rcb-modal-message.svelte-c8cuu5 {width:100%;min-height:160px;display:flex;justify-content:center;align-items:center;flex-direction:column;text-align:center;}

  @container layout-query-container (width >= 768px) {.rcb-modal-message[data-has-title="false"].svelte-c8cuu5 {margin-top:var(--rc-spacing-gapXXLarge-desktop);}
  }`
};
function Xu(e, r) {
  V(r, !0), R(e, Gu);
  const t = U(r, "title", 3, null), a = U(r, "icon", 3, null);
  var n = Yu(), o = P(n);
  Di(o, {
    gap: "large",
    align: "center",
    children: (i, s) => {
      var l = Wu(), c = Y(l);
      {
        var p = (g) => {
          var m = Hu(), f = P(m);
          ge(f, a), b(g, m);
        };
        N(c, (g) => {
          a() && g(p);
        });
      }
      var u = O(c, 2);
      {
        var _ = (g) => {
          se(g, {
            size: "heading-md",
            children: (m, f) => {
              var h = ie();
              A(() => te(h, t())), b(m, h);
            },
            $$slots: { default: !0 }
          });
        };
        N(u, (g) => {
          t() && g(_);
        });
      }
      b(i, l);
    },
    $$slots: { default: !0 }
  }), A(() => j(n, "data-has-title", !!t())), b(e, n), H();
}
const xn = "rcb-ui-events-tracker", Pn = "branding";
var Zu = /* @__PURE__ */ I('<div class="message-layout svelte-qavr33"><div class="message-layout-content svelte-qavr33"><!></div> <div class="message-layout-footer"><!></div></div>');
const Ku = {
  hash: "svelte-qavr33",
  code: `.message-layout.svelte-qavr33 {display:flex;flex-direction:column;}.message-layout-content.svelte-qavr33 {flex-grow:1;display:flex;flex-direction:column;justify-content:center;}

  @container layout-query-container (width < 768px) {.message-layout.svelte-qavr33 {flex-grow:1;gap:var(--rc-spacing-gapXXLarge-mobile);}
  }

  @container layout-query-container (width >= 768px) {.message-layout.svelte-qavr33 {min-height:354px;gap:var(--rc-spacing-gapXXLarge-desktop);}.message-layout-content.svelte-qavr33 {justify-content:flex-start;flex-grow:1;}
  }`
};
function Sn(e, r) {
  V(r, !0), R(e, Ku);
  let t = U(r, "title", 3, null), a = U(r, "closeButtonTitle", 3, "Go back to app"), n = U(r, "icon", 3, null), o = U(r, "message", 3, null);
  const i = Ee(Pn);
  function s() {
    r.onDismiss();
  }
  var l = Zu(), c = P(l), p = P(c);
  qu(p, {
    children: (g, m) => {
      var f = ee(), h = Y(f);
      {
        var v = (x) => {
          Xu(x, {
            get title() {
              return t();
            },
            get icon() {
              return n();
            }
          });
        }, y = (x) => {
          Vu(x, {
            get title() {
              return t();
            },
            get icon() {
              return n();
            },
            get message() {
              return o();
            }
          });
        };
        N(h, (x) => {
          r.type === "success" ? x(v) : x(y, !1);
        });
      }
      b(g, f);
    },
    $$slots: { default: !0 }
  });
  var u = O(c, 2), _ = P(u);
  Tu(_, {
    children: (g, m) => {
      zi(g, {
        onclick: s,
        type: "submit",
        brandingAppearance: i,
        children: (f, h) => {
          var v = ie();
          A(() => te(v, a())), b(f, v);
        },
        $$slots: { default: !0 }
      });
    },
    $$slots: { default: !0 }
  }), b(e, l), H();
}
function ur(e, r) {
  V(r, !0);
  const t = De(), a = () => ze(o, "$translator", t), n = U(r, "key", 3, ""), o = Ee(Ne), i = /* @__PURE__ */ E(() => n() ? a().translate(n() || "", r.variables) : void 0);
  var s = ee(), l = Y(s);
  {
    var c = (u) => {
      var _ = ie();
      A(() => te(_, d(i))), b(u, _);
    }, p = (u) => {
      var _ = ee(), g = Y(_);
      ge(g, () => r.children ?? ne), b(u, _);
    };
    N(l, (u) => {
      d(i) ? u(c) : u(p, !1);
    });
  }
  b(e, s), H();
}
var Ju = /* @__PURE__ */ I('<p class="footer-caption svelte-1hbk6xu"><!></p>'), Qu = /* @__PURE__ */ I('<p class="footer-caption svelte-1hbk6xu"><!></p>'), $u = /* @__PURE__ */ I('<div class="footer-caption-container svelte-1hbk6xu"><!> <!> <p class="footer-caption svelte-1hbk6xu"><!></p></div>');
const ep = {
  hash: "svelte-1hbk6xu",
  code: `.footer-caption-container.svelte-1hbk6xu {display:flex;flex-direction:column;gap:var(--rc-spacing-gapLarge-mobile);}.footer-caption.svelte-1hbk6xu {color:var(--rc-color-grey-text-light);text-align:center;margin:0;}

  @container layout-query-container (width >= 768px) {.footer-caption-container.svelte-1hbk6xu {gap:var(--rc-spacing-gapLarge-desktop);}
  }`
};
function rp(e, r) {
  V(r, !1), R(e, ep);
  const t = De(), a = () => ze(l, "$translator", t), n = Ca(), o = Ca();
  let i = U(r, "brandingInfo", 8, null), s = U(r, "subscriptionOption", 8, null);
  const l = Ee(Ne);
  Kn(
    () => (Va(i()), a(), L),
    () => {
      var h;
      D(n, i() ? a().translate(L.PaymentEntryPageTermsInfo, { appName: (h = i()) == null ? void 0 : h.app_name }) : null);
    }
  ), Kn(
    () => (Va(s()), a(), Xa),
    () => {
      var h, v, y, x, T, S, z, C, k, w, q, G, W, ae, J, re, pe, me, ce;
      D(o, (v = (h = s()) == null ? void 0 : h.base) != null && v.price && ((x = (y = s()) == null ? void 0 : y.trial) != null && x.period) && ((S = (T = s()) == null ? void 0 : T.base) != null && S.period) && ((k = (C = (z = s()) == null ? void 0 : z.base) == null ? void 0 : C.period) != null && k.unit) ? a().translate(L.PaymentEntryPageTrialInfo, {
        price: Ir((q = (w = s()) == null ? void 0 : w.base) == null ? void 0 : q.price.amountMicros, (W = (G = s()) == null ? void 0 : G.base) == null ? void 0 : W.price.currency, a().locale || a().fallbackLocale),
        perFrequency: a().translatePeriodFrequency(((re = (J = (ae = s()) == null ? void 0 : ae.base) == null ? void 0 : J.period) == null ? void 0 : re.number) || 1, (ce = (me = (pe = s()) == null ? void 0 : pe.base) == null ? void 0 : me.period) == null ? void 0 : ce.unit, { useMultipleWords: !0 }),
        renewalDate: a().translateDate(Xa(/* @__PURE__ */ new Date(), s().trial.period || s().base.period, !0), {
          year: "numeric",
          month: "long",
          day: "numeric"
        })
      }) : null);
    }
  ), pl(), Qe();
  var c = $u(), p = P(c);
  {
    var u = (h) => {
      var v = Ju(), y = P(v);
      se(y, {
        size: "caption-default",
        children: (x, T) => {
          var S = ie();
          A(() => te(S, d(n))), b(x, S);
        },
        $$slots: { default: !0 }
      }), b(h, v);
    };
    N(p, (h) => {
      d(n) && s() && h(u);
    });
  }
  var _ = O(p, 2);
  {
    var g = (h) => {
      var v = Qu(), y = P(v);
      se(y, {
        size: "caption-default",
        children: (x, T) => {
          var S = ie();
          A(() => te(S, d(o))), b(x, S);
        },
        $$slots: { default: !0 }
      }), b(h, v);
    };
    N(_, (h) => {
      d(o) && h(g);
    });
  }
  var m = O(_, 2), f = P(m);
  se(f, {
    size: "caption-default",
    children: (h, v) => {
      ur(h, {
        get key() {
          return L.PaymentEntryPagePaymentStepTitle;
        }
      });
    },
    $$slots: { default: !0 }
  }), b(e, c), H();
}
var Fe = /* @__PURE__ */ ((e) => (e.SDKInitialized = "sdk_initialized", e.CheckoutSessionStart = "checkout_session_start", e.CheckoutSessionEnd = "checkout_session_end", e.CheckoutFlowError = "checkout_flow_error", e.CheckoutPaymentTaxCalculation = "checkout_payment_tax_calculation", e.CheckoutPaymentFormImpression = "checkout_payment_form_impression", e.CheckoutPaymentFormError = "checkout_payment_form_error", e.CheckoutPaymentFormDismiss = "checkout_payment_form_dismiss", e.CheckoutPaymentFormSubmit = "checkout_payment_form_submit", e.CheckoutPaymentFormGatewayError = "checkout_payment_form_gateway_error", e.CheckoutPurchaseSuccessfulImpression = "checkout_purchase_successful_impression", e.CheckoutPurchaseSuccessfulDismiss = "checkout_purchase_successful_dismiss", e))(Fe || {}), En = /* @__PURE__ */ ((e) => (e.tax_collection_disabled = "tax_collection_disabled", e.invalid_tax_location = "invalid_tax_location", e.rate_limit_exceeded = "rate_limit_exceeded", e.missing_required_permission = "missing_required_permission", e.invalid_origin_address = "invalid_origin_address", e.taxes_not_active = "taxes_not_active", e.unexpected_gateway_error = "unexpected_gateway_error", e))(En || {});
function tp({
  errorCode: e,
  errorMessage: r
}) {
  return {
    eventName: Fe.CheckoutFlowError,
    properties: {
      errorCode: e,
      errorMessage: r
    }
  };
}
function ap({
  errorCode: e,
  errorMessage: r
}) {
  return {
    eventName: Fe.CheckoutPaymentFormError,
    properties: {
      errorCode: e,
      errorMessage: r
    }
  };
}
function np({
  appearance: e,
  rcPackage: r,
  purchaseOptionToUse: t,
  customerEmail: a
}) {
  return {
    eventName: Fe.CheckoutSessionStart,
    properties: {
      customizationColorButtonsPrimary: (e == null ? void 0 : e.color_buttons_primary) ?? null,
      customizationColorAccent: (e == null ? void 0 : e.color_accent) ?? null,
      customizationColorError: (e == null ? void 0 : e.color_error) ?? null,
      customizationColorProductInfoBg: (e == null ? void 0 : e.color_product_info_bg) ?? null,
      customizationColorFormBg: (e == null ? void 0 : e.color_form_bg) ?? null,
      customizationColorPageBg: (e == null ? void 0 : e.color_page_bg) ?? null,
      customizationFont: (e == null ? void 0 : e.font) ?? null,
      customizationShapes: (e == null ? void 0 : e.shapes) ?? null,
      customizationShowProductDescription: (e == null ? void 0 : e.show_product_description) ?? null,
      productInterval: r.webBillingProduct.normalPeriodDuration,
      productPrice: r.webBillingProduct.currentPrice.amountMicros,
      productCurrency: r.webBillingProduct.currentPrice.currency,
      selectedProductId: r.webBillingProduct.identifier,
      selectedPackageId: r.identifier,
      selectedPurchaseOption: t.id,
      customerEmailProvidedByDeveloper: !!a
    }
  };
}
function op({
  redemptionInfo: e
}) {
  return {
    eventName: Fe.CheckoutSessionEnd,
    properties: {
      outcome: "finished",
      withRedemptionInfo: !!e
    }
  };
}
function ip() {
  return {
    eventName: Fe.CheckoutSessionEnd,
    properties: {
      outcome: "closed"
    }
  };
}
function sp({
  errorCode: e,
  errorMessage: r
}) {
  return {
    eventName: Fe.CheckoutSessionEnd,
    properties: {
      outcome: "errored",
      errorCode: e,
      errorMessage: r
    }
  };
}
function lp({
  taxCalculation: e,
  taxCustomerDetails: r
}) {
  const t = e.failed_reason === En.tax_collection_disabled ? "disabled" : e.failed_reason ? "failed" : e.tax_amount_in_micros === 0 ? "not-taxed" : "taxed", a = r === null ? "auto" : "form";
  return {
    eventName: Fe.CheckoutPaymentTaxCalculation,
    properties: {
      outcome: t,
      ui_element: a,
      tax_inclusive: e.tax_inclusive,
      error_code: e.failed_reason ?? null
    }
  };
}
function cp({
  selectedPaymentMethod: e
}) {
  return {
    eventName: Fe.CheckoutPaymentFormSubmit,
    properties: {
      selectedPaymentMethod: e ?? null
    }
  };
}
function dp({
  errorCode: e,
  errorMessage: r
}) {
  return {
    eventName: Fe.CheckoutPaymentFormGatewayError,
    properties: {
      errorCode: e,
      errorMessage: r
    }
  };
}
const up = `<svg width="80" height="80" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
  <g transform="scale(0.5)" transform-origin="center">
  <path d="M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 11.5858 20.8358 11.25 21.25 11.25C21.6642 11.25 22 11.5858 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C12.4142 2 12.75 2.33579 12.75 2.75C12.75 3.16421 12.4142 3.5 12 3.5Z" fill="currentColor"/>
  </g>
</svg>`;
var pp = /* @__PURE__ */ I('<div style="color:var(--rc-color-accent);" class="rcb-ui-asset-icon svelte-1sxpw7o"><!></div>');
const _p = {
  hash: "svelte-1sxpw7o",
  code: `
  @-webkit-keyframes svelte-1sxpw7o-rotating /* Safari and Chrome */ {
    from {
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes svelte-1sxpw7o-rotating {
    from {
      -ms-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -ms-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }div.svelte-1sxpw7o {width:80px;height:80px;
    -webkit-animation: svelte-1sxpw7o-rotating 2s ease-in-out infinite;
    -moz-animation: svelte-1sxpw7o-rotating 2s ease-in-out infinite;
    -ms-animation: svelte-1sxpw7o-rotating 2s ease-in-out infinite;
    -o-animation: svelte-1sxpw7o-rotating 2s ease-in-out infinite;
    animation: svelte-1sxpw7o-rotating 2s ease-in-out infinite;}`
};
function gp(e) {
  R(e, _p);
  var r = pp(), t = P(r);
  Wr(t, () => up), b(e, r);
}
var mp = /* @__PURE__ */ I('<div class="rcb-modal-loader svelte-102edf4"><!></div>');
const fp = {
  hash: "svelte-102edf4",
  code: `.rcb-modal-loader.svelte-102edf4 {width:100%;flex-grow:1;display:flex;justify-content:center;align-items:center;}

  @container layout-query-container (width >= 768px) {.rcb-modal-loader.svelte-102edf4 {align-items:flex-start;margin-top:calc(var(--rc-spacing-gapXXLarge-desktop) * 6);}
  }`
};
function Ai(e) {
  R(e, fp);
  var r = mp(), t = P(r);
  gp(t), b(e, r);
}
function yp(e, r) {
  var c, p;
  V(r, !0);
  const t = De(), a = () => ze(n, "$translator", t), n = Ee(Ne), o = Ee(Pn), i = /* @__PURE__ */ E(() => r.priceBreakdown ? a().formatPrice(r.priceBreakdown.totalAmountInMicros, r.priceBreakdown.currency) : null), s = (p = (c = r.subscriptionOption) == null ? void 0 : c.trial) == null ? void 0 : p.period, l = /* @__PURE__ */ E(() => s ? a().translatePeriod(s.number, s.unit) : null);
  zi(e, {
    get disabled() {
      return r.disabled;
    },
    testId: "PayButton",
    brandingAppearance: o,
    children: (u, _) => {
      var g = ee(), m = Y(g);
      {
        var f = (v) => {
          var y = /* @__PURE__ */ E(() => ({ trialPeriodLabel: d(l) }));
          ur(v, {
            get key() {
              return L.PaymentEntryPageButtonStartTrial;
            },
            get variables() {
              return d(y);
            }
          });
        }, h = (v) => {
          var y = ee(), x = Y(y);
          {
            var T = (z) => {
              var C = /* @__PURE__ */ E(() => ({ formattedPrice: d(i) }));
              ur(z, {
                get key() {
                  return L.PaymentEntryPageButtonWithPrice;
                },
                get variables() {
                  return d(C);
                }
              });
            }, S = (z) => {
              ur(z, {
                get key() {
                  return L.PaymentEntryPageButtonPay;
                }
              });
            };
            N(
              x,
              (z) => {
                d(i) ? z(T) : z(S, !1);
              },
              !0
            );
          }
          b(v, y);
        };
        N(m, (v) => {
          var y;
          (y = r.subscriptionOption) != null && y.trial ? v(f) : v(h, !1);
        });
      }
      b(u, g);
    },
    $$slots: { default: !0 }
  }), H();
}
const bp = {
  error: "#B0171F",
  warning: "#f4e971",
  focus: "#1148B8",
  accent: "#767676",
  primary: "#576CDB",
  "primary-hover": "rgba(87, 108, 219, .8)",
  "primary-pressed": "rgba(87, 108, 219, .9)",
  "primary-text": "#ffffff",
  white: "#ffffff",
  "grey-text-dark": "rgba(0,0,0,1)",
  "grey-text-light": "rgba(0,0,0,0.7)",
  "grey-ui-dark": "rgba(0,0,0,0.3)",
  "grey-ui-light": "rgba(0,0,0,0.1)",
  "input-background": "white",
  background: "white"
}, hp = {
  error: "#B0171F",
  warning: "#f4e971",
  focus: "#1148B8",
  accent: "#767676",
  primary: "#576CDB",
  "primary-hover": "rgba(87, 108, 219, .8)",
  "primary-pressed": "rgba(87, 108, 219, .9)",
  "primary-text": "#ffffff",
  white: "#ffffff",
  "grey-text-dark": "rgba(0,0,0,1)",
  "grey-text-light": "rgba(0,0,0,0.7)",
  "grey-ui-dark": "rgba(0,0,0,0.3)",
  "grey-ui-light": "rgba(0,0,0,0.1)",
  "input-background": "white",
  background: "#EFF3FA"
}, Mi = {
  error: "color_error",
  focus: "color_accent",
  accent: "color_accent",
  primary: "color_buttons_primary"
}, vp = {
  ...Mi,
  "input-background": "color_form_bg",
  background: "color_form_bg"
}, kp = {
  ...Mi,
  "input-background": "color_product_info_bg",
  background: "color_product_info_bg"
}, ji = {
  "input-border-radius": "4px",
  "input-button-border-radius": "8px"
}, wp = {
  "input-border-radius": "0px",
  "input-button-border-radius": "0px"
}, xp = {
  "input-border-radius": "12px",
  "input-button-border-radius": "9999px"
}, ho = ji, la = "-apple-system, BlinkMacSystemFont, avenir next, avenir, segoe ui, helvetica neue, helvetica, Cantarell, Ubuntu, roboto, noto, arial, sans-serif", Ni = "BrandCustomFont", vo = `${Ni}, ${la}`, nr = {
  regular: "400",
  medium: "500",
  semibold: "600"
}, Be = {
  10: "10px",
  12: "12px",
  14: "14px",
  16: "16px",
  18: "18px",
  20: "20px",
  24: "24px",
  28: "28px",
  32: "32px",
  36: "36px",
  40: "40px"
}, or = {
  120: "120%",
  130: "130%",
  140: "140%"
}, ir = {
  tight: "0.20%",
  regular: "0",
  loose: "0.20%"
}, ye = {
  heading2xl: {
    fontSize: Be[28],
    lineHeight: or[130],
    fontWeight: nr.semibold,
    letterSpacing: ir.loose
  },
  headingXl: {
    fontSize: Be[24],
    lineHeight: or[130],
    fontWeight: nr.semibold,
    letterSpacing: ir.loose
  },
  headingLg: {
    fontSize: "20px",
    lineHeight: or[130],
    fontWeight: nr.semibold,
    letterSpacing: ir.loose
  },
  headingMd: {
    fontSize: "16px",
    lineHeight: or[140],
    fontWeight: nr.medium,
    letterSpacing: ir.regular
  },
  bodyBase: {
    fontSize: Be[16],
    lineHeight: or[140],
    fontWeight: nr.regular,
    letterSpacing: ir.regular
  },
  bodySmall: {
    fontSize: Be[14],
    lineHeight: or[140],
    fontWeight: nr.regular,
    letterSpacing: ir.regular
  },
  labelButton: {
    fontSize: Be[16],
    lineHeight: or[140],
    fontWeight: nr.semibold,
    letterSpacing: ir.tight
  },
  labelDefault: {
    fontSize: Be[14],
    lineHeight: or[140],
    fontWeight: nr.regular,
    letterSpacing: ir.tight
  },
  captionDefault: {
    fontSize: Be[12],
    lineHeight: or[140],
    fontWeight: nr.regular,
    letterSpacing: ir.regular
  },
  captionLink: {
    fontSize: Be[12],
    lineHeight: or[140],
    fontWeight: nr.regular,
    letterSpacing: ir.regular
  }
}, sr = {
  heading2xl: {
    ...ye.heading2xl,
    fontSize: Be[36]
  },
  headingXl: {
    ...ye.headingXl,
    fontSize: Be[32]
  },
  headingLg: {
    ...ye.headingLg,
    fontSize: Be[24]
  },
  headingMd: {
    ...ye.headingMd,
    fontSize: Be[18]
  },
  bodyBase: {
    ...ye.bodyBase
  },
  bodySmall: {
    ...ye.bodySmall
  },
  labelButton: {
    ...ye.labelButton
  },
  labelDefault: {
    ...ye.labelDefault
  },
  captionDefault: {
    ...ye.captionDefault
  },
  captionLink: {
    ...ye.captionLink
  }
}, en = {
  heading2xl: {
    mobile: ye.heading2xl,
    desktop: sr.heading2xl
  },
  headingXl: {
    desktop: sr.headingXl,
    mobile: ye.headingXl
  },
  headingLg: {
    desktop: sr.headingLg,
    mobile: ye.headingLg
  },
  headingMd: {
    desktop: sr.headingMd,
    mobile: ye.headingMd
  },
  bodyBase: {
    desktop: sr.bodyBase,
    mobile: ye.bodyBase
  },
  bodySmall: {
    desktop: sr.bodySmall,
    mobile: ye.bodySmall
  },
  labelButton: {
    desktop: sr.labelButton,
    mobile: ye.labelButton
  },
  labelDefault: {
    desktop: sr.labelDefault,
    mobile: ye.labelDefault
  },
  captionDefault: {
    desktop: sr.captionDefault,
    mobile: ye.captionDefault
  },
  captionLink: {
    desktop: sr.captionLink,
    mobile: ye.captionLink
  }
}, Tt = (e) => e.length == 7 ? {
  r: parseInt(e.slice(1, 3), 16),
  g: parseInt(e.slice(3, 5), 16),
  b: parseInt(e.slice(5, 7), 16)
} : e.length == 4 ? {
  r: parseInt(e[1], 16),
  g: parseInt(e[2], 16),
  b: parseInt(e[3], 16)
} : null, Tn = ({
  r: e,
  g: r,
  b: t,
  luminanceThreshold: a
}) => {
  const n = (i) => (i = i / 255, i <= 0.03928 ? i / 12.92 : Math.pow((i + 0.055) / 1.055, 2.4));
  return 0.2126 * n(e) + 0.7152 * n(r) + 0.0722 * n(t) > a;
}, In = 0.37, Pp = (e, r = In) => {
  const t = Tn({ ...e, luminanceThreshold: r }) ? "0,0,0" : "255,255,255";
  return {
    "grey-text-dark": `rgb(${t})`,
    "grey-text-light": `rgba(${t},0.70)`,
    "grey-ui-dark": `rgba(${t},0.3)`,
    "grey-ui-light": `rgba(${t},0.1)`
  };
};
function Sp(e, r, t) {
  const a = Tt(e) || { r: 0, g: 0, b: 0 }, n = Tt(r) || { r: 255, g: 255, b: 255 }, o = Math.round(n.r * t + a.r * (1 - t)), i = Math.round(n.g * t + a.g * (1 - t)), s = Math.round(n.b * t + a.b * (1 - t));
  return `#${za(o)}${za(i)}${za(s)}`;
}
function ko(e, r) {
  const t = { r: 255, g: 255, b: 255 }, a = Math.max(0, Math.min(1, r));
  let n = e, o = Tt(e) || t;
  (isNaN(o.r) || isNaN(o.g) || isNaN(o.b)) && (o = t, n = "#FFFFFF");
  const s = Tn({
    ...o,
    luminanceThreshold: In
  }) ? "#000000" : "#FFFFFF";
  return Sp(n, s, a);
}
function za(e) {
  return e.toString(16).padStart(2, "0").toUpperCase();
}
const Ep = (e, r, t, a = In) => {
  const n = {
    "grey-text-dark": t["grey-text-dark"],
    "grey-text-light": t["grey-text-light"],
    "grey-ui-dark": t["grey-ui-dark"],
    "grey-ui-light": t["grey-ui-light"],
    "primary-text": t["primary-text"]
  };
  if (e != null && e.startsWith("#")) {
    const o = Tt(e);
    o !== null && Object.assign(n, Pp(o));
  }
  if (r != null && r.startsWith("#")) {
    const o = Tt(r);
    o !== null && (n["primary-text"] = Tn({ ...o, luminanceThreshold: a }) ? "black" : "white");
  }
  return n;
}, Tp = (e) => ({
  "primary-hover": ko(e, 0.1),
  "primary-pressed": ko(e, 0.15)
}), Ip = (e, r) => e || r, qp = (e, r, t) => {
  const a = Object.entries(e).map(([n, o]) => [
    n,
    Ip(
      t ? t[o] : null,
      r[n]
    )
  ]);
  return Object.fromEntries(a);
}, Ci = (e, r, t) => {
  const a = qp(
    e,
    r,
    t
  );
  return t ? {
    ...r,
    ...a,
    ...Ep(
      a.background,
      a.primary,
      r
    ),
    ...Tp(a.primary)
  } : { ...r };
}, Fp = (e) => Ci(
  kp,
  hp,
  e
), Oi = (e) => Ci(
  vp,
  bp,
  e
), qn = (e) => {
  if (!e)
    return ho;
  switch (e.shapes) {
    case "rounded":
      return ji;
    case "rectangle":
      return wp;
    case "pill":
      return xp;
    default:
      return ho;
  }
}, ca = (e = "", r) => r.map(([t, a]) => `--rc-${e}-${t}: ${a}`).join("; "), Li = (e) => {
  const r = ca(
    "color",
    Object.entries(Fp(e))
  ), t = ca(
    "shape",
    Object.entries(qn(e))
  );
  return [r, t].join("; ");
}, zp = (e) => {
  const r = ca(
    "color",
    Object.entries(Oi(e))
  ), t = ca(
    "shape",
    Object.entries(qn(e))
  );
  return [r, t].join("; ");
}, Dp = (e = "", r, t) => Object.entries(r).flatMap(([a, { desktop: n, mobile: o }]) => {
  const i = `normal normal ${n.fontWeight} ${n.fontSize}/${n.lineHeight} ${la}`, s = `normal normal ${o.fontWeight} ${o.fontSize}/${o.lineHeight} ${la}`, l = `normal normal ${t == null ? void 0 : t.desktop.font_weight} ${t == null ? void 0 : t.desktop.font_size} ${vo}`, c = `normal normal ${t == null ? void 0 : t.mobile.font_weight} ${t == null ? void 0 : t.mobile.font_size} ${vo}`;
  return [
    `--rc-${e}-${a}-desktop: ${i}`,
    `--rc-${e}-${a}-mobile: ${s}`,
    `--rc-${e}-${a}-branded-desktop: ${t ? l : i}`,
    `--rc-${e}-${a}-branded-mobile: ${t ? c : s}`,
    `--rc-${e}-${a}-desktop-font-size: ${n.fontSize}`,
    `--rc-${e}-${a}-mobile-font-size: ${o.fontSize}`
  ];
}).join("; "), Ap = (e = "", r) => Object.entries(r).map(
  ([t, { mobile: a, desktop: n }]) => `--rc-${e}-${t}-mobile: ${a};  --rc-${e}-${t}-desktop: ${n};`
).join(" "), Mp = {
  outerPaddingTop: {
    mobile: "0.25rem",
    // 4px
    desktop: "clamp(1rem, 8.44vw, 7.5rem)"
    // 16px to 128px
  },
  outerPadding: {
    mobile: "clamp(1.3125rem, 5.6vw, 1.5rem)",
    // 21px to 24px
    desktop: "clamp(3rem, 6.44vw, 4.5rem)"
    // 48px to 72px
  },
  gapSmall: {
    mobile: "0.25rem",
    // 4px
    desktop: "0.5rem"
    // 8px
  },
  gapMedium: {
    mobile: "0.5rem",
    // 8px
    desktop: "0.75rem"
    // 12px
  },
  gapLarge: {
    mobile: "0.75rem",
    // 12px
    desktop: "1rem"
    // 16px
  },
  gapXLarge: {
    mobile: "1rem",
    // 16px
    desktop: "2rem"
    // 32px
  },
  gapXXLarge: {
    mobile: "1.25rem",
    // 20px
    desktop: "2.25rem"
    // 36px
  },
  gapXXXLarge: {
    mobile: "2.25rem",
    // 36px
    desktop: "5rem"
    // 80px
  },
  inputHeight: {
    // Only used with button
    // Inconsistent with design system
    // Should rely on padding spacings
    mobile: "3rem",
    // 48px
    desktop: "3rem"
    // 48px
  }
};
class It {
  constructor(r) {
    M(this, "brandingAppearance");
    r ? this.brandingAppearance = r : this.brandingAppearance = void 0;
  }
  get shape() {
    return qn(this.brandingAppearance);
  }
  get formColors() {
    return Oi(this.brandingAppearance);
  }
  get formStyleVars() {
    return zp(this.brandingAppearance);
  }
  get productInfoStyleVars() {
    return Li(this.brandingAppearance);
  }
  get spacing() {
    return Mp;
  }
  get textStyles() {
    return en;
  }
  getTextStyleVars(r) {
    return Dp("text", this.textStyles, r);
  }
  get spacingStyleVars() {
    return Ap("spacing", this.spacing);
  }
}
var rn = /* @__PURE__ */ ((e) => (e[e.ErrorLoadingStripe = 0] = "ErrorLoadingStripe", e[e.HandledFormError = 1] = "HandledFormError", e[e.UnhandledFormError = 2] = "UnhandledFormError", e))(rn || {});
class Xt {
  constructor(r, t, a) {
    this.code = r, this.gatewayErrorCode = t, this.message = a;
  }
}
const $r = class $r {
  /**
   * This function converts some particular locales to the ones that stripe supports.
   * Finally falls back to 'auto' if the initialLocale is not supported by stripe.
   * @param locale
   */
  static getStripeLocale(r) {
    if (["ca", "hi", "uk"].includes(r))
      return "auto";
    const a = {
      zh_Hans: "zh",
      zh_Hant: "zh"
    };
    return Object.keys(a).includes(r) ? a[r] : r;
  }
  static async initializeStripe(r, t, a, n, o, i, s) {
    const { loadStripe: l } = await import("./index-DuKHkfLn.js");
    if (!t || !r || !a)
      throw {
        code: 0,
        gatewayErrorCode: void 0,
        message: "Stripe configuration is missing"
      };
    const c = await l(t, {
      stripeAccount: r
    }).catch((h) => {
      throw this.mapInitializationError(h);
    });
    if (!c)
      throw {
        code: 0,
        gatewayErrorCode: void 0,
        message: "Stripe client not found"
      };
    const p = new It(n == null ? void 0 : n.appearance), u = p.shape, _ = p.formColors, g = p.textStyles, m = en.bodyBase[s].fontSize || en.bodyBase.mobile.fontSize;
    let f;
    try {
      f = c.elements({
        mode: a.mode,
        paymentMethodTypes: a.payment_method_types,
        setupFutureUsage: a.setup_future_usage,
        amount: a.amount,
        currency: a.currency,
        loader: "always",
        locale: o,
        appearance: {
          theme: "stripe",
          labels: "floating",
          variables: {
            borderRadius: u["input-border-radius"],
            focusBoxShadow: "none",
            colorDanger: _.error,
            colorTextPlaceholder: _["grey-text-light"],
            colorText: _["grey-text-dark"],
            colorTextSecondary: _["grey-text-light"],
            fontSizeBase: m,
            ...i
          },
          rules: {
            ".Input": {
              boxShadow: "none",
              paddingTop: "6px",
              paddingBottom: "6px",
              fontSize: m,
              border: `1px solid ${_["grey-ui-dark"]}`,
              backgroundColor: _["input-background"],
              color: _["grey-text-dark"]
            },
            ".Input:focus": {
              border: `1px solid ${_.focus}`,
              outline: "none"
            },
            ".Label": {
              fontWeight: g.labelDefault[s].fontWeight,
              lineHeight: "22px",
              color: _["grey-text-dark"]
            },
            ".Label--floating": {
              opacity: "1"
            },
            ".Input--invalid": {
              boxShadow: "none"
            }
          }
        }
      });
    } catch (h) {
      throw this.mapInitializationError(h);
    }
    return { stripe: c, elements: f };
  }
  static async updateElementsConfiguration(r, t) {
    r.update({
      mode: t.mode,
      paymentMethodTypes: t.payment_method_types,
      setupFutureUsage: t.setup_future_usage,
      amount: t.amount,
      currency: t.currency
    });
  }
  static isStripeHandledFormError(r) {
    const t = r.type === "validation_error", a = r.type === "card_error" && r.code && this.FORM_VALIDATED_CARD_ERROR_CODES.includes(r.code);
    return t || a;
  }
  static createPaymentElement(r, t) {
    return r.create("payment", {
      business: t ? { name: t } : void 0,
      layout: {
        type: "tabs"
      },
      terms: {
        applePay: "never",
        auBecsDebit: "never",
        bancontact: "never",
        card: "never",
        cashapp: "never",
        googlePay: "never",
        ideal: "never",
        paypal: "never",
        sepaDebit: "never",
        sofort: "never",
        usBankAccount: "never"
      }
    });
  }
  static createExpressCheckoutElement(r, t, a) {
    const n = {
      billingAddressRequired: t,
      emailRequired: !0,
      ...a || {}
    };
    return r.create("expressCheckout", n);
  }
  static createLinkAuthenticationElement(r, t) {
    return r.create("linkAuthentication", {
      defaultValues: {
        email: t ?? ""
      }
    });
  }
  static async submitElements(r) {
    const { error: t } = await r.submit();
    if (t)
      throw this.mapError(t);
  }
  static mapInitializationError(r) {
    return new Xt(
      0,
      r.code,
      r.message
    );
  }
  static mapError(r) {
    return this.isStripeHandledFormError(r) ? new Xt(
      1,
      r.code,
      r.message
    ) : new Xt(
      2,
      r.code,
      r.message
    );
  }
  static async confirmElements(r, t, a, n) {
    const o = {
      clientSecret: a,
      redirect: "if_required"
    }, i = n ? {
      ...o,
      confirmParams: { confirmation_token: n }
    } : {
      ...o,
      elements: t
    }, s = a.startsWith("seti_");
    let l;
    if (s ? l = await r.confirmSetup(i) : l = await r.confirmPayment(i), l != null && l.error)
      throw this.mapError(l.error);
  }
  static async extractTaxCustomerDetails(r, t) {
    var i, s;
    const { error: a, confirmationToken: n } = await t.createConfirmationToken({
      elements: r
    });
    if (a)
      throw this.mapError(a);
    const o = (s = (i = n.payment_method_preview) == null ? void 0 : i.billing_details) == null ? void 0 : s.address;
    return {
      customerDetails: {
        countryCode: (o == null ? void 0 : o.country) ?? void 0,
        postalCode: (o == null ? void 0 : o.postal_code) ?? void 0
      },
      confirmationTokenId: n.id
    };
  }
  static nextDateForPeriod(r, t) {
    return r.unit === xe.Year ? (t.setFullYear(t.getFullYear() + r.number), t) : r.unit === xe.Month ? (t.setMonth(t.getMonth() + r.number), t) : r.unit === xe.Week ? (t.setDate(t.getDate() + r.number * 7), t) : (r.unit === xe.Day && t.setDate(t.getDate() + r.number), t);
  }
  static applePayPeriod(r) {
    return r.unit === xe.Week ? {
      recurringPaymentIntervalUnit: "day",
      recurringPaymentIntervalCount: r.number * 7
    } : {
      recurringPaymentIntervalUnit: r.unit,
      recurringPaymentIntervalCount: r.number
    };
  }
  // https://docs.stripe.com/js/elements_object/create_without_intent#stripe_elements_no_intent-options-amount
  static microsToMinimumAmountPrice(r, t) {
    return [
      "BIF",
      "CLP",
      "DJF",
      "GNF",
      "JPY",
      "KMF",
      "KRW",
      "MGA",
      "PYG",
      "RWF",
      "UGX",
      "VND",
      "VUV",
      "XAF",
      "XOF",
      "XPF"
    ].includes(t) ? Math.floor(r / 1e6) : Math.floor(r / 1e4);
  }
  static buildStripeExpressCheckoutOptionsForSubscription(r, t, a, n, o) {
    var _;
    const i = $r.microsToMinimumAmountPrice(
      t.totalAmountInMicros,
      t.currency
    ), s = a.trial, l = (_ = a.trial) == null ? void 0 : _.period, c = a.base.period, p = s && l ? $r.nextDateForPeriod(l, /* @__PURE__ */ new Date()) : void 0, u = c ? $r.applePayPeriod(c) : {};
    return {
      applePay: {
        recurringPaymentRequest: {
          paymentDescription: r.title,
          managementURL: o,
          trialBilling: s ? {
            label: n.translate(L.ApplePayFreeTrial),
            amount: 0
          } : void 0,
          regularBilling: {
            label: r.title,
            amount: i,
            recurringPaymentStartDate: p,
            ...u
          }
        }
      }
    };
  }
};
M($r, "FORM_VALIDATED_CARD_ERROR_CODES", [
  "card_declined",
  "expired_card",
  "incorrect_cvc",
  "incorrect_number"
]);
let ve = $r;
var jp = /* @__PURE__ */ I("<div></div>");
function Np(e, r) {
  V(r, !0);
  let t = null;
  const a = "payment-element", n = async (i) => {
    await r.onError(ve.mapInitializationError(i.error));
  };
  We(() => {
    var i;
    try {
      t = ve.createPaymentElement(r.elements, (i = r.brandingInfo) == null ? void 0 : i.app_name), t.mount(`#${a}`), t.on("ready", r.onReady), t.on("change", r.onChange), t.on("loaderror", n);
    } catch (s) {
      r.onError(ve.mapInitializationError(s));
    }
  }), Nt(() => {
    t == null || t.destroy(), t = null;
  });
  var o = jp();
  j(o, "id", a), b(e, o), H();
}
var Cp = /* @__PURE__ */ I("<div></div>");
function Op(e, r) {
  V(r, !0);
  let t = null;
  const a = "link-authentication-element", n = async (i) => {
    await r.onError(ve.mapInitializationError(i.error));
  };
  We(() => {
    try {
      t = ve.createLinkAuthenticationElement(r.elements, r.email), t.mount(`#${a}`), t.on("ready", r.onReady), t.on("change", r.onChange), t.on("loaderror", n);
    } catch (i) {
      r.onError(ve.mapInitializationError(i));
    }
  }), Nt(() => {
    t == null || t.destroy(), t = null;
  });
  var o = Cp();
  j(o, "id", a), b(e, o), H();
}
var Lp = /* @__PURE__ */ I('<div class="text-separator svelte-ch0h61"><hr class="line svelte-ch0h61"> <span class="text svelte-ch0h61"><!></span> <hr class="line svelte-ch0h61"></div>');
const Bp = {
  hash: "svelte-ch0h61",
  code: `.text-separator.svelte-ch0h61 {display:flex;align-items:center;justify-content:center;gap:var(--rc-spacing-gapSmall-mobile);}

  @container layout-query-container (width >= 768px) {.text-separator.svelte-ch0h61 {gap:var(--rc-spacing-gapSmall-desktop);}
  }.line.svelte-ch0h61 {flex:1;height:1px;background-color:var(--rc-color-grey-ui-dark);border:none;}.text.svelte-ch0h61 {color:var(--rc-color-grey-text-light);text-transform:uppercase;white-space:nowrap;}`
};
function Rp(e, r) {
  R(e, Bp);
  let t = U(r, "text", 8);
  var a = Lp(), n = O(P(a), 2), o = P(n);
  se(o, {
    size: "caption-default",
    children: (i, s) => {
      var l = ie();
      A(() => te(l, t())), b(i, l);
    },
    $$slots: { default: !0 }
  }), b(e, a);
}
var Up = /* @__PURE__ */ I("<div></div> <!>", 1);
function Vp(e, r) {
  V(r, !0);
  const t = De(), a = () => ze(n, "$translator", t), n = Ee(Ne);
  let o = null, i = X(!1);
  const s = "express-checkout-element", l = async (f) => {
    const h = {
      ...r.expressCheckoutOptions ? r.expressCheckoutOptions : {}
    };
    f.resolve(h);
  }, c = async (f) => {
    await r.onError(ve.mapInitializationError(f.error));
  }, p = async (f) => {
    var h;
    r.onSubmit(f.expressPaymentType, ((h = f.billingDetails) == null ? void 0 : h.email) ?? "");
  }, u = async (f) => {
    D(i, !f.availablePaymentMethods), r.onReady();
  };
  We(() => {
    try {
      o = ve.createExpressCheckoutElement(r.elements, r.billingAddressRequired, r.expressCheckoutOptions), o.mount(`#${s}`), o.on("ready", u), o.on("confirm", p), o.on("loaderror", c), o.on("click", l);
    } catch (f) {
      r.onError(ve.mapInitializationError(f));
    }
  }), Nt(() => {
    o == null || o.destroy(), o = null;
  });
  var _ = ee(), g = Y(_);
  {
    var m = (f) => {
      var h = Up(), v = Y(h);
      j(v, "id", s);
      var y = O(v, 2), x = /* @__PURE__ */ E(() => a().translate(L.PaymentEntryPageExpressCheckoutDivider));
      Rp(y, {
        get text() {
          return d(x);
        }
      }), b(f, h);
    };
    N(g, (f) => {
      d(i) || f(m);
    });
  }
  b(e, _), H();
}
var Hp = /* @__PURE__ */ I('<div class="rc-elements svelte-6qa1vy"><!> <!> <!></div>');
const Wp = {
  hash: "svelte-6qa1vy",
  code: `.rc-elements.svelte-6qa1vy {display:flex;flex-direction:column;gap:var(--rc-spacing-gapXLarge-mobile);}

  @container layout-query-container (width >= 768px) {.rc-elements.svelte-6qa1vy {gap:var(--rc-spacing-gapLarge-desktop);}
  }`
};
function Yp(e, r) {
  V(r, !0), R(e, Wp);
  const t = De(), a = () => ze(i, "$translator", t);
  let n = U(r, "stripe", 15, null), o = U(r, "elements", 15, null);
  const i = Ee(Ne), s = ve.getStripeLocale(a().locale || a().fallbackLocale);
  let l = X(!1), c = X(B(r.skipEmail)), p = X(!1), u = X(void 0), _ = X("mobile"), g = X(void 0);
  function m() {
    window.matchMedia && window.matchMedia("(max-width: 767px)").matches ? D(_, "mobile") : D(_, "desktop"), D(u, B({
      // Floating labels size cannot be overriden in Stripe since `!important` is being used.
      // There we set fontSizeBase to the desired label size
      // and update the input font size to 16px.
      fontSizeBase: "14px",
      fontFamily: la,
      // Spacing is hardcoded to 16px to match the desired gaps in mobile/desktop
      // which do not match the design system spacing. Also we cannot use "rem" units
      // since the fontSizeBase is set to 14px per the comment above.
      spacingGridRow: "16px"
    }));
  }
  function f() {
    clearTimeout(d(g)), D(g, B(setTimeout(
      () => {
        m();
      },
      150
    )));
  }
  const h = (w) => {
    r.onError(w), r.onLoadingComplete();
  }, v = async () => {
    d(c) || (D(c, !0), d(c) && d(l) && d(p) && r.onLoadingComplete());
  }, y = async () => {
    d(p) || (D(p, !0), d(c) && d(l) && d(p) && r.onLoadingComplete());
  }, x = async () => {
    d(l) || (D(l, !0), d(c) && d(l) && d(p) && r.onLoadingComplete());
  }, T = async (w) => {
    r.onPaymentInfoChange({
      complete: w.complete,
      paymentMethod: w.complete ? w.value.type : void 0
    });
  }, S = async (w) => {
    r.onEmailChange(w.complete, w.value.email);
  };
  We(() => (window.addEventListener("resize", f), () => {
    window.removeEventListener("resize", f);
  })), We(async () => {
    m(), !n() && (o() || !r.stripeAccountId || !r.publishableApiKey || !r.elementsConfiguration || await ve.initializeStripe(r.stripeAccountId, r.publishableApiKey, r.elementsConfiguration, r.brandingInfo, s, d(u), d(_)).then(({
      stripe: w,
      elements: q
    }) => {
      n(w), o(q);
    }).catch((w) => {
      r.onError(w);
    }));
  }), at(() => {
    r.elementsConfiguration && o() && ve.updateElementsConfiguration(o(), r.elementsConfiguration);
  });
  var z = ee(), C = Y(z);
  {
    var k = (w) => {
      var q = Hp(), G = P(q);
      Vp(G, {
        get elements() {
          return o();
        },
        onError: h,
        onReady: y,
        get onSubmit() {
          return r.onExpressCheckoutElementSubmit;
        },
        get expressCheckoutOptions() {
          return r.expressCheckoutOptions;
        },
        get billingAddressRequired() {
          return r.billingAddressRequired;
        }
      });
      var W = O(G, 2);
      {
        var ae = (re) => {
          Op(re, {
            get elements() {
              return o();
            },
            onReady: v,
            onChange: S,
            onError: h
          });
        };
        N(W, (re) => {
          r.skipEmail || re(ae);
        });
      }
      var J = O(W, 2);
      Np(J, {
        get elements() {
          return o();
        },
        get brandingInfo() {
          return r.brandingInfo;
        },
        onReady: x,
        onChange: T,
        onError: h
      }), b(w, q);
    };
    N(C, (w) => {
      o() && w(k);
    });
  }
  b(e, z), H();
}
const Gp = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
  <path fill-rule="evenodd" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 6.5a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm1.25 4.5a1.25 1.25 0 10-2.5 0v4.5a1.25 1.25 0 102.5 0v-4.5z" clip-rule="evenodd" />
</svg> `;
var Xp = /* @__PURE__ */ I('<div class="rcb-ui-asset-icon svelte-1rk57mx"><!></div>');
const Zp = {
  hash: "svelte-1rk57mx",
  code: ".rcb-ui-asset-icon.svelte-1rk57mx {display:inline-block;width:1em;height:1em;}"
};
function Bi(e) {
  R(e, Zp);
  var r = Xp(), t = P(r);
  Wr(t, () => Gp), b(e, r);
}
var Kp = /* @__PURE__ */ I('<div class="rcb-info svelte-1czikbr"><div class="rcb-info-icon-wrapper svelte-1czikbr"><!></div> <div class="rcb-info-content svelte-1czikbr"><div class="rcb-info-title svelte-1czikbr"><!></div> <div class="rcb-info-message svelte-1czikbr"><!></div></div></div>');
const Jp = {
  hash: "svelte-1czikbr",
  code: `.rcb-info.svelte-1czikbr {display:flex;align-items:flex-start;background-color:var(--rc-color-grey-ui-light);border-radius:var(--rc-shape-input-border-radius);gap:var(--rc-spacing-gapLarge-mobile);padding:var(--rc-spacing-gapLarge-mobile);}.rcb-info-content.svelte-1czikbr {flex:1;}.rcb-info-icon-wrapper.svelte-1czikbr {flex-shrink:0;color:var(--rc-color-accent-primary);}.rcb-info-title.svelte-1czikbr {color:var(--rc-color-grey-text-dark);margin-bottom:var(--rc-spacing-gapSmall-mobile);display:flex;}.rcb-info-message.svelte-1czikbr {color:var(--rc-color-grey-text-light);}

  @container layout-query-container (width >= 768px) {.rcb-info.svelte-1czikbr {gap:var(--rc-spacing-gapLarge-desktop);padding:var(--rc-spacing-gapLarge-desktop);}.rcb-info-title.svelte-1czikbr {margin-bottom:var(--rc-spacing-gapSmall-desktop);}
  }`
};
function Qp(e, r) {
  R(e, Jp);
  var t = Kp(), a = P(t), n = P(a);
  Bi(n);
  var o = O(a, 2), i = P(o), s = P(i);
  se(s, {
    size: "body-small",
    children: (p, u) => {
      var _ = ie();
      A(() => te(_, r.title)), b(p, _);
    },
    $$slots: { default: !0 }
  });
  var l = O(i, 2), c = P(l);
  se(c, {
    size: "body-small",
    children: (p, u) => {
      var _ = ie();
      A(() => te(_, r.message)), b(p, _);
    },
    $$slots: { default: !0 }
  }), b(e, t);
}
function $p(e, r) {
  V(r, !0);
  const t = De(), a = () => ze(n, "$translator", t), n = Ee(Ne);
  var o = /* @__PURE__ */ E(() => a().translate(L.PriceUpdateTitle)), i = /* @__PURE__ */ E(() => {
    var s;
    return a().translate((s = r.subscriptionOption) != null && s.trial ? L.PriceUpdateTrialMessage : L.PriceUpdateBaseMessage);
  });
  Qp(e, {
    get title() {
      return d(o);
    },
    get message() {
      return d(i);
    }
  }), H();
}
class wo extends Error {
}
var e_ = /* @__PURE__ */ I('<div class="rc-loading svelte-dg9m6p"><!></div>'), r_ = /* @__PURE__ */ I('<div class="rc-checkout-container svelte-dg9m6p"><!> <!> <form data-testid="payment-form" class="rc-checkout-form svelte-dg9m6p"><div class="rc-checkout-form-container svelte-dg9m6p"><div class="rc-elements-container svelte-dg9m6p"><!></div> <div class="rc-checkout-price-update-info-container svelte-dg9m6p"><!></div> <div class="rc-checkout-pay-container svelte-dg9m6p"><!> <div class="rc-checkout-secure-container svelte-dg9m6p"><!></div></div></div></form></div>');
const t_ = {
  hash: "svelte-dg9m6p",
  code: `.rc-checkout-secure-container.svelte-dg9m6p {margin-top:var(--rc-spacing-gapXLarge-mobile);}.rc-checkout-container.svelte-dg9m6p {display:flex;flex-direction:column;gap:var(--rc-spacing-gapXLarge-mobile);user-select:none;position:relative;}.rc-checkout-price-update-info-container.svelte-dg9m6p {margin-top:var(--rc-spacing-gapXLarge-mobile);}.fully-hidden.svelte-dg9m6p {display:none;height:0;}.rc-checkout-pay-container.svelte-dg9m6p {display:flex;flex-direction:column;margin-top:var(--rc-spacing-gapXLarge-mobile);}.rc-checkout-pay-container.fully-hidden.svelte-dg9m6p {display:none;}.rc-checkout-form-container.svelte-dg9m6p {width:100%;}.rc-elements-container.svelte-dg9m6p {
    /* The standard height of the payment form from Stripe */
    /* Added to avoid the card getting smaller while loading */min-height:210px;}.rc-checkout-form-container.invisible.svelte-dg9m6p {visibility:hidden;}.rc-loading.svelte-dg9m6p {width:100%;height:100%;display:flex;justify-content:center;align-items:center;}

  @container layout-query-container (width <= 767px) {.rc-checkout-pay-container.svelte-dg9m6p {flex-grow:1;justify-content:flex-end;}.rc-checkout-form.svelte-dg9m6p {flex-grow:1;}.rc-checkout-form-container.svelte-dg9m6p {height:100%;display:flex;flex-direction:column;}.rc-checkout-container.svelte-dg9m6p {flex-grow:1;}.rc-loading.svelte-dg9m6p {position:absolute;top:0;left:0;}
  }

  @container layout-query-container (width >= 768px) {.rc-checkout-secure-container.svelte-dg9m6p {margin-top:var(--rc-spacing-gapXLarge-desktop);}.rc-checkout-container.svelte-dg9m6p {gap:var(--rc-spacing-gapXLarge-desktop);}.rc-checkout-pay-container.svelte-dg9m6p {margin-top:var(--rc-spacing-gapXLarge-desktop);}.rc-checkout-price-update-info-container.svelte-dg9m6p {margin-top:var(--rc-spacing-gapXLarge-desktop);}
  }form.svelte-dg9m6p {display:flex;flex-direction:column;flex-grow:1;}`
};
function a_(e, r) {
  var jn, Nn, Cn;
  V(r, !0), R(e, t_);
  const t = De(), a = () => ze(o, "$translator", t), n = Ee(xn), o = Ee(Ne), i = (jn = r.productDetails.subscriptionOptions) == null ? void 0 : jn[r.purchaseOption.id];
  let s = X(B(((Nn = r.defaultPriceBreakdown) == null ? void 0 : Nn.taxCalculationStatus) ?? ((Cn = r.brandingInfo) != null && Cn.gateway_tax_collection_enabled ? "unavailable" : "disabled"))), l = X(null), c = X(null), p = X(B(r.productDetails.currentPrice.amountMicros)), u = X(B(r.productDetails.currentPrice.amountMicros)), _ = /* @__PURE__ */ E(() => r.defaultPriceBreakdown ?? {
    currency: r.productDetails.currentPrice.currency,
    totalAmountInMicros: d(u),
    totalExcludingTaxInMicros: d(p),
    taxCalculationStatus: d(s),
    taxAmountInMicros: d(l),
    taxBreakdown: d(c)
  }), g = X(B(r.gatewayParams.elements_configuration)), m = X(null), f = X(null), h = X(null), v = X(B(r.customerEmail ?? void 0)), y = X(B(!!r.customerEmail)), x = X(!0), T = X(!1), S = X(void 0), z = X(void 0), C = X(void 0), k = X(!1), w = X(null), q = /* @__PURE__ */ E(() => d(x) || d(k) ? "loading" : d(z) ? "error" : "form"), G = X("unavailable"), W = /* @__PURE__ */ E(() => !d(k) && d(T) && d(y) && (d(s) === "disabled" || d(s) === "calculated" || d(s) === "miss-match")), ae = /* @__PURE__ */ E(() => i && r.managementUrl && d(_) ? ve.buildStripeExpressCheckoutOptionsForSubscription(r.productDetails, d(_), i, a(), r.managementUrl) : void 0);
  at(() => {
    r.onPriceBreakdownUpdated(d(_));
  }), We(async () => {
    d(s) === "unavailable" && await J(null).catch(Xe);
  }), Nt(() => {
    d(w) && (d(w).abort(), D(w, null));
  });
  async function J(F, Q) {
    await r.purchaseOperationHelper.checkoutCalculateTax(F == null ? void 0 : F.countryCode, F == null ? void 0 : F.postalCode, Q).then((ue) => {
      const jr = lp({ taxCalculation: ue, taxCustomerDetails: F });
      n.trackSDKEvent(jr), Q == null || Q.throwIfAborted(), ue.failed_reason ? !F && ue.failed_reason === En.invalid_tax_location ? D(s, "pending") : D(s, "disabled") : D(s, "calculated"), D(l, B(ue.tax_amount_in_micros)), D(p, B(ue.total_excluding_tax_in_micros)), D(u, B(ue.total_amount_in_micros)), D(c, B(ue.pricing_phases.base.tax_breakdown)), D(g, B(ue.gateway_params.elements_configuration)), D(m, B(F));
    });
  }
  function re() {
    n.trackSDKEvent({
      eventName: Fe.CheckoutPaymentFormImpression
    }), D(x, !1);
  }
  async function pe(F, Q) {
    D(v, B(Q)), D(y, B(F)), await Pe();
  }
  async function me({ complete: F, paymentMethod: Q }) {
    D(S, B(Q)), D(T, B(F)), await Pe();
  }
  async function ce(F) {
    if (F == null || F.preventDefault(), d(k)) return;
    const Q = cp({
      selectedPaymentMethod: d(S) ?? null
    });
    n.trackSDKEvent(Q), D(k, !0), await vr() ? r.onContinue() : D(k, !1);
  }
  async function ke(F, Q) {
    D(S, B(F)), D(v, B(Q)), await ce();
  }
  async function Pe() {
    d(S) !== "card" || !d(y) || !d(T) || d(k) || d(s) === "disabled" || (d(s) !== "loading" && (D(G, B(d(s))), D(s, "loading")), await _r(async (F) => {
      await Ge().then(() => F.throwIfAborted()).then(() => Oe(F)).then(() => F.throwIfAborted()).catch((Q) => {
        F.aborted || Xe(Q);
      }).finally(() => {
        d(s) === "loading" && !F.aborted && D(s, B(d(G)));
      });
    }));
  }
  async function vr() {
    return await _r(async (F) => {
      const Q = d(u);
      let ue;
      return await Ge().then(() => F.throwIfAborted()).then(() => Oe(F)).then((jr) => {
        ue = jr;
      }).then(() => F.throwIfAborted()).then(kr(Q)).then(() => F.throwIfAborted()).then($e).then(() => F.throwIfAborted()).then(() => wr(ue)).then(() => F.throwIfAborted()).then(() => !0).catch((jr) => (F.aborted || Xe(jr), !1));
    });
  }
  async function _r(F) {
    d(w) && d(w).abort(), D(w, B(new AbortController()));
    const Q = d(w).signal;
    try {
      return await F(Q);
    } catch (ue) {
      if (ue instanceof DOMException && ue.name === "AbortError")
        return Promise.resolve(void 0);
      throw ue;
    }
  }
  async function Ge() {
    d(h) && await ve.submitElements(d(h));
  }
  async function Oe(F) {
    var Nr, _t;
    if (d(s) === "unavailable" || d(s) === "disabled" || !d(h) || !d(f))
      return;
    const {
      customerDetails: Q,
      confirmationTokenId: ue
    } = await ve.extractTaxCustomerDetails(d(h), d(f));
    return F == null || F.throwIfAborted(), Q.postalCode === ((Nr = d(m)) == null ? void 0 : Nr.postalCode) && Q.countryCode === ((_t = d(m)) == null ? void 0 : _t.countryCode) || await J(Q, F), ue && d(S) !== "card" ? ue : void 0;
  }
  function kr(F) {
    return () => {
      if (d(u) !== F)
        throw new wo();
    };
  }
  async function $e() {
    var ue;
    const F = await r.purchaseOperationHelper.checkoutComplete(d(v)), Q = (ue = F == null ? void 0 : F.gateway_params) == null ? void 0 : ue.client_secret;
    Q && D(C, B(Q));
  }
  async function wr(F) {
    !d(f) || !d(h) || !d(C) || await ve.confirmElements(d(f), d(h), d(C), F);
  }
  async function Xe(F) {
    if (F instanceof wo)
      D(s, "miss-match");
    else if (F instanceof de) {
      const Q = ap({
        errorCode: F.errorCode.toString(),
        errorMessage: F.message
      });
      n.trackSDKEvent(Q), F.errorCode === oe.MissingEmailError ? D(z, B(a().translate(L.ErrorPageErrorMessageInvalidEmailError, { email: d(v) }))) : r.onError(F);
    } else if (F instanceof Xt)
      await Yr(F);
    else
      throw F;
  }
  async function Yr(F) {
    const Q = dp({
      errorCode: F.gatewayErrorCode ?? "",
      errorMessage: F.message ?? ""
    });
    n.trackSDKEvent(Q), F.code === rn.HandledFormError || (F.code === rn.UnhandledFormError ? D(z, B(F.message)) : r.onError(new de(oe.ErrorSettingUpPurchase, "Failed to initialize payment form", F.message)));
  }
  const Lt = () => {
    D(z, void 0);
  };
  var xr = r_(), pt = P(xr);
  {
    var Bt = (F) => {
      var Q = e_(), ue = P(Q);
      Ai(ue), b(F, Q);
    };
    N(pt, (F) => {
      d(q) === "loading" && F(Bt);
    });
  }
  var Rt = O(pt, 2);
  {
    var wa = (F) => {
      var Q = /* @__PURE__ */ E(() => a().translate(L.ErrorButtonTryAgain));
      Sn(F, {
        title: null,
        type: "error",
        get closeButtonTitle() {
          return d(Q);
        },
        onDismiss: Lt,
        icon: (Nr) => {
          yi(Nr);
        },
        message: (Nr) => {
          var _t = ie();
          A(() => te(_t, d(z))), b(Nr, _t);
        },
        $$slots: { icon: !0, message: !0 }
      });
    };
    N(Rt, (F) => {
      d(q) === "error" && F(wa);
    });
  }
  var Ut = O(Rt, 2), Gr = P(Ut), Vt = P(Gr), Mr = P(Vt), cs = /* @__PURE__ */ E(() => !!r.customerEmail), ds = /* @__PURE__ */ E(() => d(s) !== "disabled");
  Yp(Mr, {
    get stripeAccountId() {
      return r.gatewayParams.stripe_account_id;
    },
    get publishableApiKey() {
      return r.gatewayParams.publishable_api_key;
    },
    get elementsConfiguration() {
      return d(g);
    },
    get brandingInfo() {
      return r.brandingInfo;
    },
    get skipEmail() {
      return d(cs);
    },
    get billingAddressRequired() {
      return d(ds);
    },
    onLoadingComplete: re,
    onError: Yr,
    onEmailChange: pe,
    onPaymentInfoChange: me,
    onExpressCheckoutElementSubmit: ke,
    get expressCheckoutOptions() {
      return d(ae);
    },
    get stripe() {
      return d(f);
    },
    set stripe(F) {
      D(f, B(F));
    },
    get elements() {
      return d(h);
    },
    set elements(F) {
      D(h, B(F));
    }
  });
  var xa = O(Vt, 2), us = P(xa);
  $p(us, { subscriptionOption: i });
  var An = O(xa, 2), Mn = P(An), ps = /* @__PURE__ */ E(() => !d(W)), _s = /* @__PURE__ */ E(() => {
    var F;
    return (F = r.brandingInfo) != null && F.gateway_tax_collection_enabled ? d(_) : void 0;
  });
  yp(Mn, {
    get disabled() {
      return d(ps);
    },
    subscriptionOption: i,
    get priceBreakdown() {
      return d(_s);
    }
  });
  var gs = O(Mn, 2), ms = P(gs);
  rp(ms, {
    get brandingInfo() {
      return r.brandingInfo;
    },
    subscriptionOption: i
  }), A(() => {
    fr(Gr, "invisible", d(q) !== "form"), fr(xa, "fully-hidden", d(s) !== "miss-match" || d(q) !== "form"), fr(An, "fully-hidden", d(q) !== "form");
  }), nt("submit", Ut, ce), b(e, xr), H();
}
function n_(e) {
  return e != null;
}
var o_ = /* @__PURE__ */ ((e) => (e.Unknown = "unknown", e.Custom = "custom", e.Lifetime = "$rc_lifetime", e.Annual = "$rc_annual", e.SixMonth = "$rc_six_month", e.ThreeMonth = "$rc_three_month", e.TwoMonth = "$rc_two_month", e.Monthly = "$rc_monthly", e.Weekly = "$rc_weekly", e))(o_ || {}), Lr = /* @__PURE__ */ ((e) => (e.Subscription = "subscription", e.Consumable = "consumable", e.NonConsumable = "non_consumable", e))(Lr || {});
const Ri = (e) => ({
  amount: e.amount_micros / 1e4,
  amountMicros: e.amount_micros,
  currency: e.currency,
  formattedPrice: Ir(e.amount_micros, e.currency)
}), xo = (e) => {
  const r = e.period_duration, t = e.price ? Ri(e.price) : null, a = r ? mi(r) : null;
  let n = null, o = null, i = null;
  if (t !== null && a !== null) {
    const s = i_(a), l = 1e4, c = Math.round(t.amountMicros * s.toWeek);
    n = {
      amount: c / l,
      amountMicros: c,
      currency: t.currency,
      formattedPrice: Ir(c, t.currency)
    };
    const p = Math.round(t.amountMicros * s.toMonth);
    o = {
      amount: p / l,
      amountMicros: p,
      currency: t.currency,
      formattedPrice: Ir(p, t.currency)
    };
    const u = Math.round(t.amountMicros * s.toYear);
    i = {
      amount: u / l,
      amountMicros: u,
      currency: t.currency,
      formattedPrice: Ir(u, t.currency)
    };
  }
  return {
    periodDuration: r,
    period: a,
    cycleCount: e.cycle_count,
    price: t,
    pricePerWeek: n,
    pricePerMonth: o,
    pricePerYear: i
  };
};
function i_(e) {
  const { number: r, unit: t } = e, a = 7, n = 30, o = 365;
  let i;
  switch (t) {
    case xe.Day:
      i = r;
      break;
    case xe.Week:
      i = r * a;
      break;
    case xe.Month:
      i = r * n;
      break;
    case xe.Year:
      i = r * o;
      break;
    default:
      i = 0, K.errorLog(`Unknown period unit: ${t}`);
  }
  const s = i > 0 ? a / i : 0, l = i > 0 ? n / i : 0, c = i > 0 ? o / i : 0;
  return { toWeek: s, toMonth: l, toYear: c };
}
const s_ = (e) => e.base == null ? (K.debugLog("Missing base phase for subscription option. Ignoring."), null) : {
  id: e.id,
  priceId: e.price_id,
  base: xo(e.base),
  trial: e.trial ? xo(e.trial) : null
}, l_ = (e) => e.base_price == null ? (K.debugLog(
  "Missing base price for non-subscription option. Ignoring."
), null) : {
  id: e.id,
  priceId: e.price_id,
  basePrice: Ri(e.base_price)
}, c_ = (e, r) => {
  const t = e.product_type;
  return t === "subscription" ? u_(
    e,
    r,
    t
  ) : d_(
    e,
    r,
    t
  );
}, d_ = (e, r, t) => {
  const a = {};
  if (Object.entries(e.purchase_options).forEach(
    ([i, s]) => {
      const l = l_(
        s
      );
      l != null && (a[i] = l);
    }
  ), Object.keys(a).length === 0)
    return K.debugLog(
      `Product ${e.identifier} has no purchase options. Ignoring.`
    ), null;
  const n = e.default_purchase_option_id, o = n && n in e.purchase_options ? a[n] : null;
  return o == null ? (K.debugLog(
    `Product ${e.identifier} has no default purchase option. Ignoring.`
  ), null) : {
    identifier: e.identifier,
    displayName: e.title,
    title: e.title,
    description: e.description,
    productType: t,
    currentPrice: o.basePrice,
    normalPeriodDuration: null,
    presentedOfferingIdentifier: r.offeringIdentifier,
    presentedOfferingContext: r,
    defaultPurchaseOption: o,
    defaultSubscriptionOption: null,
    subscriptionOptions: {},
    defaultNonSubscriptionOption: o
  };
}, u_ = (e, r, t) => {
  const a = {};
  if (Object.entries(e.purchase_options).forEach(
    ([s, l]) => {
      const c = s_(l);
      c != null && (a[s] = c);
    }
  ), Object.keys(a).length === 0)
    return K.debugLog(
      `Product ${e.identifier} has no subscription options. Ignoring.`
    ), null;
  const n = e.default_purchase_option_id, o = n && n in a ? a[n] : null;
  if (o == null)
    return K.debugLog(
      `Product ${e.identifier} has no default subscription option. Ignoring.`
    ), null;
  const i = o.base.price;
  return i == null ? (K.debugLog(
    `Product ${e.identifier} default option has no base price. Ignoring.`
  ), null) : {
    identifier: e.identifier,
    displayName: e.title,
    title: e.title,
    description: e.description,
    productType: t,
    currentPrice: i,
    normalPeriodDuration: o.base.periodDuration,
    presentedOfferingIdentifier: r.offeringIdentifier,
    presentedOfferingContext: r,
    defaultPurchaseOption: o,
    defaultSubscriptionOption: o,
    subscriptionOptions: a,
    defaultNonSubscriptionOption: null
  };
}, p_ = (e, r, t) => {
  const a = t[r.platform_product_identifier];
  if (a === void 0) return null;
  const n = c_(a, e);
  return n === null ? null : {
    identifier: r.identifier,
    rcBillingProduct: n,
    webBillingProduct: n,
    packageType: g_(r.identifier)
  };
}, __ = (e, r, t, a) => {
  const n = {
    offeringIdentifier: r.identifier,
    targetingContext: e && a ? {
      ruleId: a.rule_id,
      revision: a.revision
    } : null,
    placementIdentifier: null
  }, o = r.packages.map(
    (s) => p_(n, s, t)
  ).filter(n_), i = {};
  for (const s of o)
    s != null && (i[s.identifier] = s);
  return o.length == 0 ? null : {
    identifier: r.identifier,
    serverDescription: r.description,
    metadata: r.metadata,
    packagesById: i,
    availablePackages: o,
    lifetime: i.$rc_lifetime ?? null,
    annual: i.$rc_annual ?? null,
    sixMonth: i.$rc_six_month ?? null,
    threeMonth: i.$rc_three_month ?? null,
    twoMonth: i.$rc_two_month ?? null,
    monthly: i.$rc_monthly ?? null,
    weekly: i.$rc_weekly ?? null,
    paywall_components: r.paywall_components ? r.paywall_components : null
  };
};
function g_(e) {
  switch (e) {
    case "$rc_lifetime":
      return "$rc_lifetime";
    case "$rc_annual":
      return "$rc_annual";
    case "$rc_six_month":
      return "$rc_six_month";
    case "$rc_three_month":
      return "$rc_three_month";
    case "$rc_two_month":
      return "$rc_two_month";
    case "$rc_monthly":
      return "$rc_monthly";
    case "$rc_weekly":
      return "$rc_weekly";
    default:
      return e.startsWith("$rc_") ? "unknown" : "custom";
  }
}
var m_ = /* @__PURE__ */ pr('<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.94 5.72656L8 8.7799L11.06 5.72656L12 6.66656L8 10.6666L4 6.66656L4.94 5.72656Z" class="arrow-fill svelte-1qexsu3" fill-opacity="0.7"></path></svg>');
const f_ = {
  hash: "svelte-1qexsu3",
  code: ".arrow.svelte-1qexsu3 {transition:transform 0.3s ease;}.arrow-fill.svelte-1qexsu3 {fill:var(--rc-color-grey-text-dark);}.arrow.left.svelte-1qexsu3 {transform:rotate(90deg);}.arrow.up.svelte-1qexsu3 {transform:rotate(180deg);}.arrow.right.svelte-1qexsu3 {transform:rotate(-90deg);}.arrow.down.svelte-1qexsu3 {transform:rotate(0deg);}"
};
function Gt(e, r) {
  R(e, f_);
  let t = U(r, "direction", 8);
  var a = m_();
  A(() => Cl(a, `arrow ${t() ?? ""} svelte-1qexsu3`)), b(e, a);
}
var y_ = /* @__PURE__ */ pr('<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="arrow"><path d="M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z" class="arrow-fill svelte-r0zny8" fill-opacity="0.7"></path></svg>');
const b_ = {
  hash: "svelte-r0zny8",
  code: ".arrow-fill.svelte-r0zny8 {fill:var(--rc-color-grey-text-dark);}"
};
function h_(e) {
  R(e, b_);
  var r = y_();
  b(e, r);
}
const v_ = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
     xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.5" clip-path="url(#clip0_344_3390)">
        <path d="M7 18C5.9 18 5.01 18.9 5.01 20C5.01 21.1 5.9 22 7 22C8.1 22 9 21.1 9 20C9 18.9 8.1 18 7 18ZM1 2V4H3L6.6 11.59L5.25 14.04C5.09 14.32 5 14.65 5 15C5 16.1 5.9 17 7 17H19V15H7.42C7.28 15 7.17 14.89 7.17 14.75L7.2 14.63L8.1 13H15.55C16.3 13 16.96 12.59 17.3 11.97L20.88 5.48C20.96 5.34 21 5.17 21 5C21 4.45 20.55 4 20 4H5.21L4.27 2H1ZM17 18C15.9 18 15.01 18.9 15.01 20C15.01 21.1 15.9 22 17 22C18.1 22 19 21.1 19 20C19 18.9 18.1 18 17 18Z"
              fill="currentColor"/>
    </g>
    <defs>
        <clipPath id="clip0_344_3390">
            <rect width="24" height="24" fill="currentColor"/>
        </clipPath>
    </defs>
</svg>
`;
var k_ = /* @__PURE__ */ I('<div style="color:var(--rc-color-gray-text-dark);"><!></div>');
function w_(e) {
  var r = k_(), t = P(r);
  Wr(t, () => v_), b(e, r);
}
const x_ = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
     xmlns="http://www.w3.org/2000/svg">
    <path d="M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17ZM15.1 8H8.9V6C8.9 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8Z"
          fill="currentColor"/>
</svg>
`;
var P_ = /* @__PURE__ */ I('<div style="color:var(--rc-color-accent);" class="rcb-ui-asset-icon svelte-wgufvv"><!></div>');
const S_ = {
  hash: "svelte-wgufvv",
  code: "div.svelte-wgufvv {height:24px;width:24px;}"
};
function E_(e) {
  R(e, S_);
  var r = P_(), t = P(r);
  Wr(t, () => x_), b(e, r);
}
const T_ = `<svg viewBox="0 0 124 124" fill="var(--rc-color-grey-text-dark)" xmlns="http://www.w3.org/2000/svg">
    <circle cx="62" cy="62" r="62" fill="var(--rc-color-grey-text-dark)" opacity="0.2"/>
    <rect x="44.1116" y="56" width="27.5" height="11" transform="rotate(45 44.1116 56)" fill="var(--rc-color-grey-text-dark)"/>
    <rect x="79.1133" y="44.334" width="11" height="44" transform="rotate(45 79.1133 44.334)" fill="var(--rc-color-grey-text-dark)"/>
</svg>
`;
var I_ = /* @__PURE__ */ I('<div style="color:var(--rc-color-primary)"><!></div>');
function Ui(e) {
  var r = I_(), t = P(r);
  Wr(t, () => T_), b(e, r);
}
var q_ = /* @__PURE__ */ pr('<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" class="arrow-fill svelte-1jpfelf" fill-opacity="0.7"></path></svg>');
const F_ = {
  hash: "svelte-1jpfelf",
  code: ".arrow-fill.svelte-1jpfelf {fill:var(--arrow-fill-color, var(--rc-color-grey-text-dark));}"
};
function z_(e) {
  R(e, F_);
  var r = q_();
  b(e, r);
}
const D_ = {
  cart: w_,
  error: yi,
  lock: E_,
  success: Ui,
  back: h_,
  info: Bi,
  close: z_,
  "chevron-left": Gt,
  "chevron-right": Gt,
  "chevron-up": Gt,
  "chevron-down": Gt
};
function qt(e, r) {
  V(r, !0);
  const t = D_[r.name];
  let a = X(B({}));
  if (r.name.startsWith("chevron")) {
    const n = r.name.split("-")[1];
    D(a, B({ direction: n }));
  }
  t(e, hr(() => d(a))), H();
}
var A_ = /* @__PURE__ */ I('<span class="rc-sandbox-only-error svelte-1d8gf9n"><!></span> <br> <br>', 1), M_ = /* @__PURE__ */ I('<!> <a class="svelte-1d8gf9n"> </a>.', 1), j_ = /* @__PURE__ */ I("<!> <!>", 1);
const N_ = {
  hash: "svelte-1d8gf9n",
  code: "a.svelte-1d8gf9n {color:var(--rc-color-grey-text-dark);}.rc-sandbox-only-error.svelte-1d8gf9n {font-weight:bold;}"
};
function C_(e, r) {
  V(r, !0), R(e, N_);
  const t = De(), a = () => ze(o, "$translator", t), n = /* @__PURE__ */ E(() => r.lastError ?? new de(oe.UnknownError, "Unknown error without state set.")), o = Ee(Ne), i = /* @__PURE__ */ E(() => d(n).errorCode === oe.StripeTaxNotActive || d(n).errorCode === oe.StripeInvalidTaxOriginAddress || d(n).errorCode === oe.StripeMissingRequiredPermission);
  We(() => {
    K.errorLog(`Displayed error: ${oe[d(n).errorCode]}. Message: ${d(n).message ?? "None"}. Underlying error: ${d(n).underlyingErrorMessage ?? "None"}`);
  });
  function s() {
    return d(n).errorCode === oe.AlreadyPurchasedError ? a().translate(L.ErrorPageCloseButtonTitle, { appName: r.appName ?? "App" }) : d(i) ? a().translate(L.ErrorButtonClose) : a().translate(L.ErrorButtonTryAgain);
  }
  function l() {
    switch (d(n).errorCode) {
      case oe.AlreadyPurchasedError:
        return r.productDetails.productType === Lr.Subscription ? a().translate(L.ErrorPageErrorTitleAlreadySubscribed, { productTitle: r.productDetails.title }) : a().translate(L.ErrorPageErrorTitleAlreadyPurchased, { productTitle: r.productDetails.title });
      case oe.StripeTaxNotActive:
        return a().translate(L.ErrorPageErrorTitleStripeTaxNotActive);
      case oe.StripeInvalidTaxOriginAddress:
        return a().translate(L.ErrorPageErrorTitleStripeInvalidTaxOriginAddress);
      case oe.StripeMissingRequiredPermission:
        return a().translate(L.ErrorPageErrorTitleStripeMissingRequiredPermission);
      default:
        return a().translate(L.ErrorPageErrorTitleOtherErrors);
    }
  }
  function c() {
    const m = d(n).getErrorCode();
    switch (d(n).errorCode) {
      case oe.ErrorSettingUpPurchase:
        return a().translate(L.ErrorPageErrorMessageErrorSettingUpPurchase, { errorCode: m });
      case oe.ErrorChargingPayment:
        return a().translate(L.ErrorPageErrorMessageErrorChargingPayment, { errorCode: m });
      case oe.AlreadyPurchasedError:
        return r.productDetails.productType === Lr.Subscription ? a().translate(L.ErrorPageErrorMessageAlreadySubscribed, { errorCode: m }) : a().translate(L.ErrorPageErrorMessageAlreadyPurchased, { errorCode: m });
      case oe.StripeTaxNotActive:
        return a().translate(L.ErrorPageErrorMessageStripeTaxNotActive, { errorCode: m });
      case oe.StripeInvalidTaxOriginAddress:
        return a().translate(L.ErrorPageErrorMessageStripeInvalidTaxOriginAddress, { errorCode: m });
      case oe.StripeMissingRequiredPermission:
        return a().translate(L.ErrorPageErrorMessageStripeMissingRequiredPermission, { errorCode: m });
      case oe.NetworkError:
        return a().translate(L.ErrorPageErrorMessageNetworkError, { errorCode: m });
      default:
        return a().translate(L.ErrorPageErrorMessageUnknownError, { errorCode: m });
    }
  }
  function p() {
    return d(n).errorCode === oe.AlreadyPurchasedError ? L.ErrorPageTroubleAccessing : L.ErrorPageIfErrorPersists;
  }
  function u() {
    return d(n).errorCode === oe.AlreadyPurchasedError ? "success" : "error";
  }
  var _ = /* @__PURE__ */ E(l), g = /* @__PURE__ */ E(s);
  Sn(e, {
    get title() {
      return d(_);
    },
    get onDismiss() {
      return r.onDismiss;
    },
    type: "error",
    get closeButtonTitle() {
      return d(g);
    },
    icon: (h) => {
      var v = /* @__PURE__ */ E(u);
      qt(h, {
        get name() {
          return d(v);
        }
      });
    },
    message: (h) => {
      var v = j_(), y = Y(v);
      {
        var x = (C) => {
          var k = A_(), w = Y(k), q = P(w);
          ur(q, {
            get key() {
              return L.ErrorPageErrorMessageOnlyInSandbox;
            }
          }), b(C, k);
        };
        N(y, (C) => {
          d(i) && C(x);
        });
      }
      var T = O(y);
      A(() => te(T, ` ${c() ?? ""} `));
      var S = O(T);
      {
        var z = (C) => {
          var k = M_(), w = Y(k), q = /* @__PURE__ */ E(p);
          ur(w, {
            get key() {
              return d(q);
            }
          });
          var G = O(w, 2), W = P(G);
          A(() => {
            j(G, "href", `mailto:${r.supportEmail ?? ""}`), te(W, r.supportEmail);
          }), b(C, k);
        };
        N(S, (C) => {
          !d(i) && r.supportEmail && C(z);
        });
      }
      b(h, v);
    },
    $$slots: { icon: !0, message: !0 }
  }), H();
}
function O_(e, r) {
  V(r, !1);
  const t = De(), a = () => ze(o, "$translator", t);
  let n = U(r, "onContinue", 8);
  const o = Ee(Ne), i = Ee(xn);
  function s() {
    i.trackSDKEvent({
      eventName: Fe.CheckoutPurchaseSuccessfulDismiss,
      properties: { ui_element: "go_back_to_app" }
    }), n()();
  }
  We(() => {
    i.trackSDKEvent({
      eventName: Fe.CheckoutPurchaseSuccessfulImpression
    });
  }), Qe();
  var l = /* @__PURE__ */ et(() => a().translate(L.SuccessPagePurchaseSuccessful)), c = /* @__PURE__ */ et(() => a().translate(L.SuccessPageButtonClose));
  Sn(e, {
    type: "success",
    get title() {
      return d(l);
    },
    onDismiss: s,
    get closeButtonTitle() {
      return d(c);
    },
    icon: (u) => {
      Ui(u);
    },
    $$slots: { icon: !0 }
  }), H();
}
function L_(e) {
  Ai(e);
}
var B_ = /* @__PURE__ */ I('<div class="rcb-pricing-dropdown svelte-fgrbnh"><div class="rcb-pricing-dropdown-header svelte-fgrbnh" tabindex="0" role="button"><!> <span class="rcb-pricing-dropdown-toggle svelte-fgrbnh"><!></span></div> <div class="rcb-pricing-dropdown-content svelte-fgrbnh"><div class="rcb-pricing-dropdown-content-inner svelte-fgrbnh"><!></div></div></div>');
const R_ = {
  hash: "svelte-fgrbnh",
  code: `.rcb-pricing-dropdown.svelte-fgrbnh {width:100%;overflow:hidden;display:flex;flex-direction:column;}.rcb-pricing-dropdown-header.svelte-fgrbnh {padding-top:var(--rc-spacing-gapSmall-mobile);padding-bottom:var(--rc-spacing-gapSmall-mobile);padding-left:var(--rc-spacing-gapLarge-mobile);padding-right:var(--rc-spacing-gapMedium-mobile);color:var(--rc-color-grey-text-light);border-radius:var(--rc-shape-input-button-border-radius);cursor:pointer;display:inline-flex;align-items:center;background-color:var(--rc-color-grey-ui-light);width:fit-content;user-select:none;}.rcb-pricing-dropdown-toggle.svelte-fgrbnh {display:flex;align-items:center;margin-left:var(--rc-spacing-gapSmall-mobile);}.rcb-pricing-dropdown-content.svelte-fgrbnh {display:flex;flex-direction:column;overflow:hidden;}

  @container layout-query-container (width < 768px) {.rcb-pricing-dropdown-content.svelte-fgrbnh {max-height:1000px; /* Set a large max-height for animation */transition:max-height 0.2s ease-in-out;}.rcb-pricing-dropdown-content.collapsed.svelte-fgrbnh {max-height:0;}.rcb-pricing-dropdown-content-inner.svelte-fgrbnh {padding-top:var(--rc-spacing-gapMedium-mobile);}
  }

  @container layout-query-container (width >= 768px) {.rcb-pricing-dropdown-header.svelte-fgrbnh {display:none;}
  }`
};
function U_(e, r) {
  V(r, !1), R(e, R_);
  const t = De(), a = () => ze(i, "$translator", t);
  let n = U(r, "isExpanded", 12, !0), o = U(r, "children", 8);
  const i = Ee(Ne);
  function s() {
    n(!n());
  }
  Qe();
  var l = B_(), c = P(l), p = P(c);
  se(p, {
    size: "label-default",
    children: (y, x) => {
      var T = ee(), S = Y(T);
      {
        var z = (k) => {
          var w = ie();
          A(() => te(w, a().translate(L.PricingDropdownHideDetails))), b(k, w);
        }, C = (k) => {
          var w = ie();
          A(() => te(w, a().translate(L.PricingDropdownShowDetails))), b(k, w);
        };
        N(S, (k) => {
          n() ? k(z) : k(C, !1);
        });
      }
      b(y, T);
    },
    $$slots: { default: !0 }
  });
  var u = O(p, 2), _ = P(u);
  {
    var g = (y) => {
      qt(y, { name: "chevron-up" });
    }, m = (y) => {
      qt(y, { name: "chevron-down" });
    };
    N(_, (y) => {
      n() ? y(g) : y(m, !1);
    });
  }
  var f = O(c, 2), h = P(f), v = P(h);
  ge(v, () => o() ?? ne), A(() => {
    j(c, "aria-expanded", n()), fr(f, "collapsed", !n());
  }), nt("click", c, s), nt("keydown", c, (y) => y.key === "Enter" || y.key === " " ? s() : null), b(e, l), H();
}
var V_ = /* @__PURE__ */ I('<div class="rcb-pricing-table-value-loading svelte-erv89n"><!></div>');
const H_ = {
  hash: "svelte-erv89n",
  code: `.rcb-pricing-table-value-loading.svelte-erv89n {color:transparent;
    animation: svelte-erv89n-rcb-pricing-table-value-loading 1.5s ease-in-out 0s infinite
      normal none running;cursor:progress;background-color:var(--rc-color-grey-text-dark);user-select:none;border-radius:var(--rc-shape-input-border-radius);}

  @keyframes svelte-erv89n-rcb-pricing-table-value-loading {
    0%,
    100% {
      opacity: 0.5;
    }
    50% {
      opacity: 0.3;
    }
  }`
};
function W_(e, r) {
  V(r, !1), R(e, H_);
  let t = U(r, "children", 8);
  Qe();
  var a = V_(), n = P(a);
  ge(n, () => t() ?? ne), b(e, a), H();
}
var Y_ = /* @__PURE__ */ I('<div class="rcb-pricing-table-row svelte-i12130" data-testid="tax-loading-skeleton"><div class="rcb-pricing-table-header svelte-i12130"><!></div> <div class="rcb-pricing-table-value svelte-i12130"><!></div></div>'), G_ = /* @__PURE__ */ I('<div class="rcb-pricing-table-row svelte-i12130"><div class="rcb-pricing-table-header svelte-i12130"> </div> <div class="rcb-pricing-table-value svelte-i12130"><!></div></div>'), X_ = /* @__PURE__ */ I('<div class="rcb-pricing-table-row svelte-i12130"><div class="rcb-pricing-table-header svelte-i12130"><!></div> <div class="rcb-pricing-table-value svelte-i12130"><!></div></div>'), Z_ = /* @__PURE__ */ I('<div class="rcb-pricing-table-row svelte-i12130"><div class="rcb-pricing-table-header svelte-i12130"><!></div> <div class="rcb-pricing-table-value svelte-i12130"><!></div></div> <!> <div class="rcb-pricing-table-separator svelte-i12130"></div>', 1), K_ = /* @__PURE__ */ I('<div class="rcb-pricing-table-row svelte-i12130"><div class="rcb-pricing-table-header svelte-i12130"><!></div> <div class="rcb-pricing-table-value svelte-i12130"><!></div></div>'), J_ = /* @__PURE__ */ I('<div class="rcb-pricing-table svelte-i12130"><!> <!> <div class="rcb-pricing-table-row rcb-header svelte-i12130"><div class="rcb-pricing-table-header svelte-i12130"><!></div> <div class="rcb-pricing-table-value svelte-i12130"><!></div></div></div>');
const Q_ = {
  hash: "svelte-i12130",
  code: `.rcb-pricing-table.svelte-i12130 {display:flex;flex-direction:column;gap:var(--rc-spacing-gapSmall-mobile);}.rcb-pricing-table-row.svelte-i12130 {display:flex;flex-direction:row;align-items:center;justify-content:space-between;}.rcb-pricing-table-separator.svelte-i12130 {height:1px;background-color:var(--rc-color-grey-ui-dark);}.rcb-pricing-table-row.svelte-i12130 > .rcb-pricing-table-header:where(.svelte-i12130) {color:var(--rc-color-grey-text-light);}.rcb-pricing-table-row.svelte-i12130 > .rcb-pricing-table-value:where(.svelte-i12130) {color:var(--rc-color-grey-text-dark);}.rcb-pricing-table-row.svelte-i12130:last-child > .rcb-pricing-table-header:where(.svelte-i12130),
  .rcb-pricing-table-row.svelte-i12130:last-child > .rcb-pricing-table-value:where(.svelte-i12130) {color:var(--rc-color-grey-text-dark);}

  @container layout-query-container (width >= 768px) {.rcb-pricing-table-separator.svelte-i12130 {display:none;}.rcb-pricing-table.svelte-i12130 {gap:var(--rc-spacing-gapSmall-desktop);}.rcb-pricing-table-row.svelte-i12130 > .rcb-pricing-table-header:where(.svelte-i12130),
    .rcb-pricing-table-row.svelte-i12130 > .rcb-pricing-table-value:where(.svelte-i12130) {color:var(--rc-color-grey-text-light);}
  }`
};
function $_(e, r) {
  var _;
  V(r, !0), R(e, Q_);
  const t = De(), a = () => ze(i, "$translator", t), n = (g) => {
    var m = J_(), f = P(m);
    {
      var h = (k) => {
        var w = Z_(), q = Y(w), G = P(q), W = P(G);
        se(W, {
          size: "body-small",
          children: (ce, ke) => {
            var Pe = ie();
            A(() => te(Pe, a().translate(L.PricingTotalExcludingTax))), b(ce, Pe);
          },
          $$slots: { default: !0 }
        });
        var ae = O(G, 2), J = P(ae);
        se(J, {
          size: "body-small",
          children: (ce, ke) => {
            var Pe = ie();
            A(() => te(Pe, a().formatPrice(r.priceBreakdown.totalExcludingTaxInMicros, r.priceBreakdown.currency))), b(ce, Pe);
          },
          $$slots: { default: !0 }
        });
        var re = O(q, 2);
        {
          var pe = (ce) => {
            var ke = Y_(), Pe = P(ke), vr = P(Pe);
            se(vr, {
              size: "body-small",
              children: (Oe, kr) => {
                var $e = ie();
                A(() => te($e, a().translate(L.PricingTableTax))), b(Oe, $e);
              },
              $$slots: { default: !0 }
            });
            var _r = O(Pe, 2), Ge = P(_r);
            se(Ge, {
              size: "body-small",
              children: (Oe, kr) => {
                W_(Oe, {
                  children: ($e, wr) => {
                    var Xe = ie();
                    A(() => te(Xe, a().formatPrice(1234e4, r.priceBreakdown.currency))), b($e, Xe);
                  },
                  $$slots: { default: !0 }
                });
              },
              $$slots: { default: !0 }
            }), b(ce, ke);
          }, me = (ce) => {
            var ke = ee(), Pe = Y(ke);
            {
              var vr = (Ge) => {
                var Oe = G_(), kr = P(Oe), $e = P(kr);
                A(() => te($e, a().translate(L.PricingTableTax)));
                var wr = O(kr, 2), Xe = P(wr);
                se(Xe, {
                  size: "body-small",
                  children: (Yr, Lt) => {
                    var xr = ie();
                    A(() => te(xr, a().translate(L.PricingTableEnterBillingAddressToCalculate))), b(Yr, xr);
                  },
                  $$slots: { default: !0 }
                }), b(Ge, Oe);
              }, _r = (Ge) => {
                var Oe = ee(), kr = Y(Oe);
                {
                  var $e = (wr) => {
                    var Xe = ee(), Yr = Y(Xe);
                    it(Yr, 17, () => r.priceBreakdown.taxBreakdown, ot, (Lt, xr) => {
                      var pt = X_(), Bt = P(pt), Rt = P(Bt);
                      se(Rt, {
                        size: "body-small",
                        children: (Gr, Vt) => {
                          var Mr = ie();
                          A(() => te(Mr, d(xr).display_name)), b(Gr, Mr);
                        },
                        $$slots: { default: !0 }
                      });
                      var wa = O(Bt, 2), Ut = P(wa);
                      se(Ut, {
                        size: "body-small",
                        children: (Gr, Vt) => {
                          var Mr = ie();
                          A(() => te(Mr, a().formatPrice(d(xr).tax_amount_in_micros, r.priceBreakdown.currency))), b(Gr, Mr);
                        },
                        $$slots: { default: !0 }
                      }), b(Lt, pt);
                    }), b(wr, Xe);
                  };
                  N(
                    kr,
                    (wr) => {
                      r.priceBreakdown.taxBreakdown !== null && wr($e);
                    },
                    !0
                  );
                }
                b(Ge, Oe);
              };
              N(
                Pe,
                (Ge) => {
                  r.priceBreakdown.taxCalculationStatus === "pending" ? Ge(vr) : Ge(_r, !1);
                },
                !0
              );
            }
            b(ce, ke);
          };
          N(re, (ce) => {
            r.priceBreakdown.taxCalculationStatus === "loading" ? ce(pe) : ce(me, !1);
          });
        }
        b(k, w);
      };
      N(f, (k) => {
        d(s) && k(h);
      });
    }
    var v = O(f, 2);
    {
      var y = (k) => {
        var w = K_(), q = P(w), G = P(q);
        se(G, {
          size: "body-small",
          children: (J, re) => {
            var pe = ie();
            A(() => te(pe, a().translate(L.PricingTableTrialEnds, {
              formattedTrialEndDate: a().translateDate(d(o), { dateStyle: "medium" })
            }))), b(J, pe);
          },
          $$slots: { default: !0 }
        });
        var W = O(q, 2), ae = P(W);
        se(ae, {
          size: "body-small",
          children: (J, re) => {
            var pe = ie();
            A(() => te(pe, a().formatPrice(r.priceBreakdown.totalAmountInMicros, r.priceBreakdown.currency))), b(J, pe);
          },
          $$slots: { default: !0 }
        }), b(k, w);
      };
      N(v, (k) => {
        d(o) && k(y);
      });
    }
    var x = O(v, 2), T = P(x), S = P(T);
    se(S, {
      size: "body-small",
      children: (k, w) => {
        var q = ie();
        A(() => te(q, a().translate(L.PricingTableTotalDueToday))), b(k, q);
      },
      $$slots: { default: !0 }
    });
    var z = O(T, 2), C = P(z);
    se(C, {
      size: "body-small",
      children: (k, w) => {
        var q = ee(), G = Y(q);
        {
          var W = (J) => {
            var re = ie();
            A(() => te(re, a().formatPrice(0, r.priceBreakdown.currency))), b(J, re);
          }, ae = (J) => {
            var re = ie();
            A(() => te(re, a().formatPrice(r.priceBreakdown.totalAmountInMicros, r.priceBreakdown.currency))), b(J, re);
          };
          N(G, (J) => {
            d(o) ? J(W) : J(ae, !1);
          });
        }
        b(k, q);
      },
      $$slots: { default: !0 }
    }), b(g, m);
  };
  let o = X(null);
  (_ = r.trialPhase) != null && _.period && D(o, B(Xa(/* @__PURE__ */ new Date(), r.trialPhase.period, !0)));
  const i = Ee(Ne), s = /* @__PURE__ */ E(() => r.priceBreakdown.taxCalculationStatus !== "unavailable" && r.priceBreakdown.taxCalculationStatus !== "disabled" && r.priceBreakdown.taxBreakdown && r.priceBreakdown.taxBreakdown.length > 0);
  var l = ee(), c = Y(l);
  {
    var p = (g) => {
      U_(g, {
        children: (m, f) => {
          n(m);
        },
        $$slots: { default: !0 }
      });
    }, u = (g) => {
      n(g);
    };
    N(c, (g) => {
      d(s) ? g(p) : g(u, !1);
    });
  }
  b(e, l), H();
}
var eg = /* @__PURE__ */ I('<div class="rcb-subscribe-to svelte-4fnm8t"><!></div>'), rg = /* @__PURE__ */ I('<span class="rcb-product-description svelte-4fnm8t"><!></span>'), tg = /* @__PURE__ */ I('<div class="rcb-pricing-info-header svelte-4fnm8t"><!> <div class="rcb-product-title svelte-4fnm8t"><!></div> <!></div>');
const ag = {
  hash: "svelte-4fnm8t",
  code: `.rcb-pricing-info-header.svelte-4fnm8t {display:flex;flex-direction:column;gap:var(--rc-spacing-gapMedium-mobile);}.rcb-product-title.svelte-4fnm8t {color:var(--rc-color-grey-text-dark);}.rcb-product-description.svelte-4fnm8t {color:var(--rc-color-grey-text-light);}.rcb-subscribe-to.svelte-4fnm8t {display:none;}

  @container layout-query-container (width >= 768px) {.rcb-subscribe-to.svelte-4fnm8t {display:block;}.rcb-pricing-info-header.svelte-4fnm8t {display:flex;flex-direction:column;gap:var(--rc-spacing-gapMedium-desktop);}
  }`
};
function ng(e, r) {
  V(r, !1), R(e, ag);
  let t = U(r, "productDetails", 8), a = U(r, "showProductDescription", 8);
  const n = t().productType === Lr.Subscription;
  Qe();
  var o = tg(), i = P(o);
  {
    var s = (_) => {
      var g = eg(), m = P(g);
      se(m, {
        size: "body-base",
        children: (f, h) => {
          var v = /* @__PURE__ */ et(() => ({ productTitle: t().title }));
          ur(f, {
            get key() {
              return L.ProductInfoSubscribeTo;
            },
            get variables() {
              return d(v);
            }
          });
        },
        $$slots: { default: !0 }
      }), b(_, g);
    };
    N(i, (_) => {
      n && _(s);
    });
  }
  var l = O(i, 2), c = P(l);
  se(c, {
    size: "heading-lg",
    branded: !0,
    children: (_, g) => {
      var m = /* @__PURE__ */ et(() => ({ productTitle: t().title }));
      ur(_, {
        get key() {
          return L.ProductInfoProductTitle;
        },
        get variables() {
          return d(m);
        }
      });
    },
    $$slots: { default: !0 }
  });
  var p = O(l, 2);
  {
    var u = (_) => {
      var g = rg(), m = P(g);
      se(m, {
        size: "body-small",
        children: (f, h) => {
          var v = /* @__PURE__ */ et(() => ({
            productDescription: t().description
          }));
          ur(f, {
            get key() {
              return L.ProductInfoProductDescription;
            },
            get variables() {
              return d(v);
            }
          });
        },
        $$slots: { default: !0 }
      }), b(_, g);
    };
    N(p, (_) => {
      a() && t().description && _(u);
    });
  }
  b(e, o), H();
}
var og = /* @__PURE__ */ I("<div><!></div>"), ig = /* @__PURE__ */ I('<div class="rcb-product-price-container svelte-509gz3"><!> <div><!> <!></div></div>');
const sg = {
  hash: "svelte-509gz3",
  code: ".rcb-product-price-container.svelte-509gz3 {display:flex;flex-direction:column;justify-content:space-between;gap:var(--rc-spacing-gapMedium-mobile);color:var(--rc-color-grey-text-dark);}"
};
function lg(e, r) {
  V(r, !0), R(e, sg);
  const t = De(), a = () => ze(n, "$translator", t), n = Ee(Ne), o = /* @__PURE__ */ E(() => a().formatPrice(r.priceBreakdown.totalAmountInMicros, r.priceBreakdown.currency));
  var i = ig(), s = P(i);
  {
    var l = (g) => {
      var m = og(), f = P(m);
      se(f, {
        size: "heading-lg",
        children: (h, v) => {
          var y = /* @__PURE__ */ E(() => ({
            trialDuration: Dc(r.trialPhase.periodDuration, a())
          }));
          ur(h, {
            get key() {
              return L.ProductInfoFreeTrialDuration;
            },
            get variables() {
              return d(y);
            }
          });
        },
        $$slots: { default: !0 }
      }), b(g, m);
    };
    N(s, (g) => {
      var m;
      (m = r.trialPhase) != null && m.periodDuration && g(l);
    });
  }
  var c = O(s, 2), p = P(c);
  se(p, {
    size: "heading-lg",
    children: (g, m) => {
      var f = ie();
      A(() => te(f, d(o))), b(g, f);
    },
    $$slots: { default: !0 }
  });
  var u = O(p, 2);
  {
    var _ = (g) => {
      se(g, {
        size: "body-small",
        children: (m, f) => {
          var h = ie();
          A(() => te(h, a().translatePeriodFrequency(r.basePhase.period.number, r.basePhase.period.unit, { useMultipleWords: !0 }))), b(m, h);
        },
        $$slots: { default: !0 }
      });
    };
    N(u, (g) => {
      var m;
      (m = r.basePhase) != null && m.period && g(_);
    });
  }
  b(e, i), H();
}
var cg = /* @__PURE__ */ I('<div class="rcb-pricing-info svelte-18guro7"><div class="rcb-pricing-info-header svelte-18guro7"><!> <!></div> <!></div>');
const dg = {
  hash: "svelte-18guro7",
  code: `.rcb-pricing-info.svelte-18guro7 {display:flex;flex-direction:column;user-select:none;gap:var(--rc-spacing-gapXXLarge-mobile);}.rcb-pricing-info-header.svelte-18guro7 {display:flex;flex-direction:column;gap:var(--rc-spacing-gapLarge-mobile);}

  @container layout-query-container (width >= 768px) {.rcb-pricing-info.svelte-18guro7 {gap:var(--rc-spacing-gapXXXLarge-desktop);}.rcb-pricing-info-header.svelte-18guro7 {gap:var(--rc-spacing-gapLarge-desktop);}
  }`
};
function ug(e, r) {
  R(e, dg);
  let t = U(r, "productDetails", 8), a = U(r, "purchaseOption", 8), n = U(r, "showProductDescription", 8), o = U(r, "priceBreakdown", 8);
  const i = a(), s = i == null ? void 0 : i.base, l = i == null ? void 0 : i.trial;
  var c = cg(), p = P(c), u = P(p);
  ng(u, {
    get productDetails() {
      return t();
    },
    get showProductDescription() {
      return n();
    }
  });
  var _ = O(u, 2);
  lg(_, {
    get priceBreakdown() {
      return o();
    },
    basePhase: s,
    trialPhase: l
  });
  var g = O(p, 2);
  $_(g, {
    get priceBreakdown() {
      return o();
    },
    trialPhase: l
  }), b(e, c);
}
const bt = (e) => `https://da08ctfrofx1b.cloudfront.net/${e}`;
var pg = /* @__PURE__ */ I('<div class="rcb-ui-container svelte-1h6xr8z"><!></div>');
const _g = {
  hash: "svelte-1h6xr8z",
  code: `.rcb-ui-container.svelte-1h6xr8z {display:flex;flex-direction:column;inset:0;color-scheme:none;line-height:1.5em;font-family:-apple-system,
      BlinkMacSystemFont,
      avenir next,
      avenir,
      segoe ui,
      helvetica neue,
      helvetica,
      Cantarell,
      Ubuntu,
      roboto,
      noto,
      arial,
      sans-serif;overflow-x:hidden;overflow-y:auto;}.rcb-ui-container.fullscreen.svelte-1h6xr8z {position:fixed;top:0;left:0;right:0;bottom:0;overscroll-behavior:none;z-index:1000001;}.rcb-ui-container.inside.svelte-1h6xr8z {position:relative;width:100%;z-index:unset;height:100%;top:0;left:0;}`
};
function gg(e, r) {
  V(r, !0), R(e, _g);
  const t = U(r, "brandingAppearance", 3, void 0), a = U(r, "brandFontConfig", 3, void 0), n = U(r, "isInElement", 3, !1), o = /* @__PURE__ */ E(() => new It(t()).getTextStyleVars(a())), i = /* @__PURE__ */ E(() => new It(t()).spacingStyleVars), s = /* @__PURE__ */ E(() => [d(o), d(i)].join("; ")), l = /* @__PURE__ */ E(() => {
    var _;
    return (_ = a()) != null && _.font_url ? bt(a().font_url) : null;
  }), c = async (_) => {
    try {
      const g = new FontFace(Ni, `url(${_})`);
      await g.load(), document.fonts.add(g);
    } catch (g) {
      console.error("Failed to set brand font:", g);
    }
  };
  at(() => {
    d(l) && c(d(l));
  });
  var p = pg(), u = P(p);
  ge(u, () => r.children ?? ne), A(() => {
    j(p, "style", d(s)), fr(p, "fullscreen", !n()), fr(p, "inside", n());
  }), b(e, p), H();
}
var mg = /* @__PURE__ */ I('<div id="layout-query-container" class="svelte-1x4ow5d"><div class="rcb-ui-layout svelte-1x4ow5d"><!></div></div>');
const fg = {
  hash: "svelte-1x4ow5d",
  code: `#layout-query-container.svelte-1x4ow5d {width:100%;height:100%;container-type:size;container-name:layout-query-container;overflow-y:auto;overscroll-behavior:none;}.rcb-ui-layout.svelte-1x4ow5d {width:100%;min-height:100%;display:flex;box-sizing:border-box;flex-direction:column;overflow-y:auto;overscroll-behavior:none;}

  @container layout-query-container (width < 768px) {.rcb-ui-layout.svelte-1x4ow5d {flex-grow:1;}
  }

  @container layout-query-container (width >= 768px) {.rcb-ui-layout.svelte-1x4ow5d {flex-direction:row;}
  }`
};
function yg(e, r) {
  V(r, !1), R(e, fg);
  let t = U(r, "style", 8, ""), a = U(r, "children", 8);
  Qe();
  var n = mg(), o = P(n), i = P(o);
  ge(i, () => a() ?? ne), A(() => j(o, "style", t())), b(e, n), H();
}
const bg = (e) => e;
function hg(e) {
  const r = e - 1;
  return r * r * r + 1;
}
function Po(e) {
  const r = typeof e == "string" && e.match(/^\s*(-?[\d.]+)([^\s]*)\s*$/);
  return r ? [parseFloat(r[1]), r[2] || "px"] : [
    /** @type {number} */
    e,
    "px"
  ];
}
function vg(e, { delay: r = 0, duration: t = 400, easing: a = bg } = {}) {
  const n = +getComputedStyle(e).opacity;
  return {
    delay: r,
    duration: t,
    easing: a,
    css: (o) => `opacity: ${o * n}`
  };
}
function kg(e, { delay: r = 0, duration: t = 400, easing: a = hg, x: n = 0, y: o = 0, opacity: i = 0 } = {}) {
  const s = getComputedStyle(e), l = +s.opacity, c = s.transform === "none" ? "" : s.transform, p = l * (1 - i), [u, _] = Po(n), [g, m] = Po(o);
  return {
    delay: r,
    duration: t,
    easing: a,
    css: (f, h) => `
			transform: ${c} translate(${(1 - f) * u}${_}, ${(1 - f) * g}${m});
			opacity: ${l - p * h}`
  };
}
var wg = /* @__PURE__ */ I('<div><div class="layout-wrapper svelte-1w6qvx7"><div><!></div></div></div>');
const xg = {
  hash: "svelte-1w6qvx7",
  code: `.layout-wrapper-outer.svelte-1w6qvx7 {flex:1;display:flex;background-color:var(--rc-color-background);}.layout-wrapper-outer.rcb-navbar.svelte-1w6qvx7 {justify-content:flex-end;}.layout-wrapper.svelte-1w6qvx7 {width:100%;}.layout-content.svelte-1w6qvx7 {box-sizing:border-box;background-color:var(--rc-color-background);color:var(--rc-color-grey-text-dark);display:flex;flex-direction:column;}.layout-content.rcb-navbar.svelte-1w6qvx7 {display:flex;flex-direction:column;gap:var(--rc-spacing-gapXLarge-mobile);}

  @container layout-query-container (width < 768px) {.layout-wrapper.svelte-1w6qvx7 {width:100%;min-width:300px;display:flex;flex-grow:1;}.layout-content.svelte-1w6qvx7 {flex-grow:1;height:100%;}.layout-content.rcb-navbar.svelte-1w6qvx7 {padding-bottom:var(--rc-spacing-outerPadding-mobile);}.layout-content.rcb-main-block.svelte-1w6qvx7 {padding:var(--rc-spacing-outerPadding-mobile);}
  }

  @container layout-query-container (width >= 768px) {.layout-wrapper.svelte-1w6qvx7 {flex-basis:544px;}.layout-content.rcb-main-block.svelte-1w6qvx7 {padding-left:var(--rc-spacing-outerPadding-desktop);padding-right:var(--rc-spacing-outerPadding-desktop);}.layout-content.rcb-navbar.svelte-1w6qvx7 {gap:var(--rc-spacing-gapXXLarge-desktop);}.layout-wrapper-outer.svelte-1w6qvx7 {padding-top:var(--rc-spacing-outerPaddingTop-desktop);padding-bottom:var(--rc-spacing-outerPadding-desktop);}
  }`
};
function Vi(e, r) {
  V(r, !0), R(e, xg);
  const t = `rcb-${r.location}`;
  var a = wg();
  Fr(a, `layout-wrapper-outer ${t ?? ""} svelte-1w6qvx7`);
  var n = P(a), o = P(n);
  Fr(o, `layout-content ${t ?? ""} svelte-1w6qvx7`);
  var i = P(o);
  ge(i, () => r.children ?? ne), pi(3, o, () => vg, () => ({ duration: 500, delay: 50 })), b(e, a), H();
}
var Pg = /* @__PURE__ */ I('<div class="navbar-body svelte-jz90ay"><!></div>'), Sg = /* @__PURE__ */ I('<div class="navbar-header svelte-jz90ay"><!></div> <!>', 1), Eg = /* @__PURE__ */ I('<div class="rcb-ui-navbar svelte-jz90ay"><!></div>');
const Tg = {
  hash: "svelte-jz90ay",
  code: `.rcb-ui-navbar.svelte-jz90ay {width:100%;max-width:none;flex-shrink:0;background-color:var(--rc-color-background);}

  @container layout-query-container (width < 768px) {.navbar-body.svelte-jz90ay {padding-left:var(--rc-spacing-outerPadding-mobile);padding-right:var(--rc-spacing-outerPadding-mobile);}
  }

  @container layout-query-container (width >= 768px) {.rcb-ui-navbar.svelte-jz90ay {width:50vw;display:flex;justify-content:flex-end;}.navbar-header.svelte-jz90ay {padding-left:var(--rc-spacing-outerPadding-desktop);padding-right:var(--rc-spacing-outerPadding-desktop);}.navbar-body.svelte-jz90ay {padding-left:var(--rc-spacing-outerPadding-desktop);padding-right:var(--rc-spacing-outerPadding-desktop);}
  }`
};
function Ig(e, r) {
  V(r, !0), R(e, Tg);
  const t = U(r, "brandingAppearance", 3, void 0), a = /* @__PURE__ */ E(() => new It(t()).productInfoStyleVars);
  var n = Eg(), o = P(n);
  Vi(o, {
    location: "navbar",
    children: (i, s) => {
      var l = Sg(), c = Y(l), p = P(c);
      ge(p, () => r.headerContent ?? ne);
      var u = O(c, 2);
      {
        var _ = (g) => {
          var m = Pg(), f = P(m);
          ge(f, () => r.bodyContent ?? ne), b(g, m);
        };
        N(u, (g) => {
          r.bodyContent && g(_);
        });
      }
      b(i, l);
    },
    $$slots: { default: !0 }
  }), A(() => j(n, "style", d(a))), b(e, n), H();
}
var qg = /* @__PURE__ */ I('<button class="rcb-close-button svelte-nssttr" data-testid="close-button"><!></button>');
const Fg = {
  hash: "svelte-nssttr",
  code: ".rcb-close-button.svelte-nssttr {padding:10px;border:none;cursor:pointer;background-color:transparent;border-radius:50%;color:var(--rc-color-grey-text-dark);display:inline-flex;align-items:center;justify-content:center;width:fit-content;height:fit-content;}.rcb-close-button.svelte-nssttr:active {transition:outline 0.1s ease-in-out;outline:2px solid var(--rc-color-focus);}.rcb-close-button.svelte-nssttr:hover {color:var(--rc-color-grey-text-dark);}"
};
function Hi(e, r) {
  R(e, Fg);
  var t = qg(), a = P(t);
  qt(a, { name: "close" }), nt("click", t, function(n) {
    gi.call(this, r, n);
  }), b(e, t);
}
var zg = /* @__PURE__ */ I('<span class="rcb-sandbox-text svelte-1rtxyta">Sandbox</span>'), Dg = /* @__PURE__ */ I('<div class="rcb-ui-sandbox-banner svelte-1rtxyta"><!> <div class="rcb-sandbox-banner-close-button-wrapper svelte-1rtxyta" style="--arrow-fill-color: black"><!></div></div>');
const Ag = {
  hash: "svelte-1rtxyta",
  code: `.rcb-ui-sandbox-banner.svelte-1rtxyta {position:fixed;top:0;z-index:1000002;left:0;width:100%;background-color:var(--rc-color-warning);color:rgba(0, 0, 0, 1);text-transform:uppercase;padding:var(--rc-spacing-gapSmall-mobile);display:flex;justify-content:center;align-items:center;}.rcb-ui-sandbox-banner.isInElement.svelte-1rtxyta {position:absolute;}.rcb-sandbox-banner-close-button-wrapper.svelte-1rtxyta {position:absolute;right:var(--rc-spacing-gapMedium-mobile);top:50%;transform:translateY(-50%);color:black;}.rcb-sandbox-text.svelte-1rtxyta {font-weight:bold;}

  @container layout-query-container (width >= 768px) {.rcb-ui-sandbox-banner.svelte-1rtxyta {padding:var(--rc-spacing-gapMedium-desktop);}.rcb-sandbox-banner-close-button-wrapper.svelte-1rtxyta {right:var(--rc-spacing-gapMedium-desktop);}
  }`
};
function Mg(e, r) {
  V(r, !1), R(e, Ag);
  let t = U(r, "style", 8, ""), a = U(r, "isInElement", 8, !1), n = Ca(!0);
  function o() {
    K.debugLog("closeBanner"), D(n, !1);
  }
  Qe();
  var i = ee(), s = Y(i);
  {
    var l = (c) => {
      var p = Dg(), u = P(p);
      se(u, {
        size: "caption-default",
        children: (m, f) => {
          var h = zg();
          b(m, h);
        },
        $$slots: { default: !0 }
      });
      var _ = O(u, 2), g = P(_);
      se(g, {
        size: "caption-default",
        children: (m, f) => {
          Hi(m, { $$events: { click: o } });
        },
        $$slots: { default: !0 }
      }), A(() => {
        j(p, "style", t()), fr(p, "isInElement", a());
      }), pi(2, p, () => kg, () => ({ y: -100, duration: 300 })), b(c, p);
    };
    N(s, (c) => {
      d(n) && c(l);
    });
  }
  b(e, i), H();
}
var jg = /* @__PURE__ */ I('<div class="rcb-ui-main svelte-nr408n"><!></div>');
const Ng = {
  hash: "svelte-nr408n",
  code: ".rcb-ui-main.svelte-nr408n {flex:1;display:flex;background-color:var(--rc-color-background);}"
};
function Cg(e, r) {
  V(r, !0), R(e, Ng);
  const t = /* @__PURE__ */ E(() => new It(r.brandingAppearance).formStyleVars);
  var a = jg(), n = P(a);
  Vi(n, {
    location: "main-block",
    children: (o, i) => {
      var s = ee(), l = Y(s);
      ge(l, () => r.children ?? ne), b(o, s);
    },
    $$slots: { default: !0 }
  }), A(() => j(a, "style", d(t))), b(e, a), H();
}
var Og = /* @__PURE__ */ I("<!> <!>", 1), Lg = /* @__PURE__ */ I("<!> <!>", 1);
function Bg(e, r) {
  V(r, !0);
  const t = /* @__PURE__ */ E(() => {
    var o;
    return Li((o = r.brandingInfo) == null ? void 0 : o.appearance) ?? "";
  });
  var a = /* @__PURE__ */ E(() => {
    var o;
    return (o = r.brandingInfo) == null ? void 0 : o.appearance;
  }), n = /* @__PURE__ */ E(() => {
    var o;
    return (o = r.brandingInfo) == null ? void 0 : o.brand_font_config;
  });
  gg(e, {
    get brandingAppearance() {
      return d(a);
    },
    get brandFontConfig() {
      return d(n);
    },
    get isInElement() {
      return r.isInElement;
    },
    children: (o, i) => {
      var s = Lg(), l = Y(s);
      {
        var c = (u) => {
          Mg(u, {
            get style() {
              return d(t);
            },
            get isInElement() {
              return r.isInElement;
            }
          });
        };
        N(l, (u) => {
          r.isSandbox && u(c);
        });
      }
      var p = O(l, 2);
      yg(p, {
        get style() {
          return d(t);
        },
        children: (u, _) => {
          var g = Og(), m = Y(g);
          {
            var f = (y) => {
              var x = /* @__PURE__ */ E(() => {
                var T;
                return (T = r.brandingInfo) == null ? void 0 : T.appearance;
              });
              Ig(y, {
                get brandingAppearance() {
                  return d(x);
                },
                get headerContent() {
                  return r.navbarHeaderContent;
                },
                get bodyContent() {
                  return r.navbarBodyContent;
                }
              });
            };
            N(m, (y) => {
              (r.navbarHeaderContent || r.navbarBodyContent) && y(f);
            });
          }
          var h = O(m, 2), v = /* @__PURE__ */ E(() => {
            var y;
            return (y = r.brandingInfo) == null ? void 0 : y.appearance;
          });
          Cg(h, {
            get brandingAppearance() {
              return d(v);
            },
            children: (y, x) => {
              var T = ee(), S = Y(T);
              ge(S, () => r.mainContent ?? ne), b(y, T);
            },
            $$slots: { default: !0 }
          }), b(u, g);
        },
        $$slots: { default: !0 }
      }), b(o, s);
    },
    $$slots: { default: !0 }
  }), H();
}
var Rg = /* @__PURE__ */ I('<source type="image/webp">'), Ug = /* @__PURE__ */ I('<picture class="rcb-app-icon-picture-container svelte-el1u77"><!> <img class="rcb-app-icon svelte-el1u77" alt="App icon"></picture>'), Vg = /* @__PURE__ */ I('<div class="rcb-app-icon loading svelte-el1u77"></div>');
const Hg = {
  hash: "svelte-el1u77",
  code: ".rcb-app-icon.svelte-el1u77 {width:32px;height:32px;border-radius:12px;box-shadow:0px 1px 10px 0px rgba(0, 0, 0, 0.1);}.rcb-app-icon-picture-container.svelte-el1u77 {height:32px;}.rcb-app-icon.loading.svelte-el1u77 {background-color:gray;}"
};
function Wg(e, r) {
  R(e, Hg);
  var t = ee(), a = Y(t);
  {
    var n = (i) => {
      var s = Ug(), l = P(s);
      {
        var c = (u) => {
          var _ = Rg();
          A(() => j(_, "srcset", r.srcWebp)), b(u, _);
        };
        N(l, (u) => {
          r.srcWebp && u(c);
        });
      }
      var p = O(l, 2);
      A(() => j(p, "src", r.src)), b(i, s);
    }, o = (i) => {
      var s = Vg();
      b(i, s);
    };
    N(a, (i) => {
      r.src ? i(n) : i(o, !1);
    });
  }
  b(e, t);
}
var Yg = /* @__PURE__ */ I('<button class="rcb-back-button svelte-9xjbko" data-testid="close-button"><!></button>');
const Gg = {
  hash: "svelte-9xjbko",
  code: ".rcb-back-button.svelte-9xjbko {padding:8px;border:none;cursor:pointer;background-color:transparent;border-radius:50%;color:var(--rc-color-grey-text-dark);display:inline-flex;align-items:center;justify-content:center;width:fit-content;height:fit-content;}"
};
function Xg(e, r) {
  R(e, Gg);
  var t = Yg(), a = P(t);
  qt(a, { name: "back" }), nt("click", t, function(n) {
    gi.call(this, r, n);
  }), b(e, t);
}
var Zg = /* @__PURE__ */ I('<source type="image/webp" class="rcb-app-icon svelte-19gv4gf">'), Kg = /* @__PURE__ */ I('<picture class="rcb-app-icon svelte-19gv4gf"><!> <img class="rcb-app-icon svelte-19gv4gf" alt="App icon"></picture>');
const Jg = {
  hash: "svelte-19gv4gf",
  code: ".rcb-app-icon.svelte-19gv4gf {height:32px;}"
};
function Qg(e, r) {
  R(e, Jg);
  var t = Kg(), a = P(t);
  {
    var n = (i) => {
      var s = Zg();
      A(() => j(s, "srcset", r.srcWebp)), b(i, s);
    };
    N(a, (i) => {
      r.srcWebp && i(n);
    });
  }
  var o = O(a, 2);
  A(() => j(o, "src", r.src)), b(e, t);
}
var $g = /* @__PURE__ */ I('<div class="rcb-back-wrapper svelte-11zapuq"><!></div>'), em = /* @__PURE__ */ I('<div class="rcb-close-wrapper svelte-11zapuq"><!></div>'), rm = /* @__PURE__ */ I('<div class="rcb-header-wrapper svelte-11zapuq"><!> <div class="rcb-header svelte-11zapuq"><div class="rcb-title svelte-11zapuq"><!> <!></div></div> <!></div>');
const tm = {
  hash: "svelte-11zapuq",
  code: `.rcb-header-wrapper.svelte-11zapuq {display:flex;position:relative;justify-content:space-between;align-items:center;}.rcb-header.svelte-11zapuq {display:flex;flex-direction:row;align-items:center;padding-top:var(--rc-spacing-gapSmall-mobile);padding-bottom:var(--rc-spacing-gapSmall-mobile);height:40px;justify-content:space-between;}.rcb-title.svelte-11zapuq {display:flex;align-items:center;position:relative;gap:var(--rc-spacing-gapMedium-mobile);}.rcb-close-wrapper.svelte-11zapuq,
  .rcb-back-wrapper.svelte-11zapuq {padding:var(--rc-spacing-gapSmall-mobile);}

  @container layout-query-container (width < 768px) {.rcb-header.svelte-11zapuq {padding-top:var(--rc-spacing-gapMedium-mobile);}.rcb-close-wrapper.svelte-11zapuq {padding-top:var(--rc-spacing-gapMedium-mobile);}.rcb-header-wrapper.svelte-11zapuq {padding-top:var(--rc-spacing-gapSmall-mobile);padding-bottom:var(--rc-spacing-gapSmall-mobile);padding-left:var(--rc-spacing-outerPadding-mobile);padding-right:var(--rc-spacing-outerPadding-mobile);}.rcb-header-wrapper.rcb-with-close-button.svelte-11zapuq {padding-right:var(--rc-spacing-gapSmall-mobile);}.rcb-back-wrapper.svelte-11zapuq {display:none;}.rcb-header-wrapper.svelte-11zapuq {padding-left:var(--rc-spacing-outerPadding-mobile);padding-right:var(--rc-spacing-outerPadding-mobile);}
  }

  @container layout-query-container (width >= 768px) {.rcb-close-wrapper.svelte-11zapuq {display:none;}.rcb-back-wrapper.svelte-11zapuq {position:absolute;left:-48px;margin-left:0;}
  }`
};
function am(e, r) {
  V(r, !0), R(e, tm);
  const t = (k) => k == null || k == null || k == "" ? null : k, a = /* @__PURE__ */ E(() => {
    var k;
    return t((k = r.brandingInfo) == null ? void 0 : k.app_icon);
  }), n = /* @__PURE__ */ E(() => {
    var k;
    return t((k = r.brandingInfo) == null ? void 0 : k.app_icon_webp);
  }), o = /* @__PURE__ */ E(() => {
    var k;
    return t((k = r.brandingInfo) == null ? void 0 : k.app_wordmark);
  }), i = /* @__PURE__ */ E(() => {
    var k;
    return t((k = r.brandingInfo) == null ? void 0 : k.app_wordmark_webp);
  }), s = /* @__PURE__ */ E(() => d(a) ? bt(d(a)) : null), l = /* @__PURE__ */ E(() => d(n) ? bt(d(n)) : null), c = /* @__PURE__ */ E(() => d(o) ? bt(d(o)) : null), p = /* @__PURE__ */ E(() => d(i) ? bt(d(i)) : null), u = () => {
    r.onClose && r.onClose();
  };
  var _ = rm(), g = P(_);
  {
    var m = (k) => {
      var w = $g(), q = P(w);
      Xg(q, { $$events: { click: u } }), b(k, w);
    };
    N(g, (k) => {
      r.showCloseButton && k(m);
    });
  }
  var f = O(g, 2), h = P(f), v = P(h);
  {
    var y = (k) => {
      Qg(k, {
        get src() {
          return d(c);
        },
        get srcWebp() {
          return d(p);
        }
      });
    }, x = (k) => {
      var w = ee(), q = Y(w);
      {
        var G = (W) => {
          Wg(W, {
            get src() {
              return d(s);
            },
            get srcWebp() {
              return d(l);
            }
          });
        };
        N(
          q,
          (W) => {
            d(s) !== null && d(l) !== null && W(G);
          },
          !0
        );
      }
      b(k, w);
    };
    N(v, (k) => {
      d(c) !== null ? k(y) : k(x, !1);
    });
  }
  var T = O(v, 2);
  {
    var S = (k) => {
      se(k, {
        size: "body-base",
        children: (w, q) => {
          var G = ie();
          A(() => {
            var W;
            return te(G, (W = r.brandingInfo) == null ? void 0 : W.app_name);
          }), b(w, G);
        },
        $$slots: { default: !0 }
      });
    };
    N(T, (k) => {
      d(c) === null && k(S);
    });
  }
  var z = O(f, 2);
  {
    var C = (k) => {
      var w = em(), q = P(w);
      Hi(q, { $$events: { click: u } }), b(k, w);
    };
    N(z, (k) => {
      r.showCloseButton && k(C);
    });
  }
  A(() => fr(_, "rcb-with-close-button", r.showCloseButton)), b(e, _), H();
}
var nm = /* @__PURE__ */ I("<!> <!> <!> <!>", 1);
function om(e, r) {
  V(r, !0);
  const t = U(r, "onClose", 3, void 0);
  let a = X(B(r.defaultPriceBreakdown ?? {
    currency: r.productDetails.currentPrice.currency,
    totalAmountInMicros: r.productDetails.currentPrice.amountMicros,
    totalExcludingTaxInMicros: r.productDetails.currentPrice.amountMicros,
    taxCalculationStatus: "unavailable",
    taxAmountInMicros: null,
    taxBreakdown: null
  }));
  const n = (o) => {
    D(a, B(o));
  };
  Bg(e, {
    get brandingInfo() {
      return r.brandingInfo;
    },
    get isInElement() {
      return r.isInElement;
    },
    get isSandbox() {
      return r.isSandbox;
    },
    get onClose() {
      return t();
    },
    navbarHeaderContent: (l) => {
      var c = /* @__PURE__ */ E(() => !r.isInElement && !!t());
      am(l, {
        get brandingInfo() {
          return r.brandingInfo;
        },
        get onClose() {
          return t();
        },
        get showCloseButton() {
          return d(c);
        }
      });
    },
    navbarBodyContent: (l) => {
      var c = /* @__PURE__ */ E(() => {
        var p, u;
        return ((u = (p = r.brandingInfo) == null ? void 0 : p.appearance) == null ? void 0 : u.show_product_description) ?? !1;
      });
      ug(l, {
        get productDetails() {
          return r.productDetails;
        },
        get purchaseOption() {
          return r.purchaseOptionToUse;
        },
        get showProductDescription() {
          return d(c);
        },
        get priceBreakdown() {
          return d(a);
        }
      });
    },
    mainContent: (l) => {
      var c = nm(), p = Y(c);
      {
        var u = (y) => {
          L_(y);
        };
        N(p, (y) => {
          r.currentPage === "payment-entry-loading" && y(u);
        });
      }
      var _ = O(p, 2);
      {
        var g = (y) => {
          a_(y, {
            get productDetails() {
              return r.productDetails;
            },
            get purchaseOption() {
              return r.purchaseOptionToUse;
            },
            get brandingInfo() {
              return r.brandingInfo;
            },
            get purchaseOperationHelper() {
              return r.purchaseOperationHelper;
            },
            get gatewayParams() {
              return r.gatewayParams;
            },
            get managementUrl() {
              return r.managementUrl;
            },
            get customerEmail() {
              return r.customerEmail;
            },
            get defaultPriceBreakdown() {
              return r.defaultPriceBreakdown;
            },
            get onContinue() {
              return r.onContinue;
            },
            get onError() {
              return r.onError;
            },
            onPriceBreakdownUpdated: n
          });
        };
        N(_, (y) => {
          r.currentPage === "payment-entry" && y(g);
        });
      }
      var m = O(_, 2);
      {
        var f = (y) => {
          var x = /* @__PURE__ */ E(() => {
            var S;
            return ((S = r.brandingInfo) == null ? void 0 : S.support_email) ?? null;
          }), T = /* @__PURE__ */ E(() => {
            var S;
            return ((S = r.brandingInfo) == null ? void 0 : S.app_name) ?? null;
          });
          C_(y, {
            get lastError() {
              return r.lastError;
            },
            get productDetails() {
              return r.productDetails;
            },
            get supportEmail() {
              return d(x);
            },
            get onDismiss() {
              return r.closeWithError;
            },
            get appName() {
              return d(T);
            }
          });
        };
        N(m, (y) => {
          r.currentPage === "error" && y(f);
        });
      }
      var h = O(m, 2);
      {
        var v = (y) => {
          O_(y, {
            get onContinue() {
              return r.onContinue;
            }
          });
        };
        N(h, (y) => {
          r.currentPage === "success" && y(v);
        });
      }
      b(l, c);
    },
    $$slots: {
      navbarHeaderContent: !0,
      navbarBodyContent: !0,
      mainContent: !0
    }
  }), H();
}
function im(e) {
  return e.trim() === "" ? "You need to provide your email address to continue." : e.match(/^[^@]+@[^@]+\.[^@]+$/) ? null : "Email is not valid. Please provide a valid email address.";
}
function sm(e) {
  if (e && !e.match(/^[A-Z]{3}$/)) {
    const r = `Currency code ${e} is not valid. Please provide a valid ISO 4217 currency code.`;
    throw K.errorLog(r), new _e(he.ConfigurationError, r);
  }
}
function lm(e, r) {
  var C;
  V(r, !0);
  const t = U(r, "customTranslations", 19, () => ({})), a = r.customerEmail ? im(r.customerEmail) : null;
  let n = X(B(a ? void 0 : r.customerEmail)), o = r.rcPackage.webBillingProduct, i = X(null);
  const s = r.rcPackage.webBillingProduct.identifier ?? null;
  let l = X("payment-entry-loading"), c = X(null), p = X(null), u = X(B({})), _ = X(null), g = X(null), m = X(null), f = X(null), h = new va(t(), r.selectedLocale, r.defaultLocale);
  var v = hi(h);
  Ia(Ne, v), Ia(Pn, (C = r.brandingInfo) == null ? void 0 : C.appearance), We(() => {
    r.isInElement || (D(g, B(document.documentElement.style.height)), D(m, B(document.documentElement.style.overflow)), D(f, B(document.body.style.height)), document.documentElement.style.height = "100%", document.body.style.height = "100%", document.documentElement.style.overflow = "hidden");
  }), Nt(() => {
    if (!r.isInElement) {
      const k = (w, q, G) => {
        G === "" ? w.style.removeProperty(q) : w.style.setProperty(q, G);
      };
      k(document.documentElement, "height", d(g)), k(document.body, "height", d(f)), k(document.documentElement, "overflow", d(m));
    }
  }), Ia(xn, r.eventsTracker), We(async () => {
    if (s === null) {
      x(new de(oe.ErrorSettingUpPurchase, "Product ID was not set before purchase."));
      return;
    }
    r.purchaseOperationHelper.checkoutStart(r.appUserId, s, r.purchaseOption, r.rcPackage.webBillingProduct.presentedOfferingContext, d(n), r.metadata).then((k) => {
      D(i, null), D(l, "payment-entry"), D(u, B(k.gateway_params)), D(_, B(k.management_url));
    }).catch((k) => {
      if (k.errorCode === oe.MissingEmailError)
        return D(n, void 0), r.purchaseOperationHelper.checkoutStart(r.appUserId, s, r.purchaseOption, r.rcPackage.webBillingProduct.presentedOfferingContext, d(n), r.metadata).then((w) => {
          D(i, null), D(l, "payment-entry"), D(u, B(w.gateway_params)), D(_, B(w.management_url));
        }).catch((w) => {
          x(w);
        });
      x(k);
    });
  });
  const y = () => {
    if (d(l) === "payment-entry") {
      r.purchaseOperationHelper.pollCurrentPurchaseForCompletion().then((k) => {
        D(l, "success"), D(c, B(k.redemptionInfo)), D(p, B(k.operationSessionId));
      }).catch((k) => {
        x(k);
      });
      return;
    }
    if (d(l) === "success" || d(l) === "error") {
      r.onFinished(d(p), d(c));
      return;
    }
    D(l, "success");
  }, x = (k) => {
    const w = tp({
      errorCode: k.getErrorCode().toString(),
      errorMessage: k.message
    });
    r.eventsTracker.trackSDKEvent(w), D(i, B(k)), D(l, "error");
  }, T = () => {
    r.onError(d(i) ?? new de(oe.UnknownError, "Unknown error without state set."));
  };
  var S = /* @__PURE__ */ E(() => r.purchases.isSandbox()), z = /* @__PURE__ */ E(() => d(n) ?? null);
  om(e, {
    get isSandbox() {
      return d(S);
    },
    get currentPage() {
      return d(l);
    },
    get brandingInfo() {
      return r.brandingInfo;
    },
    productDetails: o,
    get purchaseOptionToUse() {
      return r.purchaseOption;
    },
    get lastError() {
      return d(i);
    },
    get gatewayParams() {
      return d(u);
    },
    get managementUrl() {
      return d(_);
    },
    get purchaseOperationHelper() {
      return r.purchaseOperationHelper;
    },
    get isInElement() {
      return r.isInElement;
    },
    get customerEmail() {
      return d(z);
    },
    closeWithError: T,
    onContinue: y,
    onError: x,
    get onClose() {
      return r.onClose;
    }
  }), H();
}
function Wi(e) {
  return e == null ? !0 : new Date(e) > /* @__PURE__ */ new Date();
}
function cm(e, r, t, a) {
  const n = r.product_identifier;
  if (n in t)
    return dm(
      e,
      r,
      t[n]
    );
  if (n in a)
    return um(
      e,
      r,
      a[n]
    );
  throw new _e(
    he.CustomerInfoError,
    "Could not find entitlement product in subscriptions or non-subscriptions."
  );
}
function dm(e, r, t) {
  return {
    identifier: e,
    isActive: Wi(r.expires_date),
    willRenew: Yi(
      r.expires_date,
      t
    ),
    store: (t == null ? void 0 : t.store) ?? "unknown",
    latestPurchaseDate: new Date(r.purchase_date),
    originalPurchaseDate: new Date(r.purchase_date),
    expirationDate: lr(r.expires_date),
    productIdentifier: r.product_identifier,
    productPlanIdentifier: r.product_plan_identifier ?? null,
    unsubscribeDetectedAt: lr(
      t == null ? void 0 : t.unsubscribe_detected_at
    ),
    billingIssueDetectedAt: lr(
      t == null ? void 0 : t.billing_issues_detected_at
    ),
    isSandbox: (t == null ? void 0 : t.is_sandbox) ?? !1,
    periodType: (t == null ? void 0 : t.period_type) ?? "normal",
    ownershipType: (t == null ? void 0 : t.ownership_type) ?? "UNKNOWN"
  };
}
function um(e, r, t) {
  return {
    identifier: e,
    isActive: !0,
    willRenew: !1,
    store: t.store,
    latestPurchaseDate: new Date(r.purchase_date),
    originalPurchaseDate: new Date(
      t.original_purchase_date
    ),
    expirationDate: null,
    productIdentifier: r.product_identifier,
    productPlanIdentifier: null,
    unsubscribeDetectedAt: null,
    billingIssueDetectedAt: null,
    isSandbox: t.is_sandbox,
    periodType: "normal",
    ownershipType: "UNKNOWN"
  };
}
function pm(e, r, t) {
  const a = {}, n = {};
  for (const o in e) {
    const i = cm(
      o,
      e[o],
      r,
      t
    );
    a[o] = i, i.isActive && (n[o] = i);
  }
  return {
    all: a,
    active: n
  };
}
function lr(e) {
  return e == null ? null : new Date(e);
}
function _m(e) {
  const r = mm(e), t = e.subscriber, a = ym(
    t.non_subscriptions
  ), n = Object.entries(e.subscriber.non_subscriptions).flatMap(
    ([s, l]) => l.map((c) => ({
      transactionIdentifier: c.id,
      productIdentifier: s,
      purchaseDate: new Date(
        c.purchase_date || c.original_purchase_date
      ),
      storeTransactionId: c.store_transaction_id || null,
      store: c.store
    }))
  ), o = new Date(e.request_date), i = Object.fromEntries(
    Object.entries(e.subscriber.subscriptions).map(
      ([s, l]) => [
        s,
        {
          productIdentifier: s,
          purchaseDate: new Date(l.purchase_date),
          originalPurchaseDate: lr(
            l.original_purchase_date
          ),
          expiresDate: lr(l.expires_date),
          store: l.store,
          unsubscribeDetectedAt: lr(
            l.unsubscribe_detected_at
          ),
          isSandbox: l.is_sandbox,
          billingIssuesDetectedAt: lr(
            l.billing_issues_detected_at
          ),
          gracePeriodExpiresDate: lr(
            l.grace_period_expires_date
          ),
          ownershipType: l.ownership_type ?? "UNKNOWN",
          periodType: l.period_type,
          refundedAt: lr(l.refunded_at),
          storeTransactionId: l.store_transaction_id || null,
          isActive: Wi(l.expires_date),
          willRenew: Yi(l.expires_date, l)
        }
      ]
    )
  );
  return {
    entitlements: pm(
      t.entitlements,
      t.subscriptions,
      a
    ),
    allExpirationDatesByProduct: r,
    allPurchaseDatesByProduct: gm(
      e,
      a
    ),
    activeSubscriptions: fm(r),
    managementURL: t.management_url,
    requestDate: o,
    firstSeenDate: new Date(t.first_seen),
    originalPurchaseDate: lr(
      t.original_purchase_date
    ),
    originalAppUserId: e.subscriber.original_app_user_id,
    nonSubscriptionTransactions: n,
    subscriptionsByProductIdentifier: i
  };
}
function Yi(e, r) {
  if (r == null) return !1;
  const t = r.store == "promotional", a = e == null, n = r.unsubscribe_detected_at != null, o = r.billing_issues_detected_at != null;
  return !(t || a || n || o);
}
function gm(e, r) {
  const t = {};
  for (const a in e.subscriber.subscriptions) {
    const n = e.subscriber.subscriptions[a];
    t[a] = new Date(
      n.purchase_date
    );
  }
  for (const a in r) {
    const n = r[a].purchase_date;
    n == null ? t[a] = null : t[a] = new Date(n);
  }
  return t;
}
function mm(e) {
  const r = {};
  for (const t in e.subscriber.subscriptions) {
    const a = e.subscriber.subscriptions[t];
    a.expires_date == null ? r[t] = null : r[t] = new Date(
      a.expires_date
    );
  }
  return r;
}
function fm(e) {
  const r = /* @__PURE__ */ new Set(), t = /* @__PURE__ */ new Date();
  for (const a in e) {
    const n = e[a];
    (n == null || n > t) && r.add(a);
  }
  return r;
}
function ym(e) {
  const r = {};
  for (const t in e) {
    if (e[t].length === 0) continue;
    const a = e[t].length;
    r[t] = e[t][a - 1];
  }
  return r;
}
const Gi = "1.7.0", bm = "https://api.revenuecat.com", hm = "https://e.revenue.cat";
var da;
(function(e) {
  e[e.CONTINUE = 100] = "CONTINUE", e[e.SWITCHING_PROTOCOLS = 101] = "SWITCHING_PROTOCOLS", e[e.PROCESSING = 102] = "PROCESSING", e[e.EARLY_HINTS = 103] = "EARLY_HINTS", e[e.OK = 200] = "OK", e[e.CREATED = 201] = "CREATED", e[e.ACCEPTED = 202] = "ACCEPTED", e[e.NON_AUTHORITATIVE_INFORMATION = 203] = "NON_AUTHORITATIVE_INFORMATION", e[e.NO_CONTENT = 204] = "NO_CONTENT", e[e.RESET_CONTENT = 205] = "RESET_CONTENT", e[e.PARTIAL_CONTENT = 206] = "PARTIAL_CONTENT", e[e.MULTI_STATUS = 207] = "MULTI_STATUS", e[e.MULTIPLE_CHOICES = 300] = "MULTIPLE_CHOICES", e[e.MOVED_PERMANENTLY = 301] = "MOVED_PERMANENTLY", e[e.MOVED_TEMPORARILY = 302] = "MOVED_TEMPORARILY", e[e.SEE_OTHER = 303] = "SEE_OTHER", e[e.NOT_MODIFIED = 304] = "NOT_MODIFIED", e[e.USE_PROXY = 305] = "USE_PROXY", e[e.TEMPORARY_REDIRECT = 307] = "TEMPORARY_REDIRECT", e[e.PERMANENT_REDIRECT = 308] = "PERMANENT_REDIRECT", e[e.BAD_REQUEST = 400] = "BAD_REQUEST", e[e.UNAUTHORIZED = 401] = "UNAUTHORIZED", e[e.PAYMENT_REQUIRED = 402] = "PAYMENT_REQUIRED", e[e.FORBIDDEN = 403] = "FORBIDDEN", e[e.NOT_FOUND = 404] = "NOT_FOUND", e[e.METHOD_NOT_ALLOWED = 405] = "METHOD_NOT_ALLOWED", e[e.NOT_ACCEPTABLE = 406] = "NOT_ACCEPTABLE", e[e.PROXY_AUTHENTICATION_REQUIRED = 407] = "PROXY_AUTHENTICATION_REQUIRED", e[e.REQUEST_TIMEOUT = 408] = "REQUEST_TIMEOUT", e[e.CONFLICT = 409] = "CONFLICT", e[e.GONE = 410] = "GONE", e[e.LENGTH_REQUIRED = 411] = "LENGTH_REQUIRED", e[e.PRECONDITION_FAILED = 412] = "PRECONDITION_FAILED", e[e.REQUEST_TOO_LONG = 413] = "REQUEST_TOO_LONG", e[e.REQUEST_URI_TOO_LONG = 414] = "REQUEST_URI_TOO_LONG", e[e.UNSUPPORTED_MEDIA_TYPE = 415] = "UNSUPPORTED_MEDIA_TYPE", e[e.REQUESTED_RANGE_NOT_SATISFIABLE = 416] = "REQUESTED_RANGE_NOT_SATISFIABLE", e[e.EXPECTATION_FAILED = 417] = "EXPECTATION_FAILED", e[e.IM_A_TEAPOT = 418] = "IM_A_TEAPOT", e[e.INSUFFICIENT_SPACE_ON_RESOURCE = 419] = "INSUFFICIENT_SPACE_ON_RESOURCE", e[e.METHOD_FAILURE = 420] = "METHOD_FAILURE", e[e.MISDIRECTED_REQUEST = 421] = "MISDIRECTED_REQUEST", e[e.UNPROCESSABLE_ENTITY = 422] = "UNPROCESSABLE_ENTITY", e[e.LOCKED = 423] = "LOCKED", e[e.FAILED_DEPENDENCY = 424] = "FAILED_DEPENDENCY", e[e.UPGRADE_REQUIRED = 426] = "UPGRADE_REQUIRED", e[e.PRECONDITION_REQUIRED = 428] = "PRECONDITION_REQUIRED", e[e.TOO_MANY_REQUESTS = 429] = "TOO_MANY_REQUESTS", e[e.REQUEST_HEADER_FIELDS_TOO_LARGE = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE", e[e.UNAVAILABLE_FOR_LEGAL_REASONS = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS", e[e.INTERNAL_SERVER_ERROR = 500] = "INTERNAL_SERVER_ERROR", e[e.NOT_IMPLEMENTED = 501] = "NOT_IMPLEMENTED", e[e.BAD_GATEWAY = 502] = "BAD_GATEWAY", e[e.SERVICE_UNAVAILABLE = 503] = "SERVICE_UNAVAILABLE", e[e.GATEWAY_TIMEOUT = 504] = "GATEWAY_TIMEOUT", e[e.HTTP_VERSION_NOT_SUPPORTED = 505] = "HTTP_VERSION_NOT_SUPPORTED", e[e.INSUFFICIENT_STORAGE = 507] = "INSUFFICIENT_STORAGE", e[e.NETWORK_AUTHENTICATION_REQUIRED = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
})(da || (da = {}));
function ua(e) {
  return e ? e.startsWith("rcb_sb_") : !1;
}
async function gr(e, r, t) {
  const { apiKey: a, body: n, headers: o, httpConfig: i } = r, l = `${(i == null ? void 0 : i.proxyURL) ?? bm}${e.urlPath()}`;
  try {
    const c = await fetch(l, {
      method: e.method,
      headers: ts(a, o, i == null ? void 0 : i.additionalHeaders),
      body: km(n),
      signal: t
    });
    return await vm(c, e), await c.json();
  } catch (c) {
    throw c instanceof TypeError ? new _e(
      he.NetworkError,
      kt.getPublicMessage(he.NetworkError),
      c.message
    ) : c;
  }
}
async function vm(e, r) {
  const t = e.status;
  if (t >= da.INTERNAL_SERVER_ERROR)
    Da(r, t, await e.text());
  else if (t >= da.BAD_REQUEST) {
    const a = await e.json(), n = a ? JSON.stringify(a) : null, o = a == null ? void 0 : a.code, i = a == null ? void 0 : a.message;
    if (o != null) {
      const s = kt.convertCodeToBackendErrorCode(o);
      if (s == null)
        Da(
          r,
          t,
          n,
          o
        );
      else
        throw _e.getForBackendError(
          s,
          i
        );
    } else
      Da(r, t, n);
  }
}
function Da(e, r, t, a) {
  throw new _e(
    he.UnknownBackendError,
    "Unknown backend error.",
    `Request: ${e.name}. Status code: ${r}. Body: ${t}.`,
    { backendErrorCode: a }
  );
}
function km(e) {
  return e == null ? null : JSON.stringify(e);
}
const Xi = "Authorization", Zi = "Content-Type", Ki = "Accept", Ji = "X-Platform", Qi = "X-Version", $i = "X-Platform-Flavor", es = "X-Platform-Flavor-Version", rs = "X-Is-Sandbox", wm = /* @__PURE__ */ new Set([
  Xi,
  Zi,
  Ki,
  Ji,
  Qi,
  rs,
  $i,
  es
]);
function ts(e, r, t) {
  let a = {
    [Xi]: `Bearer ${e}`,
    [Zi]: "application/json",
    [Ki]: "application/json",
    [Ji]: "web",
    [Qi]: Gi,
    [rs]: `${ua(e)}`
  };
  const n = an.getPlatformInfo();
  if (n) {
    const o = {
      [$i]: n.flavor,
      [es]: n.version
    };
    a = { ...a, ...o };
  }
  return r && (a = { ...a, ...r }), t && (a = { ...t, ...a }), a;
}
const Fn = "/v1/subscribers", ut = "/rcbilling/v1";
class xm {
  constructor(r) {
    M(this, "appUserId");
    M(this, "method", "GET");
    M(this, "name", "getOfferings");
    this.appUserId = r;
  }
  urlPath() {
    const r = encodeURIComponent(this.appUserId);
    return `${Fn}/${r}/offerings`;
  }
}
class Pm {
  constructor(r, t, a) {
    M(this, "method", "GET");
    M(this, "name", "getProducts");
    M(this, "appUserId");
    M(this, "productIds");
    M(this, "currency");
    this.appUserId = r, this.productIds = t, this.currency = a;
  }
  urlPath() {
    const r = encodeURIComponent(this.appUserId), t = this.productIds.map(encodeURIComponent).join("&id="), a = this.currency ? `&currency=${this.currency}` : "";
    return `${ut}/subscribers/${r}/products?id=${t}${a}`;
  }
}
class Sm {
  constructor(r) {
    M(this, "method", "GET");
    M(this, "name", "getCustomerInfo");
    M(this, "appUserId");
    this.appUserId = r;
  }
  urlPath() {
    const r = encodeURIComponent(this.appUserId);
    return `${Fn}/${r}`;
  }
}
class Em {
  constructor() {
    M(this, "method", "GET");
    M(this, "name", "getBrandingInfo");
  }
  urlPath() {
    return `${ut}/branding`;
  }
}
class Tm {
  constructor() {
    M(this, "method", "POST");
    M(this, "name", "postCheckoutStart");
  }
  urlPath() {
    return `${ut}/checkout/start`;
  }
}
class Im {
  constructor(r) {
    M(this, "method", "POST");
    M(this, "name", "postCheckoutCalculateTax");
    M(this, "operationSessionId");
    this.operationSessionId = r;
  }
  urlPath() {
    return `${ut}/checkout/${this.operationSessionId}/calculate_taxes`;
  }
}
class qm {
  constructor(r) {
    M(this, "method", "POST");
    M(this, "name", "postCheckoutComplete");
    M(this, "operationSessionId");
    this.operationSessionId = r;
  }
  urlPath() {
    return `${ut}/checkout/${this.operationSessionId}/complete`;
  }
}
class Fm {
  constructor(r) {
    M(this, "method", "GET");
    M(this, "name", "getCheckoutStatus");
    M(this, "operationSessionId");
    this.operationSessionId = r;
  }
  urlPath() {
    return `${ut}/checkout/${this.operationSessionId}`;
  }
}
class zm {
  constructor(r) {
    M(this, "method", "POST");
    M(this, "name", "setAttributes");
    M(this, "appUserId");
    this.appUserId = r;
  }
  urlPath() {
    const r = encodeURIComponent(this.appUserId);
    return `${Fn}/${r}/attributes`;
  }
}
const tn = {};
class Dm {
  constructor(r, t = tn) {
    M(this, "API_KEY");
    M(this, "httpConfig");
    M(this, "isSandbox");
    this.API_KEY = r, this.httpConfig = t, this.isSandbox = ua(r);
  }
  getIsSandbox() {
    return this.isSandbox;
  }
  async getOfferings(r) {
    return await gr(
      new xm(r),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
  async getCustomerInfo(r) {
    return await gr(
      new Sm(r),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
  async getProducts(r, t, a) {
    return await gr(
      new Pm(r, t, a),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
  async getBrandingInfo() {
    return await gr(
      new Em(),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
  async postCheckoutStart(r, t, a, n, o, i, s = void 0) {
    const l = {
      app_user_id: r,
      product_id: t,
      email: i,
      price_id: n.priceId,
      presented_offering_identifier: a.offeringIdentifier,
      trace_id: o
    };
    return s && (l.metadata = s), n.id !== "base_option" && (l.offer_id = n.id), a.targetingContext && (l.applied_targeting_rule = {
      rule_id: a.targetingContext.ruleId,
      revision: a.targetingContext.revision
    }), a.placementIdentifier && (l.presented_placement_identifier = a.placementIdentifier), await gr(new Tm(), {
      apiKey: this.API_KEY,
      body: l,
      httpConfig: this.httpConfig
    });
  }
  async postCheckoutCalculateTax(r, t, a, n) {
    const o = {
      country_code: t,
      postal_code: a
    };
    return await gr(
      new Im(r),
      {
        apiKey: this.API_KEY,
        body: o,
        httpConfig: this.httpConfig
      },
      n
    );
  }
  async postCheckoutComplete(r, t) {
    const a = {
      email: t
    };
    return await gr(new qm(r), {
      apiKey: this.API_KEY,
      body: a,
      httpConfig: this.httpConfig
    });
  }
  async getCheckoutStatus(r) {
    return await gr(
      new Fm(r),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
  async setAttributes(r, t) {
    const a = Date.now(), n = {};
    for (const [i, s] of Object.entries(t))
      n[i] = {
        value: s,
        updated_at_ms: a
      };
    const o = {
      attributes: n
    };
    return await gr(
      new zm(r),
      {
        apiKey: this.API_KEY,
        body: o,
        httpConfig: this.httpConfig
      }
    );
  }
}
function Am(e) {
  const r = /^rcb_[a-zA-Z0-9_.-]+$/, t = /^pdl_[a-zA-Z0-9_.-]+$/;
  if (!r.test(e) && !t.test(e))
    throw new _e(
      he.InvalidCredentialsError,
      "Invalid API key. Use your Web Billing or Paddle API key."
    );
}
function So(e) {
  if (!e || (/* @__PURE__ */ new Set([
    "no_user",
    "null",
    "none",
    "nil",
    "(null)",
    "NaN",
    "\\x00",
    "",
    "unidentified",
    "undefined",
    "unknown"
  ])).has(e) || e.includes("/"))
    throw new _e(
      he.InvalidAppUserIdError,
      'Provided user id: "' + (e ?? "[Not provided]") + '" is not valid. See https://www.revenuecat.com/docs/customers/user-ids#tips-for-setting-app-user-ids for more information.'
    );
}
function Mm(e) {
  if (e != null && e.endsWith("/"))
    throw new _e(
      he.ConfigurationError,
      "Invalid proxy URL. The proxy URL should not end with a trailing slash."
    );
}
function jm(e) {
  if (e) {
    for (const r in e)
      if (wm.has(r))
        throw new _e(
          he.ConfigurationError,
          "Invalid additional headers. Some headers are reserved for internal use."
        );
  }
}
var as = /* @__PURE__ */ ((e) => (e.Current = "current", e))(as || {});
function Nm(e, r) {
  async function t(...a) {
    return await this.preload(), await e.call(this, ...a);
  }
  return t;
}
const ns = (e, r) => {
  const t = {
    ...e.webBillingProduct,
    presentedOfferingContext: {
      ...e.webBillingProduct.presentedOfferingContext,
      placementIdentifier: r
    }
  };
  return {
    ...e,
    webBillingProduct: t,
    rcBillingProduct: t
  };
}, Cr = (e, r) => e == null ? null : ns(e, r), Cm = (e, r, t) => {
  const a = e.offering_ids_by_placement ?? null;
  if (a == null)
    return null;
  const n = e.fallback_offering_id ?? null;
  let o;
  if (t in a) {
    const s = a[t] ?? null;
    if (s == null)
      return null;
    o = r[s], o == null && (o = r[n]);
  } else
    o = r[n];
  if (o == null)
    return null;
  const i = Object.fromEntries(
    Object.entries(o.packagesById).map(([s, l]) => [
      s,
      ns(l, t)
    ])
  );
  return {
    ...o,
    packagesById: i,
    availablePackages: Object.values(i),
    weekly: Cr(o.weekly, t),
    monthly: Cr(
      o.monthly,
      t
    ),
    twoMonth: Cr(
      o.twoMonth,
      t
    ),
    threeMonth: Cr(
      o.threeMonth,
      t
    ),
    sixMonth: Cr(
      o.sixMonth,
      t
    ),
    annual: Cr(o.annual, t),
    lifetime: Cr(
      o.lifetime,
      t
    )
  };
};
function Om(e, r) {
  const t = {};
  r.product_details.forEach((o) => {
    t[o.identifier] = o;
  });
  const a = {};
  e.offerings.forEach((o) => {
    const i = o.identifier === e.current_offering_id, s = __(
      i,
      o,
      t,
      e.targeting
    );
    s != null && (a[o.identifier] = s);
  });
  const n = e.current_offering_id ? a[e.current_offering_id] ?? null : null;
  return Object.keys(a).length == 0 && K.debugLog(
    "Empty offerings. Please make sure you've configured offerings correctly in the RevenueCat dashboard and that the products are properly configured."
  ), {
    all: a,
    current: n
  };
}
const Lm = 1000001;
function Bm(e) {
  return e.webBillingProduct.defaultPurchaseOption;
}
function Eo(e, r, t, a = !1) {
  return t.translate(L.PaywallVariablesPricePerPeriod, {
    formattedPrice: e,
    period: r.base.period ? t.translatePeriod(
      r.base.period.number,
      r.base.period.unit,
      {
        noWhitespace: !0,
        short: !a
      }
    ) : ""
  });
}
function Rm(e, r) {
  return e.unit === "year" ? r.translatePeriod(e.number * 12, xe.Month) : r.translatePeriod(e.number, e.unit);
}
function Um({
  price: e,
  period: r,
  translator: t
}) {
  const a = t.formatPrice(e.amountMicros, e.currency);
  return r ? r.unit === "year" ? t.formatPrice(e.amountMicros / 12 / 4, e.currency) : r.unit === "month" || r.unit === "week" && r.number > 1 ? t.formatPrice(
    e.amountMicros / r.number,
    e.currency
  ) : r.unit === "day" ? t.formatPrice(
    e.amountMicros * 7 / r.number,
    e.currency
  ) : a : a;
}
function Vm({
  price: e,
  period: r,
  translator: t
}) {
  const a = t.formatPrice(e.amountMicros, e.currency);
  return !r || !r.number ? a : r.unit === "year" ? t.formatPrice(e.amountMicros / 12, e.currency) : r.unit === "month" && r.number > 1 ? t.formatPrice(
    e.amountMicros / r.number,
    e.currency
  ) : r.unit === "week" ? t.formatPrice(
    e.amountMicros * 4 / r.number,
    e.currency
  ) : r.unit === "day" ? t.formatPrice(
    e.amountMicros * 30 / r.number,
    e.currency
  ) : a;
}
function To({
  price: e,
  period: r,
  full: t = !1,
  translator: a
}) {
  if (!r || !r.number || r.unit === xe.Month && r.number == 1)
    return a.formatPrice(e.amountMicros, e.currency);
  let n = "";
  switch (r.unit) {
    case xe.Year:
      n = a.formatPrice(
        e.amountMicros / 12,
        e.currency
      );
      break;
    case xe.Month:
      n = a.formatPrice(
        e.amountMicros / r.number,
        e.currency
      );
      break;
    case xe.Week:
      n = a.formatPrice(
        e.amountMicros * 4 / r.number,
        e.currency
      );
      break;
    case xe.Day:
      n = a.formatPrice(
        e.amountMicros * 30 / r.number,
        e.currency
      );
      break;
  }
  return a.translate(
    L.PaywallVariablesTotalPriceAndPerMonth,
    {
      formattedPrice: a.formatPrice(
        e.amountMicros,
        e.currency
      ),
      period: a.translatePeriod(r.number, r.unit, {
        noWhitespace: !0,
        short: !t
      }),
      formattedPricePerMonth: n,
      monthPeriod: a.translatePeriodUnit(xe.Month, {
        noWhitespace: !0,
        short: !t
      })
    }
  );
}
function Hm(e, r) {
  const t = e.availablePackages, a = t.reduce((n, o) => n.webBillingProduct.currentPrice.amountMicros > o.webBillingProduct.currentPrice.amountMicros ? n : o);
  return t.reduce(
    (n, o) => (n[o.identifier] = Wm(
      o,
      a,
      r
    ), n),
    {}
  );
}
function Wm(e, r, t) {
  const a = e.webBillingProduct, n = t.formatPrice(
    a.currentPrice.amountMicros,
    a.currentPrice.currency
  ), o = Bm(e), i = a.productType, s = {
    product_name: a.title,
    price: n,
    price_per_period: "",
    price_per_period_full: "",
    total_price_and_per_month: "",
    total_price_and_per_month_full: "",
    sub_price_per_month: "",
    sub_price_per_week: "",
    sub_duration: "",
    sub_duration_in_months: "",
    sub_period: "",
    sub_period_length: "",
    sub_period_abbreviated: "",
    sub_offer_duration: void 0,
    sub_offer_duration_2: void 0,
    // doesn't apply - only google play
    sub_offer_price: void 0,
    sub_offer_price_2: void 0,
    // doesn't apply - only google play
    sub_relative_discount: ""
  };
  if (i === Lr.Subscription && o) {
    s.price_per_period = Eo(
      n,
      o,
      t
    ), s.price_per_period_full = Eo(
      n,
      o,
      t,
      !0
    );
    const l = o.base.period;
    s.total_price_and_per_month = To({
      price: a.currentPrice,
      period: l,
      translator: t
    }), s.total_price_and_per_month_full = To({
      price: a.currentPrice,
      period: l,
      full: !0,
      translator: t
    }), s.sub_price_per_month = Vm({
      price: a.currentPrice,
      period: l,
      translator: t
    }), s.sub_price_per_week = Um({
      price: a.currentPrice,
      period: l,
      translator: t
    }), s.sub_duration = t.translatePeriod(
      l == null ? void 0 : l.number,
      l == null ? void 0 : l.unit
    ), s.sub_duration_in_months = Rm(
      l,
      t
    ), s.sub_period = t.translatePeriodFrequency(
      l == null ? void 0 : l.number,
      l == null ? void 0 : l.unit
    ), s.sub_period_length = l ? t.translatePeriodUnit(l.unit, {
      noWhitespace: !0
    }) : void 0, s.sub_period_abbreviated = l ? t.translatePeriodUnit(l.unit, {
      noWhitespace: !0,
      short: !0
    }) : void 0;
    const c = a.currentPrice.amountMicros, p = r.webBillingProduct.currentPrice.amountMicros, u = ((p - c) * 100 / p).toFixed(0);
    s.sub_relative_discount = c === p ? "" : t.translate(
      L.PaywallVariablesSubRelativeDiscount,
      {
        discount: u
      }
    );
  }
  return (i === Lr.NonConsumable || i === Lr.Consumable) && o && (s.price = n, s.price_per_period = n, s.price_per_period_full = n, s.total_price_and_per_month = n, s.sub_price_per_month = n, s.sub_duration = t.translate(
    L.PeriodsLifetime
  ), s.sub_duration_in_months = t.translate(
    L.PeriodsLifetime
  ), s.sub_period = t.translate(
    L.PeriodsLifetime
  ), s.sub_price_per_week = void 0, s.sub_relative_discount = void 0, s.price_per_period_full = n, s.total_price_and_per_month_full = n, s.sub_period_length = void 0, s.sub_period_abbreviated = void 0), s;
}
const we = [];
for (let e = 0; e < 256; ++e)
  we.push((e + 256).toString(16).slice(1));
function Ym(e, r = 0) {
  return (we[e[r + 0]] + we[e[r + 1]] + we[e[r + 2]] + we[e[r + 3]] + "-" + we[e[r + 4]] + we[e[r + 5]] + "-" + we[e[r + 6]] + we[e[r + 7]] + "-" + we[e[r + 8]] + we[e[r + 9]] + "-" + we[e[r + 10]] + we[e[r + 11]] + we[e[r + 12]] + we[e[r + 13]] + we[e[r + 14]] + we[e[r + 15]]).toLowerCase();
}
let Aa;
const Gm = new Uint8Array(16);
function Xm() {
  if (!Aa) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    Aa = crypto.getRandomValues.bind(crypto);
  }
  return Aa(Gm);
}
const Zm = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Io = { randomUUID: Zm };
function os(e, r, t) {
  var n;
  if (Io.randomUUID && !e)
    return Io.randomUUID();
  e = e || {};
  const a = e.random ?? ((n = e.rng) == null ? void 0 : n.call(e)) ?? Xm();
  if (a.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return a[6] = a[6] & 15 | 64, a[8] = a[8] & 63 | 128, Ym(a);
}
var Km = /(%?)(%([sdijo]))/g;
function Jm(e, r) {
  switch (r) {
    case "s":
      return e;
    case "d":
    case "i":
      return Number(e);
    case "j":
      return JSON.stringify(e);
    case "o": {
      if (typeof e == "string")
        return e;
      const t = JSON.stringify(e);
      return t === "{}" || t === "[]" || /^\[object .+?\]$/.test(t) ? e : t;
    }
  }
}
function zn(e, ...r) {
  if (r.length === 0)
    return e;
  let t = 0, a = e.replace(
    Km,
    (n, o, i, s) => {
      const l = r[t], c = Jm(l, s);
      return o ? n : (t++, c);
    }
  );
  return t < r.length && (a += ` ${r.slice(t).join(" ")}`), a = a.replace(/%{2,2}/g, "%"), a;
}
var Qm = 2;
function $m(e) {
  if (!e.stack)
    return;
  const r = e.stack.split(`
`);
  r.splice(1, Qm), e.stack = r.join(`
`);
}
var ef = class extends Error {
  constructor(e, ...r) {
    super(e), this.message = e, this.name = "Invariant Violation", this.message = zn(e, ...r), $m(this);
  }
}, is = (e, r, ...t) => {
  if (!e)
    throw new ef(r, ...t);
};
is.as = (e, r, t, ...a) => {
  if (!r) {
    const n = a.length === 0 ? t : zn(t, ...a);
    let o;
    try {
      o = Reflect.construct(e, [
        n
      ]);
    } catch {
      o = e(n);
    }
    throw o;
  }
};
const rf = "[MSW]";
function Dn(e, ...r) {
  const t = zn(e, ...r);
  return `${rf} ${t}`;
}
function tf(e, ...r) {
  console.warn(Dn(e, ...r));
}
function af(e, ...r) {
  console.error(Dn(e, ...r));
}
const nf = {
  formatMessage: Dn,
  warn: tf,
  error: af
};
function of() {
  is(
    typeof URL < "u",
    nf.formatMessage(
      `Global "URL" class is not defined. This likely means that you're running MSW in an environment that doesn't support all Node.js standard API (e.g. React Native). If that's the case, please use an appropriate polyfill for the "URL" class, like "react-native-url-polyfill".`
    )
  );
}
var ss = /* @__PURE__ */ ((e) => (e.HEAD = "HEAD", e.GET = "GET", e.POST = "POST", e.PUT = "PUT", e.PATCH = "PATCH", e.OPTIONS = "OPTIONS", e.DELETE = "DELETE", e))(ss || {});
of();
class sf {
  constructor(r, t, a, n) {
    M(this, "initialDelay");
    M(this, "maxDelay");
    M(this, "jitterPercent");
    M(this, "callback");
    M(this, "currentDelay");
    M(this, "timeoutId");
    M(this, "executingCallback", !1);
    this.initialDelay = r, this.currentDelay = r, this.maxDelay = t, this.jitterPercent = a, this.callback = n;
  }
  tryFlush() {
    if (this.backingOff()) {
      K.debugLog("Backing off, not flushing");
      return;
    }
    this.clearTimeout(), this.executeCallbackWithRetries();
  }
  stop() {
    this.clearTimeout();
  }
  schedule(r) {
    if (this.timeoutId !== void 0)
      return;
    const t = this.addJitter(r || this.currentDelay);
    this.timeoutId = setTimeout(() => {
      this.timeoutId = void 0, this.executeCallbackWithRetries();
    }, t);
  }
  backoff() {
    const r = this.currentDelay, t = Math.min(this.currentDelay * 2, this.maxDelay);
    K.debugLog(`Backing next off to ${r}ms delay`), this.clearTimeout(), this.currentDelay = t, this.schedule(r);
  }
  reset() {
    this.currentDelay !== this.initialDelay && (this.clearTimeout(), this.currentDelay = this.initialDelay);
  }
  async executeCallbackWithRetries() {
    if (this.executingCallback) {
      K.debugLog("Callback already running, rescheduling"), this.schedule();
      return;
    }
    this.executingCallback = !0;
    try {
      await this.callback(), this.reset();
    } catch {
      this.backoff();
    } finally {
      this.executingCallback = !1;
    }
  }
  backingOff() {
    return this.currentDelay > this.initialDelay;
  }
  clearTimeout() {
    clearTimeout(this.timeoutId), this.timeoutId = void 0;
  }
  addJitter(r) {
    const t = r * this.jitterPercent, a = r - t, n = r + t;
    return Math.floor(Math.random() * (n - a + 1) + a);
  }
}
function ls(e) {
  const r = {};
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t)) {
      const a = t.replace(/([A-Z])/g, "_$1").toLowerCase(), n = e[t];
      n && typeof n == "object" && !Array.isArray(n) ? r[a] = ls(
        n
      ) : r[a] = n;
    }
  return r;
}
class lf {
  constructor(r) {
    M(this, "EVENT_TYPE", "web_billing");
    M(this, "id");
    M(this, "timestampMs");
    M(this, "data");
    this.id = os(), this.timestampMs = Date.now(), this.data = r;
  }
  toJSON() {
    return ls({
      id: this.id,
      timestampMs: this.timestampMs,
      type: this.EVENT_TYPE,
      eventName: this.data.eventName,
      appUserId: this.data.appUserId,
      context: {
        ...this.data.context
      },
      properties: {
        ...this.data.properties,
        traceId: this.data.traceId
      }
    });
  }
}
function cf(e, r) {
  const t = new URLSearchParams(window.location.search);
  return {
    libraryName: "purchases-js",
    libraryVersion: Gi,
    locale: navigator.language,
    userAgent: navigator.userAgent,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    screenWidth: screen.width,
    screenHeight: screen.height,
    utmSource: t.get("utm_source") ?? null,
    utmMedium: t.get("utm_medium") ?? null,
    utmCampaign: t.get("utm_campaign") ?? null,
    utmContent: t.get("utm_content") ?? null,
    utmTerm: t.get("utm_term") ?? null,
    pageReferrer: document.referrer,
    pageUrl: `${window.location.origin}${window.location.pathname}`,
    pageTitle: document.title,
    source: e,
    rcSource: r
  };
}
const df = 2e3, uf = 5 * 6e4, pf = 0.1;
class _f {
  constructor(r) {
    M(this, "apiKey");
    M(this, "eventsQueue", []);
    M(this, "eventsUrl");
    M(this, "flushManager");
    M(this, "traceId", os());
    M(this, "appUserId");
    M(this, "isSilent");
    M(this, "rcSource");
    this.apiKey = r.apiKey, this.eventsUrl = `${hm}/v1/events`, this.appUserId = r.appUserId, this.isSilent = r.silent || !1, this.rcSource = r.rcSource, this.flushManager = new sf(
      df,
      uf,
      pf,
      this.flushEvents.bind(this)
    );
  }
  async updateUser(r) {
    this.appUserId = r;
  }
  getTraceId() {
    return this.traceId;
  }
  trackSDKEvent(r) {
    this.trackEvent({ ...r, source: "sdk" });
  }
  trackExternalEvent(r) {
    this.trackEvent({ ...r });
  }
  trackEvent(r) {
    if (this.isSilent) {
      K.verboseLog("Skipping event tracking, the EventsTracker is silent");
      return;
    }
    try {
      const t = new lf({
        eventName: r.eventName,
        traceId: this.traceId,
        appUserId: this.appUserId,
        context: cf(r.source, this.rcSource),
        properties: r.properties || {}
      });
      this.eventsQueue.push(t), this.flushManager.tryFlush();
    } catch {
      K.errorLog(`Error while tracking event ${r.eventName}`);
    }
  }
  dispose() {
    this.flushManager.stop();
  }
  flushEvents() {
    if (this.eventsQueue.length === 0)
      return Promise.resolve();
    const r = [...this.eventsQueue];
    return fetch(this.eventsUrl, {
      method: ss.POST,
      headers: ts(this.apiKey),
      body: JSON.stringify({ events: r })
    }).then((t) => {
      if (t.status === 200 || t.status === 201) {
        this.eventsQueue.splice(0, r.length);
        return;
      } else
        throw K.debugLog("Events failed to flush due to server error"), new Error("Events failed to flush due to server error");
    }).catch((t) => {
      throw K.debugLog("Error while flushing events"), t;
    });
  }
}
const gf = () => {
  const e = new URLSearchParams(window.location.search), r = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content"
  ], t = {};
  return r.forEach((a) => {
    const n = e.get(a);
    n !== null && (t[a] = n);
  }), t;
}, mf = ["app", "embedded"], Ma = {
  autoCollectUTMAsMetadata: !0,
  collectAnalyticsEvents: !0
};
function ff() {
  if (crypto && crypto.randomUUID)
    return crypto.randomUUID();
  const e = new Uint8Array(16);
  if (crypto && crypto.getRandomValues)
    crypto.getRandomValues(e);
  else
    for (let t = 0; t < 16; t++)
      e[t] = Math.floor(Math.random() * 256);
  e[6] = e[6] & 15 | 64, e[8] = e[8] & 63 | 128;
  const r = Array.from(e).map((t) => t.toString(16).padStart(2, "0"));
  return [
    r.slice(0, 4).join(""),
    r.slice(4, 6).join(""),
    r.slice(6, 8).join(""),
    r.slice(8, 10).join(""),
    r.slice(10, 16).join("")
  ].join("-");
}
var yf = /* @__PURE__ */ ((e) => (e.DisplayName = "$displayName", e.Email = "$email", e.PhoneNumber = "$phoneNumber", e.IDFA = "$idfa", e.IDFV = "$idfv", e.GPSAdId = "$gpsAdId", e.AndroidId = "$androidId", e.AmazonAdId = "$amazonAdId", e.IP = "$ip", e.AdjustId = "$adjustId", e.AmplitudeDeviceId = "$amplitudeDeviceId", e.AmplitudeUserId = "$amplitudeUserId", e.AppsflyerId = "$appsflyerId", e.AppsflyerSharingFilter = "$appsflyerSharingFilter", e.BranchId = "$branchId", e.BrazeAliasName = "$brazeAliasName", e.BrazeAliasLabel = "$brazeAliasLabel", e.ClevertapId = "$clevertapId", e.FbAnonId = "$fbAnonId", e.MparticleId = "$mparticleId", e.OnesignalId = "$onesignalId", e.OnesignalUserId = "$onesignalUserId", e.IntercomContactId = "$intercomContactId", e.MediaSource = "$mediaSource", e.Campaign = "$campaign", e.AdGroup = "$adGroup", e.AdId = "$ad", e.Keyword = "$keyword", e.Creative = "$creative", e.APNSTokens = "$apnsTokens", e.FCMTokens = "$fcmTokens", e.AirshipChannelId = "$airshipChannelId", e.SegmentId = "$segmentId", e.IterableUserId = "$iterableUserId", e.IterableCampaignId = "$iterableCampaignId", e.IterableTemplateId = "$iterableTemplateId", e.FirebaseAppInstanceId = "$firebaseAppInstanceId", e.MixpanelDistinctId = "$mixpanelDistinctId", e.ATTConsentStatus = "$attConsentStatus", e.KochavaDeviceId = "$kochavaDeviceId", e.DeviceVersion = "$deviceVersion", e.PosthogUserId = "$posthogUserId", e.TelemetryDeckUserId = "$telemetryDeckUserId", e.TelemetryDeckAppId = "$telemetryDeckAppId", e.AppleRefundHandlingPreference = "$appleRefundHandlingPreference", e.CustomerioId = "$customerioId", e.TenjinId = "$tenjinId", e))(yf || {});
const qo = "$RCAnonymousID:";
var Fo, ja;
Fo = [Nm];
const be = class be {
  /** @internal */
  constructor(r, t, a = tn, n = Ma) {
    Wn(ja, 5, this);
    /** @internal */
    M(this, "_API_KEY");
    /** @internal */
    M(this, "_appUserId");
    /** @internal */
    M(this, "_brandingInfo", null);
    /** @internal */
    M(this, "_loadingResourcesPromise", null);
    /** @internal */
    M(this, "_flags");
    /** @internal */
    M(this, "backend");
    /** @internal */
    M(this, "purchaseOperationHelper");
    /** @internal */
    M(this, "eventsTracker");
    this._API_KEY = r, this._appUserId = t, this._flags = { ...Ma, ...n }, ua(r) && K.debugLog("Initializing Purchases SDK with sandbox API Key"), this.eventsTracker = new _f({
      apiKey: this._API_KEY,
      appUserId: this._appUserId,
      silent: !this._flags.collectAnalyticsEvents,
      rcSource: this._flags.rcSource ?? null
    }), this.backend = new Dm(this._API_KEY, a), this.purchaseOperationHelper = new Kl(
      this.backend,
      this.eventsTracker
    ), this.eventsTracker.trackSDKEvent({
      eventName: Fe.SDKInitialized
    });
  }
  /**
   * Set the log level. Logs of the given level and below will be printed
   * in the console.
   * Default is `LogLevel.Silent` so no logs will be printed in the console.
   * @param logLevel - LogLevel to set.
   */
  static setLogLevel(r) {
    K.setLogLevel(r);
  }
  /**
   * Meant to be used by RevenueCat hybrids SDKS only.
   * @experimental
   * */
  static setPlatformInfo(r) {
    be._platformInfo = r;
  }
  /** @internal */
  static getPlatformInfo() {
    return be._platformInfo;
  }
  /**
   * Get the singleton instance of Purchases. It's preferred to use the instance
   * obtained from the `configure` method when possible.
   * @throws {@link UninitializedPurchasesError} if the instance has not been initialized yet.
   */
  static getSharedInstance() {
    if (be.isConfigured())
      return be.instance;
    throw new Xl();
  }
  /**
   * Returns whether the Purchases SDK is configured or not.
   */
  static isConfigured() {
    return be.instance !== void 0;
  }
  static configure(r, t, a, n) {
    be.instance !== void 0 && K.warnLog(
      "Purchases is already initialized. You normally should only configure Purchases once. Creating and returning new instance."
    );
    let o;
    if (typeof r == "object" && r !== null)
      o = r;
    else {
      if (typeof r != "string")
        throw new _e(
          he.ConfigurationError,
          "API key must be provided as a string"
        );
      if (typeof t != "string")
        throw new _e(
          he.ConfigurationError,
          "App user ID must be provided as a string"
        );
      o = {
        apiKey: r,
        appUserId: t,
        httpConfig: a,
        flags: n
      };
    }
    return be.configureInternal(o), be.getSharedInstance();
  }
  static configureInternal(r) {
    const { apiKey: t, appUserId: a, httpConfig: n, flags: o } = r, i = n ?? tn, s = o ?? Ma;
    be.validateConfig(r), be.instance = new be(
      t,
      a,
      i,
      s
    );
  }
  static validateConfig(r) {
    var t, a;
    Am(r.apiKey), So(r.appUserId), Mm((t = r.httpConfig) == null ? void 0 : t.proxyURL), jm((a = r.httpConfig) == null ? void 0 : a.additionalHeaders);
  }
  /**
   * Loads and caches some optional data in the Purchases SDK.
   * Currently only fetching branding information.
   * You can call this method after configuring the SDK to speed
   * up the first call to {@link Purchases.purchase}.
   */
  async preload() {
    if (this.hasLoadedResources()) {
      K.verboseLog("Purchases resources are loaded. Skipping.");
      return;
    }
    if (this._loadingResourcesPromise !== null) {
      K.verboseLog("Purchases resources are loading. Waiting."), await this._loadingResourcesPromise;
      return;
    }
    return this._loadingResourcesPromise = this.fetchAndCacheBrandingInfo().catch((r) => {
      let t = `${r}`;
      r instanceof _e && (t = `${r.message}. ${r.underlyingErrorMessage ? `Underlying error: ${r.underlyingErrorMessage}` : ""}`), K.errorLog(`Error fetching branding info: ${t}`);
    }).finally(() => {
      this._loadingResourcesPromise = null;
    }), this._loadingResourcesPromise;
  }
  /** @internal */
  fetchAndCacheBrandingInfo() {
    return this.backend.getBrandingInfo().then((r) => {
      this._brandingInfo = r;
    });
  }
  /** @internal */
  hasLoadedResources() {
    return this._brandingInfo !== null;
  }
  /**
   * Renders an RC Paywall and allows the user to purchase from it using Web Billing.
   * @experimental
   * @internal
   * @param paywallParams - The parameters object to customise the paywall render. Check {@link RenderPaywallParams}
   * @returns Promise<PurchaseResult>
   */
  async renderPaywall(r) {
    console.warn(
      "This method is @experimental, Paywalls are not generally available but they will come soon!"
    );
    let a = r.htmlTarget ?? document.getElementById("rcb-ui-pw-root");
    if (a === null) {
      const g = document.createElement("div");
      g.id = "rcb-ui-pw-root", g.className = "rcb-ui-pw-root", g.style.zIndex = `${Lm}`, document.body.appendChild(g), a = g;
    }
    if (a === null)
      throw new Error(
        "Could not generate a mount point for the billing widget"
      );
    const n = a;
    n.innerHTML = "";
    const o = r.offering;
    if (!o.paywall_components)
      throw new Error("You cannot use paywalls yet, they are coming soon!");
    const i = r.selectedLocale || navigator.language, s = new va(
      {},
      i,
      o.paywall_components.default_locale
    ), l = (g) => {
      var f;
      const m = o.availablePackages.find(
        (h) => h.identifier === g
      );
      if (m === void 0)
        throw new Error(`No package found for ${g}`);
      return this.purchase({
        rcPackage: m,
        htmlTarget: r.purchaseHtmlTarget,
        customerEmail: r.customerEmail,
        selectedLocale: i,
        defaultLocale: ((f = o.paywall_components) == null ? void 0 : f.default_locale) || tt
      });
    }, c = (g) => {
      var m;
      if (r.onNavigateToUrl) {
        r.onNavigateToUrl(g);
        return;
      }
      (m = window.open(g, "_blank")) == null || m.focus();
    }, p = () => {
    }, u = () => {
      if (r.onVisitCustomerCenter) {
        r.onVisitCustomerCenter();
        return;
      }
    }, _ = Hm(
      o,
      s
    );
    return new Promise((g, m) => {
      ro(kd, {
        target: n,
        props: {
          paywallData: o.paywall_components,
          selectedLocale: i,
          onNavigateToUrlClicked: c,
          onVisitCustomerCenterClicked: u,
          onBackClicked: () => {
            if (r.onBack) {
              r.onBack();
              return;
            }
            n.innerHTML = "", K.debugLog("Purchase cancelled by user"), m(new _e(he.UserCancelledError));
          },
          onRestorePurchasesClicked: p,
          onPurchaseClicked: (f) => {
            l(f).then((h) => {
              g(h);
            }).catch((h) => m(h));
          },
          onError: (f) => m(f),
          variablesPerPackage: _
        }
      });
    });
  }
  /**
   * Fetch the configured offerings for this user. You can configure these
   * in the RevenueCat dashboard.
   * @param params - The parameters object to customise the offerings fetch. Check {@link GetOfferingsParams}
   */
  async getOfferings(r) {
    sm(r == null ? void 0 : r.currency);
    const t = this._appUserId, a = await this.backend.getOfferings(t), n = (r == null ? void 0 : r.offeringIdentifier) === as.Current ? a.current_offering_id : r == null ? void 0 : r.offeringIdentifier;
    return n && (a.offerings = a.offerings.filter(
      (o) => o.identifier === n
    )), await this.getAllOfferings(a, t, r);
  }
  /**
   * Retrieves a specific offering by a placement identifier.
   * For more info see https://www.revenuecat.com/docs/tools/targeting
   * @param placementIdentifier - The placement identifier to retrieve the offering for.
   * @param params - The parameters object to customise the offerings fetch. Check {@link GetOfferingsParams}
   */
  async getCurrentOfferingForPlacement(r, t) {
    const a = this._appUserId, n = await this.backend.getOfferings(a), o = await this.getAllOfferings(
      n,
      a,
      t
    ), i = n.placements ?? null;
    return i == null ? null : Cm(
      i,
      o.all,
      r
    );
  }
  async getAllOfferings(r, t, a) {
    const n = r.offerings.flatMap((i) => i.packages).map((i) => i.platform_product_identifier), o = await this.backend.getProducts(
      t,
      n,
      a == null ? void 0 : a.currency
    );
    return this.logMissingProductIds(n, o.product_details), Om(r, o);
  }
  /**
   * Convenience method to check whether a user is entitled to a specific
   * entitlement. This will use {@link Purchases.getCustomerInfo} under the hood.
   * @param entitlementIdentifier - The entitlement identifier you want to check.
   * @returns Whether the user is entitled to the specified entitlement
   * @throws {@link PurchasesError} if there is an error while fetching the customer info.
   * @see {@link Purchases.getCustomerInfo}
   */
  async isEntitledTo(r) {
    const t = await this.getCustomerInfo();
    return r in t.entitlements.active;
  }
  /**
   * Method to perform a purchase for a given package. You can obtain the
   * package from {@link Purchases.getOfferings}. This method will present the purchase
   * form on your site, using the given HTML element as the mount point, if
   * provided, or as a modal if not.
   * @deprecated - please use .purchase
   * @param rcPackage - The package you want to purchase. Obtained from {@link Purchases.getOfferings}.
   * @param customerEmail - The email of the user. If undefined, RevenueCat will ask the customer for their email.
   * @param htmlTarget - The HTML element where the billing view should be added. If undefined, a new div will be created at the root of the page and appended to the body.
   * @returns a Promise for the customer info after the purchase is completed successfully.
   * @throws {@link PurchasesError} if there is an error while performing the purchase. If the {@link PurchasesError.errorCode} is {@link ErrorCode.UserCancelledError}, the user cancelled the purchase.
   */
  purchasePackage(r, t, a) {
    return this.purchase({
      rcPackage: r,
      customerEmail: t,
      htmlTarget: a
    });
  }
  purchase(r) {
    var x;
    const {
      rcPackage: t,
      purchaseOption: a,
      htmlTarget: n,
      customerEmail: o,
      selectedLocale: i = tt,
      defaultLocale: s = tt
    } = r;
    let l = n ?? document.getElementById("rcb-ui-root");
    if (l === null) {
      const T = document.createElement("div");
      T.className = "rcb-ui-root", document.body.appendChild(T), l = T;
    }
    if (l === null)
      throw new Error(
        "Could not generate a mount point for the billing widget"
      );
    const c = l, p = this._appUserId;
    K.debugLog(
      `Presenting purchase form for package ${t.identifier}`
    );
    const u = i || s, _ = a ?? t.webBillingProduct.defaultPurchaseOption, g = np({
      appearance: (x = this._brandingInfo) == null ? void 0 : x.appearance,
      rcPackage: t,
      purchaseOptionToUse: _,
      customerEmail: o
    });
    this.eventsTracker.trackSDKEvent(g);
    const f = { ...this._flags.autoCollectUTMAsMetadata ? gf() : {}, ...r.metadata || {} };
    let h = null;
    const v = this._brandingInfo;
    v && r.brandingAppearanceOverride && (v.appearance = r.brandingAppearanceOverride);
    const y = n !== void 0;
    return new Promise((T, S) => {
      y || window.history.pushState({ checkoutOpen: !0 }, "");
      const C = this._flags.rcSource && mf.includes(this._flags.rcSource) ? void 0 : () => {
        const q = ip();
        this.eventsTracker.trackSDKEvent(q), window.removeEventListener("popstate", C), h && qa(h), c.innerHTML = "", K.debugLog("Purchase cancelled by user"), S(new _e(he.UserCancelledError));
      };
      !y && C && window.addEventListener("popstate", C), h = ro(lm, {
        target: c,
        props: {
          isInElement: y,
          appUserId: p,
          rcPackage: t,
          purchaseOption: _,
          customerEmail: o,
          onFinished: async (q, G) => {
            const W = op({
              redemptionInfo: G
            });
            this.eventsTracker.trackSDKEvent(W), K.debugLog("Purchase finished"), h && qa(h), c.innerHTML = "";
            const ae = {
              customerInfo: await this._getCustomerInfoForUserId(p),
              redemptionInfo: G,
              operationSessionId: q
            };
            T(ae);
          },
          onClose: C,
          onError: (q) => {
            var W;
            const G = sp({
              errorCode: (W = q.errorCode) == null ? void 0 : W.toString(),
              errorMessage: q.message
            });
            this.eventsTracker.trackSDKEvent(G), h && qa(h), c.innerHTML = "", S(_e.getForPurchasesFlowError(q));
          },
          purchases: this,
          eventsTracker: this.eventsTracker,
          brandingInfo: this._brandingInfo,
          purchaseOperationHelper: this.purchaseOperationHelper,
          selectedLocale: u,
          metadata: f,
          defaultLocale: s,
          customTranslations: r.labelsOverride
        }
      });
    });
  }
  /**
   * Gets latest available {@link CustomerInfo}.
   * @returns The latest {@link CustomerInfo}.
   * @throws {@link PurchasesError} if there is an error while fetching the customer info.
   */
  async getCustomerInfo() {
    return await this._getCustomerInfoForUserId(this._appUserId);
  }
  /**
   * Gets the current app user id.
   */
  getAppUserId() {
    return this._appUserId;
  }
  /**
   * Sets attributes for the current user. Attributes are useful for storing additional, structured information on a customer that can be used elsewhere in the system.
   * For example, you could store your customer's email address or additional system identifiers through the applicable reserved attributes, or store arbitrary facts like onboarding survey responses, feature usage, or other dimensions as custom attributes.
   *
   * Note: Unlike our mobile SDKs, the web SDK does not cache or retry sending attributes if the request fails. If the request fails, the attributes will not be saved and you will need to retry the operation.
   *
   * @param attributes - A dictionary of attributes to set for the current user.
   * @throws {@link PurchasesError} if there is an error while setting the attributes or if the customer doesn't exist.
   */
  async setAttributes(r) {
    return await this.getCustomerInfo(), await this.backend.setAttributes(this._appUserId, r);
  }
  /**
   * Change the current app user id. Returns the customer info for the new
   * user id.
   * @param newAppUserId - The user id to change to.
   */
  async changeUser(r) {
    return So(r), this._appUserId = r, this.eventsTracker.updateUser(r), await this.getCustomerInfo();
  }
  /** @internal */
  logMissingProductIds(r, t) {
    const a = {};
    t.forEach(
      (o) => a[o.identifier] = o
    );
    const n = [];
    r.forEach((o) => {
      a[o] === void 0 && n.push(o);
    }), n.length > 0 && K.debugLog(
      `Could not find product data for product ids:
        ${n.join()}.
        Please check that your product configuration is correct.`
    );
  }
  /**
   * @returns Whether the SDK is using a sandbox API Key.
   */
  isSandbox() {
    return ua(this._API_KEY);
  }
  /**
   * @returns Whether the current user is anonymous.
   */
  isAnonymous() {
    return this._appUserId.startsWith(qo);
  }
  /**
   * Closes the Purchases instance. You should never have to do this normally.
   */
  close() {
    be.instance === this ? (this.eventsTracker && this.eventsTracker.dispose(), be.instance = void 0) : K.warnLog(
      "Trying to close a Purchases instance that is not the current instance. Ignoring."
    );
  }
  /** @internal */
  async _getCustomerInfoForUserId(r) {
    const t = await this.backend.getCustomerInfo(r);
    return _m(t);
  }
  /**
   * Generates an anonymous app user ID that follows RevenueCat's format.
   * This can be used when you don't have a user identifier system in place.
   * The generated ID will be in the format: $RCAnonymousID:\<UUID without dashes\>
   * Example: $RCAnonymousID:123e4567e89b12d3a456426614174000
   * @returns A new anonymous app user ID string
   * @public
   */
  static generateRevenueCatAnonymousAppUserId() {
    return `${qo}${ff().replace(/-/g, "")}`;
  }
  /**
   * Track an event.
   * @param props - The properties of the event.
   * @internal
   */
  _trackEvent(r) {
    this.eventsTracker.trackExternalEvent(r);
  }
};
ja = Vn(null), Yn(ja, 1, "purchase", Fo, be), Sa(ja, be), /** @internal */
M(be, "_platformInfo"), /** @internal */
M(be, "instance");
let an = be;
export {
  he as ErrorCode,
  Ae as LogLevel,
  as as OfferingKeyword,
  o_ as PackageType,
  xe as PeriodUnit,
  Lr as ProductType,
  an as Purchases,
  _e as PurchasesError,
  yf as ReservedCustomerAttribute,
  Xl as UninitializedPurchasesError
};
